export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};










export type AvifOptions = {
  quality?: Maybe<Scalars['Int']>;
  lossless?: Maybe<Scalars['Boolean']>;
  speed?: Maybe<Scalars['Int']>;
};

export type AdobeConfig = {
  __typename?: 'AdobeConfig';
  account: Scalars['String'];
  containerId: Scalars['String'];
  language: Scalars['String'];
  region: Scalars['String'];
  reportSuiteId: Scalars['String'];
  trackingServer: Scalars['String'];
  trackingServerSecure: Scalars['String'];
};

export type AdobeConfigFilterInput = {
  account?: Maybe<StringQueryOperatorInput>;
  containerId?: Maybe<StringQueryOperatorInput>;
  language?: Maybe<StringQueryOperatorInput>;
  region?: Maybe<StringQueryOperatorInput>;
  reportSuiteId?: Maybe<StringQueryOperatorInput>;
  trackingServer?: Maybe<StringQueryOperatorInput>;
  trackingServerSecure?: Maybe<StringQueryOperatorInput>;
};

export type Article = Node & {
  __typename?: 'Article';
  absolutePath?: Maybe<Scalars['String']>;
  copy?: Maybe<Array<Maybe<Copy>>>;
  hero?: Maybe<XmlContentMedia>;
  metaDescription?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  traits?: Maybe<Traits>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  totalCount: Scalars['Int'];
  edges: Array<ArticleEdge>;
  nodes: Array<Article>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ArticleGroupConnection>;
};


export type ArticleConnectionDistinctArgs = {
  field: ArticleFieldsEnum;
};


export type ArticleConnectionMaxArgs = {
  field: ArticleFieldsEnum;
};


export type ArticleConnectionMinArgs = {
  field: ArticleFieldsEnum;
};


export type ArticleConnectionSumArgs = {
  field: ArticleFieldsEnum;
};


export type ArticleConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: ArticleFieldsEnum;
};

export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  next?: Maybe<Article>;
  node: Article;
  previous?: Maybe<Article>;
};

export enum ArticleFieldsEnum {
  absolutePath = 'absolutePath',
  copy = 'copy',
  copy___id = 'copy___id',
  copy___description = 'copy___description',
  copy___type = 'copy___type',
  copy___imgSrc = 'copy___imgSrc',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  metaDescription = 'metaDescription',
  path = 'path',
  summary = 'summary',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ArticleFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  copy?: Maybe<CopyFilterListInput>;
  hero?: Maybe<XmlContentMediaFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type ArticleGroupConnection = {
  __typename?: 'ArticleGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<ArticleEdge>;
  nodes: Array<Article>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type ArticleSortInput = {
  fields?: Maybe<Array<Maybe<ArticleFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type BenefitImages = {
  __typename?: 'BenefitImages';
  description?: Maybe<Scalars['String']>;
  file?: Maybe<_File>;
};

export type BenefitImagesFilterInput = {
  description?: Maybe<StringQueryOperatorInput>;
  file?: Maybe<_FileFilterInput>;
};

export type BenefitImagesFilterListInput = {
  elemMatch?: Maybe<BenefitImagesFilterInput>;
};

export type BlurredOptions = {
  /** Width of the generated low-res preview. Default is 20px */
  width?: Maybe<Scalars['Int']>;
  /** Force the output format for the low-res preview. Default is to use the same format as the input. You should rarely need to change this */
  toFormat?: Maybe<ImageFormat>;
};

export type BooleanQueryOperatorInput = {
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type Brand = {
  __typename?: 'Brand';
  description: Scalars['String'];
  disclaimer?: Maybe<Scalars['String']>;
  favicon?: Maybe<Media>;
  lang: Scalars['String'];
  logo: Media;
  market: Scalars['String'];
  name: Scalars['String'];
  product: Scalars['String'];
};

export type BrandFilterInput = {
  description?: Maybe<StringQueryOperatorInput>;
  disclaimer?: Maybe<StringQueryOperatorInput>;
  favicon?: Maybe<MediaFilterInput>;
  lang?: Maybe<StringQueryOperatorInput>;
  logo?: Maybe<MediaFilterInput>;
  market?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  product?: Maybe<StringQueryOperatorInput>;
};

export type Certificate = {
  __typename?: 'Certificate';
  image: Media;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CertificateFilterInput = {
  image?: Maybe<MediaFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
};

export type CertificateFilterListInput = {
  elemMatch?: Maybe<CertificateFilterInput>;
};

export type ChildNode = ContentfulCategory | ContentfulArticle;

export type ContactUs = Node & {
  __typename?: 'ContactUs';
  absolutePath: Scalars['String'];
  contactFormWidgetClassName?: Maybe<Scalars['String']>;
  contactFormWidgetUrl?: Maybe<Scalars['String']>;
  legalsTextAdditional?: Maybe<Html>;
  liveChatText?: Maybe<Scalars['String']>;
  liveChatID?: Maybe<Scalars['String']>;
  liveChatDeploymentID?: Maybe<Scalars['String']>;
  main?: Maybe<Main>;
  pageTitle: Scalars['String'];
  pageType: Scalars['String'];
  path: Scalars['String'];
  phoneNumber?: Maybe<Html>;
  postalAddress?: Maybe<Html>;
  slug: Scalars['String'];
  summary: Scalars['String'];
  title: Scalars['String'];
  titlePhoneNumber?: Maybe<Scalars['String']>;
  titlePostalAddress?: Maybe<Scalars['String']>;
  traits?: Maybe<Traits>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type ContactUsConnection = {
  __typename?: 'ContactUsConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContactUsEdge>;
  nodes: Array<ContactUs>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ContactUsGroupConnection>;
};


export type ContactUsConnectionDistinctArgs = {
  field: ContactUsFieldsEnum;
};


export type ContactUsConnectionMaxArgs = {
  field: ContactUsFieldsEnum;
};


export type ContactUsConnectionMinArgs = {
  field: ContactUsFieldsEnum;
};


export type ContactUsConnectionSumArgs = {
  field: ContactUsFieldsEnum;
};


export type ContactUsConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: ContactUsFieldsEnum;
};

export type ContactUsEdge = {
  __typename?: 'ContactUsEdge';
  next?: Maybe<ContactUs>;
  node: ContactUs;
  previous?: Maybe<ContactUs>;
};

export enum ContactUsFieldsEnum {
  absolutePath = 'absolutePath',
  contactFormWidgetClassName = 'contactFormWidgetClassName',
  contactFormWidgetUrl = 'contactFormWidgetUrl',
  legalsTextAdditional___html = 'legalsTextAdditional___html',
  legalsTextAdditional___json = 'legalsTextAdditional___json',
  legalsTextAdditional___text = 'legalsTextAdditional___text',
  liveChatText = 'liveChatText',
  liveChatID = 'liveChatID',
  liveChatDeploymentID = 'liveChatDeploymentID',
  main___htmlTruncated = 'main___htmlTruncated',
  main___html = 'main___html',
  main___rawContent = 'main___rawContent',
  main___text = 'main___text',
  pageTitle = 'pageTitle',
  pageType = 'pageType',
  path = 'path',
  phoneNumber___html = 'phoneNumber___html',
  phoneNumber___json = 'phoneNumber___json',
  phoneNumber___text = 'phoneNumber___text',
  postalAddress___html = 'postalAddress___html',
  postalAddress___json = 'postalAddress___json',
  postalAddress___text = 'postalAddress___text',
  slug = 'slug',
  summary = 'summary',
  title = 'title',
  titlePhoneNumber = 'titlePhoneNumber',
  titlePostalAddress = 'titlePostalAddress',
  traits___traitsStringified = 'traits___traitsStringified',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ContactUsFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  contactFormWidgetClassName?: Maybe<StringQueryOperatorInput>;
  contactFormWidgetUrl?: Maybe<StringQueryOperatorInput>;
  legalsTextAdditional?: Maybe<HtmlFilterInput>;
  liveChatText?: Maybe<StringQueryOperatorInput>;
  liveChatID?: Maybe<StringQueryOperatorInput>;
  liveChatDeploymentID?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<MainFilterInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  phoneNumber?: Maybe<HtmlFilterInput>;
  postalAddress?: Maybe<HtmlFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  titlePhoneNumber?: Maybe<StringQueryOperatorInput>;
  titlePostalAddress?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type ContactUsGroupConnection = {
  __typename?: 'ContactUsGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContactUsEdge>;
  nodes: Array<ContactUs>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type ContactUsSortInput = {
  fields?: Maybe<Array<Maybe<ContactUsFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Content = Node & {
  __typename?: 'Content';
  absolutePath?: Maybe<Scalars['String']>;
  copy?: Maybe<Array<Maybe<Copy>>>;
  hero?: Maybe<XmlContentMedia>;
  metaDescription?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  summaryBackground?: Maybe<XmlContentMedia>;
  title?: Maybe<Scalars['String']>;
  traits?: Maybe<Traits>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type ContentConnection = {
  __typename?: 'ContentConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContentEdge>;
  nodes: Array<Content>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ContentGroupConnection>;
};


export type ContentConnectionDistinctArgs = {
  field: ContentFieldsEnum;
};


export type ContentConnectionMaxArgs = {
  field: ContentFieldsEnum;
};


export type ContentConnectionMinArgs = {
  field: ContentFieldsEnum;
};


export type ContentConnectionSumArgs = {
  field: ContentFieldsEnum;
};


export type ContentConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: ContentFieldsEnum;
};

export type ContentEdge = {
  __typename?: 'ContentEdge';
  next?: Maybe<Content>;
  node: Content;
  previous?: Maybe<Content>;
};

export enum ContentFieldsEnum {
  absolutePath = 'absolutePath',
  copy = 'copy',
  copy___id = 'copy___id',
  copy___description = 'copy___description',
  copy___type = 'copy___type',
  copy___imgSrc = 'copy___imgSrc',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  metaDescription = 'metaDescription',
  path = 'path',
  summary = 'summary',
  summaryBackground___description = 'summaryBackground___description',
  summaryBackground___file___fileLocal___sourceInstanceName = 'summaryBackground___file___fileLocal___sourceInstanceName',
  summaryBackground___file___fileLocal___absolutePath = 'summaryBackground___file___fileLocal___absolutePath',
  summaryBackground___file___fileLocal___relativePath = 'summaryBackground___file___fileLocal___relativePath',
  summaryBackground___file___fileLocal___extension = 'summaryBackground___file___fileLocal___extension',
  summaryBackground___file___fileLocal___size = 'summaryBackground___file___fileLocal___size',
  summaryBackground___file___fileLocal___prettySize = 'summaryBackground___file___fileLocal___prettySize',
  summaryBackground___file___fileLocal___modifiedTime = 'summaryBackground___file___fileLocal___modifiedTime',
  summaryBackground___file___fileLocal___accessTime = 'summaryBackground___file___fileLocal___accessTime',
  summaryBackground___file___fileLocal___changeTime = 'summaryBackground___file___fileLocal___changeTime',
  summaryBackground___file___fileLocal___birthTime = 'summaryBackground___file___fileLocal___birthTime',
  summaryBackground___file___fileLocal___root = 'summaryBackground___file___fileLocal___root',
  summaryBackground___file___fileLocal___dir = 'summaryBackground___file___fileLocal___dir',
  summaryBackground___file___fileLocal___base = 'summaryBackground___file___fileLocal___base',
  summaryBackground___file___fileLocal___ext = 'summaryBackground___file___fileLocal___ext',
  summaryBackground___file___fileLocal___name = 'summaryBackground___file___fileLocal___name',
  summaryBackground___file___fileLocal___relativeDirectory = 'summaryBackground___file___fileLocal___relativeDirectory',
  summaryBackground___file___fileLocal___dev = 'summaryBackground___file___fileLocal___dev',
  summaryBackground___file___fileLocal___mode = 'summaryBackground___file___fileLocal___mode',
  summaryBackground___file___fileLocal___nlink = 'summaryBackground___file___fileLocal___nlink',
  summaryBackground___file___fileLocal___uid = 'summaryBackground___file___fileLocal___uid',
  summaryBackground___file___fileLocal___gid = 'summaryBackground___file___fileLocal___gid',
  summaryBackground___file___fileLocal___rdev = 'summaryBackground___file___fileLocal___rdev',
  summaryBackground___file___fileLocal___ino = 'summaryBackground___file___fileLocal___ino',
  summaryBackground___file___fileLocal___atimeMs = 'summaryBackground___file___fileLocal___atimeMs',
  summaryBackground___file___fileLocal___mtimeMs = 'summaryBackground___file___fileLocal___mtimeMs',
  summaryBackground___file___fileLocal___ctimeMs = 'summaryBackground___file___fileLocal___ctimeMs',
  summaryBackground___file___fileLocal___atime = 'summaryBackground___file___fileLocal___atime',
  summaryBackground___file___fileLocal___mtime = 'summaryBackground___file___fileLocal___mtime',
  summaryBackground___file___fileLocal___ctime = 'summaryBackground___file___fileLocal___ctime',
  summaryBackground___file___fileLocal___birthtime = 'summaryBackground___file___fileLocal___birthtime',
  summaryBackground___file___fileLocal___birthtimeMs = 'summaryBackground___file___fileLocal___birthtimeMs',
  summaryBackground___file___fileLocal___blksize = 'summaryBackground___file___fileLocal___blksize',
  summaryBackground___file___fileLocal___blocks = 'summaryBackground___file___fileLocal___blocks',
  summaryBackground___file___fileLocal___url = 'summaryBackground___file___fileLocal___url',
  summaryBackground___file___fileLocal___publicURL = 'summaryBackground___file___fileLocal___publicURL',
  summaryBackground___file___fileLocal___childrenImageSharp = 'summaryBackground___file___fileLocal___childrenImageSharp',
  summaryBackground___file___fileLocal___id = 'summaryBackground___file___fileLocal___id',
  summaryBackground___file___fileLocal___children = 'summaryBackground___file___fileLocal___children',
  summaryBackground___file___url = 'summaryBackground___file___url',
  summaryBackground___title = 'summaryBackground___title',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ContentFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  copy?: Maybe<CopyFilterListInput>;
  hero?: Maybe<XmlContentMediaFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<XmlContentMediaFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type ContentGroupConnection = {
  __typename?: 'ContentGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContentEdge>;
  nodes: Array<Content>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type ContentSortInput = {
  fields?: Maybe<Array<Maybe<ContentFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type ContentfulArticle = Node & {
  __typename?: 'ContentfulArticle';
  absolutePath: Scalars['String'];
  hero?: Maybe<Media>;
  main?: Maybe<Main>;
  metaDescription: Scalars['String'];
  pageTitle: Scalars['String'];
  title: Scalars['String'];
  pageType: Scalars['String'];
  parentCategory: ContentfulCategory;
  path: Scalars['String'];
  summary: Scalars['String'];
  summaryBackground?: Maybe<Media>;
  slug: Scalars['String'];
  traits: Traits;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type ContentfulArticleConnection = {
  __typename?: 'ContentfulArticleConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContentfulArticleEdge>;
  nodes: Array<ContentfulArticle>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ContentfulArticleGroupConnection>;
};


export type ContentfulArticleConnectionDistinctArgs = {
  field: ContentfulArticleFieldsEnum;
};


export type ContentfulArticleConnectionMaxArgs = {
  field: ContentfulArticleFieldsEnum;
};


export type ContentfulArticleConnectionMinArgs = {
  field: ContentfulArticleFieldsEnum;
};


export type ContentfulArticleConnectionSumArgs = {
  field: ContentfulArticleFieldsEnum;
};


export type ContentfulArticleConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: ContentfulArticleFieldsEnum;
};

export type ContentfulArticleEdge = {
  __typename?: 'ContentfulArticleEdge';
  next?: Maybe<ContentfulArticle>;
  node: ContentfulArticle;
  previous?: Maybe<ContentfulArticle>;
};

export enum ContentfulArticleFieldsEnum {
  absolutePath = 'absolutePath',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  main___htmlTruncated = 'main___htmlTruncated',
  main___html = 'main___html',
  main___rawContent = 'main___rawContent',
  main___text = 'main___text',
  metaDescription = 'metaDescription',
  pageTitle = 'pageTitle',
  title = 'title',
  pageType = 'pageType',
  parentCategory___absolutePath = 'parentCategory___absolutePath',
  parentCategory___hero___description = 'parentCategory___hero___description',
  parentCategory___hero___file___url = 'parentCategory___hero___file___url',
  parentCategory___hero___title = 'parentCategory___hero___title',
  parentCategory___main___htmlTruncated = 'parentCategory___main___htmlTruncated',
  parentCategory___main___html = 'parentCategory___main___html',
  parentCategory___main___rawContent = 'parentCategory___main___rawContent',
  parentCategory___main___text = 'parentCategory___main___text',
  parentCategory___metaDescription = 'parentCategory___metaDescription',
  parentCategory___pageTitle = 'parentCategory___pageTitle',
  parentCategory___parentCategory___absolutePath = 'parentCategory___parentCategory___absolutePath',
  parentCategory___parentCategory___hero___description = 'parentCategory___parentCategory___hero___description',
  parentCategory___parentCategory___hero___title = 'parentCategory___parentCategory___hero___title',
  parentCategory___parentCategory___main___htmlTruncated = 'parentCategory___parentCategory___main___htmlTruncated',
  parentCategory___parentCategory___main___html = 'parentCategory___parentCategory___main___html',
  parentCategory___parentCategory___main___rawContent = 'parentCategory___parentCategory___main___rawContent',
  parentCategory___parentCategory___main___text = 'parentCategory___parentCategory___main___text',
  parentCategory___parentCategory___metaDescription = 'parentCategory___parentCategory___metaDescription',
  parentCategory___parentCategory___pageTitle = 'parentCategory___parentCategory___pageTitle',
  parentCategory___parentCategory___parentCategory___absolutePath = 'parentCategory___parentCategory___parentCategory___absolutePath',
  parentCategory___parentCategory___parentCategory___metaDescription = 'parentCategory___parentCategory___parentCategory___metaDescription',
  parentCategory___parentCategory___parentCategory___pageTitle = 'parentCategory___parentCategory___parentCategory___pageTitle',
  parentCategory___parentCategory___parentCategory___path = 'parentCategory___parentCategory___parentCategory___path',
  parentCategory___parentCategory___parentCategory___summary = 'parentCategory___parentCategory___parentCategory___summary',
  parentCategory___parentCategory___parentCategory___slug = 'parentCategory___parentCategory___parentCategory___slug',
  parentCategory___parentCategory___parentCategory___id = 'parentCategory___parentCategory___parentCategory___id',
  parentCategory___parentCategory___parentCategory___children = 'parentCategory___parentCategory___parentCategory___children',
  parentCategory___parentCategory___path = 'parentCategory___parentCategory___path',
  parentCategory___parentCategory___summary = 'parentCategory___parentCategory___summary',
  parentCategory___parentCategory___slug = 'parentCategory___parentCategory___slug',
  parentCategory___parentCategory___traits___traitsStringified = 'parentCategory___parentCategory___traits___traitsStringified',
  parentCategory___parentCategory___id = 'parentCategory___parentCategory___id',
  parentCategory___parentCategory___parent___id = 'parentCategory___parentCategory___parent___id',
  parentCategory___parentCategory___parent___children = 'parentCategory___parentCategory___parent___children',
  parentCategory___parentCategory___children = 'parentCategory___parentCategory___children',
  parentCategory___parentCategory___children___id = 'parentCategory___parentCategory___children___id',
  parentCategory___parentCategory___children___children = 'parentCategory___parentCategory___children___children',
  parentCategory___parentCategory___internal___content = 'parentCategory___parentCategory___internal___content',
  parentCategory___parentCategory___internal___contentDigest = 'parentCategory___parentCategory___internal___contentDigest',
  parentCategory___parentCategory___internal___description = 'parentCategory___parentCategory___internal___description',
  parentCategory___parentCategory___internal___fieldOwners = 'parentCategory___parentCategory___internal___fieldOwners',
  parentCategory___parentCategory___internal___ignoreType = 'parentCategory___parentCategory___internal___ignoreType',
  parentCategory___parentCategory___internal___mediaType = 'parentCategory___parentCategory___internal___mediaType',
  parentCategory___parentCategory___internal___owner = 'parentCategory___parentCategory___internal___owner',
  parentCategory___parentCategory___internal___type = 'parentCategory___parentCategory___internal___type',
  parentCategory___path = 'parentCategory___path',
  parentCategory___summary = 'parentCategory___summary',
  parentCategory___slug = 'parentCategory___slug',
  parentCategory___traits___traitsStringified = 'parentCategory___traits___traitsStringified',
  parentCategory___id = 'parentCategory___id',
  parentCategory___parent___id = 'parentCategory___parent___id',
  parentCategory___parent___parent___id = 'parentCategory___parent___parent___id',
  parentCategory___parent___parent___children = 'parentCategory___parent___parent___children',
  parentCategory___parent___children = 'parentCategory___parent___children',
  parentCategory___parent___children___id = 'parentCategory___parent___children___id',
  parentCategory___parent___children___children = 'parentCategory___parent___children___children',
  parentCategory___parent___internal___content = 'parentCategory___parent___internal___content',
  parentCategory___parent___internal___contentDigest = 'parentCategory___parent___internal___contentDigest',
  parentCategory___parent___internal___description = 'parentCategory___parent___internal___description',
  parentCategory___parent___internal___fieldOwners = 'parentCategory___parent___internal___fieldOwners',
  parentCategory___parent___internal___ignoreType = 'parentCategory___parent___internal___ignoreType',
  parentCategory___parent___internal___mediaType = 'parentCategory___parent___internal___mediaType',
  parentCategory___parent___internal___owner = 'parentCategory___parent___internal___owner',
  parentCategory___parent___internal___type = 'parentCategory___parent___internal___type',
  parentCategory___children = 'parentCategory___children',
  parentCategory___children___id = 'parentCategory___children___id',
  parentCategory___children___parent___id = 'parentCategory___children___parent___id',
  parentCategory___children___parent___children = 'parentCategory___children___parent___children',
  parentCategory___children___children = 'parentCategory___children___children',
  parentCategory___children___children___id = 'parentCategory___children___children___id',
  parentCategory___children___children___children = 'parentCategory___children___children___children',
  parentCategory___children___internal___content = 'parentCategory___children___internal___content',
  parentCategory___children___internal___contentDigest = 'parentCategory___children___internal___contentDigest',
  parentCategory___children___internal___description = 'parentCategory___children___internal___description',
  parentCategory___children___internal___fieldOwners = 'parentCategory___children___internal___fieldOwners',
  parentCategory___children___internal___ignoreType = 'parentCategory___children___internal___ignoreType',
  parentCategory___children___internal___mediaType = 'parentCategory___children___internal___mediaType',
  parentCategory___children___internal___owner = 'parentCategory___children___internal___owner',
  parentCategory___children___internal___type = 'parentCategory___children___internal___type',
  parentCategory___internal___content = 'parentCategory___internal___content',
  parentCategory___internal___contentDigest = 'parentCategory___internal___contentDigest',
  parentCategory___internal___description = 'parentCategory___internal___description',
  parentCategory___internal___fieldOwners = 'parentCategory___internal___fieldOwners',
  parentCategory___internal___ignoreType = 'parentCategory___internal___ignoreType',
  parentCategory___internal___mediaType = 'parentCategory___internal___mediaType',
  parentCategory___internal___owner = 'parentCategory___internal___owner',
  parentCategory___internal___type = 'parentCategory___internal___type',
  path = 'path',
  summary = 'summary',
  summaryBackground___description = 'summaryBackground___description',
  summaryBackground___file___fileLocal___sourceInstanceName = 'summaryBackground___file___fileLocal___sourceInstanceName',
  summaryBackground___file___fileLocal___absolutePath = 'summaryBackground___file___fileLocal___absolutePath',
  summaryBackground___file___fileLocal___relativePath = 'summaryBackground___file___fileLocal___relativePath',
  summaryBackground___file___fileLocal___extension = 'summaryBackground___file___fileLocal___extension',
  summaryBackground___file___fileLocal___size = 'summaryBackground___file___fileLocal___size',
  summaryBackground___file___fileLocal___prettySize = 'summaryBackground___file___fileLocal___prettySize',
  summaryBackground___file___fileLocal___modifiedTime = 'summaryBackground___file___fileLocal___modifiedTime',
  summaryBackground___file___fileLocal___accessTime = 'summaryBackground___file___fileLocal___accessTime',
  summaryBackground___file___fileLocal___changeTime = 'summaryBackground___file___fileLocal___changeTime',
  summaryBackground___file___fileLocal___birthTime = 'summaryBackground___file___fileLocal___birthTime',
  summaryBackground___file___fileLocal___root = 'summaryBackground___file___fileLocal___root',
  summaryBackground___file___fileLocal___dir = 'summaryBackground___file___fileLocal___dir',
  summaryBackground___file___fileLocal___base = 'summaryBackground___file___fileLocal___base',
  summaryBackground___file___fileLocal___ext = 'summaryBackground___file___fileLocal___ext',
  summaryBackground___file___fileLocal___name = 'summaryBackground___file___fileLocal___name',
  summaryBackground___file___fileLocal___relativeDirectory = 'summaryBackground___file___fileLocal___relativeDirectory',
  summaryBackground___file___fileLocal___dev = 'summaryBackground___file___fileLocal___dev',
  summaryBackground___file___fileLocal___mode = 'summaryBackground___file___fileLocal___mode',
  summaryBackground___file___fileLocal___nlink = 'summaryBackground___file___fileLocal___nlink',
  summaryBackground___file___fileLocal___uid = 'summaryBackground___file___fileLocal___uid',
  summaryBackground___file___fileLocal___gid = 'summaryBackground___file___fileLocal___gid',
  summaryBackground___file___fileLocal___rdev = 'summaryBackground___file___fileLocal___rdev',
  summaryBackground___file___fileLocal___ino = 'summaryBackground___file___fileLocal___ino',
  summaryBackground___file___fileLocal___atimeMs = 'summaryBackground___file___fileLocal___atimeMs',
  summaryBackground___file___fileLocal___mtimeMs = 'summaryBackground___file___fileLocal___mtimeMs',
  summaryBackground___file___fileLocal___ctimeMs = 'summaryBackground___file___fileLocal___ctimeMs',
  summaryBackground___file___fileLocal___atime = 'summaryBackground___file___fileLocal___atime',
  summaryBackground___file___fileLocal___mtime = 'summaryBackground___file___fileLocal___mtime',
  summaryBackground___file___fileLocal___ctime = 'summaryBackground___file___fileLocal___ctime',
  summaryBackground___file___fileLocal___birthtime = 'summaryBackground___file___fileLocal___birthtime',
  summaryBackground___file___fileLocal___birthtimeMs = 'summaryBackground___file___fileLocal___birthtimeMs',
  summaryBackground___file___fileLocal___blksize = 'summaryBackground___file___fileLocal___blksize',
  summaryBackground___file___fileLocal___blocks = 'summaryBackground___file___fileLocal___blocks',
  summaryBackground___file___fileLocal___url = 'summaryBackground___file___fileLocal___url',
  summaryBackground___file___fileLocal___publicURL = 'summaryBackground___file___fileLocal___publicURL',
  summaryBackground___file___fileLocal___childrenImageSharp = 'summaryBackground___file___fileLocal___childrenImageSharp',
  summaryBackground___file___fileLocal___id = 'summaryBackground___file___fileLocal___id',
  summaryBackground___file___fileLocal___children = 'summaryBackground___file___fileLocal___children',
  summaryBackground___file___url = 'summaryBackground___file___url',
  summaryBackground___title = 'summaryBackground___title',
  slug = 'slug',
  traits___traitsStringified = 'traits___traitsStringified',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ContentfulArticleFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  parentCategory?: Maybe<ContentfulCategoryFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<MediaFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type ContentfulArticleGroupConnection = {
  __typename?: 'ContentfulArticleGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContentfulArticleEdge>;
  nodes: Array<ContentfulArticle>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type ContentfulArticleSortInput = {
  fields?: Maybe<Array<Maybe<ContentfulArticleFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type ContentfulCategory = Node & {
  __typename?: 'ContentfulCategory';
  absolutePath: Scalars['String'];
  childNodes: Array<ChildNode>;
  hero?: Maybe<Media>;
  main?: Maybe<Main>;
  metaDescription: Scalars['String'];
  pageTitle: Scalars['String'];
  parentCategory?: Maybe<ContentfulCategory>;
  path: Scalars['String'];
  summary: Scalars['String'];
  slug: Scalars['String'];
  traits: Traits;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type ContentfulCategoryConnection = {
  __typename?: 'ContentfulCategoryConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContentfulCategoryEdge>;
  nodes: Array<ContentfulCategory>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ContentfulCategoryGroupConnection>;
};


export type ContentfulCategoryConnectionDistinctArgs = {
  field: ContentfulCategoryFieldsEnum;
};


export type ContentfulCategoryConnectionMaxArgs = {
  field: ContentfulCategoryFieldsEnum;
};


export type ContentfulCategoryConnectionMinArgs = {
  field: ContentfulCategoryFieldsEnum;
};


export type ContentfulCategoryConnectionSumArgs = {
  field: ContentfulCategoryFieldsEnum;
};


export type ContentfulCategoryConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: ContentfulCategoryFieldsEnum;
};

export type ContentfulCategoryEdge = {
  __typename?: 'ContentfulCategoryEdge';
  next?: Maybe<ContentfulCategory>;
  node: ContentfulCategory;
  previous?: Maybe<ContentfulCategory>;
};

export enum ContentfulCategoryFieldsEnum {
  absolutePath = 'absolutePath',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  main___htmlTruncated = 'main___htmlTruncated',
  main___html = 'main___html',
  main___rawContent = 'main___rawContent',
  main___text = 'main___text',
  metaDescription = 'metaDescription',
  pageTitle = 'pageTitle',
  parentCategory___absolutePath = 'parentCategory___absolutePath',
  parentCategory___hero___description = 'parentCategory___hero___description',
  parentCategory___hero___file___url = 'parentCategory___hero___file___url',
  parentCategory___hero___title = 'parentCategory___hero___title',
  parentCategory___main___htmlTruncated = 'parentCategory___main___htmlTruncated',
  parentCategory___main___html = 'parentCategory___main___html',
  parentCategory___main___rawContent = 'parentCategory___main___rawContent',
  parentCategory___main___text = 'parentCategory___main___text',
  parentCategory___metaDescription = 'parentCategory___metaDescription',
  parentCategory___pageTitle = 'parentCategory___pageTitle',
  parentCategory___parentCategory___absolutePath = 'parentCategory___parentCategory___absolutePath',
  parentCategory___parentCategory___hero___description = 'parentCategory___parentCategory___hero___description',
  parentCategory___parentCategory___hero___title = 'parentCategory___parentCategory___hero___title',
  parentCategory___parentCategory___main___htmlTruncated = 'parentCategory___parentCategory___main___htmlTruncated',
  parentCategory___parentCategory___main___html = 'parentCategory___parentCategory___main___html',
  parentCategory___parentCategory___main___rawContent = 'parentCategory___parentCategory___main___rawContent',
  parentCategory___parentCategory___main___text = 'parentCategory___parentCategory___main___text',
  parentCategory___parentCategory___metaDescription = 'parentCategory___parentCategory___metaDescription',
  parentCategory___parentCategory___pageTitle = 'parentCategory___parentCategory___pageTitle',
  parentCategory___parentCategory___parentCategory___absolutePath = 'parentCategory___parentCategory___parentCategory___absolutePath',
  parentCategory___parentCategory___parentCategory___metaDescription = 'parentCategory___parentCategory___parentCategory___metaDescription',
  parentCategory___parentCategory___parentCategory___pageTitle = 'parentCategory___parentCategory___parentCategory___pageTitle',
  parentCategory___parentCategory___parentCategory___path = 'parentCategory___parentCategory___parentCategory___path',
  parentCategory___parentCategory___parentCategory___summary = 'parentCategory___parentCategory___parentCategory___summary',
  parentCategory___parentCategory___parentCategory___slug = 'parentCategory___parentCategory___parentCategory___slug',
  parentCategory___parentCategory___parentCategory___id = 'parentCategory___parentCategory___parentCategory___id',
  parentCategory___parentCategory___parentCategory___children = 'parentCategory___parentCategory___parentCategory___children',
  parentCategory___parentCategory___path = 'parentCategory___parentCategory___path',
  parentCategory___parentCategory___summary = 'parentCategory___parentCategory___summary',
  parentCategory___parentCategory___slug = 'parentCategory___parentCategory___slug',
  parentCategory___parentCategory___traits___traitsStringified = 'parentCategory___parentCategory___traits___traitsStringified',
  parentCategory___parentCategory___id = 'parentCategory___parentCategory___id',
  parentCategory___parentCategory___parent___id = 'parentCategory___parentCategory___parent___id',
  parentCategory___parentCategory___parent___children = 'parentCategory___parentCategory___parent___children',
  parentCategory___parentCategory___children = 'parentCategory___parentCategory___children',
  parentCategory___parentCategory___children___id = 'parentCategory___parentCategory___children___id',
  parentCategory___parentCategory___children___children = 'parentCategory___parentCategory___children___children',
  parentCategory___parentCategory___internal___content = 'parentCategory___parentCategory___internal___content',
  parentCategory___parentCategory___internal___contentDigest = 'parentCategory___parentCategory___internal___contentDigest',
  parentCategory___parentCategory___internal___description = 'parentCategory___parentCategory___internal___description',
  parentCategory___parentCategory___internal___fieldOwners = 'parentCategory___parentCategory___internal___fieldOwners',
  parentCategory___parentCategory___internal___ignoreType = 'parentCategory___parentCategory___internal___ignoreType',
  parentCategory___parentCategory___internal___mediaType = 'parentCategory___parentCategory___internal___mediaType',
  parentCategory___parentCategory___internal___owner = 'parentCategory___parentCategory___internal___owner',
  parentCategory___parentCategory___internal___type = 'parentCategory___parentCategory___internal___type',
  parentCategory___path = 'parentCategory___path',
  parentCategory___summary = 'parentCategory___summary',
  parentCategory___slug = 'parentCategory___slug',
  parentCategory___traits___traitsStringified = 'parentCategory___traits___traitsStringified',
  parentCategory___id = 'parentCategory___id',
  parentCategory___parent___id = 'parentCategory___parent___id',
  parentCategory___parent___parent___id = 'parentCategory___parent___parent___id',
  parentCategory___parent___parent___children = 'parentCategory___parent___parent___children',
  parentCategory___parent___children = 'parentCategory___parent___children',
  parentCategory___parent___children___id = 'parentCategory___parent___children___id',
  parentCategory___parent___children___children = 'parentCategory___parent___children___children',
  parentCategory___parent___internal___content = 'parentCategory___parent___internal___content',
  parentCategory___parent___internal___contentDigest = 'parentCategory___parent___internal___contentDigest',
  parentCategory___parent___internal___description = 'parentCategory___parent___internal___description',
  parentCategory___parent___internal___fieldOwners = 'parentCategory___parent___internal___fieldOwners',
  parentCategory___parent___internal___ignoreType = 'parentCategory___parent___internal___ignoreType',
  parentCategory___parent___internal___mediaType = 'parentCategory___parent___internal___mediaType',
  parentCategory___parent___internal___owner = 'parentCategory___parent___internal___owner',
  parentCategory___parent___internal___type = 'parentCategory___parent___internal___type',
  parentCategory___children = 'parentCategory___children',
  parentCategory___children___id = 'parentCategory___children___id',
  parentCategory___children___parent___id = 'parentCategory___children___parent___id',
  parentCategory___children___parent___children = 'parentCategory___children___parent___children',
  parentCategory___children___children = 'parentCategory___children___children',
  parentCategory___children___children___id = 'parentCategory___children___children___id',
  parentCategory___children___children___children = 'parentCategory___children___children___children',
  parentCategory___children___internal___content = 'parentCategory___children___internal___content',
  parentCategory___children___internal___contentDigest = 'parentCategory___children___internal___contentDigest',
  parentCategory___children___internal___description = 'parentCategory___children___internal___description',
  parentCategory___children___internal___fieldOwners = 'parentCategory___children___internal___fieldOwners',
  parentCategory___children___internal___ignoreType = 'parentCategory___children___internal___ignoreType',
  parentCategory___children___internal___mediaType = 'parentCategory___children___internal___mediaType',
  parentCategory___children___internal___owner = 'parentCategory___children___internal___owner',
  parentCategory___children___internal___type = 'parentCategory___children___internal___type',
  parentCategory___internal___content = 'parentCategory___internal___content',
  parentCategory___internal___contentDigest = 'parentCategory___internal___contentDigest',
  parentCategory___internal___description = 'parentCategory___internal___description',
  parentCategory___internal___fieldOwners = 'parentCategory___internal___fieldOwners',
  parentCategory___internal___ignoreType = 'parentCategory___internal___ignoreType',
  parentCategory___internal___mediaType = 'parentCategory___internal___mediaType',
  parentCategory___internal___owner = 'parentCategory___internal___owner',
  parentCategory___internal___type = 'parentCategory___internal___type',
  path = 'path',
  summary = 'summary',
  slug = 'slug',
  traits___traitsStringified = 'traits___traitsStringified',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ContentfulCategoryFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  parentCategory?: Maybe<ContentfulCategoryFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type ContentfulCategoryGroupConnection = {
  __typename?: 'ContentfulCategoryGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<ContentfulCategoryEdge>;
  nodes: Array<ContentfulCategory>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type ContentfulCategorySortInput = {
  fields?: Maybe<Array<Maybe<ContentfulCategoryFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Copy = {
  __typename?: 'Copy';
  id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imgSrc?: Maybe<Scalars['String']>;
};

export type CopyFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  type?: Maybe<StringQueryOperatorInput>;
  imgSrc?: Maybe<StringQueryOperatorInput>;
};

export type CopyFilterListInput = {
  elemMatch?: Maybe<CopyFilterInput>;
};


export type DateQueryOperatorInput = {
  eq?: Maybe<Scalars['Date']>;
  ne?: Maybe<Scalars['Date']>;
  gt?: Maybe<Scalars['Date']>;
  gte?: Maybe<Scalars['Date']>;
  lt?: Maybe<Scalars['Date']>;
  lte?: Maybe<Scalars['Date']>;
  in?: Maybe<Array<Maybe<Scalars['Date']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Date']>>>;
};

export type Directory = Node & {
  __typename?: 'Directory';
  sourceInstanceName: Scalars['String'];
  absolutePath: Scalars['String'];
  relativePath: Scalars['String'];
  extension: Scalars['String'];
  size: Scalars['Int'];
  prettySize: Scalars['String'];
  modifiedTime: Scalars['Date'];
  accessTime: Scalars['Date'];
  changeTime: Scalars['Date'];
  birthTime: Scalars['Date'];
  root: Scalars['String'];
  dir: Scalars['String'];
  base: Scalars['String'];
  ext: Scalars['String'];
  name: Scalars['String'];
  relativeDirectory: Scalars['String'];
  dev: Scalars['Int'];
  mode: Scalars['Int'];
  nlink: Scalars['Int'];
  uid: Scalars['Int'];
  gid: Scalars['Int'];
  rdev: Scalars['Int'];
  ino: Scalars['Float'];
  atimeMs: Scalars['Float'];
  mtimeMs: Scalars['Float'];
  ctimeMs: Scalars['Float'];
  atime: Scalars['Date'];
  mtime: Scalars['Date'];
  ctime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  blksize?: Maybe<Scalars['Int']>;
  blocks?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type DirectoryModifiedTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryAccessTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryChangeTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryBirthTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryAtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryMtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryCtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type DirectoryConnection = {
  __typename?: 'DirectoryConnection';
  totalCount: Scalars['Int'];
  edges: Array<DirectoryEdge>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<DirectoryGroupConnection>;
};


export type DirectoryConnectionDistinctArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionMaxArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionMinArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionSumArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: DirectoryFieldsEnum;
};

export type DirectoryEdge = {
  __typename?: 'DirectoryEdge';
  next?: Maybe<Directory>;
  node: Directory;
  previous?: Maybe<Directory>;
};

export enum DirectoryFieldsEnum {
  sourceInstanceName = 'sourceInstanceName',
  absolutePath = 'absolutePath',
  relativePath = 'relativePath',
  extension = 'extension',
  size = 'size',
  prettySize = 'prettySize',
  modifiedTime = 'modifiedTime',
  accessTime = 'accessTime',
  changeTime = 'changeTime',
  birthTime = 'birthTime',
  root = 'root',
  dir = 'dir',
  base = 'base',
  ext = 'ext',
  name = 'name',
  relativeDirectory = 'relativeDirectory',
  dev = 'dev',
  mode = 'mode',
  nlink = 'nlink',
  uid = 'uid',
  gid = 'gid',
  rdev = 'rdev',
  ino = 'ino',
  atimeMs = 'atimeMs',
  mtimeMs = 'mtimeMs',
  ctimeMs = 'ctimeMs',
  atime = 'atime',
  mtime = 'mtime',
  ctime = 'ctime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  blksize = 'blksize',
  blocks = 'blocks',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type DirectoryFilterInput = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  blksize?: Maybe<IntQueryOperatorInput>;
  blocks?: Maybe<IntQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type DirectoryGroupConnection = {
  __typename?: 'DirectoryGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<DirectoryEdge>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type DirectorySortInput = {
  fields?: Maybe<Array<Maybe<DirectoryFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Domain = {
  __typename?: 'Domain';
  adChoicesConfig?: Maybe<Scalars['JSON']>;
  adobeConfig?: Maybe<AdobeConfig>;
  dv360AnalyticsID?: Maybe<Scalars['String']>;
  hotJarID?: Maybe<Scalars['Int']>;
  hasVersatag?: Maybe<Scalars['Boolean']>;
  hasVKAnalytics?: Maybe<Scalars['Boolean']>;
  lang: Scalars['String'];
  languages?: Maybe<Array<Language>>;
  market: Scalars['String'];
  myTargetAnalyticsID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oneTrustAutoBlock?: Maybe<Scalars['Boolean']>;
  oneTrustId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  product: Scalars['String'];
  yandexId?: Maybe<Scalars['String']>;
};

export type DomainFilterInput = {
  adChoicesConfig?: Maybe<JsonQueryOperatorInput>;
  adobeConfig?: Maybe<AdobeConfigFilterInput>;
  dv360AnalyticsID?: Maybe<StringQueryOperatorInput>;
  hotJarID?: Maybe<IntQueryOperatorInput>;
  hasVersatag?: Maybe<BooleanQueryOperatorInput>;
  hasVKAnalytics?: Maybe<BooleanQueryOperatorInput>;
  lang?: Maybe<StringQueryOperatorInput>;
  languages?: Maybe<LanguageFilterListInput>;
  market?: Maybe<StringQueryOperatorInput>;
  myTargetAnalyticsID?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  oneTrustAutoBlock?: Maybe<BooleanQueryOperatorInput>;
  oneTrustId?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  product?: Maybe<StringQueryOperatorInput>;
  yandexId?: Maybe<StringQueryOperatorInput>;
};

export type DuotoneGradient = {
  highlight: Scalars['String'];
  shadow: Scalars['String'];
  opacity?: Maybe<Scalars['Int']>;
};

export type EmbeddedAsset = EmbeddedImage | EmbeddedVideo;

export type EmbeddedImage = {
  __typename?: 'EmbeddedImage';
  description: Scalars['String'];
  file: _File;
  title: Scalars['String'];
};

export type EmbeddedVideo = {
  __typename?: 'EmbeddedVideo';
  description: Scalars['String'];
  file: _File;
  title: Scalars['String'];
};

export type Fact = {
  __typename?: 'Fact';
  image: Media;
  summary: Scalars['String'];
  title: Scalars['String'];
};

export type FactFilterInput = {
  image?: Maybe<MediaFilterInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
};

export type FactFilterListInput = {
  elemMatch?: Maybe<FactFilterInput>;
};

export enum FieldCaptureType {
  /** The field is required */
  Required = 'Required',
  /** The field is optional */
  Optional = 'Optional',
  /** Don't show the field */
  No = 'No'
}

export type FieldCaptureTypeQueryOperatorInput = {
  eq?: Maybe<FieldCaptureType>;
  ne?: Maybe<FieldCaptureType>;
  in?: Maybe<Array<Maybe<FieldCaptureType>>>;
  nin?: Maybe<Array<Maybe<FieldCaptureType>>>;
};

export type File = Node & {
  __typename?: 'File';
  sourceInstanceName: Scalars['String'];
  absolutePath: Scalars['String'];
  relativePath: Scalars['String'];
  extension: Scalars['String'];
  size: Scalars['Int'];
  prettySize: Scalars['String'];
  modifiedTime: Scalars['Date'];
  accessTime: Scalars['Date'];
  changeTime: Scalars['Date'];
  birthTime: Scalars['Date'];
  root: Scalars['String'];
  dir: Scalars['String'];
  base: Scalars['String'];
  ext: Scalars['String'];
  name: Scalars['String'];
  relativeDirectory: Scalars['String'];
  dev: Scalars['Int'];
  mode: Scalars['Int'];
  nlink: Scalars['Int'];
  uid: Scalars['Int'];
  gid: Scalars['Int'];
  rdev: Scalars['Int'];
  ino: Scalars['Float'];
  atimeMs: Scalars['Float'];
  mtimeMs: Scalars['Float'];
  ctimeMs: Scalars['Float'];
  atime: Scalars['Date'];
  mtime: Scalars['Date'];
  ctime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  blksize?: Maybe<Scalars['Int']>;
  blocks?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  /** Copy file to static directory and return public url to it */
  publicURL?: Maybe<Scalars['String']>;
  /** Returns all children nodes filtered by type ImageSharp */
  childrenImageSharp?: Maybe<Array<Maybe<ImageSharp>>>;
  /** Returns the first child node of type ImageSharp or null if there are no children of given type on this node */
  childImageSharp?: Maybe<ImageSharp>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  videoH264?: Maybe<GatsbyVideo>;
  videoH265?: Maybe<GatsbyVideo>;
  videoVP9?: Maybe<GatsbyVideo>;
  videoWebP?: Maybe<GatsbyVideo>;
  videoGif?: Maybe<GatsbyVideo>;
  videoProfile?: Maybe<GatsbyVideo>;
};


export type FileModifiedTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileAccessTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileChangeTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileBirthTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileAtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileMtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileCtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileVideoH264Args = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Int']>;
  saturation?: Maybe<Scalars['Float']>;
  overlay?: Maybe<Scalars['String']>;
  overlayX?: Maybe<Scalars['String']>;
  overlayY?: Maybe<Scalars['String']>;
  overlayPadding?: Maybe<Scalars['Int']>;
  publicPath?: Maybe<Scalars['String']>;
  screenshots?: Maybe<Scalars['String']>;
  screenshotWidth?: Maybe<Scalars['Int']>;
  crf?: Maybe<Scalars['Int']>;
  preset?: Maybe<Scalars['String']>;
  maxRate?: Maybe<Scalars['String']>;
  bufSize?: Maybe<Scalars['String']>;
};


export type FileVideoH265Args = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Int']>;
  saturation?: Maybe<Scalars['Float']>;
  overlay?: Maybe<Scalars['String']>;
  overlayX?: Maybe<Scalars['String']>;
  overlayY?: Maybe<Scalars['String']>;
  overlayPadding?: Maybe<Scalars['Int']>;
  publicPath?: Maybe<Scalars['String']>;
  screenshots?: Maybe<Scalars['String']>;
  screenshotWidth?: Maybe<Scalars['Int']>;
  crf?: Maybe<Scalars['Int']>;
  preset?: Maybe<Scalars['String']>;
  maxRate?: Maybe<Scalars['Int']>;
  bufSize?: Maybe<Scalars['Int']>;
};


export type FileVideoVp9Args = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Int']>;
  saturation?: Maybe<Scalars['Float']>;
  overlay?: Maybe<Scalars['String']>;
  overlayX?: Maybe<Scalars['String']>;
  overlayY?: Maybe<Scalars['String']>;
  overlayPadding?: Maybe<Scalars['Int']>;
  publicPath?: Maybe<Scalars['String']>;
  screenshots?: Maybe<Scalars['String']>;
  screenshotWidth?: Maybe<Scalars['Int']>;
  crf?: Maybe<Scalars['Int']>;
  bitrate?: Maybe<Scalars['String']>;
  minrate?: Maybe<Scalars['String']>;
  maxrate?: Maybe<Scalars['String']>;
  cpuUsed?: Maybe<Scalars['Int']>;
};


export type FileVideoWebPArgs = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Int']>;
  saturation?: Maybe<Scalars['Float']>;
  overlay?: Maybe<Scalars['String']>;
  overlayX?: Maybe<Scalars['String']>;
  overlayY?: Maybe<Scalars['String']>;
  overlayPadding?: Maybe<Scalars['Int']>;
  publicPath?: Maybe<Scalars['String']>;
  screenshots?: Maybe<Scalars['String']>;
  screenshotWidth?: Maybe<Scalars['Int']>;
};


export type FileVideoGifArgs = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Int']>;
  saturation?: Maybe<Scalars['Float']>;
  overlay?: Maybe<Scalars['String']>;
  overlayX?: Maybe<Scalars['String']>;
  overlayY?: Maybe<Scalars['String']>;
  overlayPadding?: Maybe<Scalars['Int']>;
  publicPath?: Maybe<Scalars['String']>;
  screenshots?: Maybe<Scalars['String']>;
  screenshotWidth?: Maybe<Scalars['Int']>;
};


export type FileVideoProfileArgs = {
  profile?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Int']>;
  saturation?: Maybe<Scalars['Float']>;
  overlay?: Maybe<Scalars['String']>;
  overlayX?: Maybe<Scalars['String']>;
  overlayY?: Maybe<Scalars['String']>;
  overlayPadding?: Maybe<Scalars['Int']>;
  publicPath?: Maybe<Scalars['String']>;
  screenshots?: Maybe<Scalars['String']>;
  screenshotWidth?: Maybe<Scalars['Int']>;
};

export type FileConnection = {
  __typename?: 'FileConnection';
  totalCount: Scalars['Int'];
  edges: Array<FileEdge>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<FileGroupConnection>;
};


export type FileConnectionDistinctArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionMaxArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionMinArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionSumArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: FileFieldsEnum;
};

export type FileEdge = {
  __typename?: 'FileEdge';
  next?: Maybe<File>;
  node: File;
  previous?: Maybe<File>;
};

export enum FileFieldsEnum {
  sourceInstanceName = 'sourceInstanceName',
  absolutePath = 'absolutePath',
  relativePath = 'relativePath',
  extension = 'extension',
  size = 'size',
  prettySize = 'prettySize',
  modifiedTime = 'modifiedTime',
  accessTime = 'accessTime',
  changeTime = 'changeTime',
  birthTime = 'birthTime',
  root = 'root',
  dir = 'dir',
  base = 'base',
  ext = 'ext',
  name = 'name',
  relativeDirectory = 'relativeDirectory',
  dev = 'dev',
  mode = 'mode',
  nlink = 'nlink',
  uid = 'uid',
  gid = 'gid',
  rdev = 'rdev',
  ino = 'ino',
  atimeMs = 'atimeMs',
  mtimeMs = 'mtimeMs',
  ctimeMs = 'ctimeMs',
  atime = 'atime',
  mtime = 'mtime',
  ctime = 'ctime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  blksize = 'blksize',
  blocks = 'blocks',
  url = 'url',
  publicURL = 'publicURL',
  childrenImageSharp = 'childrenImageSharp',
  childrenImageSharp___fixed___base64 = 'childrenImageSharp___fixed___base64',
  childrenImageSharp___fixed___tracedSVG = 'childrenImageSharp___fixed___tracedSVG',
  childrenImageSharp___fixed___aspectRatio = 'childrenImageSharp___fixed___aspectRatio',
  childrenImageSharp___fixed___width = 'childrenImageSharp___fixed___width',
  childrenImageSharp___fixed___height = 'childrenImageSharp___fixed___height',
  childrenImageSharp___fixed___src = 'childrenImageSharp___fixed___src',
  childrenImageSharp___fixed___srcSet = 'childrenImageSharp___fixed___srcSet',
  childrenImageSharp___fixed___srcWebp = 'childrenImageSharp___fixed___srcWebp',
  childrenImageSharp___fixed___srcSetWebp = 'childrenImageSharp___fixed___srcSetWebp',
  childrenImageSharp___fixed___originalName = 'childrenImageSharp___fixed___originalName',
  childrenImageSharp___fluid___base64 = 'childrenImageSharp___fluid___base64',
  childrenImageSharp___fluid___tracedSVG = 'childrenImageSharp___fluid___tracedSVG',
  childrenImageSharp___fluid___aspectRatio = 'childrenImageSharp___fluid___aspectRatio',
  childrenImageSharp___fluid___src = 'childrenImageSharp___fluid___src',
  childrenImageSharp___fluid___srcSet = 'childrenImageSharp___fluid___srcSet',
  childrenImageSharp___fluid___srcWebp = 'childrenImageSharp___fluid___srcWebp',
  childrenImageSharp___fluid___srcSetWebp = 'childrenImageSharp___fluid___srcSetWebp',
  childrenImageSharp___fluid___sizes = 'childrenImageSharp___fluid___sizes',
  childrenImageSharp___fluid___originalImg = 'childrenImageSharp___fluid___originalImg',
  childrenImageSharp___fluid___originalName = 'childrenImageSharp___fluid___originalName',
  childrenImageSharp___fluid___presentationWidth = 'childrenImageSharp___fluid___presentationWidth',
  childrenImageSharp___fluid___presentationHeight = 'childrenImageSharp___fluid___presentationHeight',
  childrenImageSharp___gatsbyImageData = 'childrenImageSharp___gatsbyImageData',
  childrenImageSharp___original___width = 'childrenImageSharp___original___width',
  childrenImageSharp___original___height = 'childrenImageSharp___original___height',
  childrenImageSharp___original___src = 'childrenImageSharp___original___src',
  childrenImageSharp___resize___src = 'childrenImageSharp___resize___src',
  childrenImageSharp___resize___tracedSVG = 'childrenImageSharp___resize___tracedSVG',
  childrenImageSharp___resize___width = 'childrenImageSharp___resize___width',
  childrenImageSharp___resize___height = 'childrenImageSharp___resize___height',
  childrenImageSharp___resize___aspectRatio = 'childrenImageSharp___resize___aspectRatio',
  childrenImageSharp___resize___originalName = 'childrenImageSharp___resize___originalName',
  childrenImageSharp___id = 'childrenImageSharp___id',
  childrenImageSharp___parent___id = 'childrenImageSharp___parent___id',
  childrenImageSharp___parent___parent___id = 'childrenImageSharp___parent___parent___id',
  childrenImageSharp___parent___parent___children = 'childrenImageSharp___parent___parent___children',
  childrenImageSharp___parent___children = 'childrenImageSharp___parent___children',
  childrenImageSharp___parent___children___id = 'childrenImageSharp___parent___children___id',
  childrenImageSharp___parent___children___children = 'childrenImageSharp___parent___children___children',
  childrenImageSharp___parent___internal___content = 'childrenImageSharp___parent___internal___content',
  childrenImageSharp___parent___internal___contentDigest = 'childrenImageSharp___parent___internal___contentDigest',
  childrenImageSharp___parent___internal___description = 'childrenImageSharp___parent___internal___description',
  childrenImageSharp___parent___internal___fieldOwners = 'childrenImageSharp___parent___internal___fieldOwners',
  childrenImageSharp___parent___internal___ignoreType = 'childrenImageSharp___parent___internal___ignoreType',
  childrenImageSharp___parent___internal___mediaType = 'childrenImageSharp___parent___internal___mediaType',
  childrenImageSharp___parent___internal___owner = 'childrenImageSharp___parent___internal___owner',
  childrenImageSharp___parent___internal___type = 'childrenImageSharp___parent___internal___type',
  childrenImageSharp___children = 'childrenImageSharp___children',
  childrenImageSharp___children___id = 'childrenImageSharp___children___id',
  childrenImageSharp___children___parent___id = 'childrenImageSharp___children___parent___id',
  childrenImageSharp___children___parent___children = 'childrenImageSharp___children___parent___children',
  childrenImageSharp___children___children = 'childrenImageSharp___children___children',
  childrenImageSharp___children___children___id = 'childrenImageSharp___children___children___id',
  childrenImageSharp___children___children___children = 'childrenImageSharp___children___children___children',
  childrenImageSharp___children___internal___content = 'childrenImageSharp___children___internal___content',
  childrenImageSharp___children___internal___contentDigest = 'childrenImageSharp___children___internal___contentDigest',
  childrenImageSharp___children___internal___description = 'childrenImageSharp___children___internal___description',
  childrenImageSharp___children___internal___fieldOwners = 'childrenImageSharp___children___internal___fieldOwners',
  childrenImageSharp___children___internal___ignoreType = 'childrenImageSharp___children___internal___ignoreType',
  childrenImageSharp___children___internal___mediaType = 'childrenImageSharp___children___internal___mediaType',
  childrenImageSharp___children___internal___owner = 'childrenImageSharp___children___internal___owner',
  childrenImageSharp___children___internal___type = 'childrenImageSharp___children___internal___type',
  childrenImageSharp___internal___content = 'childrenImageSharp___internal___content',
  childrenImageSharp___internal___contentDigest = 'childrenImageSharp___internal___contentDigest',
  childrenImageSharp___internal___description = 'childrenImageSharp___internal___description',
  childrenImageSharp___internal___fieldOwners = 'childrenImageSharp___internal___fieldOwners',
  childrenImageSharp___internal___ignoreType = 'childrenImageSharp___internal___ignoreType',
  childrenImageSharp___internal___mediaType = 'childrenImageSharp___internal___mediaType',
  childrenImageSharp___internal___owner = 'childrenImageSharp___internal___owner',
  childrenImageSharp___internal___type = 'childrenImageSharp___internal___type',
  childImageSharp___fixed___base64 = 'childImageSharp___fixed___base64',
  childImageSharp___fixed___tracedSVG = 'childImageSharp___fixed___tracedSVG',
  childImageSharp___fixed___aspectRatio = 'childImageSharp___fixed___aspectRatio',
  childImageSharp___fixed___width = 'childImageSharp___fixed___width',
  childImageSharp___fixed___height = 'childImageSharp___fixed___height',
  childImageSharp___fixed___src = 'childImageSharp___fixed___src',
  childImageSharp___fixed___srcSet = 'childImageSharp___fixed___srcSet',
  childImageSharp___fixed___srcWebp = 'childImageSharp___fixed___srcWebp',
  childImageSharp___fixed___srcSetWebp = 'childImageSharp___fixed___srcSetWebp',
  childImageSharp___fixed___originalName = 'childImageSharp___fixed___originalName',
  childImageSharp___fluid___base64 = 'childImageSharp___fluid___base64',
  childImageSharp___fluid___tracedSVG = 'childImageSharp___fluid___tracedSVG',
  childImageSharp___fluid___aspectRatio = 'childImageSharp___fluid___aspectRatio',
  childImageSharp___fluid___src = 'childImageSharp___fluid___src',
  childImageSharp___fluid___srcSet = 'childImageSharp___fluid___srcSet',
  childImageSharp___fluid___srcWebp = 'childImageSharp___fluid___srcWebp',
  childImageSharp___fluid___srcSetWebp = 'childImageSharp___fluid___srcSetWebp',
  childImageSharp___fluid___sizes = 'childImageSharp___fluid___sizes',
  childImageSharp___fluid___originalImg = 'childImageSharp___fluid___originalImg',
  childImageSharp___fluid___originalName = 'childImageSharp___fluid___originalName',
  childImageSharp___fluid___presentationWidth = 'childImageSharp___fluid___presentationWidth',
  childImageSharp___fluid___presentationHeight = 'childImageSharp___fluid___presentationHeight',
  childImageSharp___gatsbyImageData = 'childImageSharp___gatsbyImageData',
  childImageSharp___original___width = 'childImageSharp___original___width',
  childImageSharp___original___height = 'childImageSharp___original___height',
  childImageSharp___original___src = 'childImageSharp___original___src',
  childImageSharp___resize___src = 'childImageSharp___resize___src',
  childImageSharp___resize___tracedSVG = 'childImageSharp___resize___tracedSVG',
  childImageSharp___resize___width = 'childImageSharp___resize___width',
  childImageSharp___resize___height = 'childImageSharp___resize___height',
  childImageSharp___resize___aspectRatio = 'childImageSharp___resize___aspectRatio',
  childImageSharp___resize___originalName = 'childImageSharp___resize___originalName',
  childImageSharp___id = 'childImageSharp___id',
  childImageSharp___parent___id = 'childImageSharp___parent___id',
  childImageSharp___parent___parent___id = 'childImageSharp___parent___parent___id',
  childImageSharp___parent___parent___children = 'childImageSharp___parent___parent___children',
  childImageSharp___parent___children = 'childImageSharp___parent___children',
  childImageSharp___parent___children___id = 'childImageSharp___parent___children___id',
  childImageSharp___parent___children___children = 'childImageSharp___parent___children___children',
  childImageSharp___parent___internal___content = 'childImageSharp___parent___internal___content',
  childImageSharp___parent___internal___contentDigest = 'childImageSharp___parent___internal___contentDigest',
  childImageSharp___parent___internal___description = 'childImageSharp___parent___internal___description',
  childImageSharp___parent___internal___fieldOwners = 'childImageSharp___parent___internal___fieldOwners',
  childImageSharp___parent___internal___ignoreType = 'childImageSharp___parent___internal___ignoreType',
  childImageSharp___parent___internal___mediaType = 'childImageSharp___parent___internal___mediaType',
  childImageSharp___parent___internal___owner = 'childImageSharp___parent___internal___owner',
  childImageSharp___parent___internal___type = 'childImageSharp___parent___internal___type',
  childImageSharp___children = 'childImageSharp___children',
  childImageSharp___children___id = 'childImageSharp___children___id',
  childImageSharp___children___parent___id = 'childImageSharp___children___parent___id',
  childImageSharp___children___parent___children = 'childImageSharp___children___parent___children',
  childImageSharp___children___children = 'childImageSharp___children___children',
  childImageSharp___children___children___id = 'childImageSharp___children___children___id',
  childImageSharp___children___children___children = 'childImageSharp___children___children___children',
  childImageSharp___children___internal___content = 'childImageSharp___children___internal___content',
  childImageSharp___children___internal___contentDigest = 'childImageSharp___children___internal___contentDigest',
  childImageSharp___children___internal___description = 'childImageSharp___children___internal___description',
  childImageSharp___children___internal___fieldOwners = 'childImageSharp___children___internal___fieldOwners',
  childImageSharp___children___internal___ignoreType = 'childImageSharp___children___internal___ignoreType',
  childImageSharp___children___internal___mediaType = 'childImageSharp___children___internal___mediaType',
  childImageSharp___children___internal___owner = 'childImageSharp___children___internal___owner',
  childImageSharp___children___internal___type = 'childImageSharp___children___internal___type',
  childImageSharp___internal___content = 'childImageSharp___internal___content',
  childImageSharp___internal___contentDigest = 'childImageSharp___internal___contentDigest',
  childImageSharp___internal___description = 'childImageSharp___internal___description',
  childImageSharp___internal___fieldOwners = 'childImageSharp___internal___fieldOwners',
  childImageSharp___internal___ignoreType = 'childImageSharp___internal___ignoreType',
  childImageSharp___internal___mediaType = 'childImageSharp___internal___mediaType',
  childImageSharp___internal___owner = 'childImageSharp___internal___owner',
  childImageSharp___internal___type = 'childImageSharp___internal___type',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type FileFilterInput = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  blksize?: Maybe<IntQueryOperatorInput>;
  blocks?: Maybe<IntQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  publicURL?: Maybe<StringQueryOperatorInput>;
  childrenImageSharp?: Maybe<ImageSharpFilterListInput>;
  childImageSharp?: Maybe<ImageSharpFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type FileGroupConnection = {
  __typename?: 'FileGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<FileEdge>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type FileSortInput = {
  fields?: Maybe<Array<Maybe<FileFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type FloatQueryOperatorInput = {
  eq?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type FooterLink = Hyperlink | ContentfulArticle | ContentfulCategory | ContactUs | Message | Product | Sitemap | SustainabilityCategory | SustainabilityLandingPage | Topic;

export type GatsbyVideo = {
  __typename?: 'GatsbyVideo';
  path?: Maybe<Scalars['String']>;
  absolutePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  codec?: Maybe<Scalars['String']>;
  formatName?: Maybe<Scalars['String']>;
  formatLongName?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Int']>;
  bitRate?: Maybe<Scalars['Int']>;
  screenshots?: Maybe<Array<Maybe<GatsbyVideoScreenshot>>>;
};

export type GatsbyVideoScreenshot = {
  __typename?: 'GatsbyVideoScreenshot';
  path?: Maybe<Scalars['String']>;
  absolutePath?: Maybe<Scalars['String']>;
};

export type HomeVideo = {
  __typename?: 'HomeVideo';
  description: Scalars['String'];
  title: Scalars['String'];
  video: File;
  videoPoster: File;
};

export type HomeVideoFilterInput = {
  description?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  video?: Maybe<FileFilterInput>;
  videoPoster?: Maybe<FileFilterInput>;
};

export type Html = {
  __typename?: 'Html';
  html: Scalars['String'];
  json: Scalars['String'];
  text: Scalars['String'];
};

export type HtmlFilterInput = {
  html?: Maybe<StringQueryOperatorInput>;
  json?: Maybe<StringQueryOperatorInput>;
  text?: Maybe<StringQueryOperatorInput>;
};

export type Hyperlink = {
  __typename?: 'Hyperlink';
  id: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type HyperlinkFilterInput = {
  id?: Maybe<IdQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
};

export type HyperlinkFilterListInput = {
  elemMatch?: Maybe<HyperlinkFilterInput>;
};

export type IdQueryOperatorInput = {
  eq?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  nin?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export enum ImageCropFocus {
  CENTER = 'CENTER',
  NORTH = 'NORTH',
  NORTHEAST = 'NORTHEAST',
  EAST = 'EAST',
  SOUTHEAST = 'SOUTHEAST',
  SOUTH = 'SOUTH',
  SOUTHWEST = 'SOUTHWEST',
  WEST = 'WEST',
  NORTHWEST = 'NORTHWEST',
  ENTROPY = 'ENTROPY',
  ATTENTION = 'ATTENTION'
}

export enum ImageFit {
  COVER = 'COVER',
  CONTAIN = 'CONTAIN',
  FILL = 'FILL',
  INSIDE = 'INSIDE',
  OUTSIDE = 'OUTSIDE'
}

export enum ImageFormat {
  NO_CHANGE = 'NO_CHANGE',
  AUTO = 'AUTO',
  JPG = 'JPG',
  PNG = 'PNG',
  WEBP = 'WEBP',
  AVIF = 'AVIF'
}

export enum ImageLayout {
  FIXED = 'FIXED',
  FULL_WIDTH = 'FULL_WIDTH',
  CONSTRAINED = 'CONSTRAINED'
}

export enum ImagePlaceholder {
  DOMINANT_COLOR = 'DOMINANT_COLOR',
  TRACED_SVG = 'TRACED_SVG',
  BLURRED = 'BLURRED',
  NONE = 'NONE'
}

export type ImageSharp = Node & {
  __typename?: 'ImageSharp';
  fixed?: Maybe<ImageSharpFixed>;
  fluid?: Maybe<ImageSharpFluid>;
  gatsbyImageData: Scalars['JSON'];
  original?: Maybe<ImageSharpOriginal>;
  resize?: Maybe<ImageSharpResize>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type ImageSharpFixedArgs = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  base64Width?: Maybe<Scalars['Int']>;
  jpegProgressive?: Maybe<Scalars['Boolean']>;
  pngCompressionSpeed?: Maybe<Scalars['Int']>;
  grayscale?: Maybe<Scalars['Boolean']>;
  duotone?: Maybe<DuotoneGradient>;
  traceSVG?: Maybe<Potrace>;
  quality?: Maybe<Scalars['Int']>;
  jpegQuality?: Maybe<Scalars['Int']>;
  pngQuality?: Maybe<Scalars['Int']>;
  webpQuality?: Maybe<Scalars['Int']>;
  toFormat?: Maybe<ImageFormat>;
  toFormatBase64?: Maybe<ImageFormat>;
  cropFocus?: Maybe<ImageCropFocus>;
  fit?: Maybe<ImageFit>;
  background?: Maybe<Scalars['String']>;
  rotate?: Maybe<Scalars['Int']>;
  trim?: Maybe<Scalars['Float']>;
};


export type ImageSharpFluidArgs = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  base64Width?: Maybe<Scalars['Int']>;
  grayscale?: Maybe<Scalars['Boolean']>;
  jpegProgressive?: Maybe<Scalars['Boolean']>;
  pngCompressionSpeed?: Maybe<Scalars['Int']>;
  duotone?: Maybe<DuotoneGradient>;
  traceSVG?: Maybe<Potrace>;
  quality?: Maybe<Scalars['Int']>;
  jpegQuality?: Maybe<Scalars['Int']>;
  pngQuality?: Maybe<Scalars['Int']>;
  webpQuality?: Maybe<Scalars['Int']>;
  toFormat?: Maybe<ImageFormat>;
  toFormatBase64?: Maybe<ImageFormat>;
  cropFocus?: Maybe<ImageCropFocus>;
  fit?: Maybe<ImageFit>;
  background?: Maybe<Scalars['String']>;
  rotate?: Maybe<Scalars['Int']>;
  trim?: Maybe<Scalars['Float']>;
  sizes?: Maybe<Scalars['String']>;
  srcSetBreakpoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
};


export type ImageSharpGatsbyImageDataArgs = {
  layout?: Maybe<ImageLayout>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  placeholder?: Maybe<ImagePlaceholder>;
  blurredOptions?: Maybe<BlurredOptions>;
  tracedSVGOptions?: Maybe<Potrace>;
  formats?: Maybe<Array<Maybe<ImageFormat>>>;
  outputPixelDensities?: Maybe<Array<Maybe<Scalars['Float']>>>;
  breakpoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
  sizes?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['Int']>;
  jpgOptions?: Maybe<JpgOptions>;
  pngOptions?: Maybe<PngOptions>;
  webpOptions?: Maybe<WebPOptions>;
  avifOptions?: Maybe<AvifOptions>;
  transformOptions?: Maybe<TransformOptions>;
  backgroundColor?: Maybe<Scalars['String']>;
};


export type ImageSharpResizeArgs = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  quality?: Maybe<Scalars['Int']>;
  jpegQuality?: Maybe<Scalars['Int']>;
  pngQuality?: Maybe<Scalars['Int']>;
  webpQuality?: Maybe<Scalars['Int']>;
  jpegProgressive?: Maybe<Scalars['Boolean']>;
  pngCompressionLevel?: Maybe<Scalars['Int']>;
  pngCompressionSpeed?: Maybe<Scalars['Int']>;
  grayscale?: Maybe<Scalars['Boolean']>;
  duotone?: Maybe<DuotoneGradient>;
  base64?: Maybe<Scalars['Boolean']>;
  traceSVG?: Maybe<Potrace>;
  toFormat?: Maybe<ImageFormat>;
  cropFocus?: Maybe<ImageCropFocus>;
  fit?: Maybe<ImageFit>;
  background?: Maybe<Scalars['String']>;
  rotate?: Maybe<Scalars['Int']>;
  trim?: Maybe<Scalars['Float']>;
};

export type ImageSharpConnection = {
  __typename?: 'ImageSharpConnection';
  totalCount: Scalars['Int'];
  edges: Array<ImageSharpEdge>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ImageSharpGroupConnection>;
};


export type ImageSharpConnectionDistinctArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionMaxArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionMinArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionSumArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: ImageSharpFieldsEnum;
};

export type ImageSharpEdge = {
  __typename?: 'ImageSharpEdge';
  next?: Maybe<ImageSharp>;
  node: ImageSharp;
  previous?: Maybe<ImageSharp>;
};

export enum ImageSharpFieldsEnum {
  fixed___base64 = 'fixed___base64',
  fixed___tracedSVG = 'fixed___tracedSVG',
  fixed___aspectRatio = 'fixed___aspectRatio',
  fixed___width = 'fixed___width',
  fixed___height = 'fixed___height',
  fixed___src = 'fixed___src',
  fixed___srcSet = 'fixed___srcSet',
  fixed___srcWebp = 'fixed___srcWebp',
  fixed___srcSetWebp = 'fixed___srcSetWebp',
  fixed___originalName = 'fixed___originalName',
  fluid___base64 = 'fluid___base64',
  fluid___tracedSVG = 'fluid___tracedSVG',
  fluid___aspectRatio = 'fluid___aspectRatio',
  fluid___src = 'fluid___src',
  fluid___srcSet = 'fluid___srcSet',
  fluid___srcWebp = 'fluid___srcWebp',
  fluid___srcSetWebp = 'fluid___srcSetWebp',
  fluid___sizes = 'fluid___sizes',
  fluid___originalImg = 'fluid___originalImg',
  fluid___originalName = 'fluid___originalName',
  fluid___presentationWidth = 'fluid___presentationWidth',
  fluid___presentationHeight = 'fluid___presentationHeight',
  gatsbyImageData = 'gatsbyImageData',
  original___width = 'original___width',
  original___height = 'original___height',
  original___src = 'original___src',
  resize___src = 'resize___src',
  resize___tracedSVG = 'resize___tracedSVG',
  resize___width = 'resize___width',
  resize___height = 'resize___height',
  resize___aspectRatio = 'resize___aspectRatio',
  resize___originalName = 'resize___originalName',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ImageSharpFilterInput = {
  fixed?: Maybe<ImageSharpFixedFilterInput>;
  fluid?: Maybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: Maybe<JsonQueryOperatorInput>;
  original?: Maybe<ImageSharpOriginalFilterInput>;
  resize?: Maybe<ImageSharpResizeFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type ImageSharpFilterListInput = {
  elemMatch?: Maybe<ImageSharpFilterInput>;
};

export type ImageSharpFixed = {
  __typename?: 'ImageSharpFixed';
  base64?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  width: Scalars['Float'];
  height: Scalars['Float'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcWebp?: Maybe<Scalars['String']>;
  srcSetWebp?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
};

export type ImageSharpFixedFilterInput = {
  base64?: Maybe<StringQueryOperatorInput>;
  tracedSVG?: Maybe<StringQueryOperatorInput>;
  aspectRatio?: Maybe<FloatQueryOperatorInput>;
  width?: Maybe<FloatQueryOperatorInput>;
  height?: Maybe<FloatQueryOperatorInput>;
  src?: Maybe<StringQueryOperatorInput>;
  srcSet?: Maybe<StringQueryOperatorInput>;
  srcWebp?: Maybe<StringQueryOperatorInput>;
  srcSetWebp?: Maybe<StringQueryOperatorInput>;
  originalName?: Maybe<StringQueryOperatorInput>;
};

export type ImageSharpFluid = {
  __typename?: 'ImageSharpFluid';
  base64?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  aspectRatio: Scalars['Float'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcWebp?: Maybe<Scalars['String']>;
  srcSetWebp?: Maybe<Scalars['String']>;
  sizes: Scalars['String'];
  originalImg?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  presentationWidth: Scalars['Int'];
  presentationHeight: Scalars['Int'];
};

export type ImageSharpFluidFilterInput = {
  base64?: Maybe<StringQueryOperatorInput>;
  tracedSVG?: Maybe<StringQueryOperatorInput>;
  aspectRatio?: Maybe<FloatQueryOperatorInput>;
  src?: Maybe<StringQueryOperatorInput>;
  srcSet?: Maybe<StringQueryOperatorInput>;
  srcWebp?: Maybe<StringQueryOperatorInput>;
  srcSetWebp?: Maybe<StringQueryOperatorInput>;
  sizes?: Maybe<StringQueryOperatorInput>;
  originalImg?: Maybe<StringQueryOperatorInput>;
  originalName?: Maybe<StringQueryOperatorInput>;
  presentationWidth?: Maybe<IntQueryOperatorInput>;
  presentationHeight?: Maybe<IntQueryOperatorInput>;
};

export type ImageSharpGroupConnection = {
  __typename?: 'ImageSharpGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<ImageSharpEdge>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type ImageSharpOriginal = {
  __typename?: 'ImageSharpOriginal';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  src?: Maybe<Scalars['String']>;
};

export type ImageSharpOriginalFilterInput = {
  width?: Maybe<FloatQueryOperatorInput>;
  height?: Maybe<FloatQueryOperatorInput>;
  src?: Maybe<StringQueryOperatorInput>;
};

export type ImageSharpResize = {
  __typename?: 'ImageSharpResize';
  src?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  originalName?: Maybe<Scalars['String']>;
};

export type ImageSharpResizeFilterInput = {
  src?: Maybe<StringQueryOperatorInput>;
  tracedSVG?: Maybe<StringQueryOperatorInput>;
  width?: Maybe<IntQueryOperatorInput>;
  height?: Maybe<IntQueryOperatorInput>;
  aspectRatio?: Maybe<FloatQueryOperatorInput>;
  originalName?: Maybe<StringQueryOperatorInput>;
};

export type ImageSharpSortInput = {
  fields?: Maybe<Array<Maybe<ImageSharpFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type IntQueryOperatorInput = {
  eq?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type Internal = {
  __typename?: 'Internal';
  content?: Maybe<Scalars['String']>;
  contentDigest: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fieldOwners?: Maybe<Array<Maybe<Scalars['String']>>>;
  ignoreType?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  type: Scalars['String'];
};

export type InternalFilterInput = {
  content?: Maybe<StringQueryOperatorInput>;
  contentDigest?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  fieldOwners?: Maybe<StringQueryOperatorInput>;
  ignoreType?: Maybe<BooleanQueryOperatorInput>;
  mediaType?: Maybe<StringQueryOperatorInput>;
  owner?: Maybe<StringQueryOperatorInput>;
  type?: Maybe<StringQueryOperatorInput>;
};

export type JpgOptions = {
  quality?: Maybe<Scalars['Int']>;
  progressive?: Maybe<Scalars['Boolean']>;
};


export type JsonQueryOperatorInput = {
  eq?: Maybe<Scalars['JSON']>;
  ne?: Maybe<Scalars['JSON']>;
  in?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  nin?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  regex?: Maybe<Scalars['JSON']>;
  glob?: Maybe<Scalars['JSON']>;
};

export type KritiqueRating = {
  __typename?: 'KritiqueRating';
  averageRating: Scalars['Float'];
  reviewCount: Scalars['Int'];
  reviews: Array<Maybe<KritiqueReview>>;
};

export type KritiqueRatingFilterInput = {
  averageRating?: Maybe<FloatQueryOperatorInput>;
  reviewCount?: Maybe<IntQueryOperatorInput>;
  reviews?: Maybe<KritiqueReviewFilterListInput>;
};

export type KritiqueReview = {
  __typename?: 'KritiqueReview';
  id: Scalars['ID'];
  comment: Scalars['String'];
  contributor: Scalars['String'];
  rating: Scalars['Int'];
};

export type KritiqueReviewFilterInput = {
  id?: Maybe<IdQueryOperatorInput>;
  comment?: Maybe<StringQueryOperatorInput>;
  contributor?: Maybe<StringQueryOperatorInput>;
  rating?: Maybe<IntQueryOperatorInput>;
};

export type KritiqueReviewFilterListInput = {
  elemMatch?: Maybe<KritiqueReviewFilterInput>;
};

export type Language = {
  __typename?: 'Language';
  locale: Locale;
  name: Scalars['String'];
  path: Scalars['String'];
};

export type LanguageFilterInput = {
  locale?: Maybe<LocaleQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
};

export type LanguageFilterListInput = {
  elemMatch?: Maybe<LanguageFilterInput>;
};

export type Legals = {
  __typename?: 'Legals';
  additionalMessages?: Maybe<Array<Maybe<Message>>>;
  blurb?: Maybe<Html>;
  contactUsLabel?: Maybe<Scalars['String']>;
  contactUsUrl?: Maybe<Scalars['String']>;
  cookieNoticeLabel: Scalars['String'];
  cookieNoticeUrl: Scalars['String'];
  legalWarningLabel?: Maybe<Scalars['String']>;
  legalWarningUrl?: Maybe<Scalars['String']>;
  privacyNoticeLabel: Scalars['String'];
  privacyNoticeUrl: Scalars['String'];
  protectionOfPersonalDataLabel?: Maybe<Scalars['String']>;
  protectionOfPersonalDataUrl?: Maybe<Scalars['String']>;
  termsOfUseLabel?: Maybe<Scalars['String']>;
  termsOfUseUrl?: Maybe<Scalars['String']>;
  whatsInOurProductsLabel?: Maybe<Scalars['String']>;
  whatsInOurProductsUrl?: Maybe<Scalars['String']>;
};

export type LegalsFilterInput = {
  additionalMessages?: Maybe<MessageFilterListInput>;
  blurb?: Maybe<HtmlFilterInput>;
  contactUsLabel?: Maybe<StringQueryOperatorInput>;
  contactUsUrl?: Maybe<StringQueryOperatorInput>;
  cookieNoticeLabel?: Maybe<StringQueryOperatorInput>;
  cookieNoticeUrl?: Maybe<StringQueryOperatorInput>;
  legalWarningLabel?: Maybe<StringQueryOperatorInput>;
  legalWarningUrl?: Maybe<StringQueryOperatorInput>;
  privacyNoticeLabel?: Maybe<StringQueryOperatorInput>;
  privacyNoticeUrl?: Maybe<StringQueryOperatorInput>;
  protectionOfPersonalDataLabel?: Maybe<StringQueryOperatorInput>;
  protectionOfPersonalDataUrl?: Maybe<StringQueryOperatorInput>;
  termsOfUseLabel?: Maybe<StringQueryOperatorInput>;
  termsOfUseUrl?: Maybe<StringQueryOperatorInput>;
  whatsInOurProductsLabel?: Maybe<StringQueryOperatorInput>;
  whatsInOurProductsUrl?: Maybe<StringQueryOperatorInput>;
};

export type Lexicon = {
  __typename?: 'Lexicon';
  benefits?: Maybe<Scalars['String']>;
  buyItNow?: Maybe<Scalars['String']>;
  certificates?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  facts?: Maybe<Scalars['String']>;
  home?: Maybe<Scalars['String']>;
  howToUseHeading?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Scalars['String']>;
  opensInNewTab?: Maybe<Scalars['String']>;
  pageNotFoundText?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  ratingFormatString?: Maybe<Scalars['String']>;
  readMore?: Maybe<Scalars['String']>;
  reviewCountFormatString?: Maybe<Scalars['String']>;
  reviewsHeading?: Maybe<Scalars['String']>;
  share?: Maybe<Scalars['String']>;
  skipToContent?: Maybe<Scalars['String']>;
  socialTitle?: Maybe<Scalars['String']>;
};

export type LexiconFilterInput = {
  benefits?: Maybe<StringQueryOperatorInput>;
  buyItNow?: Maybe<StringQueryOperatorInput>;
  certificates?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  facts?: Maybe<StringQueryOperatorInput>;
  home?: Maybe<StringQueryOperatorInput>;
  howToUseHeading?: Maybe<StringQueryOperatorInput>;
  ingredients?: Maybe<StringQueryOperatorInput>;
  opensInNewTab?: Maybe<StringQueryOperatorInput>;
  pageNotFoundText?: Maybe<StringQueryOperatorInput>;
  products?: Maybe<StringQueryOperatorInput>;
  ratingFormatString?: Maybe<StringQueryOperatorInput>;
  readMore?: Maybe<StringQueryOperatorInput>;
  reviewCountFormatString?: Maybe<StringQueryOperatorInput>;
  reviewsHeading?: Maybe<StringQueryOperatorInput>;
  share?: Maybe<StringQueryOperatorInput>;
  skipToContent?: Maybe<StringQueryOperatorInput>;
  socialTitle?: Maybe<StringQueryOperatorInput>;
};

export enum Locale {
  EN_GB = 'EN_GB',
  FR_FR = 'FR_FR'
}

export type LocaleQueryOperatorInput = {
  eq?: Maybe<Locale>;
  ne?: Maybe<Locale>;
  in?: Maybe<Array<Maybe<Locale>>>;
  nin?: Maybe<Array<Maybe<Locale>>>;
};

export type Main = {
  __typename?: 'Main';
  assets: Array<EmbeddedAsset>;
  htmlTruncated: Scalars['String'];
  html: Scalars['String'];
  rawContent: Scalars['JSON'];
  text: Scalars['String'];
};

export type MainFilterInput = {
  htmlTruncated?: Maybe<StringQueryOperatorInput>;
  html?: Maybe<StringQueryOperatorInput>;
  rawContent?: Maybe<JsonQueryOperatorInput>;
  text?: Maybe<StringQueryOperatorInput>;
};

export type Media = {
  __typename?: 'Media';
  description?: Maybe<Scalars['String']>;
  file?: Maybe<_File>;
  title?: Maybe<Scalars['String']>;
};

export type MediaFilterInput = {
  description?: Maybe<StringQueryOperatorInput>;
  file?: Maybe<_FileFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
};

/** Represent a link to be shown in the navigation */
export type NavLink = {
  __typename?: 'NavLink';
  path: Scalars['String'];
  title: Scalars['String'];
};

export type NavLinkFilterInput = {
  path?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
};

export type NavLinkFilterListInput = {
  elemMatch?: Maybe<NavLinkFilterInput>;
};

/** Node Interface */
export type Node = {
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type NodeFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type NodeFilterListInput = {
  elemMatch?: Maybe<NodeFilterInput>;
};

export type PngOptions = {
  quality?: Maybe<Scalars['Int']>;
  compressionSpeed?: Maybe<Scalars['Int']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int'];
  hasPreviousPage: Scalars['Boolean'];
  hasNextPage: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type Potrace = {
  turnPolicy?: Maybe<PotraceTurnPolicy>;
  turdSize?: Maybe<Scalars['Float']>;
  alphaMax?: Maybe<Scalars['Float']>;
  optCurve?: Maybe<Scalars['Boolean']>;
  optTolerance?: Maybe<Scalars['Float']>;
  threshold?: Maybe<Scalars['Int']>;
  blackOnWhite?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
};

export enum PotraceTurnPolicy {
  TURNPOLICY_BLACK = 'TURNPOLICY_BLACK',
  TURNPOLICY_WHITE = 'TURNPOLICY_WHITE',
  TURNPOLICY_LEFT = 'TURNPOLICY_LEFT',
  TURNPOLICY_RIGHT = 'TURNPOLICY_RIGHT',
  TURNPOLICY_MINORITY = 'TURNPOLICY_MINORITY',
  TURNPOLICY_MAJORITY = 'TURNPOLICY_MAJORITY'
}

export type Product = Node & {
  __typename?: 'Product';
  absolutePath: Scalars['String'];
  benefits: Array<Scalars['String']>;
  benefitsDisclaimer?: Maybe<Scalars['String']>;
  description: Main;
  hero: Media;
  howToUse?: Maybe<Html>;
  main?: Maybe<Main>;
  metaDescription?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pageTitle: Scalars['String'];
  pageType: Scalars['String'];
  parentMessage?: Maybe<Message>;
  path: Scalars['String'];
  slug: Scalars['String'];
  summaryBackground?: Maybe<Media>;
  traits?: Maybe<Traits>;
  variants: Array<Variant>;
  fields?: Maybe<ProductFields>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  totalCount: Scalars['Int'];
  edges: Array<ProductEdge>;
  nodes: Array<Product>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ProductGroupConnection>;
};


export type ProductConnectionDistinctArgs = {
  field: ProductFieldsEnum;
};


export type ProductConnectionMaxArgs = {
  field: ProductFieldsEnum;
};


export type ProductConnectionMinArgs = {
  field: ProductFieldsEnum;
};


export type ProductConnectionSumArgs = {
  field: ProductFieldsEnum;
};


export type ProductConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: ProductFieldsEnum;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  next?: Maybe<Product>;
  node: Product;
  previous?: Maybe<Product>;
};

export type ProductFields = {
  __typename?: 'ProductFields';
  kritiqueRating?: Maybe<KritiqueRating>;
};

export enum ProductFieldsEnum {
  absolutePath = 'absolutePath',
  benefits = 'benefits',
  benefitsDisclaimer = 'benefitsDisclaimer',
  description___htmlTruncated = 'description___htmlTruncated',
  description___html = 'description___html',
  description___rawContent = 'description___rawContent',
  description___text = 'description___text',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  howToUse___html = 'howToUse___html',
  howToUse___json = 'howToUse___json',
  howToUse___text = 'howToUse___text',
  main___htmlTruncated = 'main___htmlTruncated',
  main___html = 'main___html',
  main___rawContent = 'main___rawContent',
  main___text = 'main___text',
  metaDescription = 'metaDescription',
  name = 'name',
  pageTitle = 'pageTitle',
  pageType = 'pageType',
  parentMessage___absolutePath = 'parentMessage___absolutePath',
  parentMessage___benefitImages = 'parentMessage___benefitImages',
  parentMessage___benefitImages___description = 'parentMessage___benefitImages___description',
  parentMessage___benefitImages___file___url = 'parentMessage___benefitImages___file___url',
  parentMessage___benefits = 'parentMessage___benefits',
  parentMessage___benefitsDisclaimer = 'parentMessage___benefitsDisclaimer',
  parentMessage___certificate = 'parentMessage___certificate',
  parentMessage___certificate___image___description = 'parentMessage___certificate___image___description',
  parentMessage___certificate___image___title = 'parentMessage___certificate___image___title',
  parentMessage___certificate___title = 'parentMessage___certificate___title',
  parentMessage___certificate___url = 'parentMessage___certificate___url',
  parentMessage___facts = 'parentMessage___facts',
  parentMessage___facts___image___description = 'parentMessage___facts___image___description',
  parentMessage___facts___image___title = 'parentMessage___facts___image___title',
  parentMessage___facts___summary = 'parentMessage___facts___summary',
  parentMessage___facts___title = 'parentMessage___facts___title',
  parentMessage___hero___description = 'parentMessage___hero___description',
  parentMessage___hero___file___url = 'parentMessage___hero___file___url',
  parentMessage___hero___title = 'parentMessage___hero___title',
  parentMessage___heroVideo___description = 'parentMessage___heroVideo___description',
  parentMessage___heroVideo___file___url = 'parentMessage___heroVideo___file___url',
  parentMessage___heroVideo___title = 'parentMessage___heroVideo___title',
  parentMessage___main___htmlTruncated = 'parentMessage___main___htmlTruncated',
  parentMessage___main___html = 'parentMessage___main___html',
  parentMessage___main___rawContent = 'parentMessage___main___rawContent',
  parentMessage___main___text = 'parentMessage___main___text',
  parentMessage___metaDescription = 'parentMessage___metaDescription',
  parentMessage___pageTitle = 'parentMessage___pageTitle',
  parentMessage___pageType = 'parentMessage___pageType',
  parentMessage___parentTopic___absolutePath = 'parentMessage___parentTopic___absolutePath',
  parentMessage___parentTopic___hero___description = 'parentMessage___parentTopic___hero___description',
  parentMessage___parentTopic___hero___title = 'parentMessage___parentTopic___hero___title',
  parentMessage___parentTopic___messagesNodes = 'parentMessage___parentTopic___messagesNodes',
  parentMessage___parentTopic___messagesNodes___absolutePath = 'parentMessage___parentTopic___messagesNodes___absolutePath',
  parentMessage___parentTopic___messagesNodes___benefitImages = 'parentMessage___parentTopic___messagesNodes___benefitImages',
  parentMessage___parentTopic___messagesNodes___benefits = 'parentMessage___parentTopic___messagesNodes___benefits',
  parentMessage___parentTopic___messagesNodes___benefitsDisclaimer = 'parentMessage___parentTopic___messagesNodes___benefitsDisclaimer',
  parentMessage___parentTopic___messagesNodes___certificate = 'parentMessage___parentTopic___messagesNodes___certificate',
  parentMessage___parentTopic___messagesNodes___facts = 'parentMessage___parentTopic___messagesNodes___facts',
  parentMessage___parentTopic___messagesNodes___metaDescription = 'parentMessage___parentTopic___messagesNodes___metaDescription',
  parentMessage___parentTopic___messagesNodes___pageTitle = 'parentMessage___parentTopic___messagesNodes___pageTitle',
  parentMessage___parentTopic___messagesNodes___pageType = 'parentMessage___parentTopic___messagesNodes___pageType',
  parentMessage___parentTopic___messagesNodes___path = 'parentMessage___parentTopic___messagesNodes___path',
  parentMessage___parentTopic___messagesNodes___product = 'parentMessage___parentTopic___messagesNodes___product',
  parentMessage___parentTopic___messagesNodes___productsNodes = 'parentMessage___parentTopic___messagesNodes___productsNodes',
  parentMessage___parentTopic___messagesNodes___slug = 'parentMessage___parentTopic___messagesNodes___slug',
  parentMessage___parentTopic___messagesNodes___summary = 'parentMessage___parentTopic___messagesNodes___summary',
  parentMessage___parentTopic___messagesNodes___title = 'parentMessage___parentTopic___messagesNodes___title',
  parentMessage___parentTopic___messagesNodes___id = 'parentMessage___parentTopic___messagesNodes___id',
  parentMessage___parentTopic___messagesNodes___children = 'parentMessage___parentTopic___messagesNodes___children',
  parentMessage___parentTopic___metaDescription = 'parentMessage___parentTopic___metaDescription',
  parentMessage___parentTopic___navigationTitle = 'parentMessage___parentTopic___navigationTitle',
  parentMessage___parentTopic___topicDisclaimer = 'parentMessage___parentTopic___topicDisclaimer',
  parentMessage___parentTopic___pageTitle = 'parentMessage___parentTopic___pageTitle',
  parentMessage___parentTopic___pageType = 'parentMessage___parentTopic___pageType',
  parentMessage___parentTopic___path = 'parentMessage___parentTopic___path',
  parentMessage___parentTopic___slug = 'parentMessage___parentTopic___slug',
  parentMessage___parentTopic___summary = 'parentMessage___parentTopic___summary',
  parentMessage___parentTopic___title = 'parentMessage___parentTopic___title',
  parentMessage___parentTopic___traits___traitsStringified = 'parentMessage___parentTopic___traits___traitsStringified',
  parentMessage___parentTopic___id = 'parentMessage___parentTopic___id',
  parentMessage___parentTopic___parent___id = 'parentMessage___parentTopic___parent___id',
  parentMessage___parentTopic___parent___children = 'parentMessage___parentTopic___parent___children',
  parentMessage___parentTopic___children = 'parentMessage___parentTopic___children',
  parentMessage___parentTopic___children___id = 'parentMessage___parentTopic___children___id',
  parentMessage___parentTopic___children___children = 'parentMessage___parentTopic___children___children',
  parentMessage___parentTopic___internal___content = 'parentMessage___parentTopic___internal___content',
  parentMessage___parentTopic___internal___contentDigest = 'parentMessage___parentTopic___internal___contentDigest',
  parentMessage___parentTopic___internal___description = 'parentMessage___parentTopic___internal___description',
  parentMessage___parentTopic___internal___fieldOwners = 'parentMessage___parentTopic___internal___fieldOwners',
  parentMessage___parentTopic___internal___ignoreType = 'parentMessage___parentTopic___internal___ignoreType',
  parentMessage___parentTopic___internal___mediaType = 'parentMessage___parentTopic___internal___mediaType',
  parentMessage___parentTopic___internal___owner = 'parentMessage___parentTopic___internal___owner',
  parentMessage___parentTopic___internal___type = 'parentMessage___parentTopic___internal___type',
  parentMessage___path = 'parentMessage___path',
  parentMessage___product = 'parentMessage___product',
  parentMessage___productsNodes = 'parentMessage___productsNodes',
  parentMessage___productsNodes___absolutePath = 'parentMessage___productsNodes___absolutePath',
  parentMessage___productsNodes___benefits = 'parentMessage___productsNodes___benefits',
  parentMessage___productsNodes___benefitsDisclaimer = 'parentMessage___productsNodes___benefitsDisclaimer',
  parentMessage___productsNodes___description___htmlTruncated = 'parentMessage___productsNodes___description___htmlTruncated',
  parentMessage___productsNodes___description___html = 'parentMessage___productsNodes___description___html',
  parentMessage___productsNodes___description___rawContent = 'parentMessage___productsNodes___description___rawContent',
  parentMessage___productsNodes___description___text = 'parentMessage___productsNodes___description___text',
  parentMessage___productsNodes___hero___description = 'parentMessage___productsNodes___hero___description',
  parentMessage___productsNodes___hero___title = 'parentMessage___productsNodes___hero___title',
  parentMessage___productsNodes___howToUse___html = 'parentMessage___productsNodes___howToUse___html',
  parentMessage___productsNodes___howToUse___json = 'parentMessage___productsNodes___howToUse___json',
  parentMessage___productsNodes___howToUse___text = 'parentMessage___productsNodes___howToUse___text',
  parentMessage___productsNodes___main___htmlTruncated = 'parentMessage___productsNodes___main___htmlTruncated',
  parentMessage___productsNodes___main___html = 'parentMessage___productsNodes___main___html',
  parentMessage___productsNodes___main___rawContent = 'parentMessage___productsNodes___main___rawContent',
  parentMessage___productsNodes___main___text = 'parentMessage___productsNodes___main___text',
  parentMessage___productsNodes___metaDescription = 'parentMessage___productsNodes___metaDescription',
  parentMessage___productsNodes___name = 'parentMessage___productsNodes___name',
  parentMessage___productsNodes___pageTitle = 'parentMessage___productsNodes___pageTitle',
  parentMessage___productsNodes___pageType = 'parentMessage___productsNodes___pageType',
  parentMessage___productsNodes___parentMessage___absolutePath = 'parentMessage___productsNodes___parentMessage___absolutePath',
  parentMessage___productsNodes___parentMessage___benefitImages = 'parentMessage___productsNodes___parentMessage___benefitImages',
  parentMessage___productsNodes___parentMessage___benefits = 'parentMessage___productsNodes___parentMessage___benefits',
  parentMessage___productsNodes___parentMessage___benefitsDisclaimer = 'parentMessage___productsNodes___parentMessage___benefitsDisclaimer',
  parentMessage___productsNodes___parentMessage___certificate = 'parentMessage___productsNodes___parentMessage___certificate',
  parentMessage___productsNodes___parentMessage___facts = 'parentMessage___productsNodes___parentMessage___facts',
  parentMessage___productsNodes___parentMessage___metaDescription = 'parentMessage___productsNodes___parentMessage___metaDescription',
  parentMessage___productsNodes___parentMessage___pageTitle = 'parentMessage___productsNodes___parentMessage___pageTitle',
  parentMessage___productsNodes___parentMessage___pageType = 'parentMessage___productsNodes___parentMessage___pageType',
  parentMessage___productsNodes___parentMessage___path = 'parentMessage___productsNodes___parentMessage___path',
  parentMessage___productsNodes___parentMessage___product = 'parentMessage___productsNodes___parentMessage___product',
  parentMessage___productsNodes___parentMessage___productsNodes = 'parentMessage___productsNodes___parentMessage___productsNodes',
  parentMessage___productsNodes___parentMessage___slug = 'parentMessage___productsNodes___parentMessage___slug',
  parentMessage___productsNodes___parentMessage___summary = 'parentMessage___productsNodes___parentMessage___summary',
  parentMessage___productsNodes___parentMessage___title = 'parentMessage___productsNodes___parentMessage___title',
  parentMessage___productsNodes___parentMessage___id = 'parentMessage___productsNodes___parentMessage___id',
  parentMessage___productsNodes___parentMessage___children = 'parentMessage___productsNodes___parentMessage___children',
  parentMessage___productsNodes___path = 'parentMessage___productsNodes___path',
  parentMessage___productsNodes___slug = 'parentMessage___productsNodes___slug',
  parentMessage___productsNodes___summaryBackground___description = 'parentMessage___productsNodes___summaryBackground___description',
  parentMessage___productsNodes___summaryBackground___title = 'parentMessage___productsNodes___summaryBackground___title',
  parentMessage___productsNodes___traits___traitsStringified = 'parentMessage___productsNodes___traits___traitsStringified',
  parentMessage___productsNodes___variants = 'parentMessage___productsNodes___variants',
  parentMessage___productsNodes___variants___buyItNowUrl = 'parentMessage___productsNodes___variants___buyItNowUrl',
  parentMessage___productsNodes___variants___name = 'parentMessage___productsNodes___variants___name',
  parentMessage___productsNodes___variants___product = 'parentMessage___productsNodes___variants___product',
  parentMessage___productsNodes___variants___sizes = 'parentMessage___productsNodes___variants___sizes',
  parentMessage___productsNodes___id = 'parentMessage___productsNodes___id',
  parentMessage___productsNodes___parent___id = 'parentMessage___productsNodes___parent___id',
  parentMessage___productsNodes___parent___children = 'parentMessage___productsNodes___parent___children',
  parentMessage___productsNodes___children = 'parentMessage___productsNodes___children',
  parentMessage___productsNodes___children___id = 'parentMessage___productsNodes___children___id',
  parentMessage___productsNodes___children___children = 'parentMessage___productsNodes___children___children',
  parentMessage___productsNodes___internal___content = 'parentMessage___productsNodes___internal___content',
  parentMessage___productsNodes___internal___contentDigest = 'parentMessage___productsNodes___internal___contentDigest',
  parentMessage___productsNodes___internal___description = 'parentMessage___productsNodes___internal___description',
  parentMessage___productsNodes___internal___fieldOwners = 'parentMessage___productsNodes___internal___fieldOwners',
  parentMessage___productsNodes___internal___ignoreType = 'parentMessage___productsNodes___internal___ignoreType',
  parentMessage___productsNodes___internal___mediaType = 'parentMessage___productsNodes___internal___mediaType',
  parentMessage___productsNodes___internal___owner = 'parentMessage___productsNodes___internal___owner',
  parentMessage___productsNodes___internal___type = 'parentMessage___productsNodes___internal___type',
  parentMessage___slug = 'parentMessage___slug',
  parentMessage___summary = 'parentMessage___summary',
  parentMessage___summaryBackground___description = 'parentMessage___summaryBackground___description',
  parentMessage___summaryBackground___file___url = 'parentMessage___summaryBackground___file___url',
  parentMessage___summaryBackground___title = 'parentMessage___summaryBackground___title',
  parentMessage___teaserImage___description = 'parentMessage___teaserImage___description',
  parentMessage___teaserImage___file___url = 'parentMessage___teaserImage___file___url',
  parentMessage___teaserImage___title = 'parentMessage___teaserImage___title',
  parentMessage___territoryWidget___bottomGraphic___description = 'parentMessage___territoryWidget___bottomGraphic___description',
  parentMessage___territoryWidget___bottomGraphic___title = 'parentMessage___territoryWidget___bottomGraphic___title',
  parentMessage___territoryWidget___bottomHeading = 'parentMessage___territoryWidget___bottomHeading',
  parentMessage___territoryWidget___graphicHeading = 'parentMessage___territoryWidget___graphicHeading',
  parentMessage___territoryWidget___topCopy = 'parentMessage___territoryWidget___topCopy',
  parentMessage___territoryWidget___topHeading = 'parentMessage___territoryWidget___topHeading',
  parentMessage___territoryWidget___topHeroImage___description = 'parentMessage___territoryWidget___topHeroImage___description',
  parentMessage___territoryWidget___topHeroImage___title = 'parentMessage___territoryWidget___topHeroImage___title',
  parentMessage___territoryWidget___topLeftHeadingImage___description = 'parentMessage___territoryWidget___topLeftHeadingImage___description',
  parentMessage___territoryWidget___topLeftHeadingImage___title = 'parentMessage___territoryWidget___topLeftHeadingImage___title',
  parentMessage___title = 'parentMessage___title',
  parentMessage___traits___traitsStringified = 'parentMessage___traits___traitsStringified',
  parentMessage___video___description = 'parentMessage___video___description',
  parentMessage___video___file___url = 'parentMessage___video___file___url',
  parentMessage___video___title = 'parentMessage___video___title',
  parentMessage___id = 'parentMessage___id',
  parentMessage___parent___id = 'parentMessage___parent___id',
  parentMessage___parent___parent___id = 'parentMessage___parent___parent___id',
  parentMessage___parent___parent___children = 'parentMessage___parent___parent___children',
  parentMessage___parent___children = 'parentMessage___parent___children',
  parentMessage___parent___children___id = 'parentMessage___parent___children___id',
  parentMessage___parent___children___children = 'parentMessage___parent___children___children',
  parentMessage___parent___internal___content = 'parentMessage___parent___internal___content',
  parentMessage___parent___internal___contentDigest = 'parentMessage___parent___internal___contentDigest',
  parentMessage___parent___internal___description = 'parentMessage___parent___internal___description',
  parentMessage___parent___internal___fieldOwners = 'parentMessage___parent___internal___fieldOwners',
  parentMessage___parent___internal___ignoreType = 'parentMessage___parent___internal___ignoreType',
  parentMessage___parent___internal___mediaType = 'parentMessage___parent___internal___mediaType',
  parentMessage___parent___internal___owner = 'parentMessage___parent___internal___owner',
  parentMessage___parent___internal___type = 'parentMessage___parent___internal___type',
  parentMessage___children = 'parentMessage___children',
  parentMessage___children___id = 'parentMessage___children___id',
  parentMessage___children___parent___id = 'parentMessage___children___parent___id',
  parentMessage___children___parent___children = 'parentMessage___children___parent___children',
  parentMessage___children___children = 'parentMessage___children___children',
  parentMessage___children___children___id = 'parentMessage___children___children___id',
  parentMessage___children___children___children = 'parentMessage___children___children___children',
  parentMessage___children___internal___content = 'parentMessage___children___internal___content',
  parentMessage___children___internal___contentDigest = 'parentMessage___children___internal___contentDigest',
  parentMessage___children___internal___description = 'parentMessage___children___internal___description',
  parentMessage___children___internal___fieldOwners = 'parentMessage___children___internal___fieldOwners',
  parentMessage___children___internal___ignoreType = 'parentMessage___children___internal___ignoreType',
  parentMessage___children___internal___mediaType = 'parentMessage___children___internal___mediaType',
  parentMessage___children___internal___owner = 'parentMessage___children___internal___owner',
  parentMessage___children___internal___type = 'parentMessage___children___internal___type',
  parentMessage___internal___content = 'parentMessage___internal___content',
  parentMessage___internal___contentDigest = 'parentMessage___internal___contentDigest',
  parentMessage___internal___description = 'parentMessage___internal___description',
  parentMessage___internal___fieldOwners = 'parentMessage___internal___fieldOwners',
  parentMessage___internal___ignoreType = 'parentMessage___internal___ignoreType',
  parentMessage___internal___mediaType = 'parentMessage___internal___mediaType',
  parentMessage___internal___owner = 'parentMessage___internal___owner',
  parentMessage___internal___type = 'parentMessage___internal___type',
  path = 'path',
  slug = 'slug',
  summaryBackground___description = 'summaryBackground___description',
  summaryBackground___file___fileLocal___sourceInstanceName = 'summaryBackground___file___fileLocal___sourceInstanceName',
  summaryBackground___file___fileLocal___absolutePath = 'summaryBackground___file___fileLocal___absolutePath',
  summaryBackground___file___fileLocal___relativePath = 'summaryBackground___file___fileLocal___relativePath',
  summaryBackground___file___fileLocal___extension = 'summaryBackground___file___fileLocal___extension',
  summaryBackground___file___fileLocal___size = 'summaryBackground___file___fileLocal___size',
  summaryBackground___file___fileLocal___prettySize = 'summaryBackground___file___fileLocal___prettySize',
  summaryBackground___file___fileLocal___modifiedTime = 'summaryBackground___file___fileLocal___modifiedTime',
  summaryBackground___file___fileLocal___accessTime = 'summaryBackground___file___fileLocal___accessTime',
  summaryBackground___file___fileLocal___changeTime = 'summaryBackground___file___fileLocal___changeTime',
  summaryBackground___file___fileLocal___birthTime = 'summaryBackground___file___fileLocal___birthTime',
  summaryBackground___file___fileLocal___root = 'summaryBackground___file___fileLocal___root',
  summaryBackground___file___fileLocal___dir = 'summaryBackground___file___fileLocal___dir',
  summaryBackground___file___fileLocal___base = 'summaryBackground___file___fileLocal___base',
  summaryBackground___file___fileLocal___ext = 'summaryBackground___file___fileLocal___ext',
  summaryBackground___file___fileLocal___name = 'summaryBackground___file___fileLocal___name',
  summaryBackground___file___fileLocal___relativeDirectory = 'summaryBackground___file___fileLocal___relativeDirectory',
  summaryBackground___file___fileLocal___dev = 'summaryBackground___file___fileLocal___dev',
  summaryBackground___file___fileLocal___mode = 'summaryBackground___file___fileLocal___mode',
  summaryBackground___file___fileLocal___nlink = 'summaryBackground___file___fileLocal___nlink',
  summaryBackground___file___fileLocal___uid = 'summaryBackground___file___fileLocal___uid',
  summaryBackground___file___fileLocal___gid = 'summaryBackground___file___fileLocal___gid',
  summaryBackground___file___fileLocal___rdev = 'summaryBackground___file___fileLocal___rdev',
  summaryBackground___file___fileLocal___ino = 'summaryBackground___file___fileLocal___ino',
  summaryBackground___file___fileLocal___atimeMs = 'summaryBackground___file___fileLocal___atimeMs',
  summaryBackground___file___fileLocal___mtimeMs = 'summaryBackground___file___fileLocal___mtimeMs',
  summaryBackground___file___fileLocal___ctimeMs = 'summaryBackground___file___fileLocal___ctimeMs',
  summaryBackground___file___fileLocal___atime = 'summaryBackground___file___fileLocal___atime',
  summaryBackground___file___fileLocal___mtime = 'summaryBackground___file___fileLocal___mtime',
  summaryBackground___file___fileLocal___ctime = 'summaryBackground___file___fileLocal___ctime',
  summaryBackground___file___fileLocal___birthtime = 'summaryBackground___file___fileLocal___birthtime',
  summaryBackground___file___fileLocal___birthtimeMs = 'summaryBackground___file___fileLocal___birthtimeMs',
  summaryBackground___file___fileLocal___blksize = 'summaryBackground___file___fileLocal___blksize',
  summaryBackground___file___fileLocal___blocks = 'summaryBackground___file___fileLocal___blocks',
  summaryBackground___file___fileLocal___url = 'summaryBackground___file___fileLocal___url',
  summaryBackground___file___fileLocal___publicURL = 'summaryBackground___file___fileLocal___publicURL',
  summaryBackground___file___fileLocal___childrenImageSharp = 'summaryBackground___file___fileLocal___childrenImageSharp',
  summaryBackground___file___fileLocal___id = 'summaryBackground___file___fileLocal___id',
  summaryBackground___file___fileLocal___children = 'summaryBackground___file___fileLocal___children',
  summaryBackground___file___url = 'summaryBackground___file___url',
  summaryBackground___title = 'summaryBackground___title',
  traits___traitsStringified = 'traits___traitsStringified',
  variants = 'variants',
  variants___buyItNowUrl = 'variants___buyItNowUrl',
  variants___ingredientsBlurb___html = 'variants___ingredientsBlurb___html',
  variants___ingredientsBlurb___json = 'variants___ingredientsBlurb___json',
  variants___ingredientsBlurb___text = 'variants___ingredientsBlurb___text',
  variants___name = 'variants___name',
  variants___packshot___description = 'variants___packshot___description',
  variants___packshot___file___url = 'variants___packshot___file___url',
  variants___packshot___title = 'variants___packshot___title',
  variants___product = 'variants___product',
  variants___sizes = 'variants___sizes',
  fields___kritiqueRating___averageRating = 'fields___kritiqueRating___averageRating',
  fields___kritiqueRating___reviewCount = 'fields___kritiqueRating___reviewCount',
  fields___kritiqueRating___reviews = 'fields___kritiqueRating___reviews',
  fields___kritiqueRating___reviews___id = 'fields___kritiqueRating___reviews___id',
  fields___kritiqueRating___reviews___comment = 'fields___kritiqueRating___reviews___comment',
  fields___kritiqueRating___reviews___contributor = 'fields___kritiqueRating___reviews___contributor',
  fields___kritiqueRating___reviews___rating = 'fields___kritiqueRating___reviews___rating',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ProductFieldsFilterInput = {
  kritiqueRating?: Maybe<KritiqueRatingFilterInput>;
};

export type ProductFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  benefitsDisclaimer?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<MainFilterInput>;
  hero?: Maybe<MediaFilterInput>;
  howToUse?: Maybe<HtmlFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  parentMessage?: Maybe<MessageFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<MediaFilterInput>;
  traits?: Maybe<TraitsFilterInput>;
  variants?: Maybe<VariantFilterListInput>;
  fields?: Maybe<ProductFieldsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type ProductFilterListInput = {
  elemMatch?: Maybe<ProductFilterInput>;
};

export type ProductGroupConnection = {
  __typename?: 'ProductGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<ProductEdge>;
  nodes: Array<Product>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type ProductSortInput = {
  fields?: Maybe<Array<Maybe<ProductFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Query = {
  __typename?: 'Query';
  file?: Maybe<File>;
  allFile: FileConnection;
  directory?: Maybe<Directory>;
  allDirectory: DirectoryConnection;
  site?: Maybe<Site>;
  allSite: SiteConnection;
  siteFunction?: Maybe<SiteFunction>;
  allSiteFunction: SiteFunctionConnection;
  sitePage?: Maybe<SitePage>;
  allSitePage: SitePageConnection;
  contentfulArticle?: Maybe<ContentfulArticle>;
  allContentfulArticle: ContentfulArticleConnection;
  contentfulCategory?: Maybe<ContentfulCategory>;
  allContentfulCategory: ContentfulCategoryConnection;
  contactUs?: Maybe<ContactUs>;
  allContactUs: ContactUsConnection;
  message?: Maybe<Message>;
  allMessage: MessageConnection;
  product?: Maybe<Product>;
  allProduct: ProductConnection;
  sitemap?: Maybe<Sitemap>;
  allSitemap: SitemapConnection;
  sustainabilityCategory?: Maybe<SustainabilityCategory>;
  allSustainabilityCategory: SustainabilityCategoryConnection;
  sustainabilityLandingPage?: Maybe<SustainabilityLandingPage>;
  allSustainabilityLandingPage: SustainabilityLandingPageConnection;
  topic?: Maybe<Topic>;
  allTopic: TopicConnection;
  signUp?: Maybe<SignUp>;
  allSignUp: SignUpConnection;
  home?: Maybe<Home>;
  allHome: HomeConnection;
  faq?: Maybe<Faq>;
  allFaq: FaqConnection;
  content?: Maybe<Content>;
  allContent: ContentConnection;
  article?: Maybe<Article>;
  allArticle: ArticleConnection;
  imageSharp?: Maybe<ImageSharp>;
  allImageSharp: ImageSharpConnection;
  s3ContentfulRichText?: Maybe<S3ContentfulRichText>;
  allS3ContentfulRichText: S3ContentfulRichTextConnection;
  sitePageContext?: Maybe<SitePageContext>;
  allSitePageContext: SitePageContextConnection;
  sitePlugin?: Maybe<SitePlugin>;
  allSitePlugin: SitePluginConnection;
  siteBuildMetadata?: Maybe<SiteBuildMetadata>;
  allSiteBuildMetadata: SiteBuildMetadataConnection;
  s3ContentfulWebsite?: Maybe<S3ContentfulWebsite>;
  allS3ContentfulWebsite: S3ContentfulWebsiteConnection;
  s3ContentfulVariant?: Maybe<S3ContentfulVariant>;
  allS3ContentfulVariant: S3ContentfulVariantConnection;
  s3ContentfulTopic?: Maybe<S3ContentfulTopic>;
  allS3ContentfulTopic: S3ContentfulTopicConnection;
  s3ContentfulSocialChannel?: Maybe<S3ContentfulSocialChannel>;
  allS3ContentfulSocialChannel: S3ContentfulSocialChannelConnection;
  s3ContentfulSitemap?: Maybe<S3ContentfulSitemap>;
  allS3ContentfulSitemap: S3ContentfulSitemapConnection;
  s3ContentfulProduct?: Maybe<S3ContentfulProduct>;
  allS3ContentfulProduct: S3ContentfulProductConnection;
  s3ContentfulMessage?: Maybe<S3ContentfulMessage>;
  allS3ContentfulMessage: S3ContentfulMessageConnection;
  s3ContentfulLexicon?: Maybe<S3ContentfulLexicon>;
  allS3ContentfulLexicon: S3ContentfulLexiconConnection;
  s3ContentfulLegals?: Maybe<S3ContentfulLegals>;
  allS3ContentfulLegals: S3ContentfulLegalsConnection;
  s3ContentfulDomain?: Maybe<S3ContentfulDomain>;
  allS3ContentfulDomain: S3ContentfulDomainConnection;
  s3ContentfulContactUs?: Maybe<S3ContentfulContactUs>;
  allS3ContentfulContactUs: S3ContentfulContactUsConnection;
  s3ContentfulCategory?: Maybe<S3ContentfulCategory>;
  allS3ContentfulCategory: S3ContentfulCategoryConnection;
  s3ContentfulBrand?: Maybe<S3ContentfulBrand>;
  allS3ContentfulBrand: S3ContentfulBrandConnection;
  s3ContentfulAsset?: Maybe<S3ContentfulAsset>;
  allS3ContentfulAsset: S3ContentfulAssetConnection;
  s3ContentfulArticle?: Maybe<S3ContentfulArticle>;
  allS3ContentfulArticle: S3ContentfulArticleConnection;
  s3ContentfulAdobeConfig?: Maybe<S3ContentfulAdobeConfig>;
  allS3ContentfulAdobeConfig: S3ContentfulAdobeConfigConnection;
};


export type QueryFileArgs = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  blksize?: Maybe<IntQueryOperatorInput>;
  blocks?: Maybe<IntQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  publicURL?: Maybe<StringQueryOperatorInput>;
  childrenImageSharp?: Maybe<ImageSharpFilterListInput>;
  childImageSharp?: Maybe<ImageSharpFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllFileArgs = {
  filter?: Maybe<FileFilterInput>;
  sort?: Maybe<FileSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryDirectoryArgs = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  blksize?: Maybe<IntQueryOperatorInput>;
  blocks?: Maybe<IntQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllDirectoryArgs = {
  filter?: Maybe<DirectoryFilterInput>;
  sort?: Maybe<DirectorySortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySiteArgs = {
  buildTime?: Maybe<DateQueryOperatorInput>;
  siteMetadata?: Maybe<SiteSiteMetadataFilterInput>;
  port?: Maybe<IntQueryOperatorInput>;
  host?: Maybe<StringQueryOperatorInput>;
  pathPrefix?: Maybe<StringQueryOperatorInput>;
  flags?: Maybe<SiteFlagsFilterInput>;
  polyfill?: Maybe<BooleanQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSiteArgs = {
  filter?: Maybe<SiteFilterInput>;
  sort?: Maybe<SiteSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySiteFunctionArgs = {
  functionRoute?: Maybe<StringQueryOperatorInput>;
  pluginName?: Maybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: Maybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: Maybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: Maybe<StringQueryOperatorInput>;
  absoluteCompiledFilePath?: Maybe<StringQueryOperatorInput>;
  matchPath?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSiteFunctionArgs = {
  filter?: Maybe<SiteFunctionFilterInput>;
  sort?: Maybe<SiteFunctionSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySitePageArgs = {
  path?: Maybe<StringQueryOperatorInput>;
  component?: Maybe<StringQueryOperatorInput>;
  internalComponentName?: Maybe<StringQueryOperatorInput>;
  componentChunkName?: Maybe<StringQueryOperatorInput>;
  matchPath?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  isCreatedByStatefulCreatePages?: Maybe<BooleanQueryOperatorInput>;
  context?: Maybe<SitePageContextFilterInput>;
  pluginCreator?: Maybe<SitePluginFilterInput>;
  pluginCreatorId?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllSitePageArgs = {
  filter?: Maybe<SitePageFilterInput>;
  sort?: Maybe<SitePageSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryContentfulArticleArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  parentCategory?: Maybe<ContentfulCategoryFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<MediaFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllContentfulArticleArgs = {
  filter?: Maybe<ContentfulArticleFilterInput>;
  sort?: Maybe<ContentfulArticleSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryContentfulCategoryArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  parentCategory?: Maybe<ContentfulCategoryFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllContentfulCategoryArgs = {
  filter?: Maybe<ContentfulCategoryFilterInput>;
  sort?: Maybe<ContentfulCategorySortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryContactUsArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  contactFormWidgetClassName?: Maybe<StringQueryOperatorInput>;
  contactFormWidgetUrl?: Maybe<StringQueryOperatorInput>;
  legalsTextAdditional?: Maybe<HtmlFilterInput>;
  liveChatText?: Maybe<StringQueryOperatorInput>;
  liveChatID?: Maybe<StringQueryOperatorInput>;
  liveChatDeploymentID?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<MainFilterInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  phoneNumber?: Maybe<HtmlFilterInput>;
  postalAddress?: Maybe<HtmlFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  titlePhoneNumber?: Maybe<StringQueryOperatorInput>;
  titlePostalAddress?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllContactUsArgs = {
  filter?: Maybe<ContactUsFilterInput>;
  sort?: Maybe<ContactUsSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMessageArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  benefitImages?: Maybe<BenefitImagesFilterListInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  benefitsDisclaimer?: Maybe<StringQueryOperatorInput>;
  certificate?: Maybe<CertificateFilterListInput>;
  facts?: Maybe<FactFilterListInput>;
  hero?: Maybe<MediaFilterInput>;
  heroVideo?: Maybe<MediaFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  parentTopic?: Maybe<TopicFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  product?: Maybe<StringQueryOperatorInput>;
  productsNodes?: Maybe<ProductFilterListInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<MediaFilterInput>;
  teaserImage?: Maybe<MediaFilterInput>;
  territoryWidget?: Maybe<TerritoryFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  video?: Maybe<MediaFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllMessageArgs = {
  filter?: Maybe<MessageFilterInput>;
  sort?: Maybe<MessageSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryProductArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  benefitsDisclaimer?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<MainFilterInput>;
  hero?: Maybe<MediaFilterInput>;
  howToUse?: Maybe<HtmlFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  parentMessage?: Maybe<MessageFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<MediaFilterInput>;
  traits?: Maybe<TraitsFilterInput>;
  variants?: Maybe<VariantFilterListInput>;
  fields?: Maybe<ProductFieldsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllProductArgs = {
  filter?: Maybe<ProductFilterInput>;
  sort?: Maybe<ProductSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySitemapArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  heading?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSitemapArgs = {
  filter?: Maybe<SitemapFilterInput>;
  sort?: Maybe<SitemapSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySustainabilityCategoryArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  ctaMicrocopy?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  heroOverlay?: Maybe<MediaFilterInput>;
  messageCards?: Maybe<SustainabilityMessageCardFilterListInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  metaTitle?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  shareImage?: Maybe<MediaFilterInput>;
  shortDescription?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<HtmlFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSustainabilityCategoryArgs = {
  filter?: Maybe<SustainabilityCategoryFilterInput>;
  sort?: Maybe<SustainabilityCategorySortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySustainabilityLandingPageArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  heroVideo?: Maybe<MediaFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  metaTitle?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  shareImage?: Maybe<MediaFilterInput>;
  summary?: Maybe<HtmlFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSustainabilityLandingPageArgs = {
  filter?: Maybe<SustainabilityLandingPageFilterInput>;
  sort?: Maybe<SustainabilityLandingPageSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryTopicArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  messagesNodes?: Maybe<MessageFilterListInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  navigationTitle?: Maybe<StringQueryOperatorInput>;
  topicDisclaimer?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllTopicArgs = {
  filter?: Maybe<TopicFilterInput>;
  sort?: Maybe<TopicSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySignUpArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  ageConsentLabel?: Maybe<StringQueryOperatorInput>;
  brandConsentLabel?: Maybe<StringQueryOperatorInput>;
  brandConsentRequired?: Maybe<BooleanQueryOperatorInput>;
  corporateConsentLabel?: Maybe<StringQueryOperatorInput>;
  dateOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  dayOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  disclaimer?: Maybe<HtmlFilterInput>;
  emailAddressFieldLabel?: Maybe<StringQueryOperatorInput>;
  enterpriseConsent?: Maybe<HtmlFilterInput>;
  failureMessage?: Maybe<StringQueryOperatorInput>;
  femaleGenderFieldLabel?: Maybe<StringQueryOperatorInput>;
  firstNameFieldLabel?: Maybe<StringQueryOperatorInput>;
  genderFieldLabel?: Maybe<StringQueryOperatorInput>;
  heading?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  lastNameFieldLabel?: Maybe<StringQueryOperatorInput>;
  maleGenderFieldLabel?: Maybe<StringQueryOperatorInput>;
  mobileNumberFieldLabel?: Maybe<StringQueryOperatorInput>;
  monthOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  notSpecifiedGenderFieldLabel?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  postalCodeFieldLabel?: Maybe<StringQueryOperatorInput>;
  shouldCaptureAgeConsent?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureDayOfBirth?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureEnterpriseConsent?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureGender?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureMobileNumber?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureMonthOfBirth?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCapturePostalCode?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureYearOfBirth?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  submitButtonLabel?: Maybe<StringQueryOperatorInput>;
  successMessage?: Maybe<StringQueryOperatorInput>;
  successMessageAttachment?: Maybe<MediaFilterInput>;
  termsAndConditionsBlurb?: Maybe<HtmlFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  yearOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  submissionConsentMessage?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSignUpArgs = {
  filter?: Maybe<SignUpFilterInput>;
  sort?: Maybe<SignUpSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryHomeArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  additionalExternalLinks?: Maybe<HyperlinkFilterListInput>;
  brand?: Maybe<BrandFilterInput>;
  certificate?: Maybe<CertificateFilterListInput>;
  contactUs?: Maybe<ContactUsFilterInput>;
  contactUsMessage?: Maybe<MessageFilterInput>;
  coreMessage?: Maybe<MessageFilterInput>;
  currentYear?: Maybe<StringQueryOperatorInput>;
  disclaimerMessage?: Maybe<MessageFilterInput>;
  domain?: Maybe<DomainFilterInput>;
  externalLinks?: Maybe<HyperlinkFilterListInput>;
  faq?: Maybe<FaqFilterInput>;
  legals?: Maybe<LegalsFilterInput>;
  lexicon?: Maybe<LexiconFilterInput>;
  messagesNodes?: Maybe<MessageFilterListInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  product?: Maybe<StringQueryOperatorInput>;
  productsNodes?: Maybe<ProductFilterListInput>;
  secondaryMessage?: Maybe<MessageFilterInput>;
  signUp?: Maybe<SignUpFilterInput>;
  socialChannels?: Maybe<SocialChannelFilterListInput>;
  termsMessage?: Maybe<MessageFilterInput>;
  navLinks?: Maybe<NavLinkFilterListInput>;
  traits?: Maybe<TraitsFilterInput>;
  sustainabilityWidgetWebsite?: Maybe<SustainabilityWidgetFilterInput>;
  homeVideo?: Maybe<HomeVideoFilterInput>;
  homepageTitle?: Maybe<StringQueryOperatorInput>;
  homepageVideoHero?: Maybe<MediaFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllHomeArgs = {
  filter?: Maybe<HomeFilterInput>;
  sort?: Maybe<HomeSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFaqArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  questionsAndAnswers?: Maybe<FaqPairFilterListInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllFaqArgs = {
  filter?: Maybe<FaqFilterInput>;
  sort?: Maybe<FaqSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryContentArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  copy?: Maybe<CopyFilterListInput>;
  hero?: Maybe<XmlContentMediaFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<XmlContentMediaFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllContentArgs = {
  filter?: Maybe<ContentFilterInput>;
  sort?: Maybe<ContentSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryArticleArgs = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  copy?: Maybe<CopyFilterListInput>;
  hero?: Maybe<XmlContentMediaFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllArticleArgs = {
  filter?: Maybe<ArticleFilterInput>;
  sort?: Maybe<ArticleSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryImageSharpArgs = {
  fixed?: Maybe<ImageSharpFixedFilterInput>;
  fluid?: Maybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: Maybe<JsonQueryOperatorInput>;
  original?: Maybe<ImageSharpOriginalFilterInput>;
  resize?: Maybe<ImageSharpResizeFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllImageSharpArgs = {
  filter?: Maybe<ImageSharpFilterInput>;
  sort?: Maybe<ImageSharpSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulRichTextArgs = {
  raw?: Maybe<JsonQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllS3ContentfulRichTextArgs = {
  filter?: Maybe<S3ContentfulRichTextFilterInput>;
  sort?: Maybe<S3ContentfulRichTextSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySitePageContextArgs = {
  sitemapTitle?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSitePageContextArgs = {
  filter?: Maybe<SitePageContextFilterInput>;
  sort?: Maybe<SitePageContextSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySitePluginArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  resolve?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
  pluginOptions?: Maybe<SitePluginPluginOptionsFilterInput>;
  nodeAPIs?: Maybe<StringQueryOperatorInput>;
  browserAPIs?: Maybe<StringQueryOperatorInput>;
  ssrAPIs?: Maybe<StringQueryOperatorInput>;
  pluginFilepath?: Maybe<StringQueryOperatorInput>;
  packageJson?: Maybe<SitePluginPackageJsonFilterInput>;
};


export type QueryAllSitePluginArgs = {
  filter?: Maybe<SitePluginFilterInput>;
  sort?: Maybe<SitePluginSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySiteBuildMetadataArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  buildTime?: Maybe<DateQueryOperatorInput>;
};


export type QueryAllSiteBuildMetadataArgs = {
  filter?: Maybe<SiteBuildMetadataFilterInput>;
  sort?: Maybe<SiteBuildMetadataSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulWebsiteArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  homepageTitle?: Maybe<StringQueryOperatorInput>;
  brand?: Maybe<S3ContentfulBrandFilterInput>;
  domain?: Maybe<S3ContentfulDomainFilterInput>;
  message?: Maybe<S3ContentfulMessageFilterInput>;
  messageSecondary?: Maybe<S3ContentfulMessageFilterInput>;
  lexicon?: Maybe<S3ContentfulLexiconFilterInput>;
  legals?: Maybe<S3ContentfulLegalsFilterInput>;
  socialChannels?: Maybe<S3ContentfulSocialChannelFilterListInput>;
  messages?: Maybe<S3ContentfulMessageFilterListInput>;
  contactUs?: Maybe<S3ContentfulContactUsFilterInput>;
  sitemap?: Maybe<S3ContentfulSitemapFilterInput>;
  footerLinks?: Maybe<S3ContentfulContactUsFilterListInput>;
};


export type QueryAllS3ContentfulWebsiteArgs = {
  filter?: Maybe<S3ContentfulWebsiteFilterInput>;
  sort?: Maybe<S3ContentfulWebsiteSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulVariantArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  packshot?: Maybe<S3ContentfulAssetFilterInput>;
  sizes?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulVariantArgs = {
  filter?: Maybe<S3ContentfulVariantFilterInput>;
  sort?: Maybe<S3ContentfulVariantSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulTopicArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  navigationTitle?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  messages?: Maybe<S3ContentfulMessageFilterListInput>;
};


export type QueryAllS3ContentfulTopicArgs = {
  filter?: Maybe<S3ContentfulTopicFilterInput>;
  sort?: Maybe<S3ContentfulTopicSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulSocialChannelArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  url?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  image?: Maybe<S3ContentfulAssetFilterInput>;
};


export type QueryAllS3ContentfulSocialChannelArgs = {
  filter?: Maybe<S3ContentfulSocialChannelFilterInput>;
  sort?: Maybe<S3ContentfulSocialChannelSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulSitemapArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  heading?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulSitemapArgs = {
  filter?: Maybe<S3ContentfulSitemapFilterInput>;
  sort?: Maybe<S3ContentfulSitemapSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulProductArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<S3ContentfulRichTextFilterInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  variants?: Maybe<S3ContentfulVariantFilterListInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
};


export type QueryAllS3ContentfulProductArgs = {
  filter?: Maybe<S3ContentfulProductFilterInput>;
  sort?: Maybe<S3ContentfulProductSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulMessageArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<S3ContentfulAssetFilterInput>;
  benefitImages?: Maybe<S3ContentfulMessageBenefitImagesFilterListInput>;
  benefitsDisclaimer?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<S3ContentfulRichTextFilterInput>;
  products?: Maybe<S3ContentfulProductFilterListInput>;
};


export type QueryAllS3ContentfulMessageArgs = {
  filter?: Maybe<S3ContentfulMessageFilterInput>;
  sort?: Maybe<S3ContentfulMessageSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulLexiconArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  home?: Maybe<StringQueryOperatorInput>;
  ingredients?: Maybe<StringQueryOperatorInput>;
  products?: Maybe<StringQueryOperatorInput>;
  readMore?: Maybe<StringQueryOperatorInput>;
  pageNotFoundText?: Maybe<StringQueryOperatorInput>;
  opensInNewTab?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulLexiconArgs = {
  filter?: Maybe<S3ContentfulLexiconFilterInput>;
  sort?: Maybe<S3ContentfulLexiconSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulLegalsArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  privacyNoticeLabel?: Maybe<StringQueryOperatorInput>;
  privacyNoticeUrl?: Maybe<StringQueryOperatorInput>;
  cookieNoticeLabel?: Maybe<StringQueryOperatorInput>;
  cookieNoticeUrl?: Maybe<StringQueryOperatorInput>;
  termsOfUseLabel?: Maybe<StringQueryOperatorInput>;
  termsOfUseUrl?: Maybe<StringQueryOperatorInput>;
  legalWarningLabel?: Maybe<StringQueryOperatorInput>;
  legalWarningUrl?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulLegalsArgs = {
  filter?: Maybe<S3ContentfulLegalsFilterInput>;
  sort?: Maybe<S3ContentfulLegalsSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulDomainArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  name?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  gaTrackingIds?: Maybe<StringQueryOperatorInput>;
  adobeConfig?: Maybe<S3ContentfulAdobeConfigFilterInput>;
  oneTrustId?: Maybe<StringQueryOperatorInput>;
  oneTrustAutoBlock?: Maybe<BooleanQueryOperatorInput>;
  oneTrustShowSettingsButton?: Maybe<BooleanQueryOperatorInput>;
};


export type QueryAllS3ContentfulDomainArgs = {
  filter?: Maybe<S3ContentfulDomainFilterInput>;
  sort?: Maybe<S3ContentfulDomainSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulContactUsArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  titlePhoneNumber?: Maybe<StringQueryOperatorInput>;
  phoneNumber?: Maybe<S3ContentfulRichTextFilterInput>;
  contactFormWidgetUrl?: Maybe<StringQueryOperatorInput>;
  contactFormWidgetClassName?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulContactUsArgs = {
  filter?: Maybe<S3ContentfulContactUsFilterInput>;
  sort?: Maybe<S3ContentfulContactUsSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulCategoryArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  summary?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulCategoryArgs = {
  filter?: Maybe<S3ContentfulCategoryFilterInput>;
  sort?: Maybe<S3ContentfulCategorySortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulBrandArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  name?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  logo?: Maybe<S3ContentfulAssetFilterInput>;
  favicon?: Maybe<S3ContentfulAssetFilterInput>;
  disclaimer?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulBrandArgs = {
  filter?: Maybe<S3ContentfulBrandFilterInput>;
  sort?: Maybe<S3ContentfulBrandSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulAssetArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  url?: Maybe<StringQueryOperatorInput>;
  details?: Maybe<S3ContentfulAssetDetailsFilterInput>;
  fileName?: Maybe<StringQueryOperatorInput>;
  contentType?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulAssetArgs = {
  filter?: Maybe<S3ContentfulAssetFilterInput>;
  sort?: Maybe<S3ContentfulAssetSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulArticleArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<S3ContentfulRichTextFilterInput>;
};


export type QueryAllS3ContentfulArticleArgs = {
  filter?: Maybe<S3ContentfulArticleFilterInput>;
  sort?: Maybe<S3ContentfulArticleSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryS3ContentfulAdobeConfigArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  account?: Maybe<StringQueryOperatorInput>;
  trackingServer?: Maybe<StringQueryOperatorInput>;
  trackingServerSecure?: Maybe<StringQueryOperatorInput>;
  reportSuiteId?: Maybe<StringQueryOperatorInput>;
  containerId?: Maybe<StringQueryOperatorInput>;
  region?: Maybe<StringQueryOperatorInput>;
  language?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllS3ContentfulAdobeConfigArgs = {
  filter?: Maybe<S3ContentfulAdobeConfigFilterInput>;
  sort?: Maybe<S3ContentfulAdobeConfigSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type S3ContentfulAdobeConfig = Node & {
  __typename?: 'S3ContentfulAdobeConfig';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  account?: Maybe<Scalars['String']>;
  trackingServer?: Maybe<Scalars['String']>;
  trackingServerSecure?: Maybe<Scalars['String']>;
  reportSuiteId?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type S3ContentfulAdobeConfigConnection = {
  __typename?: 'S3ContentfulAdobeConfigConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulAdobeConfigEdge>;
  nodes: Array<S3ContentfulAdobeConfig>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulAdobeConfigGroupConnection>;
};


export type S3ContentfulAdobeConfigConnectionDistinctArgs = {
  field: S3ContentfulAdobeConfigFieldsEnum;
};


export type S3ContentfulAdobeConfigConnectionMaxArgs = {
  field: S3ContentfulAdobeConfigFieldsEnum;
};


export type S3ContentfulAdobeConfigConnectionMinArgs = {
  field: S3ContentfulAdobeConfigFieldsEnum;
};


export type S3ContentfulAdobeConfigConnectionSumArgs = {
  field: S3ContentfulAdobeConfigFieldsEnum;
};


export type S3ContentfulAdobeConfigConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulAdobeConfigFieldsEnum;
};

export type S3ContentfulAdobeConfigEdge = {
  __typename?: 'S3ContentfulAdobeConfigEdge';
  next?: Maybe<S3ContentfulAdobeConfig>;
  node: S3ContentfulAdobeConfig;
  previous?: Maybe<S3ContentfulAdobeConfig>;
};

export enum S3ContentfulAdobeConfigFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  account = 'account',
  trackingServer = 'trackingServer',
  trackingServerSecure = 'trackingServerSecure',
  reportSuiteId = 'reportSuiteId',
  containerId = 'containerId',
  region = 'region',
  language = 'language'
}

export type S3ContentfulAdobeConfigFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  account?: Maybe<StringQueryOperatorInput>;
  trackingServer?: Maybe<StringQueryOperatorInput>;
  trackingServerSecure?: Maybe<StringQueryOperatorInput>;
  reportSuiteId?: Maybe<StringQueryOperatorInput>;
  containerId?: Maybe<StringQueryOperatorInput>;
  region?: Maybe<StringQueryOperatorInput>;
  language?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulAdobeConfigGroupConnection = {
  __typename?: 'S3ContentfulAdobeConfigGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulAdobeConfigEdge>;
  nodes: Array<S3ContentfulAdobeConfig>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulAdobeConfigSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulAdobeConfigFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulArticle = Node & {
  __typename?: 'S3ContentfulArticle';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  hero?: Maybe<S3ContentfulAsset>;
  summary?: Maybe<Scalars['String']>;
  main?: Maybe<S3ContentfulRichText>;
};

export type S3ContentfulArticleConnection = {
  __typename?: 'S3ContentfulArticleConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulArticleEdge>;
  nodes: Array<S3ContentfulArticle>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulArticleGroupConnection>;
};


export type S3ContentfulArticleConnectionDistinctArgs = {
  field: S3ContentfulArticleFieldsEnum;
};


export type S3ContentfulArticleConnectionMaxArgs = {
  field: S3ContentfulArticleFieldsEnum;
};


export type S3ContentfulArticleConnectionMinArgs = {
  field: S3ContentfulArticleFieldsEnum;
};


export type S3ContentfulArticleConnectionSumArgs = {
  field: S3ContentfulArticleFieldsEnum;
};


export type S3ContentfulArticleConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulArticleFieldsEnum;
};

export type S3ContentfulArticleEdge = {
  __typename?: 'S3ContentfulArticleEdge';
  next?: Maybe<S3ContentfulArticle>;
  node: S3ContentfulArticle;
  previous?: Maybe<S3ContentfulArticle>;
};

export enum S3ContentfulArticleFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  pageTitle = 'pageTitle',
  metaDescription = 'metaDescription',
  hero___id = 'hero___id',
  hero___parent___id = 'hero___parent___id',
  hero___parent___parent___id = 'hero___parent___parent___id',
  hero___parent___parent___children = 'hero___parent___parent___children',
  hero___parent___children = 'hero___parent___children',
  hero___parent___children___id = 'hero___parent___children___id',
  hero___parent___children___children = 'hero___parent___children___children',
  hero___parent___internal___content = 'hero___parent___internal___content',
  hero___parent___internal___contentDigest = 'hero___parent___internal___contentDigest',
  hero___parent___internal___description = 'hero___parent___internal___description',
  hero___parent___internal___fieldOwners = 'hero___parent___internal___fieldOwners',
  hero___parent___internal___ignoreType = 'hero___parent___internal___ignoreType',
  hero___parent___internal___mediaType = 'hero___parent___internal___mediaType',
  hero___parent___internal___owner = 'hero___parent___internal___owner',
  hero___parent___internal___type = 'hero___parent___internal___type',
  hero___children = 'hero___children',
  hero___children___id = 'hero___children___id',
  hero___children___parent___id = 'hero___children___parent___id',
  hero___children___parent___children = 'hero___children___parent___children',
  hero___children___children = 'hero___children___children',
  hero___children___children___id = 'hero___children___children___id',
  hero___children___children___children = 'hero___children___children___children',
  hero___children___internal___content = 'hero___children___internal___content',
  hero___children___internal___contentDigest = 'hero___children___internal___contentDigest',
  hero___children___internal___description = 'hero___children___internal___description',
  hero___children___internal___fieldOwners = 'hero___children___internal___fieldOwners',
  hero___children___internal___ignoreType = 'hero___children___internal___ignoreType',
  hero___children___internal___mediaType = 'hero___children___internal___mediaType',
  hero___children___internal___owner = 'hero___children___internal___owner',
  hero___children___internal___type = 'hero___children___internal___type',
  hero___internal___content = 'hero___internal___content',
  hero___internal___contentDigest = 'hero___internal___contentDigest',
  hero___internal___description = 'hero___internal___description',
  hero___internal___fieldOwners = 'hero___internal___fieldOwners',
  hero___internal___ignoreType = 'hero___internal___ignoreType',
  hero___internal___mediaType = 'hero___internal___mediaType',
  hero___internal___owner = 'hero___internal___owner',
  hero___internal___type = 'hero___internal___type',
  hero___url = 'hero___url',
  hero___details___size = 'hero___details___size',
  hero___details___image___width = 'hero___details___image___width',
  hero___details___image___height = 'hero___details___image___height',
  hero___fileName = 'hero___fileName',
  hero___contentType = 'hero___contentType',
  summary = 'summary',
  main___raw = 'main___raw',
  main___id = 'main___id',
  main___parent___id = 'main___parent___id',
  main___parent___parent___id = 'main___parent___parent___id',
  main___parent___parent___children = 'main___parent___parent___children',
  main___parent___children = 'main___parent___children',
  main___parent___children___id = 'main___parent___children___id',
  main___parent___children___children = 'main___parent___children___children',
  main___parent___internal___content = 'main___parent___internal___content',
  main___parent___internal___contentDigest = 'main___parent___internal___contentDigest',
  main___parent___internal___description = 'main___parent___internal___description',
  main___parent___internal___fieldOwners = 'main___parent___internal___fieldOwners',
  main___parent___internal___ignoreType = 'main___parent___internal___ignoreType',
  main___parent___internal___mediaType = 'main___parent___internal___mediaType',
  main___parent___internal___owner = 'main___parent___internal___owner',
  main___parent___internal___type = 'main___parent___internal___type',
  main___children = 'main___children',
  main___children___id = 'main___children___id',
  main___children___parent___id = 'main___children___parent___id',
  main___children___parent___children = 'main___children___parent___children',
  main___children___children = 'main___children___children',
  main___children___children___id = 'main___children___children___id',
  main___children___children___children = 'main___children___children___children',
  main___children___internal___content = 'main___children___internal___content',
  main___children___internal___contentDigest = 'main___children___internal___contentDigest',
  main___children___internal___description = 'main___children___internal___description',
  main___children___internal___fieldOwners = 'main___children___internal___fieldOwners',
  main___children___internal___ignoreType = 'main___children___internal___ignoreType',
  main___children___internal___mediaType = 'main___children___internal___mediaType',
  main___children___internal___owner = 'main___children___internal___owner',
  main___children___internal___type = 'main___children___internal___type',
  main___internal___content = 'main___internal___content',
  main___internal___contentDigest = 'main___internal___contentDigest',
  main___internal___description = 'main___internal___description',
  main___internal___fieldOwners = 'main___internal___fieldOwners',
  main___internal___ignoreType = 'main___internal___ignoreType',
  main___internal___mediaType = 'main___internal___mediaType',
  main___internal___owner = 'main___internal___owner',
  main___internal___type = 'main___internal___type'
}

export type S3ContentfulArticleFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<S3ContentfulRichTextFilterInput>;
};

export type S3ContentfulArticleGroupConnection = {
  __typename?: 'S3ContentfulArticleGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulArticleEdge>;
  nodes: Array<S3ContentfulArticle>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulArticleSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulArticleFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulAsset = Node & {
  __typename?: 'S3ContentfulAsset';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  url?: Maybe<Scalars['String']>;
  details?: Maybe<S3ContentfulAssetDetails>;
  fileName?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  localFile: File;
};

export type S3ContentfulAssetConnection = {
  __typename?: 'S3ContentfulAssetConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulAssetEdge>;
  nodes: Array<S3ContentfulAsset>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulAssetGroupConnection>;
};


export type S3ContentfulAssetConnectionDistinctArgs = {
  field: S3ContentfulAssetFieldsEnum;
};


export type S3ContentfulAssetConnectionMaxArgs = {
  field: S3ContentfulAssetFieldsEnum;
};


export type S3ContentfulAssetConnectionMinArgs = {
  field: S3ContentfulAssetFieldsEnum;
};


export type S3ContentfulAssetConnectionSumArgs = {
  field: S3ContentfulAssetFieldsEnum;
};


export type S3ContentfulAssetConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulAssetFieldsEnum;
};

export type S3ContentfulAssetDetails = {
  __typename?: 'S3ContentfulAssetDetails';
  size?: Maybe<Scalars['Int']>;
  image?: Maybe<S3ContentfulAssetDetailsImage>;
};

export type S3ContentfulAssetDetailsFilterInput = {
  size?: Maybe<IntQueryOperatorInput>;
  image?: Maybe<S3ContentfulAssetDetailsImageFilterInput>;
};

export type S3ContentfulAssetDetailsImage = {
  __typename?: 'S3ContentfulAssetDetailsImage';
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type S3ContentfulAssetDetailsImageFilterInput = {
  width?: Maybe<IntQueryOperatorInput>;
  height?: Maybe<IntQueryOperatorInput>;
};

export type S3ContentfulAssetEdge = {
  __typename?: 'S3ContentfulAssetEdge';
  next?: Maybe<S3ContentfulAsset>;
  node: S3ContentfulAsset;
  previous?: Maybe<S3ContentfulAsset>;
};

export enum S3ContentfulAssetFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  url = 'url',
  details___size = 'details___size',
  details___image___width = 'details___image___width',
  details___image___height = 'details___image___height',
  fileName = 'fileName',
  contentType = 'contentType'
}

export type S3ContentfulAssetFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  url?: Maybe<StringQueryOperatorInput>;
  details?: Maybe<S3ContentfulAssetDetailsFilterInput>;
  fileName?: Maybe<StringQueryOperatorInput>;
  contentType?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulAssetGroupConnection = {
  __typename?: 'S3ContentfulAssetGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulAssetEdge>;
  nodes: Array<S3ContentfulAsset>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulAssetSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulAssetFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulBrand = Node & {
  __typename?: 'S3ContentfulBrand';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<S3ContentfulAsset>;
  favicon?: Maybe<S3ContentfulAsset>;
  disclaimer?: Maybe<Scalars['String']>;
};

export type S3ContentfulBrandConnection = {
  __typename?: 'S3ContentfulBrandConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulBrandEdge>;
  nodes: Array<S3ContentfulBrand>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulBrandGroupConnection>;
};


export type S3ContentfulBrandConnectionDistinctArgs = {
  field: S3ContentfulBrandFieldsEnum;
};


export type S3ContentfulBrandConnectionMaxArgs = {
  field: S3ContentfulBrandFieldsEnum;
};


export type S3ContentfulBrandConnectionMinArgs = {
  field: S3ContentfulBrandFieldsEnum;
};


export type S3ContentfulBrandConnectionSumArgs = {
  field: S3ContentfulBrandFieldsEnum;
};


export type S3ContentfulBrandConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulBrandFieldsEnum;
};

export type S3ContentfulBrandEdge = {
  __typename?: 'S3ContentfulBrandEdge';
  next?: Maybe<S3ContentfulBrand>;
  node: S3ContentfulBrand;
  previous?: Maybe<S3ContentfulBrand>;
};

export enum S3ContentfulBrandFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  name = 'name',
  description = 'description',
  logo___id = 'logo___id',
  logo___parent___id = 'logo___parent___id',
  logo___parent___parent___id = 'logo___parent___parent___id',
  logo___parent___parent___children = 'logo___parent___parent___children',
  logo___parent___children = 'logo___parent___children',
  logo___parent___children___id = 'logo___parent___children___id',
  logo___parent___children___children = 'logo___parent___children___children',
  logo___parent___internal___content = 'logo___parent___internal___content',
  logo___parent___internal___contentDigest = 'logo___parent___internal___contentDigest',
  logo___parent___internal___description = 'logo___parent___internal___description',
  logo___parent___internal___fieldOwners = 'logo___parent___internal___fieldOwners',
  logo___parent___internal___ignoreType = 'logo___parent___internal___ignoreType',
  logo___parent___internal___mediaType = 'logo___parent___internal___mediaType',
  logo___parent___internal___owner = 'logo___parent___internal___owner',
  logo___parent___internal___type = 'logo___parent___internal___type',
  logo___children = 'logo___children',
  logo___children___id = 'logo___children___id',
  logo___children___parent___id = 'logo___children___parent___id',
  logo___children___parent___children = 'logo___children___parent___children',
  logo___children___children = 'logo___children___children',
  logo___children___children___id = 'logo___children___children___id',
  logo___children___children___children = 'logo___children___children___children',
  logo___children___internal___content = 'logo___children___internal___content',
  logo___children___internal___contentDigest = 'logo___children___internal___contentDigest',
  logo___children___internal___description = 'logo___children___internal___description',
  logo___children___internal___fieldOwners = 'logo___children___internal___fieldOwners',
  logo___children___internal___ignoreType = 'logo___children___internal___ignoreType',
  logo___children___internal___mediaType = 'logo___children___internal___mediaType',
  logo___children___internal___owner = 'logo___children___internal___owner',
  logo___children___internal___type = 'logo___children___internal___type',
  logo___internal___content = 'logo___internal___content',
  logo___internal___contentDigest = 'logo___internal___contentDigest',
  logo___internal___description = 'logo___internal___description',
  logo___internal___fieldOwners = 'logo___internal___fieldOwners',
  logo___internal___ignoreType = 'logo___internal___ignoreType',
  logo___internal___mediaType = 'logo___internal___mediaType',
  logo___internal___owner = 'logo___internal___owner',
  logo___internal___type = 'logo___internal___type',
  logo___url = 'logo___url',
  logo___details___size = 'logo___details___size',
  logo___details___image___width = 'logo___details___image___width',
  logo___details___image___height = 'logo___details___image___height',
  logo___fileName = 'logo___fileName',
  logo___contentType = 'logo___contentType',
  favicon___id = 'favicon___id',
  favicon___parent___id = 'favicon___parent___id',
  favicon___parent___parent___id = 'favicon___parent___parent___id',
  favicon___parent___parent___children = 'favicon___parent___parent___children',
  favicon___parent___children = 'favicon___parent___children',
  favicon___parent___children___id = 'favicon___parent___children___id',
  favicon___parent___children___children = 'favicon___parent___children___children',
  favicon___parent___internal___content = 'favicon___parent___internal___content',
  favicon___parent___internal___contentDigest = 'favicon___parent___internal___contentDigest',
  favicon___parent___internal___description = 'favicon___parent___internal___description',
  favicon___parent___internal___fieldOwners = 'favicon___parent___internal___fieldOwners',
  favicon___parent___internal___ignoreType = 'favicon___parent___internal___ignoreType',
  favicon___parent___internal___mediaType = 'favicon___parent___internal___mediaType',
  favicon___parent___internal___owner = 'favicon___parent___internal___owner',
  favicon___parent___internal___type = 'favicon___parent___internal___type',
  favicon___children = 'favicon___children',
  favicon___children___id = 'favicon___children___id',
  favicon___children___parent___id = 'favicon___children___parent___id',
  favicon___children___parent___children = 'favicon___children___parent___children',
  favicon___children___children = 'favicon___children___children',
  favicon___children___children___id = 'favicon___children___children___id',
  favicon___children___children___children = 'favicon___children___children___children',
  favicon___children___internal___content = 'favicon___children___internal___content',
  favicon___children___internal___contentDigest = 'favicon___children___internal___contentDigest',
  favicon___children___internal___description = 'favicon___children___internal___description',
  favicon___children___internal___fieldOwners = 'favicon___children___internal___fieldOwners',
  favicon___children___internal___ignoreType = 'favicon___children___internal___ignoreType',
  favicon___children___internal___mediaType = 'favicon___children___internal___mediaType',
  favicon___children___internal___owner = 'favicon___children___internal___owner',
  favicon___children___internal___type = 'favicon___children___internal___type',
  favicon___internal___content = 'favicon___internal___content',
  favicon___internal___contentDigest = 'favicon___internal___contentDigest',
  favicon___internal___description = 'favicon___internal___description',
  favicon___internal___fieldOwners = 'favicon___internal___fieldOwners',
  favicon___internal___ignoreType = 'favicon___internal___ignoreType',
  favicon___internal___mediaType = 'favicon___internal___mediaType',
  favicon___internal___owner = 'favicon___internal___owner',
  favicon___internal___type = 'favicon___internal___type',
  favicon___url = 'favicon___url',
  favicon___details___size = 'favicon___details___size',
  favicon___details___image___width = 'favicon___details___image___width',
  favicon___details___image___height = 'favicon___details___image___height',
  favicon___fileName = 'favicon___fileName',
  favicon___contentType = 'favicon___contentType',
  disclaimer = 'disclaimer'
}

export type S3ContentfulBrandFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  name?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  logo?: Maybe<S3ContentfulAssetFilterInput>;
  favicon?: Maybe<S3ContentfulAssetFilterInput>;
  disclaimer?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulBrandGroupConnection = {
  __typename?: 'S3ContentfulBrandGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulBrandEdge>;
  nodes: Array<S3ContentfulBrand>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulBrandSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulBrandFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulCategory = Node & {
  __typename?: 'S3ContentfulCategory';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  hero?: Maybe<S3ContentfulAsset>;
  summary?: Maybe<Scalars['String']>;
};

export type S3ContentfulCategoryConnection = {
  __typename?: 'S3ContentfulCategoryConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulCategoryEdge>;
  nodes: Array<S3ContentfulCategory>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulCategoryGroupConnection>;
};


export type S3ContentfulCategoryConnectionDistinctArgs = {
  field: S3ContentfulCategoryFieldsEnum;
};


export type S3ContentfulCategoryConnectionMaxArgs = {
  field: S3ContentfulCategoryFieldsEnum;
};


export type S3ContentfulCategoryConnectionMinArgs = {
  field: S3ContentfulCategoryFieldsEnum;
};


export type S3ContentfulCategoryConnectionSumArgs = {
  field: S3ContentfulCategoryFieldsEnum;
};


export type S3ContentfulCategoryConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulCategoryFieldsEnum;
};

export type S3ContentfulCategoryEdge = {
  __typename?: 'S3ContentfulCategoryEdge';
  next?: Maybe<S3ContentfulCategory>;
  node: S3ContentfulCategory;
  previous?: Maybe<S3ContentfulCategory>;
};

export enum S3ContentfulCategoryFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  pageTitle = 'pageTitle',
  metaDescription = 'metaDescription',
  hero___id = 'hero___id',
  hero___parent___id = 'hero___parent___id',
  hero___parent___parent___id = 'hero___parent___parent___id',
  hero___parent___parent___children = 'hero___parent___parent___children',
  hero___parent___children = 'hero___parent___children',
  hero___parent___children___id = 'hero___parent___children___id',
  hero___parent___children___children = 'hero___parent___children___children',
  hero___parent___internal___content = 'hero___parent___internal___content',
  hero___parent___internal___contentDigest = 'hero___parent___internal___contentDigest',
  hero___parent___internal___description = 'hero___parent___internal___description',
  hero___parent___internal___fieldOwners = 'hero___parent___internal___fieldOwners',
  hero___parent___internal___ignoreType = 'hero___parent___internal___ignoreType',
  hero___parent___internal___mediaType = 'hero___parent___internal___mediaType',
  hero___parent___internal___owner = 'hero___parent___internal___owner',
  hero___parent___internal___type = 'hero___parent___internal___type',
  hero___children = 'hero___children',
  hero___children___id = 'hero___children___id',
  hero___children___parent___id = 'hero___children___parent___id',
  hero___children___parent___children = 'hero___children___parent___children',
  hero___children___children = 'hero___children___children',
  hero___children___children___id = 'hero___children___children___id',
  hero___children___children___children = 'hero___children___children___children',
  hero___children___internal___content = 'hero___children___internal___content',
  hero___children___internal___contentDigest = 'hero___children___internal___contentDigest',
  hero___children___internal___description = 'hero___children___internal___description',
  hero___children___internal___fieldOwners = 'hero___children___internal___fieldOwners',
  hero___children___internal___ignoreType = 'hero___children___internal___ignoreType',
  hero___children___internal___mediaType = 'hero___children___internal___mediaType',
  hero___children___internal___owner = 'hero___children___internal___owner',
  hero___children___internal___type = 'hero___children___internal___type',
  hero___internal___content = 'hero___internal___content',
  hero___internal___contentDigest = 'hero___internal___contentDigest',
  hero___internal___description = 'hero___internal___description',
  hero___internal___fieldOwners = 'hero___internal___fieldOwners',
  hero___internal___ignoreType = 'hero___internal___ignoreType',
  hero___internal___mediaType = 'hero___internal___mediaType',
  hero___internal___owner = 'hero___internal___owner',
  hero___internal___type = 'hero___internal___type',
  hero___url = 'hero___url',
  hero___details___size = 'hero___details___size',
  hero___details___image___width = 'hero___details___image___width',
  hero___details___image___height = 'hero___details___image___height',
  hero___fileName = 'hero___fileName',
  hero___contentType = 'hero___contentType',
  summary = 'summary'
}

export type S3ContentfulCategoryFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  summary?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulCategoryGroupConnection = {
  __typename?: 'S3ContentfulCategoryGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulCategoryEdge>;
  nodes: Array<S3ContentfulCategory>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulCategoryS3ContentfulTopicUnion = S3ContentfulCategory | S3ContentfulTopic;

export type S3ContentfulCategorySortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulCategoryFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulContactUs = Node & {
  __typename?: 'S3ContentfulContactUs';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  titlePhoneNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<S3ContentfulRichText>;
  contactFormWidgetUrl?: Maybe<Scalars['String']>;
  contactFormWidgetClassName?: Maybe<Scalars['String']>;
};

export type S3ContentfulContactUsConnection = {
  __typename?: 'S3ContentfulContactUsConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulContactUsEdge>;
  nodes: Array<S3ContentfulContactUs>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulContactUsGroupConnection>;
};


export type S3ContentfulContactUsConnectionDistinctArgs = {
  field: S3ContentfulContactUsFieldsEnum;
};


export type S3ContentfulContactUsConnectionMaxArgs = {
  field: S3ContentfulContactUsFieldsEnum;
};


export type S3ContentfulContactUsConnectionMinArgs = {
  field: S3ContentfulContactUsFieldsEnum;
};


export type S3ContentfulContactUsConnectionSumArgs = {
  field: S3ContentfulContactUsFieldsEnum;
};


export type S3ContentfulContactUsConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulContactUsFieldsEnum;
};

export type S3ContentfulContactUsEdge = {
  __typename?: 'S3ContentfulContactUsEdge';
  next?: Maybe<S3ContentfulContactUs>;
  node: S3ContentfulContactUs;
  previous?: Maybe<S3ContentfulContactUs>;
};

export enum S3ContentfulContactUsFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  title = 'title',
  summary = 'summary',
  titlePhoneNumber = 'titlePhoneNumber',
  phoneNumber___raw = 'phoneNumber___raw',
  phoneNumber___id = 'phoneNumber___id',
  phoneNumber___parent___id = 'phoneNumber___parent___id',
  phoneNumber___parent___parent___id = 'phoneNumber___parent___parent___id',
  phoneNumber___parent___parent___children = 'phoneNumber___parent___parent___children',
  phoneNumber___parent___children = 'phoneNumber___parent___children',
  phoneNumber___parent___children___id = 'phoneNumber___parent___children___id',
  phoneNumber___parent___children___children = 'phoneNumber___parent___children___children',
  phoneNumber___parent___internal___content = 'phoneNumber___parent___internal___content',
  phoneNumber___parent___internal___contentDigest = 'phoneNumber___parent___internal___contentDigest',
  phoneNumber___parent___internal___description = 'phoneNumber___parent___internal___description',
  phoneNumber___parent___internal___fieldOwners = 'phoneNumber___parent___internal___fieldOwners',
  phoneNumber___parent___internal___ignoreType = 'phoneNumber___parent___internal___ignoreType',
  phoneNumber___parent___internal___mediaType = 'phoneNumber___parent___internal___mediaType',
  phoneNumber___parent___internal___owner = 'phoneNumber___parent___internal___owner',
  phoneNumber___parent___internal___type = 'phoneNumber___parent___internal___type',
  phoneNumber___children = 'phoneNumber___children',
  phoneNumber___children___id = 'phoneNumber___children___id',
  phoneNumber___children___parent___id = 'phoneNumber___children___parent___id',
  phoneNumber___children___parent___children = 'phoneNumber___children___parent___children',
  phoneNumber___children___children = 'phoneNumber___children___children',
  phoneNumber___children___children___id = 'phoneNumber___children___children___id',
  phoneNumber___children___children___children = 'phoneNumber___children___children___children',
  phoneNumber___children___internal___content = 'phoneNumber___children___internal___content',
  phoneNumber___children___internal___contentDigest = 'phoneNumber___children___internal___contentDigest',
  phoneNumber___children___internal___description = 'phoneNumber___children___internal___description',
  phoneNumber___children___internal___fieldOwners = 'phoneNumber___children___internal___fieldOwners',
  phoneNumber___children___internal___ignoreType = 'phoneNumber___children___internal___ignoreType',
  phoneNumber___children___internal___mediaType = 'phoneNumber___children___internal___mediaType',
  phoneNumber___children___internal___owner = 'phoneNumber___children___internal___owner',
  phoneNumber___children___internal___type = 'phoneNumber___children___internal___type',
  phoneNumber___internal___content = 'phoneNumber___internal___content',
  phoneNumber___internal___contentDigest = 'phoneNumber___internal___contentDigest',
  phoneNumber___internal___description = 'phoneNumber___internal___description',
  phoneNumber___internal___fieldOwners = 'phoneNumber___internal___fieldOwners',
  phoneNumber___internal___ignoreType = 'phoneNumber___internal___ignoreType',
  phoneNumber___internal___mediaType = 'phoneNumber___internal___mediaType',
  phoneNumber___internal___owner = 'phoneNumber___internal___owner',
  phoneNumber___internal___type = 'phoneNumber___internal___type',
  contactFormWidgetUrl = 'contactFormWidgetUrl',
  contactFormWidgetClassName = 'contactFormWidgetClassName'
}

export type S3ContentfulContactUsFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  titlePhoneNumber?: Maybe<StringQueryOperatorInput>;
  phoneNumber?: Maybe<S3ContentfulRichTextFilterInput>;
  contactFormWidgetUrl?: Maybe<StringQueryOperatorInput>;
  contactFormWidgetClassName?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulContactUsFilterListInput = {
  elemMatch?: Maybe<S3ContentfulContactUsFilterInput>;
};

export type S3ContentfulContactUsGroupConnection = {
  __typename?: 'S3ContentfulContactUsGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulContactUsEdge>;
  nodes: Array<S3ContentfulContactUs>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulContactUsSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulContactUsFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulDomain = Node & {
  __typename?: 'S3ContentfulDomain';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  gaTrackingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  adobeConfig?: Maybe<S3ContentfulAdobeConfig>;
  oneTrustId?: Maybe<Scalars['String']>;
  oneTrustAutoBlock?: Maybe<Scalars['Boolean']>;
  oneTrustShowSettingsButton?: Maybe<Scalars['Boolean']>;
};

export type S3ContentfulDomainConnection = {
  __typename?: 'S3ContentfulDomainConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulDomainEdge>;
  nodes: Array<S3ContentfulDomain>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulDomainGroupConnection>;
};


export type S3ContentfulDomainConnectionDistinctArgs = {
  field: S3ContentfulDomainFieldsEnum;
};


export type S3ContentfulDomainConnectionMaxArgs = {
  field: S3ContentfulDomainFieldsEnum;
};


export type S3ContentfulDomainConnectionMinArgs = {
  field: S3ContentfulDomainFieldsEnum;
};


export type S3ContentfulDomainConnectionSumArgs = {
  field: S3ContentfulDomainFieldsEnum;
};


export type S3ContentfulDomainConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulDomainFieldsEnum;
};

export type S3ContentfulDomainEdge = {
  __typename?: 'S3ContentfulDomainEdge';
  next?: Maybe<S3ContentfulDomain>;
  node: S3ContentfulDomain;
  previous?: Maybe<S3ContentfulDomain>;
};

export enum S3ContentfulDomainFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  name = 'name',
  path = 'path',
  gaTrackingIds = 'gaTrackingIds',
  adobeConfig___id = 'adobeConfig___id',
  adobeConfig___parent___id = 'adobeConfig___parent___id',
  adobeConfig___parent___parent___id = 'adobeConfig___parent___parent___id',
  adobeConfig___parent___parent___children = 'adobeConfig___parent___parent___children',
  adobeConfig___parent___children = 'adobeConfig___parent___children',
  adobeConfig___parent___children___id = 'adobeConfig___parent___children___id',
  adobeConfig___parent___children___children = 'adobeConfig___parent___children___children',
  adobeConfig___parent___internal___content = 'adobeConfig___parent___internal___content',
  adobeConfig___parent___internal___contentDigest = 'adobeConfig___parent___internal___contentDigest',
  adobeConfig___parent___internal___description = 'adobeConfig___parent___internal___description',
  adobeConfig___parent___internal___fieldOwners = 'adobeConfig___parent___internal___fieldOwners',
  adobeConfig___parent___internal___ignoreType = 'adobeConfig___parent___internal___ignoreType',
  adobeConfig___parent___internal___mediaType = 'adobeConfig___parent___internal___mediaType',
  adobeConfig___parent___internal___owner = 'adobeConfig___parent___internal___owner',
  adobeConfig___parent___internal___type = 'adobeConfig___parent___internal___type',
  adobeConfig___children = 'adobeConfig___children',
  adobeConfig___children___id = 'adobeConfig___children___id',
  adobeConfig___children___parent___id = 'adobeConfig___children___parent___id',
  adobeConfig___children___parent___children = 'adobeConfig___children___parent___children',
  adobeConfig___children___children = 'adobeConfig___children___children',
  adobeConfig___children___children___id = 'adobeConfig___children___children___id',
  adobeConfig___children___children___children = 'adobeConfig___children___children___children',
  adobeConfig___children___internal___content = 'adobeConfig___children___internal___content',
  adobeConfig___children___internal___contentDigest = 'adobeConfig___children___internal___contentDigest',
  adobeConfig___children___internal___description = 'adobeConfig___children___internal___description',
  adobeConfig___children___internal___fieldOwners = 'adobeConfig___children___internal___fieldOwners',
  adobeConfig___children___internal___ignoreType = 'adobeConfig___children___internal___ignoreType',
  adobeConfig___children___internal___mediaType = 'adobeConfig___children___internal___mediaType',
  adobeConfig___children___internal___owner = 'adobeConfig___children___internal___owner',
  adobeConfig___children___internal___type = 'adobeConfig___children___internal___type',
  adobeConfig___internal___content = 'adobeConfig___internal___content',
  adobeConfig___internal___contentDigest = 'adobeConfig___internal___contentDigest',
  adobeConfig___internal___description = 'adobeConfig___internal___description',
  adobeConfig___internal___fieldOwners = 'adobeConfig___internal___fieldOwners',
  adobeConfig___internal___ignoreType = 'adobeConfig___internal___ignoreType',
  adobeConfig___internal___mediaType = 'adobeConfig___internal___mediaType',
  adobeConfig___internal___owner = 'adobeConfig___internal___owner',
  adobeConfig___internal___type = 'adobeConfig___internal___type',
  adobeConfig___account = 'adobeConfig___account',
  adobeConfig___trackingServer = 'adobeConfig___trackingServer',
  adobeConfig___trackingServerSecure = 'adobeConfig___trackingServerSecure',
  adobeConfig___reportSuiteId = 'adobeConfig___reportSuiteId',
  adobeConfig___containerId = 'adobeConfig___containerId',
  adobeConfig___region = 'adobeConfig___region',
  adobeConfig___language = 'adobeConfig___language',
  oneTrustId = 'oneTrustId',
  oneTrustAutoBlock = 'oneTrustAutoBlock',
  oneTrustShowSettingsButton = 'oneTrustShowSettingsButton'
}

export type S3ContentfulDomainFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  name?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  gaTrackingIds?: Maybe<StringQueryOperatorInput>;
  adobeConfig?: Maybe<S3ContentfulAdobeConfigFilterInput>;
  oneTrustId?: Maybe<StringQueryOperatorInput>;
  oneTrustAutoBlock?: Maybe<BooleanQueryOperatorInput>;
  oneTrustShowSettingsButton?: Maybe<BooleanQueryOperatorInput>;
};

export type S3ContentfulDomainGroupConnection = {
  __typename?: 'S3ContentfulDomainGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulDomainEdge>;
  nodes: Array<S3ContentfulDomain>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulDomainSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulDomainFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulLegals = Node & {
  __typename?: 'S3ContentfulLegals';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  privacyNoticeLabel?: Maybe<Scalars['String']>;
  privacyNoticeUrl?: Maybe<Scalars['String']>;
  cookieNoticeLabel?: Maybe<Scalars['String']>;
  cookieNoticeUrl?: Maybe<Scalars['String']>;
  termsOfUseLabel?: Maybe<Scalars['String']>;
  termsOfUseUrl?: Maybe<Scalars['String']>;
  legalWarningLabel?: Maybe<Scalars['String']>;
  legalWarningUrl?: Maybe<Scalars['String']>;
};

export type S3ContentfulLegalsConnection = {
  __typename?: 'S3ContentfulLegalsConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulLegalsEdge>;
  nodes: Array<S3ContentfulLegals>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulLegalsGroupConnection>;
};


export type S3ContentfulLegalsConnectionDistinctArgs = {
  field: S3ContentfulLegalsFieldsEnum;
};


export type S3ContentfulLegalsConnectionMaxArgs = {
  field: S3ContentfulLegalsFieldsEnum;
};


export type S3ContentfulLegalsConnectionMinArgs = {
  field: S3ContentfulLegalsFieldsEnum;
};


export type S3ContentfulLegalsConnectionSumArgs = {
  field: S3ContentfulLegalsFieldsEnum;
};


export type S3ContentfulLegalsConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulLegalsFieldsEnum;
};

export type S3ContentfulLegalsEdge = {
  __typename?: 'S3ContentfulLegalsEdge';
  next?: Maybe<S3ContentfulLegals>;
  node: S3ContentfulLegals;
  previous?: Maybe<S3ContentfulLegals>;
};

export enum S3ContentfulLegalsFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  privacyNoticeLabel = 'privacyNoticeLabel',
  privacyNoticeUrl = 'privacyNoticeUrl',
  cookieNoticeLabel = 'cookieNoticeLabel',
  cookieNoticeUrl = 'cookieNoticeUrl',
  termsOfUseLabel = 'termsOfUseLabel',
  termsOfUseUrl = 'termsOfUseUrl',
  legalWarningLabel = 'legalWarningLabel',
  legalWarningUrl = 'legalWarningUrl'
}

export type S3ContentfulLegalsFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  privacyNoticeLabel?: Maybe<StringQueryOperatorInput>;
  privacyNoticeUrl?: Maybe<StringQueryOperatorInput>;
  cookieNoticeLabel?: Maybe<StringQueryOperatorInput>;
  cookieNoticeUrl?: Maybe<StringQueryOperatorInput>;
  termsOfUseLabel?: Maybe<StringQueryOperatorInput>;
  termsOfUseUrl?: Maybe<StringQueryOperatorInput>;
  legalWarningLabel?: Maybe<StringQueryOperatorInput>;
  legalWarningUrl?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulLegalsGroupConnection = {
  __typename?: 'S3ContentfulLegalsGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulLegalsEdge>;
  nodes: Array<S3ContentfulLegals>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulLegalsSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulLegalsFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulLexicon = Node & {
  __typename?: 'S3ContentfulLexicon';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  benefits?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  home?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  readMore?: Maybe<Scalars['String']>;
  pageNotFoundText?: Maybe<Scalars['String']>;
  opensInNewTab?: Maybe<Scalars['String']>;
};

export type S3ContentfulLexiconConnection = {
  __typename?: 'S3ContentfulLexiconConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulLexiconEdge>;
  nodes: Array<S3ContentfulLexicon>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulLexiconGroupConnection>;
};


export type S3ContentfulLexiconConnectionDistinctArgs = {
  field: S3ContentfulLexiconFieldsEnum;
};


export type S3ContentfulLexiconConnectionMaxArgs = {
  field: S3ContentfulLexiconFieldsEnum;
};


export type S3ContentfulLexiconConnectionMinArgs = {
  field: S3ContentfulLexiconFieldsEnum;
};


export type S3ContentfulLexiconConnectionSumArgs = {
  field: S3ContentfulLexiconFieldsEnum;
};


export type S3ContentfulLexiconConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulLexiconFieldsEnum;
};

export type S3ContentfulLexiconEdge = {
  __typename?: 'S3ContentfulLexiconEdge';
  next?: Maybe<S3ContentfulLexicon>;
  node: S3ContentfulLexicon;
  previous?: Maybe<S3ContentfulLexicon>;
};

export enum S3ContentfulLexiconFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  benefits = 'benefits',
  description = 'description',
  home = 'home',
  ingredients = 'ingredients',
  products = 'products',
  readMore = 'readMore',
  pageNotFoundText = 'pageNotFoundText',
  opensInNewTab = 'opensInNewTab'
}

export type S3ContentfulLexiconFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  home?: Maybe<StringQueryOperatorInput>;
  ingredients?: Maybe<StringQueryOperatorInput>;
  products?: Maybe<StringQueryOperatorInput>;
  readMore?: Maybe<StringQueryOperatorInput>;
  pageNotFoundText?: Maybe<StringQueryOperatorInput>;
  opensInNewTab?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulLexiconGroupConnection = {
  __typename?: 'S3ContentfulLexiconGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulLexiconEdge>;
  nodes: Array<S3ContentfulLexicon>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulLexiconSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulLexiconFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulMessage = Node & {
  __typename?: 'S3ContentfulMessage';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  hero?: Maybe<S3ContentfulAsset>;
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  summaryBackground?: Maybe<S3ContentfulAsset>;
  benefitImages?: Maybe<Array<Maybe<S3ContentfulMessageBenefitImages>>>;
  benefitsDisclaimer?: Maybe<Scalars['String']>;
  main?: Maybe<S3ContentfulRichText>;
  products?: Maybe<Array<Maybe<S3ContentfulProduct>>>;
};

export type S3ContentfulMessageBenefitImages = {
  __typename?: 'S3ContentfulMessageBenefitImages';
  sysId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  file?: Maybe<S3ContentfulMessageBenefitImagesFile>;
};

export type S3ContentfulMessageBenefitImagesFile = {
  __typename?: 'S3ContentfulMessageBenefitImagesFile';
  url?: Maybe<Scalars['String']>;
  details?: Maybe<S3ContentfulMessageBenefitImagesFileDetails>;
  fileName?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
};

export type S3ContentfulMessageBenefitImagesFileDetails = {
  __typename?: 'S3ContentfulMessageBenefitImagesFileDetails';
  size?: Maybe<Scalars['Int']>;
  image?: Maybe<S3ContentfulMessageBenefitImagesFileDetailsImage>;
};

export type S3ContentfulMessageBenefitImagesFileDetailsFilterInput = {
  size?: Maybe<IntQueryOperatorInput>;
  image?: Maybe<S3ContentfulMessageBenefitImagesFileDetailsImageFilterInput>;
};

export type S3ContentfulMessageBenefitImagesFileDetailsImage = {
  __typename?: 'S3ContentfulMessageBenefitImagesFileDetailsImage';
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type S3ContentfulMessageBenefitImagesFileDetailsImageFilterInput = {
  width?: Maybe<IntQueryOperatorInput>;
  height?: Maybe<IntQueryOperatorInput>;
};

export type S3ContentfulMessageBenefitImagesFileFilterInput = {
  url?: Maybe<StringQueryOperatorInput>;
  details?: Maybe<S3ContentfulMessageBenefitImagesFileDetailsFilterInput>;
  fileName?: Maybe<StringQueryOperatorInput>;
  contentType?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulMessageBenefitImagesFilterInput = {
  sysId?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  file?: Maybe<S3ContentfulMessageBenefitImagesFileFilterInput>;
};

export type S3ContentfulMessageBenefitImagesFilterListInput = {
  elemMatch?: Maybe<S3ContentfulMessageBenefitImagesFilterInput>;
};

export type S3ContentfulMessageConnection = {
  __typename?: 'S3ContentfulMessageConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulMessageEdge>;
  nodes: Array<S3ContentfulMessage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulMessageGroupConnection>;
};


export type S3ContentfulMessageConnectionDistinctArgs = {
  field: S3ContentfulMessageFieldsEnum;
};


export type S3ContentfulMessageConnectionMaxArgs = {
  field: S3ContentfulMessageFieldsEnum;
};


export type S3ContentfulMessageConnectionMinArgs = {
  field: S3ContentfulMessageFieldsEnum;
};


export type S3ContentfulMessageConnectionSumArgs = {
  field: S3ContentfulMessageFieldsEnum;
};


export type S3ContentfulMessageConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulMessageFieldsEnum;
};

export type S3ContentfulMessageEdge = {
  __typename?: 'S3ContentfulMessageEdge';
  next?: Maybe<S3ContentfulMessage>;
  node: S3ContentfulMessage;
  previous?: Maybe<S3ContentfulMessage>;
};

export enum S3ContentfulMessageFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  hero___id = 'hero___id',
  hero___parent___id = 'hero___parent___id',
  hero___parent___parent___id = 'hero___parent___parent___id',
  hero___parent___parent___children = 'hero___parent___parent___children',
  hero___parent___children = 'hero___parent___children',
  hero___parent___children___id = 'hero___parent___children___id',
  hero___parent___children___children = 'hero___parent___children___children',
  hero___parent___internal___content = 'hero___parent___internal___content',
  hero___parent___internal___contentDigest = 'hero___parent___internal___contentDigest',
  hero___parent___internal___description = 'hero___parent___internal___description',
  hero___parent___internal___fieldOwners = 'hero___parent___internal___fieldOwners',
  hero___parent___internal___ignoreType = 'hero___parent___internal___ignoreType',
  hero___parent___internal___mediaType = 'hero___parent___internal___mediaType',
  hero___parent___internal___owner = 'hero___parent___internal___owner',
  hero___parent___internal___type = 'hero___parent___internal___type',
  hero___children = 'hero___children',
  hero___children___id = 'hero___children___id',
  hero___children___parent___id = 'hero___children___parent___id',
  hero___children___parent___children = 'hero___children___parent___children',
  hero___children___children = 'hero___children___children',
  hero___children___children___id = 'hero___children___children___id',
  hero___children___children___children = 'hero___children___children___children',
  hero___children___internal___content = 'hero___children___internal___content',
  hero___children___internal___contentDigest = 'hero___children___internal___contentDigest',
  hero___children___internal___description = 'hero___children___internal___description',
  hero___children___internal___fieldOwners = 'hero___children___internal___fieldOwners',
  hero___children___internal___ignoreType = 'hero___children___internal___ignoreType',
  hero___children___internal___mediaType = 'hero___children___internal___mediaType',
  hero___children___internal___owner = 'hero___children___internal___owner',
  hero___children___internal___type = 'hero___children___internal___type',
  hero___internal___content = 'hero___internal___content',
  hero___internal___contentDigest = 'hero___internal___contentDigest',
  hero___internal___description = 'hero___internal___description',
  hero___internal___fieldOwners = 'hero___internal___fieldOwners',
  hero___internal___ignoreType = 'hero___internal___ignoreType',
  hero___internal___mediaType = 'hero___internal___mediaType',
  hero___internal___owner = 'hero___internal___owner',
  hero___internal___type = 'hero___internal___type',
  hero___url = 'hero___url',
  hero___details___size = 'hero___details___size',
  hero___details___image___width = 'hero___details___image___width',
  hero___details___image___height = 'hero___details___image___height',
  hero___fileName = 'hero___fileName',
  hero___contentType = 'hero___contentType',
  title = 'title',
  summary = 'summary',
  summaryBackground___id = 'summaryBackground___id',
  summaryBackground___parent___id = 'summaryBackground___parent___id',
  summaryBackground___parent___parent___id = 'summaryBackground___parent___parent___id',
  summaryBackground___parent___parent___children = 'summaryBackground___parent___parent___children',
  summaryBackground___parent___children = 'summaryBackground___parent___children',
  summaryBackground___parent___children___id = 'summaryBackground___parent___children___id',
  summaryBackground___parent___children___children = 'summaryBackground___parent___children___children',
  summaryBackground___parent___internal___content = 'summaryBackground___parent___internal___content',
  summaryBackground___parent___internal___contentDigest = 'summaryBackground___parent___internal___contentDigest',
  summaryBackground___parent___internal___description = 'summaryBackground___parent___internal___description',
  summaryBackground___parent___internal___fieldOwners = 'summaryBackground___parent___internal___fieldOwners',
  summaryBackground___parent___internal___ignoreType = 'summaryBackground___parent___internal___ignoreType',
  summaryBackground___parent___internal___mediaType = 'summaryBackground___parent___internal___mediaType',
  summaryBackground___parent___internal___owner = 'summaryBackground___parent___internal___owner',
  summaryBackground___parent___internal___type = 'summaryBackground___parent___internal___type',
  summaryBackground___children = 'summaryBackground___children',
  summaryBackground___children___id = 'summaryBackground___children___id',
  summaryBackground___children___parent___id = 'summaryBackground___children___parent___id',
  summaryBackground___children___parent___children = 'summaryBackground___children___parent___children',
  summaryBackground___children___children = 'summaryBackground___children___children',
  summaryBackground___children___children___id = 'summaryBackground___children___children___id',
  summaryBackground___children___children___children = 'summaryBackground___children___children___children',
  summaryBackground___children___internal___content = 'summaryBackground___children___internal___content',
  summaryBackground___children___internal___contentDigest = 'summaryBackground___children___internal___contentDigest',
  summaryBackground___children___internal___description = 'summaryBackground___children___internal___description',
  summaryBackground___children___internal___fieldOwners = 'summaryBackground___children___internal___fieldOwners',
  summaryBackground___children___internal___ignoreType = 'summaryBackground___children___internal___ignoreType',
  summaryBackground___children___internal___mediaType = 'summaryBackground___children___internal___mediaType',
  summaryBackground___children___internal___owner = 'summaryBackground___children___internal___owner',
  summaryBackground___children___internal___type = 'summaryBackground___children___internal___type',
  summaryBackground___internal___content = 'summaryBackground___internal___content',
  summaryBackground___internal___contentDigest = 'summaryBackground___internal___contentDigest',
  summaryBackground___internal___description = 'summaryBackground___internal___description',
  summaryBackground___internal___fieldOwners = 'summaryBackground___internal___fieldOwners',
  summaryBackground___internal___ignoreType = 'summaryBackground___internal___ignoreType',
  summaryBackground___internal___mediaType = 'summaryBackground___internal___mediaType',
  summaryBackground___internal___owner = 'summaryBackground___internal___owner',
  summaryBackground___internal___type = 'summaryBackground___internal___type',
  summaryBackground___url = 'summaryBackground___url',
  summaryBackground___details___size = 'summaryBackground___details___size',
  summaryBackground___details___image___width = 'summaryBackground___details___image___width',
  summaryBackground___details___image___height = 'summaryBackground___details___image___height',
  summaryBackground___fileName = 'summaryBackground___fileName',
  summaryBackground___contentType = 'summaryBackground___contentType',
  benefitImages = 'benefitImages',
  benefitImages___sysId = 'benefitImages___sysId',
  benefitImages___title = 'benefitImages___title',
  benefitImages___description = 'benefitImages___description',
  benefitImages___file___url = 'benefitImages___file___url',
  benefitImages___file___details___size = 'benefitImages___file___details___size',
  benefitImages___file___fileName = 'benefitImages___file___fileName',
  benefitImages___file___contentType = 'benefitImages___file___contentType',
  benefitsDisclaimer = 'benefitsDisclaimer',
  main___raw = 'main___raw',
  main___id = 'main___id',
  main___parent___id = 'main___parent___id',
  main___parent___parent___id = 'main___parent___parent___id',
  main___parent___parent___children = 'main___parent___parent___children',
  main___parent___children = 'main___parent___children',
  main___parent___children___id = 'main___parent___children___id',
  main___parent___children___children = 'main___parent___children___children',
  main___parent___internal___content = 'main___parent___internal___content',
  main___parent___internal___contentDigest = 'main___parent___internal___contentDigest',
  main___parent___internal___description = 'main___parent___internal___description',
  main___parent___internal___fieldOwners = 'main___parent___internal___fieldOwners',
  main___parent___internal___ignoreType = 'main___parent___internal___ignoreType',
  main___parent___internal___mediaType = 'main___parent___internal___mediaType',
  main___parent___internal___owner = 'main___parent___internal___owner',
  main___parent___internal___type = 'main___parent___internal___type',
  main___children = 'main___children',
  main___children___id = 'main___children___id',
  main___children___parent___id = 'main___children___parent___id',
  main___children___parent___children = 'main___children___parent___children',
  main___children___children = 'main___children___children',
  main___children___children___id = 'main___children___children___id',
  main___children___children___children = 'main___children___children___children',
  main___children___internal___content = 'main___children___internal___content',
  main___children___internal___contentDigest = 'main___children___internal___contentDigest',
  main___children___internal___description = 'main___children___internal___description',
  main___children___internal___fieldOwners = 'main___children___internal___fieldOwners',
  main___children___internal___ignoreType = 'main___children___internal___ignoreType',
  main___children___internal___mediaType = 'main___children___internal___mediaType',
  main___children___internal___owner = 'main___children___internal___owner',
  main___children___internal___type = 'main___children___internal___type',
  main___internal___content = 'main___internal___content',
  main___internal___contentDigest = 'main___internal___contentDigest',
  main___internal___description = 'main___internal___description',
  main___internal___fieldOwners = 'main___internal___fieldOwners',
  main___internal___ignoreType = 'main___internal___ignoreType',
  main___internal___mediaType = 'main___internal___mediaType',
  main___internal___owner = 'main___internal___owner',
  main___internal___type = 'main___internal___type',
  products = 'products',
  products___id = 'products___id',
  products___parent___id = 'products___parent___id',
  products___parent___parent___id = 'products___parent___parent___id',
  products___parent___parent___children = 'products___parent___parent___children',
  products___parent___children = 'products___parent___children',
  products___parent___children___id = 'products___parent___children___id',
  products___parent___children___children = 'products___parent___children___children',
  products___parent___internal___content = 'products___parent___internal___content',
  products___parent___internal___contentDigest = 'products___parent___internal___contentDigest',
  products___parent___internal___description = 'products___parent___internal___description',
  products___parent___internal___fieldOwners = 'products___parent___internal___fieldOwners',
  products___parent___internal___ignoreType = 'products___parent___internal___ignoreType',
  products___parent___internal___mediaType = 'products___parent___internal___mediaType',
  products___parent___internal___owner = 'products___parent___internal___owner',
  products___parent___internal___type = 'products___parent___internal___type',
  products___children = 'products___children',
  products___children___id = 'products___children___id',
  products___children___parent___id = 'products___children___parent___id',
  products___children___parent___children = 'products___children___parent___children',
  products___children___children = 'products___children___children',
  products___children___children___id = 'products___children___children___id',
  products___children___children___children = 'products___children___children___children',
  products___children___internal___content = 'products___children___internal___content',
  products___children___internal___contentDigest = 'products___children___internal___contentDigest',
  products___children___internal___description = 'products___children___internal___description',
  products___children___internal___fieldOwners = 'products___children___internal___fieldOwners',
  products___children___internal___ignoreType = 'products___children___internal___ignoreType',
  products___children___internal___mediaType = 'products___children___internal___mediaType',
  products___children___internal___owner = 'products___children___internal___owner',
  products___children___internal___type = 'products___children___internal___type',
  products___internal___content = 'products___internal___content',
  products___internal___contentDigest = 'products___internal___contentDigest',
  products___internal___description = 'products___internal___description',
  products___internal___fieldOwners = 'products___internal___fieldOwners',
  products___internal___ignoreType = 'products___internal___ignoreType',
  products___internal___mediaType = 'products___internal___mediaType',
  products___internal___owner = 'products___internal___owner',
  products___internal___type = 'products___internal___type',
  products___slug = 'products___slug',
  products___name = 'products___name',
  products___description___raw = 'products___description___raw',
  products___description___id = 'products___description___id',
  products___description___parent___id = 'products___description___parent___id',
  products___description___parent___children = 'products___description___parent___children',
  products___description___children = 'products___description___children',
  products___description___children___id = 'products___description___children___id',
  products___description___children___children = 'products___description___children___children',
  products___description___internal___content = 'products___description___internal___content',
  products___description___internal___contentDigest = 'products___description___internal___contentDigest',
  products___description___internal___description = 'products___description___internal___description',
  products___description___internal___fieldOwners = 'products___description___internal___fieldOwners',
  products___description___internal___ignoreType = 'products___description___internal___ignoreType',
  products___description___internal___mediaType = 'products___description___internal___mediaType',
  products___description___internal___owner = 'products___description___internal___owner',
  products___description___internal___type = 'products___description___internal___type',
  products___benefits = 'products___benefits',
  products___variants = 'products___variants',
  products___variants___id = 'products___variants___id',
  products___variants___parent___id = 'products___variants___parent___id',
  products___variants___parent___children = 'products___variants___parent___children',
  products___variants___children = 'products___variants___children',
  products___variants___children___id = 'products___variants___children___id',
  products___variants___children___children = 'products___variants___children___children',
  products___variants___internal___content = 'products___variants___internal___content',
  products___variants___internal___contentDigest = 'products___variants___internal___contentDigest',
  products___variants___internal___description = 'products___variants___internal___description',
  products___variants___internal___fieldOwners = 'products___variants___internal___fieldOwners',
  products___variants___internal___ignoreType = 'products___variants___internal___ignoreType',
  products___variants___internal___mediaType = 'products___variants___internal___mediaType',
  products___variants___internal___owner = 'products___variants___internal___owner',
  products___variants___internal___type = 'products___variants___internal___type',
  products___variants___slug = 'products___variants___slug',
  products___variants___name = 'products___variants___name',
  products___variants___packshot___id = 'products___variants___packshot___id',
  products___variants___packshot___children = 'products___variants___packshot___children',
  products___variants___packshot___url = 'products___variants___packshot___url',
  products___variants___packshot___fileName = 'products___variants___packshot___fileName',
  products___variants___packshot___contentType = 'products___variants___packshot___contentType',
  products___variants___sizes = 'products___variants___sizes',
  products___hero___id = 'products___hero___id',
  products___hero___parent___id = 'products___hero___parent___id',
  products___hero___parent___children = 'products___hero___parent___children',
  products___hero___children = 'products___hero___children',
  products___hero___children___id = 'products___hero___children___id',
  products___hero___children___children = 'products___hero___children___children',
  products___hero___internal___content = 'products___hero___internal___content',
  products___hero___internal___contentDigest = 'products___hero___internal___contentDigest',
  products___hero___internal___description = 'products___hero___internal___description',
  products___hero___internal___fieldOwners = 'products___hero___internal___fieldOwners',
  products___hero___internal___ignoreType = 'products___hero___internal___ignoreType',
  products___hero___internal___mediaType = 'products___hero___internal___mediaType',
  products___hero___internal___owner = 'products___hero___internal___owner',
  products___hero___internal___type = 'products___hero___internal___type',
  products___hero___url = 'products___hero___url',
  products___hero___details___size = 'products___hero___details___size',
  products___hero___fileName = 'products___hero___fileName',
  products___hero___contentType = 'products___hero___contentType'
}

export type S3ContentfulMessageFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<S3ContentfulAssetFilterInput>;
  benefitImages?: Maybe<S3ContentfulMessageBenefitImagesFilterListInput>;
  benefitsDisclaimer?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<S3ContentfulRichTextFilterInput>;
  products?: Maybe<S3ContentfulProductFilterListInput>;
};

export type S3ContentfulMessageFilterListInput = {
  elemMatch?: Maybe<S3ContentfulMessageFilterInput>;
};

export type S3ContentfulMessageGroupConnection = {
  __typename?: 'S3ContentfulMessageGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulMessageEdge>;
  nodes: Array<S3ContentfulMessage>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulMessageSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulMessageFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulProduct = Node & {
  __typename?: 'S3ContentfulProduct';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<S3ContentfulRichText>;
  benefits?: Maybe<Array<Maybe<Scalars['String']>>>;
  variants?: Maybe<Array<Maybe<S3ContentfulVariant>>>;
  hero?: Maybe<S3ContentfulAsset>;
};

export type S3ContentfulProductConnection = {
  __typename?: 'S3ContentfulProductConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulProductEdge>;
  nodes: Array<S3ContentfulProduct>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulProductGroupConnection>;
};


export type S3ContentfulProductConnectionDistinctArgs = {
  field: S3ContentfulProductFieldsEnum;
};


export type S3ContentfulProductConnectionMaxArgs = {
  field: S3ContentfulProductFieldsEnum;
};


export type S3ContentfulProductConnectionMinArgs = {
  field: S3ContentfulProductFieldsEnum;
};


export type S3ContentfulProductConnectionSumArgs = {
  field: S3ContentfulProductFieldsEnum;
};


export type S3ContentfulProductConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulProductFieldsEnum;
};

export type S3ContentfulProductEdge = {
  __typename?: 'S3ContentfulProductEdge';
  next?: Maybe<S3ContentfulProduct>;
  node: S3ContentfulProduct;
  previous?: Maybe<S3ContentfulProduct>;
};

export enum S3ContentfulProductFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  name = 'name',
  description___raw = 'description___raw',
  description___id = 'description___id',
  description___parent___id = 'description___parent___id',
  description___parent___parent___id = 'description___parent___parent___id',
  description___parent___parent___children = 'description___parent___parent___children',
  description___parent___children = 'description___parent___children',
  description___parent___children___id = 'description___parent___children___id',
  description___parent___children___children = 'description___parent___children___children',
  description___parent___internal___content = 'description___parent___internal___content',
  description___parent___internal___contentDigest = 'description___parent___internal___contentDigest',
  description___parent___internal___description = 'description___parent___internal___description',
  description___parent___internal___fieldOwners = 'description___parent___internal___fieldOwners',
  description___parent___internal___ignoreType = 'description___parent___internal___ignoreType',
  description___parent___internal___mediaType = 'description___parent___internal___mediaType',
  description___parent___internal___owner = 'description___parent___internal___owner',
  description___parent___internal___type = 'description___parent___internal___type',
  description___children = 'description___children',
  description___children___id = 'description___children___id',
  description___children___parent___id = 'description___children___parent___id',
  description___children___parent___children = 'description___children___parent___children',
  description___children___children = 'description___children___children',
  description___children___children___id = 'description___children___children___id',
  description___children___children___children = 'description___children___children___children',
  description___children___internal___content = 'description___children___internal___content',
  description___children___internal___contentDigest = 'description___children___internal___contentDigest',
  description___children___internal___description = 'description___children___internal___description',
  description___children___internal___fieldOwners = 'description___children___internal___fieldOwners',
  description___children___internal___ignoreType = 'description___children___internal___ignoreType',
  description___children___internal___mediaType = 'description___children___internal___mediaType',
  description___children___internal___owner = 'description___children___internal___owner',
  description___children___internal___type = 'description___children___internal___type',
  description___internal___content = 'description___internal___content',
  description___internal___contentDigest = 'description___internal___contentDigest',
  description___internal___description = 'description___internal___description',
  description___internal___fieldOwners = 'description___internal___fieldOwners',
  description___internal___ignoreType = 'description___internal___ignoreType',
  description___internal___mediaType = 'description___internal___mediaType',
  description___internal___owner = 'description___internal___owner',
  description___internal___type = 'description___internal___type',
  benefits = 'benefits',
  variants = 'variants',
  variants___id = 'variants___id',
  variants___parent___id = 'variants___parent___id',
  variants___parent___parent___id = 'variants___parent___parent___id',
  variants___parent___parent___children = 'variants___parent___parent___children',
  variants___parent___children = 'variants___parent___children',
  variants___parent___children___id = 'variants___parent___children___id',
  variants___parent___children___children = 'variants___parent___children___children',
  variants___parent___internal___content = 'variants___parent___internal___content',
  variants___parent___internal___contentDigest = 'variants___parent___internal___contentDigest',
  variants___parent___internal___description = 'variants___parent___internal___description',
  variants___parent___internal___fieldOwners = 'variants___parent___internal___fieldOwners',
  variants___parent___internal___ignoreType = 'variants___parent___internal___ignoreType',
  variants___parent___internal___mediaType = 'variants___parent___internal___mediaType',
  variants___parent___internal___owner = 'variants___parent___internal___owner',
  variants___parent___internal___type = 'variants___parent___internal___type',
  variants___children = 'variants___children',
  variants___children___id = 'variants___children___id',
  variants___children___parent___id = 'variants___children___parent___id',
  variants___children___parent___children = 'variants___children___parent___children',
  variants___children___children = 'variants___children___children',
  variants___children___children___id = 'variants___children___children___id',
  variants___children___children___children = 'variants___children___children___children',
  variants___children___internal___content = 'variants___children___internal___content',
  variants___children___internal___contentDigest = 'variants___children___internal___contentDigest',
  variants___children___internal___description = 'variants___children___internal___description',
  variants___children___internal___fieldOwners = 'variants___children___internal___fieldOwners',
  variants___children___internal___ignoreType = 'variants___children___internal___ignoreType',
  variants___children___internal___mediaType = 'variants___children___internal___mediaType',
  variants___children___internal___owner = 'variants___children___internal___owner',
  variants___children___internal___type = 'variants___children___internal___type',
  variants___internal___content = 'variants___internal___content',
  variants___internal___contentDigest = 'variants___internal___contentDigest',
  variants___internal___description = 'variants___internal___description',
  variants___internal___fieldOwners = 'variants___internal___fieldOwners',
  variants___internal___ignoreType = 'variants___internal___ignoreType',
  variants___internal___mediaType = 'variants___internal___mediaType',
  variants___internal___owner = 'variants___internal___owner',
  variants___internal___type = 'variants___internal___type',
  variants___slug = 'variants___slug',
  variants___name = 'variants___name',
  variants___packshot___id = 'variants___packshot___id',
  variants___packshot___parent___id = 'variants___packshot___parent___id',
  variants___packshot___parent___children = 'variants___packshot___parent___children',
  variants___packshot___children = 'variants___packshot___children',
  variants___packshot___children___id = 'variants___packshot___children___id',
  variants___packshot___children___children = 'variants___packshot___children___children',
  variants___packshot___internal___content = 'variants___packshot___internal___content',
  variants___packshot___internal___contentDigest = 'variants___packshot___internal___contentDigest',
  variants___packshot___internal___description = 'variants___packshot___internal___description',
  variants___packshot___internal___fieldOwners = 'variants___packshot___internal___fieldOwners',
  variants___packshot___internal___ignoreType = 'variants___packshot___internal___ignoreType',
  variants___packshot___internal___mediaType = 'variants___packshot___internal___mediaType',
  variants___packshot___internal___owner = 'variants___packshot___internal___owner',
  variants___packshot___internal___type = 'variants___packshot___internal___type',
  variants___packshot___url = 'variants___packshot___url',
  variants___packshot___details___size = 'variants___packshot___details___size',
  variants___packshot___fileName = 'variants___packshot___fileName',
  variants___packshot___contentType = 'variants___packshot___contentType',
  variants___sizes = 'variants___sizes',
  hero___id = 'hero___id',
  hero___parent___id = 'hero___parent___id',
  hero___parent___parent___id = 'hero___parent___parent___id',
  hero___parent___parent___children = 'hero___parent___parent___children',
  hero___parent___children = 'hero___parent___children',
  hero___parent___children___id = 'hero___parent___children___id',
  hero___parent___children___children = 'hero___parent___children___children',
  hero___parent___internal___content = 'hero___parent___internal___content',
  hero___parent___internal___contentDigest = 'hero___parent___internal___contentDigest',
  hero___parent___internal___description = 'hero___parent___internal___description',
  hero___parent___internal___fieldOwners = 'hero___parent___internal___fieldOwners',
  hero___parent___internal___ignoreType = 'hero___parent___internal___ignoreType',
  hero___parent___internal___mediaType = 'hero___parent___internal___mediaType',
  hero___parent___internal___owner = 'hero___parent___internal___owner',
  hero___parent___internal___type = 'hero___parent___internal___type',
  hero___children = 'hero___children',
  hero___children___id = 'hero___children___id',
  hero___children___parent___id = 'hero___children___parent___id',
  hero___children___parent___children = 'hero___children___parent___children',
  hero___children___children = 'hero___children___children',
  hero___children___children___id = 'hero___children___children___id',
  hero___children___children___children = 'hero___children___children___children',
  hero___children___internal___content = 'hero___children___internal___content',
  hero___children___internal___contentDigest = 'hero___children___internal___contentDigest',
  hero___children___internal___description = 'hero___children___internal___description',
  hero___children___internal___fieldOwners = 'hero___children___internal___fieldOwners',
  hero___children___internal___ignoreType = 'hero___children___internal___ignoreType',
  hero___children___internal___mediaType = 'hero___children___internal___mediaType',
  hero___children___internal___owner = 'hero___children___internal___owner',
  hero___children___internal___type = 'hero___children___internal___type',
  hero___internal___content = 'hero___internal___content',
  hero___internal___contentDigest = 'hero___internal___contentDigest',
  hero___internal___description = 'hero___internal___description',
  hero___internal___fieldOwners = 'hero___internal___fieldOwners',
  hero___internal___ignoreType = 'hero___internal___ignoreType',
  hero___internal___mediaType = 'hero___internal___mediaType',
  hero___internal___owner = 'hero___internal___owner',
  hero___internal___type = 'hero___internal___type',
  hero___url = 'hero___url',
  hero___details___size = 'hero___details___size',
  hero___details___image___width = 'hero___details___image___width',
  hero___details___image___height = 'hero___details___image___height',
  hero___fileName = 'hero___fileName',
  hero___contentType = 'hero___contentType'
}

export type S3ContentfulProductFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<S3ContentfulRichTextFilterInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  variants?: Maybe<S3ContentfulVariantFilterListInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
};

export type S3ContentfulProductFilterListInput = {
  elemMatch?: Maybe<S3ContentfulProductFilterInput>;
};

export type S3ContentfulProductGroupConnection = {
  __typename?: 'S3ContentfulProductGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulProductEdge>;
  nodes: Array<S3ContentfulProduct>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulProductSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulProductFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulRichText = Node & {
  __typename?: 'S3ContentfulRichText';
  raw: Scalars['JSON'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type S3ContentfulRichTextConnection = {
  __typename?: 'S3ContentfulRichTextConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulRichTextEdge>;
  nodes: Array<S3ContentfulRichText>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulRichTextGroupConnection>;
};


export type S3ContentfulRichTextConnectionDistinctArgs = {
  field: S3ContentfulRichTextFieldsEnum;
};


export type S3ContentfulRichTextConnectionMaxArgs = {
  field: S3ContentfulRichTextFieldsEnum;
};


export type S3ContentfulRichTextConnectionMinArgs = {
  field: S3ContentfulRichTextFieldsEnum;
};


export type S3ContentfulRichTextConnectionSumArgs = {
  field: S3ContentfulRichTextFieldsEnum;
};


export type S3ContentfulRichTextConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulRichTextFieldsEnum;
};

export type S3ContentfulRichTextEdge = {
  __typename?: 'S3ContentfulRichTextEdge';
  next?: Maybe<S3ContentfulRichText>;
  node: S3ContentfulRichText;
  previous?: Maybe<S3ContentfulRichText>;
};

export enum S3ContentfulRichTextFieldsEnum {
  raw = 'raw',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type S3ContentfulRichTextFilterInput = {
  raw?: Maybe<JsonQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type S3ContentfulRichTextGroupConnection = {
  __typename?: 'S3ContentfulRichTextGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulRichTextEdge>;
  nodes: Array<S3ContentfulRichText>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulRichTextSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulRichTextFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulSitemap = Node & {
  __typename?: 'S3ContentfulSitemap';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
};

export type S3ContentfulSitemapConnection = {
  __typename?: 'S3ContentfulSitemapConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulSitemapEdge>;
  nodes: Array<S3ContentfulSitemap>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulSitemapGroupConnection>;
};


export type S3ContentfulSitemapConnectionDistinctArgs = {
  field: S3ContentfulSitemapFieldsEnum;
};


export type S3ContentfulSitemapConnectionMaxArgs = {
  field: S3ContentfulSitemapFieldsEnum;
};


export type S3ContentfulSitemapConnectionMinArgs = {
  field: S3ContentfulSitemapFieldsEnum;
};


export type S3ContentfulSitemapConnectionSumArgs = {
  field: S3ContentfulSitemapFieldsEnum;
};


export type S3ContentfulSitemapConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulSitemapFieldsEnum;
};

export type S3ContentfulSitemapEdge = {
  __typename?: 'S3ContentfulSitemapEdge';
  next?: Maybe<S3ContentfulSitemap>;
  node: S3ContentfulSitemap;
  previous?: Maybe<S3ContentfulSitemap>;
};

export enum S3ContentfulSitemapFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  title = 'title',
  heading = 'heading'
}

export type S3ContentfulSitemapFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  heading?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulSitemapGroupConnection = {
  __typename?: 'S3ContentfulSitemapGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulSitemapEdge>;
  nodes: Array<S3ContentfulSitemap>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulSitemapSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulSitemapFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulSocialChannel = Node & {
  __typename?: 'S3ContentfulSocialChannel';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  image?: Maybe<S3ContentfulAsset>;
};

export type S3ContentfulSocialChannelConnection = {
  __typename?: 'S3ContentfulSocialChannelConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulSocialChannelEdge>;
  nodes: Array<S3ContentfulSocialChannel>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulSocialChannelGroupConnection>;
};


export type S3ContentfulSocialChannelConnectionDistinctArgs = {
  field: S3ContentfulSocialChannelFieldsEnum;
};


export type S3ContentfulSocialChannelConnectionMaxArgs = {
  field: S3ContentfulSocialChannelFieldsEnum;
};


export type S3ContentfulSocialChannelConnectionMinArgs = {
  field: S3ContentfulSocialChannelFieldsEnum;
};


export type S3ContentfulSocialChannelConnectionSumArgs = {
  field: S3ContentfulSocialChannelFieldsEnum;
};


export type S3ContentfulSocialChannelConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulSocialChannelFieldsEnum;
};

export type S3ContentfulSocialChannelEdge = {
  __typename?: 'S3ContentfulSocialChannelEdge';
  next?: Maybe<S3ContentfulSocialChannel>;
  node: S3ContentfulSocialChannel;
  previous?: Maybe<S3ContentfulSocialChannel>;
};

export enum S3ContentfulSocialChannelFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  url = 'url',
  name = 'name',
  image___id = 'image___id',
  image___parent___id = 'image___parent___id',
  image___parent___parent___id = 'image___parent___parent___id',
  image___parent___parent___children = 'image___parent___parent___children',
  image___parent___children = 'image___parent___children',
  image___parent___children___id = 'image___parent___children___id',
  image___parent___children___children = 'image___parent___children___children',
  image___parent___internal___content = 'image___parent___internal___content',
  image___parent___internal___contentDigest = 'image___parent___internal___contentDigest',
  image___parent___internal___description = 'image___parent___internal___description',
  image___parent___internal___fieldOwners = 'image___parent___internal___fieldOwners',
  image___parent___internal___ignoreType = 'image___parent___internal___ignoreType',
  image___parent___internal___mediaType = 'image___parent___internal___mediaType',
  image___parent___internal___owner = 'image___parent___internal___owner',
  image___parent___internal___type = 'image___parent___internal___type',
  image___children = 'image___children',
  image___children___id = 'image___children___id',
  image___children___parent___id = 'image___children___parent___id',
  image___children___parent___children = 'image___children___parent___children',
  image___children___children = 'image___children___children',
  image___children___children___id = 'image___children___children___id',
  image___children___children___children = 'image___children___children___children',
  image___children___internal___content = 'image___children___internal___content',
  image___children___internal___contentDigest = 'image___children___internal___contentDigest',
  image___children___internal___description = 'image___children___internal___description',
  image___children___internal___fieldOwners = 'image___children___internal___fieldOwners',
  image___children___internal___ignoreType = 'image___children___internal___ignoreType',
  image___children___internal___mediaType = 'image___children___internal___mediaType',
  image___children___internal___owner = 'image___children___internal___owner',
  image___children___internal___type = 'image___children___internal___type',
  image___internal___content = 'image___internal___content',
  image___internal___contentDigest = 'image___internal___contentDigest',
  image___internal___description = 'image___internal___description',
  image___internal___fieldOwners = 'image___internal___fieldOwners',
  image___internal___ignoreType = 'image___internal___ignoreType',
  image___internal___mediaType = 'image___internal___mediaType',
  image___internal___owner = 'image___internal___owner',
  image___internal___type = 'image___internal___type',
  image___url = 'image___url',
  image___details___size = 'image___details___size',
  image___details___image___width = 'image___details___image___width',
  image___details___image___height = 'image___details___image___height',
  image___fileName = 'image___fileName',
  image___contentType = 'image___contentType'
}

export type S3ContentfulSocialChannelFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  url?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  image?: Maybe<S3ContentfulAssetFilterInput>;
};

export type S3ContentfulSocialChannelFilterListInput = {
  elemMatch?: Maybe<S3ContentfulSocialChannelFilterInput>;
};

export type S3ContentfulSocialChannelGroupConnection = {
  __typename?: 'S3ContentfulSocialChannelGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulSocialChannelEdge>;
  nodes: Array<S3ContentfulSocialChannel>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulSocialChannelSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulSocialChannelFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulTopic = Node & {
  __typename?: 'S3ContentfulTopic';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  hero?: Maybe<S3ContentfulAsset>;
  title?: Maybe<Scalars['String']>;
  navigationTitle?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<S3ContentfulMessage>>>;
};

export type S3ContentfulTopicConnection = {
  __typename?: 'S3ContentfulTopicConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulTopicEdge>;
  nodes: Array<S3ContentfulTopic>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulTopicGroupConnection>;
};


export type S3ContentfulTopicConnectionDistinctArgs = {
  field: S3ContentfulTopicFieldsEnum;
};


export type S3ContentfulTopicConnectionMaxArgs = {
  field: S3ContentfulTopicFieldsEnum;
};


export type S3ContentfulTopicConnectionMinArgs = {
  field: S3ContentfulTopicFieldsEnum;
};


export type S3ContentfulTopicConnectionSumArgs = {
  field: S3ContentfulTopicFieldsEnum;
};


export type S3ContentfulTopicConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulTopicFieldsEnum;
};

export type S3ContentfulTopicEdge = {
  __typename?: 'S3ContentfulTopicEdge';
  next?: Maybe<S3ContentfulTopic>;
  node: S3ContentfulTopic;
  previous?: Maybe<S3ContentfulTopic>;
};

export enum S3ContentfulTopicFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  hero___id = 'hero___id',
  hero___parent___id = 'hero___parent___id',
  hero___parent___parent___id = 'hero___parent___parent___id',
  hero___parent___parent___children = 'hero___parent___parent___children',
  hero___parent___children = 'hero___parent___children',
  hero___parent___children___id = 'hero___parent___children___id',
  hero___parent___children___children = 'hero___parent___children___children',
  hero___parent___internal___content = 'hero___parent___internal___content',
  hero___parent___internal___contentDigest = 'hero___parent___internal___contentDigest',
  hero___parent___internal___description = 'hero___parent___internal___description',
  hero___parent___internal___fieldOwners = 'hero___parent___internal___fieldOwners',
  hero___parent___internal___ignoreType = 'hero___parent___internal___ignoreType',
  hero___parent___internal___mediaType = 'hero___parent___internal___mediaType',
  hero___parent___internal___owner = 'hero___parent___internal___owner',
  hero___parent___internal___type = 'hero___parent___internal___type',
  hero___children = 'hero___children',
  hero___children___id = 'hero___children___id',
  hero___children___parent___id = 'hero___children___parent___id',
  hero___children___parent___children = 'hero___children___parent___children',
  hero___children___children = 'hero___children___children',
  hero___children___children___id = 'hero___children___children___id',
  hero___children___children___children = 'hero___children___children___children',
  hero___children___internal___content = 'hero___children___internal___content',
  hero___children___internal___contentDigest = 'hero___children___internal___contentDigest',
  hero___children___internal___description = 'hero___children___internal___description',
  hero___children___internal___fieldOwners = 'hero___children___internal___fieldOwners',
  hero___children___internal___ignoreType = 'hero___children___internal___ignoreType',
  hero___children___internal___mediaType = 'hero___children___internal___mediaType',
  hero___children___internal___owner = 'hero___children___internal___owner',
  hero___children___internal___type = 'hero___children___internal___type',
  hero___internal___content = 'hero___internal___content',
  hero___internal___contentDigest = 'hero___internal___contentDigest',
  hero___internal___description = 'hero___internal___description',
  hero___internal___fieldOwners = 'hero___internal___fieldOwners',
  hero___internal___ignoreType = 'hero___internal___ignoreType',
  hero___internal___mediaType = 'hero___internal___mediaType',
  hero___internal___owner = 'hero___internal___owner',
  hero___internal___type = 'hero___internal___type',
  hero___url = 'hero___url',
  hero___details___size = 'hero___details___size',
  hero___details___image___width = 'hero___details___image___width',
  hero___details___image___height = 'hero___details___image___height',
  hero___fileName = 'hero___fileName',
  hero___contentType = 'hero___contentType',
  title = 'title',
  navigationTitle = 'navigationTitle',
  summary = 'summary',
  messages = 'messages',
  messages___id = 'messages___id',
  messages___parent___id = 'messages___parent___id',
  messages___parent___parent___id = 'messages___parent___parent___id',
  messages___parent___parent___children = 'messages___parent___parent___children',
  messages___parent___children = 'messages___parent___children',
  messages___parent___children___id = 'messages___parent___children___id',
  messages___parent___children___children = 'messages___parent___children___children',
  messages___parent___internal___content = 'messages___parent___internal___content',
  messages___parent___internal___contentDigest = 'messages___parent___internal___contentDigest',
  messages___parent___internal___description = 'messages___parent___internal___description',
  messages___parent___internal___fieldOwners = 'messages___parent___internal___fieldOwners',
  messages___parent___internal___ignoreType = 'messages___parent___internal___ignoreType',
  messages___parent___internal___mediaType = 'messages___parent___internal___mediaType',
  messages___parent___internal___owner = 'messages___parent___internal___owner',
  messages___parent___internal___type = 'messages___parent___internal___type',
  messages___children = 'messages___children',
  messages___children___id = 'messages___children___id',
  messages___children___parent___id = 'messages___children___parent___id',
  messages___children___parent___children = 'messages___children___parent___children',
  messages___children___children = 'messages___children___children',
  messages___children___children___id = 'messages___children___children___id',
  messages___children___children___children = 'messages___children___children___children',
  messages___children___internal___content = 'messages___children___internal___content',
  messages___children___internal___contentDigest = 'messages___children___internal___contentDigest',
  messages___children___internal___description = 'messages___children___internal___description',
  messages___children___internal___fieldOwners = 'messages___children___internal___fieldOwners',
  messages___children___internal___ignoreType = 'messages___children___internal___ignoreType',
  messages___children___internal___mediaType = 'messages___children___internal___mediaType',
  messages___children___internal___owner = 'messages___children___internal___owner',
  messages___children___internal___type = 'messages___children___internal___type',
  messages___internal___content = 'messages___internal___content',
  messages___internal___contentDigest = 'messages___internal___contentDigest',
  messages___internal___description = 'messages___internal___description',
  messages___internal___fieldOwners = 'messages___internal___fieldOwners',
  messages___internal___ignoreType = 'messages___internal___ignoreType',
  messages___internal___mediaType = 'messages___internal___mediaType',
  messages___internal___owner = 'messages___internal___owner',
  messages___internal___type = 'messages___internal___type',
  messages___slug = 'messages___slug',
  messages___hero___id = 'messages___hero___id',
  messages___hero___parent___id = 'messages___hero___parent___id',
  messages___hero___parent___children = 'messages___hero___parent___children',
  messages___hero___children = 'messages___hero___children',
  messages___hero___children___id = 'messages___hero___children___id',
  messages___hero___children___children = 'messages___hero___children___children',
  messages___hero___internal___content = 'messages___hero___internal___content',
  messages___hero___internal___contentDigest = 'messages___hero___internal___contentDigest',
  messages___hero___internal___description = 'messages___hero___internal___description',
  messages___hero___internal___fieldOwners = 'messages___hero___internal___fieldOwners',
  messages___hero___internal___ignoreType = 'messages___hero___internal___ignoreType',
  messages___hero___internal___mediaType = 'messages___hero___internal___mediaType',
  messages___hero___internal___owner = 'messages___hero___internal___owner',
  messages___hero___internal___type = 'messages___hero___internal___type',
  messages___hero___url = 'messages___hero___url',
  messages___hero___details___size = 'messages___hero___details___size',
  messages___hero___fileName = 'messages___hero___fileName',
  messages___hero___contentType = 'messages___hero___contentType',
  messages___title = 'messages___title',
  messages___summary = 'messages___summary',
  messages___summaryBackground___id = 'messages___summaryBackground___id',
  messages___summaryBackground___parent___id = 'messages___summaryBackground___parent___id',
  messages___summaryBackground___parent___children = 'messages___summaryBackground___parent___children',
  messages___summaryBackground___children = 'messages___summaryBackground___children',
  messages___summaryBackground___children___id = 'messages___summaryBackground___children___id',
  messages___summaryBackground___children___children = 'messages___summaryBackground___children___children',
  messages___summaryBackground___internal___content = 'messages___summaryBackground___internal___content',
  messages___summaryBackground___internal___contentDigest = 'messages___summaryBackground___internal___contentDigest',
  messages___summaryBackground___internal___description = 'messages___summaryBackground___internal___description',
  messages___summaryBackground___internal___fieldOwners = 'messages___summaryBackground___internal___fieldOwners',
  messages___summaryBackground___internal___ignoreType = 'messages___summaryBackground___internal___ignoreType',
  messages___summaryBackground___internal___mediaType = 'messages___summaryBackground___internal___mediaType',
  messages___summaryBackground___internal___owner = 'messages___summaryBackground___internal___owner',
  messages___summaryBackground___internal___type = 'messages___summaryBackground___internal___type',
  messages___summaryBackground___url = 'messages___summaryBackground___url',
  messages___summaryBackground___details___size = 'messages___summaryBackground___details___size',
  messages___summaryBackground___fileName = 'messages___summaryBackground___fileName',
  messages___summaryBackground___contentType = 'messages___summaryBackground___contentType',
  messages___benefitImages = 'messages___benefitImages',
  messages___benefitImages___sysId = 'messages___benefitImages___sysId',
  messages___benefitImages___title = 'messages___benefitImages___title',
  messages___benefitImages___description = 'messages___benefitImages___description',
  messages___benefitImages___file___url = 'messages___benefitImages___file___url',
  messages___benefitImages___file___fileName = 'messages___benefitImages___file___fileName',
  messages___benefitImages___file___contentType = 'messages___benefitImages___file___contentType',
  messages___benefitsDisclaimer = 'messages___benefitsDisclaimer',
  messages___main___raw = 'messages___main___raw',
  messages___main___id = 'messages___main___id',
  messages___main___parent___id = 'messages___main___parent___id',
  messages___main___parent___children = 'messages___main___parent___children',
  messages___main___children = 'messages___main___children',
  messages___main___children___id = 'messages___main___children___id',
  messages___main___children___children = 'messages___main___children___children',
  messages___main___internal___content = 'messages___main___internal___content',
  messages___main___internal___contentDigest = 'messages___main___internal___contentDigest',
  messages___main___internal___description = 'messages___main___internal___description',
  messages___main___internal___fieldOwners = 'messages___main___internal___fieldOwners',
  messages___main___internal___ignoreType = 'messages___main___internal___ignoreType',
  messages___main___internal___mediaType = 'messages___main___internal___mediaType',
  messages___main___internal___owner = 'messages___main___internal___owner',
  messages___main___internal___type = 'messages___main___internal___type',
  messages___products = 'messages___products',
  messages___products___id = 'messages___products___id',
  messages___products___parent___id = 'messages___products___parent___id',
  messages___products___parent___children = 'messages___products___parent___children',
  messages___products___children = 'messages___products___children',
  messages___products___children___id = 'messages___products___children___id',
  messages___products___children___children = 'messages___products___children___children',
  messages___products___internal___content = 'messages___products___internal___content',
  messages___products___internal___contentDigest = 'messages___products___internal___contentDigest',
  messages___products___internal___description = 'messages___products___internal___description',
  messages___products___internal___fieldOwners = 'messages___products___internal___fieldOwners',
  messages___products___internal___ignoreType = 'messages___products___internal___ignoreType',
  messages___products___internal___mediaType = 'messages___products___internal___mediaType',
  messages___products___internal___owner = 'messages___products___internal___owner',
  messages___products___internal___type = 'messages___products___internal___type',
  messages___products___slug = 'messages___products___slug',
  messages___products___name = 'messages___products___name',
  messages___products___description___raw = 'messages___products___description___raw',
  messages___products___description___id = 'messages___products___description___id',
  messages___products___description___children = 'messages___products___description___children',
  messages___products___benefits = 'messages___products___benefits',
  messages___products___variants = 'messages___products___variants',
  messages___products___variants___id = 'messages___products___variants___id',
  messages___products___variants___children = 'messages___products___variants___children',
  messages___products___variants___slug = 'messages___products___variants___slug',
  messages___products___variants___name = 'messages___products___variants___name',
  messages___products___variants___sizes = 'messages___products___variants___sizes',
  messages___products___hero___id = 'messages___products___hero___id',
  messages___products___hero___children = 'messages___products___hero___children',
  messages___products___hero___url = 'messages___products___hero___url',
  messages___products___hero___fileName = 'messages___products___hero___fileName',
  messages___products___hero___contentType = 'messages___products___hero___contentType'
}

export type S3ContentfulTopicFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<S3ContentfulAssetFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  navigationTitle?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  messages?: Maybe<S3ContentfulMessageFilterListInput>;
};

export type S3ContentfulTopicGroupConnection = {
  __typename?: 'S3ContentfulTopicGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulTopicEdge>;
  nodes: Array<S3ContentfulTopic>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulTopicSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulTopicFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulVariant = Node & {
  __typename?: 'S3ContentfulVariant';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  packshot?: Maybe<S3ContentfulAsset>;
  sizes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type S3ContentfulVariantConnection = {
  __typename?: 'S3ContentfulVariantConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulVariantEdge>;
  nodes: Array<S3ContentfulVariant>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulVariantGroupConnection>;
};


export type S3ContentfulVariantConnectionDistinctArgs = {
  field: S3ContentfulVariantFieldsEnum;
};


export type S3ContentfulVariantConnectionMaxArgs = {
  field: S3ContentfulVariantFieldsEnum;
};


export type S3ContentfulVariantConnectionMinArgs = {
  field: S3ContentfulVariantFieldsEnum;
};


export type S3ContentfulVariantConnectionSumArgs = {
  field: S3ContentfulVariantFieldsEnum;
};


export type S3ContentfulVariantConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulVariantFieldsEnum;
};

export type S3ContentfulVariantEdge = {
  __typename?: 'S3ContentfulVariantEdge';
  next?: Maybe<S3ContentfulVariant>;
  node: S3ContentfulVariant;
  previous?: Maybe<S3ContentfulVariant>;
};

export enum S3ContentfulVariantFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  slug = 'slug',
  name = 'name',
  packshot___id = 'packshot___id',
  packshot___parent___id = 'packshot___parent___id',
  packshot___parent___parent___id = 'packshot___parent___parent___id',
  packshot___parent___parent___children = 'packshot___parent___parent___children',
  packshot___parent___children = 'packshot___parent___children',
  packshot___parent___children___id = 'packshot___parent___children___id',
  packshot___parent___children___children = 'packshot___parent___children___children',
  packshot___parent___internal___content = 'packshot___parent___internal___content',
  packshot___parent___internal___contentDigest = 'packshot___parent___internal___contentDigest',
  packshot___parent___internal___description = 'packshot___parent___internal___description',
  packshot___parent___internal___fieldOwners = 'packshot___parent___internal___fieldOwners',
  packshot___parent___internal___ignoreType = 'packshot___parent___internal___ignoreType',
  packshot___parent___internal___mediaType = 'packshot___parent___internal___mediaType',
  packshot___parent___internal___owner = 'packshot___parent___internal___owner',
  packshot___parent___internal___type = 'packshot___parent___internal___type',
  packshot___children = 'packshot___children',
  packshot___children___id = 'packshot___children___id',
  packshot___children___parent___id = 'packshot___children___parent___id',
  packshot___children___parent___children = 'packshot___children___parent___children',
  packshot___children___children = 'packshot___children___children',
  packshot___children___children___id = 'packshot___children___children___id',
  packshot___children___children___children = 'packshot___children___children___children',
  packshot___children___internal___content = 'packshot___children___internal___content',
  packshot___children___internal___contentDigest = 'packshot___children___internal___contentDigest',
  packshot___children___internal___description = 'packshot___children___internal___description',
  packshot___children___internal___fieldOwners = 'packshot___children___internal___fieldOwners',
  packshot___children___internal___ignoreType = 'packshot___children___internal___ignoreType',
  packshot___children___internal___mediaType = 'packshot___children___internal___mediaType',
  packshot___children___internal___owner = 'packshot___children___internal___owner',
  packshot___children___internal___type = 'packshot___children___internal___type',
  packshot___internal___content = 'packshot___internal___content',
  packshot___internal___contentDigest = 'packshot___internal___contentDigest',
  packshot___internal___description = 'packshot___internal___description',
  packshot___internal___fieldOwners = 'packshot___internal___fieldOwners',
  packshot___internal___ignoreType = 'packshot___internal___ignoreType',
  packshot___internal___mediaType = 'packshot___internal___mediaType',
  packshot___internal___owner = 'packshot___internal___owner',
  packshot___internal___type = 'packshot___internal___type',
  packshot___url = 'packshot___url',
  packshot___details___size = 'packshot___details___size',
  packshot___details___image___width = 'packshot___details___image___width',
  packshot___details___image___height = 'packshot___details___image___height',
  packshot___fileName = 'packshot___fileName',
  packshot___contentType = 'packshot___contentType',
  sizes = 'sizes'
}

export type S3ContentfulVariantFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  packshot?: Maybe<S3ContentfulAssetFilterInput>;
  sizes?: Maybe<StringQueryOperatorInput>;
};

export type S3ContentfulVariantFilterListInput = {
  elemMatch?: Maybe<S3ContentfulVariantFilterInput>;
};

export type S3ContentfulVariantGroupConnection = {
  __typename?: 'S3ContentfulVariantGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulVariantEdge>;
  nodes: Array<S3ContentfulVariant>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulVariantSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulVariantFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type S3ContentfulWebsite = Node & {
  __typename?: 'S3ContentfulWebsite';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  homepageTitle?: Maybe<Scalars['String']>;
  brand?: Maybe<S3ContentfulBrand>;
  domain?: Maybe<S3ContentfulDomain>;
  message?: Maybe<S3ContentfulMessage>;
  messageSecondary?: Maybe<S3ContentfulMessage>;
  lexicon?: Maybe<S3ContentfulLexicon>;
  legals?: Maybe<S3ContentfulLegals>;
  topics?: Maybe<Array<Maybe<S3ContentfulCategoryS3ContentfulTopicUnion>>>;
  socialChannels?: Maybe<Array<Maybe<S3ContentfulSocialChannel>>>;
  messages?: Maybe<Array<Maybe<S3ContentfulMessage>>>;
  contactUs?: Maybe<S3ContentfulContactUs>;
  sitemap?: Maybe<S3ContentfulSitemap>;
  footerLinks?: Maybe<Array<Maybe<S3ContentfulContactUs>>>;
};

export type S3ContentfulWebsiteConnection = {
  __typename?: 'S3ContentfulWebsiteConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulWebsiteEdge>;
  nodes: Array<S3ContentfulWebsite>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<S3ContentfulWebsiteGroupConnection>;
};


export type S3ContentfulWebsiteConnectionDistinctArgs = {
  field: S3ContentfulWebsiteFieldsEnum;
};


export type S3ContentfulWebsiteConnectionMaxArgs = {
  field: S3ContentfulWebsiteFieldsEnum;
};


export type S3ContentfulWebsiteConnectionMinArgs = {
  field: S3ContentfulWebsiteFieldsEnum;
};


export type S3ContentfulWebsiteConnectionSumArgs = {
  field: S3ContentfulWebsiteFieldsEnum;
};


export type S3ContentfulWebsiteConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: S3ContentfulWebsiteFieldsEnum;
};

export type S3ContentfulWebsiteEdge = {
  __typename?: 'S3ContentfulWebsiteEdge';
  next?: Maybe<S3ContentfulWebsite>;
  node: S3ContentfulWebsite;
  previous?: Maybe<S3ContentfulWebsite>;
};

export enum S3ContentfulWebsiteFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  homepageTitle = 'homepageTitle',
  brand___id = 'brand___id',
  brand___parent___id = 'brand___parent___id',
  brand___parent___parent___id = 'brand___parent___parent___id',
  brand___parent___parent___children = 'brand___parent___parent___children',
  brand___parent___children = 'brand___parent___children',
  brand___parent___children___id = 'brand___parent___children___id',
  brand___parent___children___children = 'brand___parent___children___children',
  brand___parent___internal___content = 'brand___parent___internal___content',
  brand___parent___internal___contentDigest = 'brand___parent___internal___contentDigest',
  brand___parent___internal___description = 'brand___parent___internal___description',
  brand___parent___internal___fieldOwners = 'brand___parent___internal___fieldOwners',
  brand___parent___internal___ignoreType = 'brand___parent___internal___ignoreType',
  brand___parent___internal___mediaType = 'brand___parent___internal___mediaType',
  brand___parent___internal___owner = 'brand___parent___internal___owner',
  brand___parent___internal___type = 'brand___parent___internal___type',
  brand___children = 'brand___children',
  brand___children___id = 'brand___children___id',
  brand___children___parent___id = 'brand___children___parent___id',
  brand___children___parent___children = 'brand___children___parent___children',
  brand___children___children = 'brand___children___children',
  brand___children___children___id = 'brand___children___children___id',
  brand___children___children___children = 'brand___children___children___children',
  brand___children___internal___content = 'brand___children___internal___content',
  brand___children___internal___contentDigest = 'brand___children___internal___contentDigest',
  brand___children___internal___description = 'brand___children___internal___description',
  brand___children___internal___fieldOwners = 'brand___children___internal___fieldOwners',
  brand___children___internal___ignoreType = 'brand___children___internal___ignoreType',
  brand___children___internal___mediaType = 'brand___children___internal___mediaType',
  brand___children___internal___owner = 'brand___children___internal___owner',
  brand___children___internal___type = 'brand___children___internal___type',
  brand___internal___content = 'brand___internal___content',
  brand___internal___contentDigest = 'brand___internal___contentDigest',
  brand___internal___description = 'brand___internal___description',
  brand___internal___fieldOwners = 'brand___internal___fieldOwners',
  brand___internal___ignoreType = 'brand___internal___ignoreType',
  brand___internal___mediaType = 'brand___internal___mediaType',
  brand___internal___owner = 'brand___internal___owner',
  brand___internal___type = 'brand___internal___type',
  brand___name = 'brand___name',
  brand___description = 'brand___description',
  brand___logo___id = 'brand___logo___id',
  brand___logo___parent___id = 'brand___logo___parent___id',
  brand___logo___parent___children = 'brand___logo___parent___children',
  brand___logo___children = 'brand___logo___children',
  brand___logo___children___id = 'brand___logo___children___id',
  brand___logo___children___children = 'brand___logo___children___children',
  brand___logo___internal___content = 'brand___logo___internal___content',
  brand___logo___internal___contentDigest = 'brand___logo___internal___contentDigest',
  brand___logo___internal___description = 'brand___logo___internal___description',
  brand___logo___internal___fieldOwners = 'brand___logo___internal___fieldOwners',
  brand___logo___internal___ignoreType = 'brand___logo___internal___ignoreType',
  brand___logo___internal___mediaType = 'brand___logo___internal___mediaType',
  brand___logo___internal___owner = 'brand___logo___internal___owner',
  brand___logo___internal___type = 'brand___logo___internal___type',
  brand___logo___url = 'brand___logo___url',
  brand___logo___details___size = 'brand___logo___details___size',
  brand___logo___fileName = 'brand___logo___fileName',
  brand___logo___contentType = 'brand___logo___contentType',
  brand___favicon___id = 'brand___favicon___id',
  brand___favicon___parent___id = 'brand___favicon___parent___id',
  brand___favicon___parent___children = 'brand___favicon___parent___children',
  brand___favicon___children = 'brand___favicon___children',
  brand___favicon___children___id = 'brand___favicon___children___id',
  brand___favicon___children___children = 'brand___favicon___children___children',
  brand___favicon___internal___content = 'brand___favicon___internal___content',
  brand___favicon___internal___contentDigest = 'brand___favicon___internal___contentDigest',
  brand___favicon___internal___description = 'brand___favicon___internal___description',
  brand___favicon___internal___fieldOwners = 'brand___favicon___internal___fieldOwners',
  brand___favicon___internal___ignoreType = 'brand___favicon___internal___ignoreType',
  brand___favicon___internal___mediaType = 'brand___favicon___internal___mediaType',
  brand___favicon___internal___owner = 'brand___favicon___internal___owner',
  brand___favicon___internal___type = 'brand___favicon___internal___type',
  brand___favicon___url = 'brand___favicon___url',
  brand___favicon___details___size = 'brand___favicon___details___size',
  brand___favicon___fileName = 'brand___favicon___fileName',
  brand___favicon___contentType = 'brand___favicon___contentType',
  brand___disclaimer = 'brand___disclaimer',
  domain___id = 'domain___id',
  domain___parent___id = 'domain___parent___id',
  domain___parent___parent___id = 'domain___parent___parent___id',
  domain___parent___parent___children = 'domain___parent___parent___children',
  domain___parent___children = 'domain___parent___children',
  domain___parent___children___id = 'domain___parent___children___id',
  domain___parent___children___children = 'domain___parent___children___children',
  domain___parent___internal___content = 'domain___parent___internal___content',
  domain___parent___internal___contentDigest = 'domain___parent___internal___contentDigest',
  domain___parent___internal___description = 'domain___parent___internal___description',
  domain___parent___internal___fieldOwners = 'domain___parent___internal___fieldOwners',
  domain___parent___internal___ignoreType = 'domain___parent___internal___ignoreType',
  domain___parent___internal___mediaType = 'domain___parent___internal___mediaType',
  domain___parent___internal___owner = 'domain___parent___internal___owner',
  domain___parent___internal___type = 'domain___parent___internal___type',
  domain___children = 'domain___children',
  domain___children___id = 'domain___children___id',
  domain___children___parent___id = 'domain___children___parent___id',
  domain___children___parent___children = 'domain___children___parent___children',
  domain___children___children = 'domain___children___children',
  domain___children___children___id = 'domain___children___children___id',
  domain___children___children___children = 'domain___children___children___children',
  domain___children___internal___content = 'domain___children___internal___content',
  domain___children___internal___contentDigest = 'domain___children___internal___contentDigest',
  domain___children___internal___description = 'domain___children___internal___description',
  domain___children___internal___fieldOwners = 'domain___children___internal___fieldOwners',
  domain___children___internal___ignoreType = 'domain___children___internal___ignoreType',
  domain___children___internal___mediaType = 'domain___children___internal___mediaType',
  domain___children___internal___owner = 'domain___children___internal___owner',
  domain___children___internal___type = 'domain___children___internal___type',
  domain___internal___content = 'domain___internal___content',
  domain___internal___contentDigest = 'domain___internal___contentDigest',
  domain___internal___description = 'domain___internal___description',
  domain___internal___fieldOwners = 'domain___internal___fieldOwners',
  domain___internal___ignoreType = 'domain___internal___ignoreType',
  domain___internal___mediaType = 'domain___internal___mediaType',
  domain___internal___owner = 'domain___internal___owner',
  domain___internal___type = 'domain___internal___type',
  domain___name = 'domain___name',
  domain___path = 'domain___path',
  domain___gaTrackingIds = 'domain___gaTrackingIds',
  domain___adobeConfig___id = 'domain___adobeConfig___id',
  domain___adobeConfig___parent___id = 'domain___adobeConfig___parent___id',
  domain___adobeConfig___parent___children = 'domain___adobeConfig___parent___children',
  domain___adobeConfig___children = 'domain___adobeConfig___children',
  domain___adobeConfig___children___id = 'domain___adobeConfig___children___id',
  domain___adobeConfig___children___children = 'domain___adobeConfig___children___children',
  domain___adobeConfig___internal___content = 'domain___adobeConfig___internal___content',
  domain___adobeConfig___internal___contentDigest = 'domain___adobeConfig___internal___contentDigest',
  domain___adobeConfig___internal___description = 'domain___adobeConfig___internal___description',
  domain___adobeConfig___internal___fieldOwners = 'domain___adobeConfig___internal___fieldOwners',
  domain___adobeConfig___internal___ignoreType = 'domain___adobeConfig___internal___ignoreType',
  domain___adobeConfig___internal___mediaType = 'domain___adobeConfig___internal___mediaType',
  domain___adobeConfig___internal___owner = 'domain___adobeConfig___internal___owner',
  domain___adobeConfig___internal___type = 'domain___adobeConfig___internal___type',
  domain___adobeConfig___account = 'domain___adobeConfig___account',
  domain___adobeConfig___trackingServer = 'domain___adobeConfig___trackingServer',
  domain___adobeConfig___trackingServerSecure = 'domain___adobeConfig___trackingServerSecure',
  domain___adobeConfig___reportSuiteId = 'domain___adobeConfig___reportSuiteId',
  domain___adobeConfig___containerId = 'domain___adobeConfig___containerId',
  domain___adobeConfig___region = 'domain___adobeConfig___region',
  domain___adobeConfig___language = 'domain___adobeConfig___language',
  domain___oneTrustId = 'domain___oneTrustId',
  domain___oneTrustAutoBlock = 'domain___oneTrustAutoBlock',
  domain___oneTrustShowSettingsButton = 'domain___oneTrustShowSettingsButton',
  message___id = 'message___id',
  message___parent___id = 'message___parent___id',
  message___parent___parent___id = 'message___parent___parent___id',
  message___parent___parent___children = 'message___parent___parent___children',
  message___parent___children = 'message___parent___children',
  message___parent___children___id = 'message___parent___children___id',
  message___parent___children___children = 'message___parent___children___children',
  message___parent___internal___content = 'message___parent___internal___content',
  message___parent___internal___contentDigest = 'message___parent___internal___contentDigest',
  message___parent___internal___description = 'message___parent___internal___description',
  message___parent___internal___fieldOwners = 'message___parent___internal___fieldOwners',
  message___parent___internal___ignoreType = 'message___parent___internal___ignoreType',
  message___parent___internal___mediaType = 'message___parent___internal___mediaType',
  message___parent___internal___owner = 'message___parent___internal___owner',
  message___parent___internal___type = 'message___parent___internal___type',
  message___children = 'message___children',
  message___children___id = 'message___children___id',
  message___children___parent___id = 'message___children___parent___id',
  message___children___parent___children = 'message___children___parent___children',
  message___children___children = 'message___children___children',
  message___children___children___id = 'message___children___children___id',
  message___children___children___children = 'message___children___children___children',
  message___children___internal___content = 'message___children___internal___content',
  message___children___internal___contentDigest = 'message___children___internal___contentDigest',
  message___children___internal___description = 'message___children___internal___description',
  message___children___internal___fieldOwners = 'message___children___internal___fieldOwners',
  message___children___internal___ignoreType = 'message___children___internal___ignoreType',
  message___children___internal___mediaType = 'message___children___internal___mediaType',
  message___children___internal___owner = 'message___children___internal___owner',
  message___children___internal___type = 'message___children___internal___type',
  message___internal___content = 'message___internal___content',
  message___internal___contentDigest = 'message___internal___contentDigest',
  message___internal___description = 'message___internal___description',
  message___internal___fieldOwners = 'message___internal___fieldOwners',
  message___internal___ignoreType = 'message___internal___ignoreType',
  message___internal___mediaType = 'message___internal___mediaType',
  message___internal___owner = 'message___internal___owner',
  message___internal___type = 'message___internal___type',
  message___slug = 'message___slug',
  message___hero___id = 'message___hero___id',
  message___hero___parent___id = 'message___hero___parent___id',
  message___hero___parent___children = 'message___hero___parent___children',
  message___hero___children = 'message___hero___children',
  message___hero___children___id = 'message___hero___children___id',
  message___hero___children___children = 'message___hero___children___children',
  message___hero___internal___content = 'message___hero___internal___content',
  message___hero___internal___contentDigest = 'message___hero___internal___contentDigest',
  message___hero___internal___description = 'message___hero___internal___description',
  message___hero___internal___fieldOwners = 'message___hero___internal___fieldOwners',
  message___hero___internal___ignoreType = 'message___hero___internal___ignoreType',
  message___hero___internal___mediaType = 'message___hero___internal___mediaType',
  message___hero___internal___owner = 'message___hero___internal___owner',
  message___hero___internal___type = 'message___hero___internal___type',
  message___hero___url = 'message___hero___url',
  message___hero___details___size = 'message___hero___details___size',
  message___hero___fileName = 'message___hero___fileName',
  message___hero___contentType = 'message___hero___contentType',
  message___title = 'message___title',
  message___summary = 'message___summary',
  message___summaryBackground___id = 'message___summaryBackground___id',
  message___summaryBackground___parent___id = 'message___summaryBackground___parent___id',
  message___summaryBackground___parent___children = 'message___summaryBackground___parent___children',
  message___summaryBackground___children = 'message___summaryBackground___children',
  message___summaryBackground___children___id = 'message___summaryBackground___children___id',
  message___summaryBackground___children___children = 'message___summaryBackground___children___children',
  message___summaryBackground___internal___content = 'message___summaryBackground___internal___content',
  message___summaryBackground___internal___contentDigest = 'message___summaryBackground___internal___contentDigest',
  message___summaryBackground___internal___description = 'message___summaryBackground___internal___description',
  message___summaryBackground___internal___fieldOwners = 'message___summaryBackground___internal___fieldOwners',
  message___summaryBackground___internal___ignoreType = 'message___summaryBackground___internal___ignoreType',
  message___summaryBackground___internal___mediaType = 'message___summaryBackground___internal___mediaType',
  message___summaryBackground___internal___owner = 'message___summaryBackground___internal___owner',
  message___summaryBackground___internal___type = 'message___summaryBackground___internal___type',
  message___summaryBackground___url = 'message___summaryBackground___url',
  message___summaryBackground___details___size = 'message___summaryBackground___details___size',
  message___summaryBackground___fileName = 'message___summaryBackground___fileName',
  message___summaryBackground___contentType = 'message___summaryBackground___contentType',
  message___benefitImages = 'message___benefitImages',
  message___benefitImages___sysId = 'message___benefitImages___sysId',
  message___benefitImages___title = 'message___benefitImages___title',
  message___benefitImages___description = 'message___benefitImages___description',
  message___benefitImages___file___url = 'message___benefitImages___file___url',
  message___benefitImages___file___fileName = 'message___benefitImages___file___fileName',
  message___benefitImages___file___contentType = 'message___benefitImages___file___contentType',
  message___benefitsDisclaimer = 'message___benefitsDisclaimer',
  message___main___raw = 'message___main___raw',
  message___main___id = 'message___main___id',
  message___main___parent___id = 'message___main___parent___id',
  message___main___parent___children = 'message___main___parent___children',
  message___main___children = 'message___main___children',
  message___main___children___id = 'message___main___children___id',
  message___main___children___children = 'message___main___children___children',
  message___main___internal___content = 'message___main___internal___content',
  message___main___internal___contentDigest = 'message___main___internal___contentDigest',
  message___main___internal___description = 'message___main___internal___description',
  message___main___internal___fieldOwners = 'message___main___internal___fieldOwners',
  message___main___internal___ignoreType = 'message___main___internal___ignoreType',
  message___main___internal___mediaType = 'message___main___internal___mediaType',
  message___main___internal___owner = 'message___main___internal___owner',
  message___main___internal___type = 'message___main___internal___type',
  message___products = 'message___products',
  message___products___id = 'message___products___id',
  message___products___parent___id = 'message___products___parent___id',
  message___products___parent___children = 'message___products___parent___children',
  message___products___children = 'message___products___children',
  message___products___children___id = 'message___products___children___id',
  message___products___children___children = 'message___products___children___children',
  message___products___internal___content = 'message___products___internal___content',
  message___products___internal___contentDigest = 'message___products___internal___contentDigest',
  message___products___internal___description = 'message___products___internal___description',
  message___products___internal___fieldOwners = 'message___products___internal___fieldOwners',
  message___products___internal___ignoreType = 'message___products___internal___ignoreType',
  message___products___internal___mediaType = 'message___products___internal___mediaType',
  message___products___internal___owner = 'message___products___internal___owner',
  message___products___internal___type = 'message___products___internal___type',
  message___products___slug = 'message___products___slug',
  message___products___name = 'message___products___name',
  message___products___description___raw = 'message___products___description___raw',
  message___products___description___id = 'message___products___description___id',
  message___products___description___children = 'message___products___description___children',
  message___products___benefits = 'message___products___benefits',
  message___products___variants = 'message___products___variants',
  message___products___variants___id = 'message___products___variants___id',
  message___products___variants___children = 'message___products___variants___children',
  message___products___variants___slug = 'message___products___variants___slug',
  message___products___variants___name = 'message___products___variants___name',
  message___products___variants___sizes = 'message___products___variants___sizes',
  message___products___hero___id = 'message___products___hero___id',
  message___products___hero___children = 'message___products___hero___children',
  message___products___hero___url = 'message___products___hero___url',
  message___products___hero___fileName = 'message___products___hero___fileName',
  message___products___hero___contentType = 'message___products___hero___contentType',
  messageSecondary___id = 'messageSecondary___id',
  messageSecondary___parent___id = 'messageSecondary___parent___id',
  messageSecondary___parent___parent___id = 'messageSecondary___parent___parent___id',
  messageSecondary___parent___parent___children = 'messageSecondary___parent___parent___children',
  messageSecondary___parent___children = 'messageSecondary___parent___children',
  messageSecondary___parent___children___id = 'messageSecondary___parent___children___id',
  messageSecondary___parent___children___children = 'messageSecondary___parent___children___children',
  messageSecondary___parent___internal___content = 'messageSecondary___parent___internal___content',
  messageSecondary___parent___internal___contentDigest = 'messageSecondary___parent___internal___contentDigest',
  messageSecondary___parent___internal___description = 'messageSecondary___parent___internal___description',
  messageSecondary___parent___internal___fieldOwners = 'messageSecondary___parent___internal___fieldOwners',
  messageSecondary___parent___internal___ignoreType = 'messageSecondary___parent___internal___ignoreType',
  messageSecondary___parent___internal___mediaType = 'messageSecondary___parent___internal___mediaType',
  messageSecondary___parent___internal___owner = 'messageSecondary___parent___internal___owner',
  messageSecondary___parent___internal___type = 'messageSecondary___parent___internal___type',
  messageSecondary___children = 'messageSecondary___children',
  messageSecondary___children___id = 'messageSecondary___children___id',
  messageSecondary___children___parent___id = 'messageSecondary___children___parent___id',
  messageSecondary___children___parent___children = 'messageSecondary___children___parent___children',
  messageSecondary___children___children = 'messageSecondary___children___children',
  messageSecondary___children___children___id = 'messageSecondary___children___children___id',
  messageSecondary___children___children___children = 'messageSecondary___children___children___children',
  messageSecondary___children___internal___content = 'messageSecondary___children___internal___content',
  messageSecondary___children___internal___contentDigest = 'messageSecondary___children___internal___contentDigest',
  messageSecondary___children___internal___description = 'messageSecondary___children___internal___description',
  messageSecondary___children___internal___fieldOwners = 'messageSecondary___children___internal___fieldOwners',
  messageSecondary___children___internal___ignoreType = 'messageSecondary___children___internal___ignoreType',
  messageSecondary___children___internal___mediaType = 'messageSecondary___children___internal___mediaType',
  messageSecondary___children___internal___owner = 'messageSecondary___children___internal___owner',
  messageSecondary___children___internal___type = 'messageSecondary___children___internal___type',
  messageSecondary___internal___content = 'messageSecondary___internal___content',
  messageSecondary___internal___contentDigest = 'messageSecondary___internal___contentDigest',
  messageSecondary___internal___description = 'messageSecondary___internal___description',
  messageSecondary___internal___fieldOwners = 'messageSecondary___internal___fieldOwners',
  messageSecondary___internal___ignoreType = 'messageSecondary___internal___ignoreType',
  messageSecondary___internal___mediaType = 'messageSecondary___internal___mediaType',
  messageSecondary___internal___owner = 'messageSecondary___internal___owner',
  messageSecondary___internal___type = 'messageSecondary___internal___type',
  messageSecondary___slug = 'messageSecondary___slug',
  messageSecondary___hero___id = 'messageSecondary___hero___id',
  messageSecondary___hero___parent___id = 'messageSecondary___hero___parent___id',
  messageSecondary___hero___parent___children = 'messageSecondary___hero___parent___children',
  messageSecondary___hero___children = 'messageSecondary___hero___children',
  messageSecondary___hero___children___id = 'messageSecondary___hero___children___id',
  messageSecondary___hero___children___children = 'messageSecondary___hero___children___children',
  messageSecondary___hero___internal___content = 'messageSecondary___hero___internal___content',
  messageSecondary___hero___internal___contentDigest = 'messageSecondary___hero___internal___contentDigest',
  messageSecondary___hero___internal___description = 'messageSecondary___hero___internal___description',
  messageSecondary___hero___internal___fieldOwners = 'messageSecondary___hero___internal___fieldOwners',
  messageSecondary___hero___internal___ignoreType = 'messageSecondary___hero___internal___ignoreType',
  messageSecondary___hero___internal___mediaType = 'messageSecondary___hero___internal___mediaType',
  messageSecondary___hero___internal___owner = 'messageSecondary___hero___internal___owner',
  messageSecondary___hero___internal___type = 'messageSecondary___hero___internal___type',
  messageSecondary___hero___url = 'messageSecondary___hero___url',
  messageSecondary___hero___details___size = 'messageSecondary___hero___details___size',
  messageSecondary___hero___fileName = 'messageSecondary___hero___fileName',
  messageSecondary___hero___contentType = 'messageSecondary___hero___contentType',
  messageSecondary___title = 'messageSecondary___title',
  messageSecondary___summary = 'messageSecondary___summary',
  messageSecondary___summaryBackground___id = 'messageSecondary___summaryBackground___id',
  messageSecondary___summaryBackground___parent___id = 'messageSecondary___summaryBackground___parent___id',
  messageSecondary___summaryBackground___parent___children = 'messageSecondary___summaryBackground___parent___children',
  messageSecondary___summaryBackground___children = 'messageSecondary___summaryBackground___children',
  messageSecondary___summaryBackground___children___id = 'messageSecondary___summaryBackground___children___id',
  messageSecondary___summaryBackground___children___children = 'messageSecondary___summaryBackground___children___children',
  messageSecondary___summaryBackground___internal___content = 'messageSecondary___summaryBackground___internal___content',
  messageSecondary___summaryBackground___internal___contentDigest = 'messageSecondary___summaryBackground___internal___contentDigest',
  messageSecondary___summaryBackground___internal___description = 'messageSecondary___summaryBackground___internal___description',
  messageSecondary___summaryBackground___internal___fieldOwners = 'messageSecondary___summaryBackground___internal___fieldOwners',
  messageSecondary___summaryBackground___internal___ignoreType = 'messageSecondary___summaryBackground___internal___ignoreType',
  messageSecondary___summaryBackground___internal___mediaType = 'messageSecondary___summaryBackground___internal___mediaType',
  messageSecondary___summaryBackground___internal___owner = 'messageSecondary___summaryBackground___internal___owner',
  messageSecondary___summaryBackground___internal___type = 'messageSecondary___summaryBackground___internal___type',
  messageSecondary___summaryBackground___url = 'messageSecondary___summaryBackground___url',
  messageSecondary___summaryBackground___details___size = 'messageSecondary___summaryBackground___details___size',
  messageSecondary___summaryBackground___fileName = 'messageSecondary___summaryBackground___fileName',
  messageSecondary___summaryBackground___contentType = 'messageSecondary___summaryBackground___contentType',
  messageSecondary___benefitImages = 'messageSecondary___benefitImages',
  messageSecondary___benefitImages___sysId = 'messageSecondary___benefitImages___sysId',
  messageSecondary___benefitImages___title = 'messageSecondary___benefitImages___title',
  messageSecondary___benefitImages___description = 'messageSecondary___benefitImages___description',
  messageSecondary___benefitImages___file___url = 'messageSecondary___benefitImages___file___url',
  messageSecondary___benefitImages___file___fileName = 'messageSecondary___benefitImages___file___fileName',
  messageSecondary___benefitImages___file___contentType = 'messageSecondary___benefitImages___file___contentType',
  messageSecondary___benefitsDisclaimer = 'messageSecondary___benefitsDisclaimer',
  messageSecondary___main___raw = 'messageSecondary___main___raw',
  messageSecondary___main___id = 'messageSecondary___main___id',
  messageSecondary___main___parent___id = 'messageSecondary___main___parent___id',
  messageSecondary___main___parent___children = 'messageSecondary___main___parent___children',
  messageSecondary___main___children = 'messageSecondary___main___children',
  messageSecondary___main___children___id = 'messageSecondary___main___children___id',
  messageSecondary___main___children___children = 'messageSecondary___main___children___children',
  messageSecondary___main___internal___content = 'messageSecondary___main___internal___content',
  messageSecondary___main___internal___contentDigest = 'messageSecondary___main___internal___contentDigest',
  messageSecondary___main___internal___description = 'messageSecondary___main___internal___description',
  messageSecondary___main___internal___fieldOwners = 'messageSecondary___main___internal___fieldOwners',
  messageSecondary___main___internal___ignoreType = 'messageSecondary___main___internal___ignoreType',
  messageSecondary___main___internal___mediaType = 'messageSecondary___main___internal___mediaType',
  messageSecondary___main___internal___owner = 'messageSecondary___main___internal___owner',
  messageSecondary___main___internal___type = 'messageSecondary___main___internal___type',
  messageSecondary___products = 'messageSecondary___products',
  messageSecondary___products___id = 'messageSecondary___products___id',
  messageSecondary___products___parent___id = 'messageSecondary___products___parent___id',
  messageSecondary___products___parent___children = 'messageSecondary___products___parent___children',
  messageSecondary___products___children = 'messageSecondary___products___children',
  messageSecondary___products___children___id = 'messageSecondary___products___children___id',
  messageSecondary___products___children___children = 'messageSecondary___products___children___children',
  messageSecondary___products___internal___content = 'messageSecondary___products___internal___content',
  messageSecondary___products___internal___contentDigest = 'messageSecondary___products___internal___contentDigest',
  messageSecondary___products___internal___description = 'messageSecondary___products___internal___description',
  messageSecondary___products___internal___fieldOwners = 'messageSecondary___products___internal___fieldOwners',
  messageSecondary___products___internal___ignoreType = 'messageSecondary___products___internal___ignoreType',
  messageSecondary___products___internal___mediaType = 'messageSecondary___products___internal___mediaType',
  messageSecondary___products___internal___owner = 'messageSecondary___products___internal___owner',
  messageSecondary___products___internal___type = 'messageSecondary___products___internal___type',
  messageSecondary___products___slug = 'messageSecondary___products___slug',
  messageSecondary___products___name = 'messageSecondary___products___name',
  messageSecondary___products___description___raw = 'messageSecondary___products___description___raw',
  messageSecondary___products___description___id = 'messageSecondary___products___description___id',
  messageSecondary___products___description___children = 'messageSecondary___products___description___children',
  messageSecondary___products___benefits = 'messageSecondary___products___benefits',
  messageSecondary___products___variants = 'messageSecondary___products___variants',
  messageSecondary___products___variants___id = 'messageSecondary___products___variants___id',
  messageSecondary___products___variants___children = 'messageSecondary___products___variants___children',
  messageSecondary___products___variants___slug = 'messageSecondary___products___variants___slug',
  messageSecondary___products___variants___name = 'messageSecondary___products___variants___name',
  messageSecondary___products___variants___sizes = 'messageSecondary___products___variants___sizes',
  messageSecondary___products___hero___id = 'messageSecondary___products___hero___id',
  messageSecondary___products___hero___children = 'messageSecondary___products___hero___children',
  messageSecondary___products___hero___url = 'messageSecondary___products___hero___url',
  messageSecondary___products___hero___fileName = 'messageSecondary___products___hero___fileName',
  messageSecondary___products___hero___contentType = 'messageSecondary___products___hero___contentType',
  lexicon___id = 'lexicon___id',
  lexicon___parent___id = 'lexicon___parent___id',
  lexicon___parent___parent___id = 'lexicon___parent___parent___id',
  lexicon___parent___parent___children = 'lexicon___parent___parent___children',
  lexicon___parent___children = 'lexicon___parent___children',
  lexicon___parent___children___id = 'lexicon___parent___children___id',
  lexicon___parent___children___children = 'lexicon___parent___children___children',
  lexicon___parent___internal___content = 'lexicon___parent___internal___content',
  lexicon___parent___internal___contentDigest = 'lexicon___parent___internal___contentDigest',
  lexicon___parent___internal___description = 'lexicon___parent___internal___description',
  lexicon___parent___internal___fieldOwners = 'lexicon___parent___internal___fieldOwners',
  lexicon___parent___internal___ignoreType = 'lexicon___parent___internal___ignoreType',
  lexicon___parent___internal___mediaType = 'lexicon___parent___internal___mediaType',
  lexicon___parent___internal___owner = 'lexicon___parent___internal___owner',
  lexicon___parent___internal___type = 'lexicon___parent___internal___type',
  lexicon___children = 'lexicon___children',
  lexicon___children___id = 'lexicon___children___id',
  lexicon___children___parent___id = 'lexicon___children___parent___id',
  lexicon___children___parent___children = 'lexicon___children___parent___children',
  lexicon___children___children = 'lexicon___children___children',
  lexicon___children___children___id = 'lexicon___children___children___id',
  lexicon___children___children___children = 'lexicon___children___children___children',
  lexicon___children___internal___content = 'lexicon___children___internal___content',
  lexicon___children___internal___contentDigest = 'lexicon___children___internal___contentDigest',
  lexicon___children___internal___description = 'lexicon___children___internal___description',
  lexicon___children___internal___fieldOwners = 'lexicon___children___internal___fieldOwners',
  lexicon___children___internal___ignoreType = 'lexicon___children___internal___ignoreType',
  lexicon___children___internal___mediaType = 'lexicon___children___internal___mediaType',
  lexicon___children___internal___owner = 'lexicon___children___internal___owner',
  lexicon___children___internal___type = 'lexicon___children___internal___type',
  lexicon___internal___content = 'lexicon___internal___content',
  lexicon___internal___contentDigest = 'lexicon___internal___contentDigest',
  lexicon___internal___description = 'lexicon___internal___description',
  lexicon___internal___fieldOwners = 'lexicon___internal___fieldOwners',
  lexicon___internal___ignoreType = 'lexicon___internal___ignoreType',
  lexicon___internal___mediaType = 'lexicon___internal___mediaType',
  lexicon___internal___owner = 'lexicon___internal___owner',
  lexicon___internal___type = 'lexicon___internal___type',
  lexicon___benefits = 'lexicon___benefits',
  lexicon___description = 'lexicon___description',
  lexicon___home = 'lexicon___home',
  lexicon___ingredients = 'lexicon___ingredients',
  lexicon___products = 'lexicon___products',
  lexicon___readMore = 'lexicon___readMore',
  lexicon___pageNotFoundText = 'lexicon___pageNotFoundText',
  lexicon___opensInNewTab = 'lexicon___opensInNewTab',
  legals___id = 'legals___id',
  legals___parent___id = 'legals___parent___id',
  legals___parent___parent___id = 'legals___parent___parent___id',
  legals___parent___parent___children = 'legals___parent___parent___children',
  legals___parent___children = 'legals___parent___children',
  legals___parent___children___id = 'legals___parent___children___id',
  legals___parent___children___children = 'legals___parent___children___children',
  legals___parent___internal___content = 'legals___parent___internal___content',
  legals___parent___internal___contentDigest = 'legals___parent___internal___contentDigest',
  legals___parent___internal___description = 'legals___parent___internal___description',
  legals___parent___internal___fieldOwners = 'legals___parent___internal___fieldOwners',
  legals___parent___internal___ignoreType = 'legals___parent___internal___ignoreType',
  legals___parent___internal___mediaType = 'legals___parent___internal___mediaType',
  legals___parent___internal___owner = 'legals___parent___internal___owner',
  legals___parent___internal___type = 'legals___parent___internal___type',
  legals___children = 'legals___children',
  legals___children___id = 'legals___children___id',
  legals___children___parent___id = 'legals___children___parent___id',
  legals___children___parent___children = 'legals___children___parent___children',
  legals___children___children = 'legals___children___children',
  legals___children___children___id = 'legals___children___children___id',
  legals___children___children___children = 'legals___children___children___children',
  legals___children___internal___content = 'legals___children___internal___content',
  legals___children___internal___contentDigest = 'legals___children___internal___contentDigest',
  legals___children___internal___description = 'legals___children___internal___description',
  legals___children___internal___fieldOwners = 'legals___children___internal___fieldOwners',
  legals___children___internal___ignoreType = 'legals___children___internal___ignoreType',
  legals___children___internal___mediaType = 'legals___children___internal___mediaType',
  legals___children___internal___owner = 'legals___children___internal___owner',
  legals___children___internal___type = 'legals___children___internal___type',
  legals___internal___content = 'legals___internal___content',
  legals___internal___contentDigest = 'legals___internal___contentDigest',
  legals___internal___description = 'legals___internal___description',
  legals___internal___fieldOwners = 'legals___internal___fieldOwners',
  legals___internal___ignoreType = 'legals___internal___ignoreType',
  legals___internal___mediaType = 'legals___internal___mediaType',
  legals___internal___owner = 'legals___internal___owner',
  legals___internal___type = 'legals___internal___type',
  legals___privacyNoticeLabel = 'legals___privacyNoticeLabel',
  legals___privacyNoticeUrl = 'legals___privacyNoticeUrl',
  legals___cookieNoticeLabel = 'legals___cookieNoticeLabel',
  legals___cookieNoticeUrl = 'legals___cookieNoticeUrl',
  legals___termsOfUseLabel = 'legals___termsOfUseLabel',
  legals___termsOfUseUrl = 'legals___termsOfUseUrl',
  legals___legalWarningLabel = 'legals___legalWarningLabel',
  legals___legalWarningUrl = 'legals___legalWarningUrl',
  socialChannels = 'socialChannels',
  socialChannels___id = 'socialChannels___id',
  socialChannels___parent___id = 'socialChannels___parent___id',
  socialChannels___parent___parent___id = 'socialChannels___parent___parent___id',
  socialChannels___parent___parent___children = 'socialChannels___parent___parent___children',
  socialChannels___parent___children = 'socialChannels___parent___children',
  socialChannels___parent___children___id = 'socialChannels___parent___children___id',
  socialChannels___parent___children___children = 'socialChannels___parent___children___children',
  socialChannels___parent___internal___content = 'socialChannels___parent___internal___content',
  socialChannels___parent___internal___contentDigest = 'socialChannels___parent___internal___contentDigest',
  socialChannels___parent___internal___description = 'socialChannels___parent___internal___description',
  socialChannels___parent___internal___fieldOwners = 'socialChannels___parent___internal___fieldOwners',
  socialChannels___parent___internal___ignoreType = 'socialChannels___parent___internal___ignoreType',
  socialChannels___parent___internal___mediaType = 'socialChannels___parent___internal___mediaType',
  socialChannels___parent___internal___owner = 'socialChannels___parent___internal___owner',
  socialChannels___parent___internal___type = 'socialChannels___parent___internal___type',
  socialChannels___children = 'socialChannels___children',
  socialChannels___children___id = 'socialChannels___children___id',
  socialChannels___children___parent___id = 'socialChannels___children___parent___id',
  socialChannels___children___parent___children = 'socialChannels___children___parent___children',
  socialChannels___children___children = 'socialChannels___children___children',
  socialChannels___children___children___id = 'socialChannels___children___children___id',
  socialChannels___children___children___children = 'socialChannels___children___children___children',
  socialChannels___children___internal___content = 'socialChannels___children___internal___content',
  socialChannels___children___internal___contentDigest = 'socialChannels___children___internal___contentDigest',
  socialChannels___children___internal___description = 'socialChannels___children___internal___description',
  socialChannels___children___internal___fieldOwners = 'socialChannels___children___internal___fieldOwners',
  socialChannels___children___internal___ignoreType = 'socialChannels___children___internal___ignoreType',
  socialChannels___children___internal___mediaType = 'socialChannels___children___internal___mediaType',
  socialChannels___children___internal___owner = 'socialChannels___children___internal___owner',
  socialChannels___children___internal___type = 'socialChannels___children___internal___type',
  socialChannels___internal___content = 'socialChannels___internal___content',
  socialChannels___internal___contentDigest = 'socialChannels___internal___contentDigest',
  socialChannels___internal___description = 'socialChannels___internal___description',
  socialChannels___internal___fieldOwners = 'socialChannels___internal___fieldOwners',
  socialChannels___internal___ignoreType = 'socialChannels___internal___ignoreType',
  socialChannels___internal___mediaType = 'socialChannels___internal___mediaType',
  socialChannels___internal___owner = 'socialChannels___internal___owner',
  socialChannels___internal___type = 'socialChannels___internal___type',
  socialChannels___url = 'socialChannels___url',
  socialChannels___name = 'socialChannels___name',
  socialChannels___image___id = 'socialChannels___image___id',
  socialChannels___image___parent___id = 'socialChannels___image___parent___id',
  socialChannels___image___parent___children = 'socialChannels___image___parent___children',
  socialChannels___image___children = 'socialChannels___image___children',
  socialChannels___image___children___id = 'socialChannels___image___children___id',
  socialChannels___image___children___children = 'socialChannels___image___children___children',
  socialChannels___image___internal___content = 'socialChannels___image___internal___content',
  socialChannels___image___internal___contentDigest = 'socialChannels___image___internal___contentDigest',
  socialChannels___image___internal___description = 'socialChannels___image___internal___description',
  socialChannels___image___internal___fieldOwners = 'socialChannels___image___internal___fieldOwners',
  socialChannels___image___internal___ignoreType = 'socialChannels___image___internal___ignoreType',
  socialChannels___image___internal___mediaType = 'socialChannels___image___internal___mediaType',
  socialChannels___image___internal___owner = 'socialChannels___image___internal___owner',
  socialChannels___image___internal___type = 'socialChannels___image___internal___type',
  socialChannels___image___url = 'socialChannels___image___url',
  socialChannels___image___details___size = 'socialChannels___image___details___size',
  socialChannels___image___fileName = 'socialChannels___image___fileName',
  socialChannels___image___contentType = 'socialChannels___image___contentType',
  messages = 'messages',
  messages___id = 'messages___id',
  messages___parent___id = 'messages___parent___id',
  messages___parent___parent___id = 'messages___parent___parent___id',
  messages___parent___parent___children = 'messages___parent___parent___children',
  messages___parent___children = 'messages___parent___children',
  messages___parent___children___id = 'messages___parent___children___id',
  messages___parent___children___children = 'messages___parent___children___children',
  messages___parent___internal___content = 'messages___parent___internal___content',
  messages___parent___internal___contentDigest = 'messages___parent___internal___contentDigest',
  messages___parent___internal___description = 'messages___parent___internal___description',
  messages___parent___internal___fieldOwners = 'messages___parent___internal___fieldOwners',
  messages___parent___internal___ignoreType = 'messages___parent___internal___ignoreType',
  messages___parent___internal___mediaType = 'messages___parent___internal___mediaType',
  messages___parent___internal___owner = 'messages___parent___internal___owner',
  messages___parent___internal___type = 'messages___parent___internal___type',
  messages___children = 'messages___children',
  messages___children___id = 'messages___children___id',
  messages___children___parent___id = 'messages___children___parent___id',
  messages___children___parent___children = 'messages___children___parent___children',
  messages___children___children = 'messages___children___children',
  messages___children___children___id = 'messages___children___children___id',
  messages___children___children___children = 'messages___children___children___children',
  messages___children___internal___content = 'messages___children___internal___content',
  messages___children___internal___contentDigest = 'messages___children___internal___contentDigest',
  messages___children___internal___description = 'messages___children___internal___description',
  messages___children___internal___fieldOwners = 'messages___children___internal___fieldOwners',
  messages___children___internal___ignoreType = 'messages___children___internal___ignoreType',
  messages___children___internal___mediaType = 'messages___children___internal___mediaType',
  messages___children___internal___owner = 'messages___children___internal___owner',
  messages___children___internal___type = 'messages___children___internal___type',
  messages___internal___content = 'messages___internal___content',
  messages___internal___contentDigest = 'messages___internal___contentDigest',
  messages___internal___description = 'messages___internal___description',
  messages___internal___fieldOwners = 'messages___internal___fieldOwners',
  messages___internal___ignoreType = 'messages___internal___ignoreType',
  messages___internal___mediaType = 'messages___internal___mediaType',
  messages___internal___owner = 'messages___internal___owner',
  messages___internal___type = 'messages___internal___type',
  messages___slug = 'messages___slug',
  messages___hero___id = 'messages___hero___id',
  messages___hero___parent___id = 'messages___hero___parent___id',
  messages___hero___parent___children = 'messages___hero___parent___children',
  messages___hero___children = 'messages___hero___children',
  messages___hero___children___id = 'messages___hero___children___id',
  messages___hero___children___children = 'messages___hero___children___children',
  messages___hero___internal___content = 'messages___hero___internal___content',
  messages___hero___internal___contentDigest = 'messages___hero___internal___contentDigest',
  messages___hero___internal___description = 'messages___hero___internal___description',
  messages___hero___internal___fieldOwners = 'messages___hero___internal___fieldOwners',
  messages___hero___internal___ignoreType = 'messages___hero___internal___ignoreType',
  messages___hero___internal___mediaType = 'messages___hero___internal___mediaType',
  messages___hero___internal___owner = 'messages___hero___internal___owner',
  messages___hero___internal___type = 'messages___hero___internal___type',
  messages___hero___url = 'messages___hero___url',
  messages___hero___details___size = 'messages___hero___details___size',
  messages___hero___fileName = 'messages___hero___fileName',
  messages___hero___contentType = 'messages___hero___contentType',
  messages___title = 'messages___title',
  messages___summary = 'messages___summary',
  messages___summaryBackground___id = 'messages___summaryBackground___id',
  messages___summaryBackground___parent___id = 'messages___summaryBackground___parent___id',
  messages___summaryBackground___parent___children = 'messages___summaryBackground___parent___children',
  messages___summaryBackground___children = 'messages___summaryBackground___children',
  messages___summaryBackground___children___id = 'messages___summaryBackground___children___id',
  messages___summaryBackground___children___children = 'messages___summaryBackground___children___children',
  messages___summaryBackground___internal___content = 'messages___summaryBackground___internal___content',
  messages___summaryBackground___internal___contentDigest = 'messages___summaryBackground___internal___contentDigest',
  messages___summaryBackground___internal___description = 'messages___summaryBackground___internal___description',
  messages___summaryBackground___internal___fieldOwners = 'messages___summaryBackground___internal___fieldOwners',
  messages___summaryBackground___internal___ignoreType = 'messages___summaryBackground___internal___ignoreType',
  messages___summaryBackground___internal___mediaType = 'messages___summaryBackground___internal___mediaType',
  messages___summaryBackground___internal___owner = 'messages___summaryBackground___internal___owner',
  messages___summaryBackground___internal___type = 'messages___summaryBackground___internal___type',
  messages___summaryBackground___url = 'messages___summaryBackground___url',
  messages___summaryBackground___details___size = 'messages___summaryBackground___details___size',
  messages___summaryBackground___fileName = 'messages___summaryBackground___fileName',
  messages___summaryBackground___contentType = 'messages___summaryBackground___contentType',
  messages___benefitImages = 'messages___benefitImages',
  messages___benefitImages___sysId = 'messages___benefitImages___sysId',
  messages___benefitImages___title = 'messages___benefitImages___title',
  messages___benefitImages___description = 'messages___benefitImages___description',
  messages___benefitImages___file___url = 'messages___benefitImages___file___url',
  messages___benefitImages___file___fileName = 'messages___benefitImages___file___fileName',
  messages___benefitImages___file___contentType = 'messages___benefitImages___file___contentType',
  messages___benefitsDisclaimer = 'messages___benefitsDisclaimer',
  messages___main___raw = 'messages___main___raw',
  messages___main___id = 'messages___main___id',
  messages___main___parent___id = 'messages___main___parent___id',
  messages___main___parent___children = 'messages___main___parent___children',
  messages___main___children = 'messages___main___children',
  messages___main___children___id = 'messages___main___children___id',
  messages___main___children___children = 'messages___main___children___children',
  messages___main___internal___content = 'messages___main___internal___content',
  messages___main___internal___contentDigest = 'messages___main___internal___contentDigest',
  messages___main___internal___description = 'messages___main___internal___description',
  messages___main___internal___fieldOwners = 'messages___main___internal___fieldOwners',
  messages___main___internal___ignoreType = 'messages___main___internal___ignoreType',
  messages___main___internal___mediaType = 'messages___main___internal___mediaType',
  messages___main___internal___owner = 'messages___main___internal___owner',
  messages___main___internal___type = 'messages___main___internal___type',
  messages___products = 'messages___products',
  messages___products___id = 'messages___products___id',
  messages___products___parent___id = 'messages___products___parent___id',
  messages___products___parent___children = 'messages___products___parent___children',
  messages___products___children = 'messages___products___children',
  messages___products___children___id = 'messages___products___children___id',
  messages___products___children___children = 'messages___products___children___children',
  messages___products___internal___content = 'messages___products___internal___content',
  messages___products___internal___contentDigest = 'messages___products___internal___contentDigest',
  messages___products___internal___description = 'messages___products___internal___description',
  messages___products___internal___fieldOwners = 'messages___products___internal___fieldOwners',
  messages___products___internal___ignoreType = 'messages___products___internal___ignoreType',
  messages___products___internal___mediaType = 'messages___products___internal___mediaType',
  messages___products___internal___owner = 'messages___products___internal___owner',
  messages___products___internal___type = 'messages___products___internal___type',
  messages___products___slug = 'messages___products___slug',
  messages___products___name = 'messages___products___name',
  messages___products___description___raw = 'messages___products___description___raw',
  messages___products___description___id = 'messages___products___description___id',
  messages___products___description___children = 'messages___products___description___children',
  messages___products___benefits = 'messages___products___benefits',
  messages___products___variants = 'messages___products___variants',
  messages___products___variants___id = 'messages___products___variants___id',
  messages___products___variants___children = 'messages___products___variants___children',
  messages___products___variants___slug = 'messages___products___variants___slug',
  messages___products___variants___name = 'messages___products___variants___name',
  messages___products___variants___sizes = 'messages___products___variants___sizes',
  messages___products___hero___id = 'messages___products___hero___id',
  messages___products___hero___children = 'messages___products___hero___children',
  messages___products___hero___url = 'messages___products___hero___url',
  messages___products___hero___fileName = 'messages___products___hero___fileName',
  messages___products___hero___contentType = 'messages___products___hero___contentType',
  contactUs___id = 'contactUs___id',
  contactUs___parent___id = 'contactUs___parent___id',
  contactUs___parent___parent___id = 'contactUs___parent___parent___id',
  contactUs___parent___parent___children = 'contactUs___parent___parent___children',
  contactUs___parent___children = 'contactUs___parent___children',
  contactUs___parent___children___id = 'contactUs___parent___children___id',
  contactUs___parent___children___children = 'contactUs___parent___children___children',
  contactUs___parent___internal___content = 'contactUs___parent___internal___content',
  contactUs___parent___internal___contentDigest = 'contactUs___parent___internal___contentDigest',
  contactUs___parent___internal___description = 'contactUs___parent___internal___description',
  contactUs___parent___internal___fieldOwners = 'contactUs___parent___internal___fieldOwners',
  contactUs___parent___internal___ignoreType = 'contactUs___parent___internal___ignoreType',
  contactUs___parent___internal___mediaType = 'contactUs___parent___internal___mediaType',
  contactUs___parent___internal___owner = 'contactUs___parent___internal___owner',
  contactUs___parent___internal___type = 'contactUs___parent___internal___type',
  contactUs___children = 'contactUs___children',
  contactUs___children___id = 'contactUs___children___id',
  contactUs___children___parent___id = 'contactUs___children___parent___id',
  contactUs___children___parent___children = 'contactUs___children___parent___children',
  contactUs___children___children = 'contactUs___children___children',
  contactUs___children___children___id = 'contactUs___children___children___id',
  contactUs___children___children___children = 'contactUs___children___children___children',
  contactUs___children___internal___content = 'contactUs___children___internal___content',
  contactUs___children___internal___contentDigest = 'contactUs___children___internal___contentDigest',
  contactUs___children___internal___description = 'contactUs___children___internal___description',
  contactUs___children___internal___fieldOwners = 'contactUs___children___internal___fieldOwners',
  contactUs___children___internal___ignoreType = 'contactUs___children___internal___ignoreType',
  contactUs___children___internal___mediaType = 'contactUs___children___internal___mediaType',
  contactUs___children___internal___owner = 'contactUs___children___internal___owner',
  contactUs___children___internal___type = 'contactUs___children___internal___type',
  contactUs___internal___content = 'contactUs___internal___content',
  contactUs___internal___contentDigest = 'contactUs___internal___contentDigest',
  contactUs___internal___description = 'contactUs___internal___description',
  contactUs___internal___fieldOwners = 'contactUs___internal___fieldOwners',
  contactUs___internal___ignoreType = 'contactUs___internal___ignoreType',
  contactUs___internal___mediaType = 'contactUs___internal___mediaType',
  contactUs___internal___owner = 'contactUs___internal___owner',
  contactUs___internal___type = 'contactUs___internal___type',
  contactUs___slug = 'contactUs___slug',
  contactUs___title = 'contactUs___title',
  contactUs___summary = 'contactUs___summary',
  contactUs___titlePhoneNumber = 'contactUs___titlePhoneNumber',
  contactUs___phoneNumber___raw = 'contactUs___phoneNumber___raw',
  contactUs___phoneNumber___id = 'contactUs___phoneNumber___id',
  contactUs___phoneNumber___parent___id = 'contactUs___phoneNumber___parent___id',
  contactUs___phoneNumber___parent___children = 'contactUs___phoneNumber___parent___children',
  contactUs___phoneNumber___children = 'contactUs___phoneNumber___children',
  contactUs___phoneNumber___children___id = 'contactUs___phoneNumber___children___id',
  contactUs___phoneNumber___children___children = 'contactUs___phoneNumber___children___children',
  contactUs___phoneNumber___internal___content = 'contactUs___phoneNumber___internal___content',
  contactUs___phoneNumber___internal___contentDigest = 'contactUs___phoneNumber___internal___contentDigest',
  contactUs___phoneNumber___internal___description = 'contactUs___phoneNumber___internal___description',
  contactUs___phoneNumber___internal___fieldOwners = 'contactUs___phoneNumber___internal___fieldOwners',
  contactUs___phoneNumber___internal___ignoreType = 'contactUs___phoneNumber___internal___ignoreType',
  contactUs___phoneNumber___internal___mediaType = 'contactUs___phoneNumber___internal___mediaType',
  contactUs___phoneNumber___internal___owner = 'contactUs___phoneNumber___internal___owner',
  contactUs___phoneNumber___internal___type = 'contactUs___phoneNumber___internal___type',
  contactUs___contactFormWidgetUrl = 'contactUs___contactFormWidgetUrl',
  contactUs___contactFormWidgetClassName = 'contactUs___contactFormWidgetClassName',
  sitemap___id = 'sitemap___id',
  sitemap___parent___id = 'sitemap___parent___id',
  sitemap___parent___parent___id = 'sitemap___parent___parent___id',
  sitemap___parent___parent___children = 'sitemap___parent___parent___children',
  sitemap___parent___children = 'sitemap___parent___children',
  sitemap___parent___children___id = 'sitemap___parent___children___id',
  sitemap___parent___children___children = 'sitemap___parent___children___children',
  sitemap___parent___internal___content = 'sitemap___parent___internal___content',
  sitemap___parent___internal___contentDigest = 'sitemap___parent___internal___contentDigest',
  sitemap___parent___internal___description = 'sitemap___parent___internal___description',
  sitemap___parent___internal___fieldOwners = 'sitemap___parent___internal___fieldOwners',
  sitemap___parent___internal___ignoreType = 'sitemap___parent___internal___ignoreType',
  sitemap___parent___internal___mediaType = 'sitemap___parent___internal___mediaType',
  sitemap___parent___internal___owner = 'sitemap___parent___internal___owner',
  sitemap___parent___internal___type = 'sitemap___parent___internal___type',
  sitemap___children = 'sitemap___children',
  sitemap___children___id = 'sitemap___children___id',
  sitemap___children___parent___id = 'sitemap___children___parent___id',
  sitemap___children___parent___children = 'sitemap___children___parent___children',
  sitemap___children___children = 'sitemap___children___children',
  sitemap___children___children___id = 'sitemap___children___children___id',
  sitemap___children___children___children = 'sitemap___children___children___children',
  sitemap___children___internal___content = 'sitemap___children___internal___content',
  sitemap___children___internal___contentDigest = 'sitemap___children___internal___contentDigest',
  sitemap___children___internal___description = 'sitemap___children___internal___description',
  sitemap___children___internal___fieldOwners = 'sitemap___children___internal___fieldOwners',
  sitemap___children___internal___ignoreType = 'sitemap___children___internal___ignoreType',
  sitemap___children___internal___mediaType = 'sitemap___children___internal___mediaType',
  sitemap___children___internal___owner = 'sitemap___children___internal___owner',
  sitemap___children___internal___type = 'sitemap___children___internal___type',
  sitemap___internal___content = 'sitemap___internal___content',
  sitemap___internal___contentDigest = 'sitemap___internal___contentDigest',
  sitemap___internal___description = 'sitemap___internal___description',
  sitemap___internal___fieldOwners = 'sitemap___internal___fieldOwners',
  sitemap___internal___ignoreType = 'sitemap___internal___ignoreType',
  sitemap___internal___mediaType = 'sitemap___internal___mediaType',
  sitemap___internal___owner = 'sitemap___internal___owner',
  sitemap___internal___type = 'sitemap___internal___type',
  sitemap___slug = 'sitemap___slug',
  sitemap___title = 'sitemap___title',
  sitemap___heading = 'sitemap___heading',
  footerLinks = 'footerLinks',
  footerLinks___id = 'footerLinks___id',
  footerLinks___parent___id = 'footerLinks___parent___id',
  footerLinks___parent___parent___id = 'footerLinks___parent___parent___id',
  footerLinks___parent___parent___children = 'footerLinks___parent___parent___children',
  footerLinks___parent___children = 'footerLinks___parent___children',
  footerLinks___parent___children___id = 'footerLinks___parent___children___id',
  footerLinks___parent___children___children = 'footerLinks___parent___children___children',
  footerLinks___parent___internal___content = 'footerLinks___parent___internal___content',
  footerLinks___parent___internal___contentDigest = 'footerLinks___parent___internal___contentDigest',
  footerLinks___parent___internal___description = 'footerLinks___parent___internal___description',
  footerLinks___parent___internal___fieldOwners = 'footerLinks___parent___internal___fieldOwners',
  footerLinks___parent___internal___ignoreType = 'footerLinks___parent___internal___ignoreType',
  footerLinks___parent___internal___mediaType = 'footerLinks___parent___internal___mediaType',
  footerLinks___parent___internal___owner = 'footerLinks___parent___internal___owner',
  footerLinks___parent___internal___type = 'footerLinks___parent___internal___type',
  footerLinks___children = 'footerLinks___children',
  footerLinks___children___id = 'footerLinks___children___id',
  footerLinks___children___parent___id = 'footerLinks___children___parent___id',
  footerLinks___children___parent___children = 'footerLinks___children___parent___children',
  footerLinks___children___children = 'footerLinks___children___children',
  footerLinks___children___children___id = 'footerLinks___children___children___id',
  footerLinks___children___children___children = 'footerLinks___children___children___children',
  footerLinks___children___internal___content = 'footerLinks___children___internal___content',
  footerLinks___children___internal___contentDigest = 'footerLinks___children___internal___contentDigest',
  footerLinks___children___internal___description = 'footerLinks___children___internal___description',
  footerLinks___children___internal___fieldOwners = 'footerLinks___children___internal___fieldOwners',
  footerLinks___children___internal___ignoreType = 'footerLinks___children___internal___ignoreType',
  footerLinks___children___internal___mediaType = 'footerLinks___children___internal___mediaType',
  footerLinks___children___internal___owner = 'footerLinks___children___internal___owner',
  footerLinks___children___internal___type = 'footerLinks___children___internal___type',
  footerLinks___internal___content = 'footerLinks___internal___content',
  footerLinks___internal___contentDigest = 'footerLinks___internal___contentDigest',
  footerLinks___internal___description = 'footerLinks___internal___description',
  footerLinks___internal___fieldOwners = 'footerLinks___internal___fieldOwners',
  footerLinks___internal___ignoreType = 'footerLinks___internal___ignoreType',
  footerLinks___internal___mediaType = 'footerLinks___internal___mediaType',
  footerLinks___internal___owner = 'footerLinks___internal___owner',
  footerLinks___internal___type = 'footerLinks___internal___type',
  footerLinks___slug = 'footerLinks___slug',
  footerLinks___title = 'footerLinks___title',
  footerLinks___summary = 'footerLinks___summary',
  footerLinks___titlePhoneNumber = 'footerLinks___titlePhoneNumber',
  footerLinks___phoneNumber___raw = 'footerLinks___phoneNumber___raw',
  footerLinks___phoneNumber___id = 'footerLinks___phoneNumber___id',
  footerLinks___phoneNumber___parent___id = 'footerLinks___phoneNumber___parent___id',
  footerLinks___phoneNumber___parent___children = 'footerLinks___phoneNumber___parent___children',
  footerLinks___phoneNumber___children = 'footerLinks___phoneNumber___children',
  footerLinks___phoneNumber___children___id = 'footerLinks___phoneNumber___children___id',
  footerLinks___phoneNumber___children___children = 'footerLinks___phoneNumber___children___children',
  footerLinks___phoneNumber___internal___content = 'footerLinks___phoneNumber___internal___content',
  footerLinks___phoneNumber___internal___contentDigest = 'footerLinks___phoneNumber___internal___contentDigest',
  footerLinks___phoneNumber___internal___description = 'footerLinks___phoneNumber___internal___description',
  footerLinks___phoneNumber___internal___fieldOwners = 'footerLinks___phoneNumber___internal___fieldOwners',
  footerLinks___phoneNumber___internal___ignoreType = 'footerLinks___phoneNumber___internal___ignoreType',
  footerLinks___phoneNumber___internal___mediaType = 'footerLinks___phoneNumber___internal___mediaType',
  footerLinks___phoneNumber___internal___owner = 'footerLinks___phoneNumber___internal___owner',
  footerLinks___phoneNumber___internal___type = 'footerLinks___phoneNumber___internal___type',
  footerLinks___contactFormWidgetUrl = 'footerLinks___contactFormWidgetUrl',
  footerLinks___contactFormWidgetClassName = 'footerLinks___contactFormWidgetClassName'
}

export type S3ContentfulWebsiteFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  homepageTitle?: Maybe<StringQueryOperatorInput>;
  brand?: Maybe<S3ContentfulBrandFilterInput>;
  domain?: Maybe<S3ContentfulDomainFilterInput>;
  message?: Maybe<S3ContentfulMessageFilterInput>;
  messageSecondary?: Maybe<S3ContentfulMessageFilterInput>;
  lexicon?: Maybe<S3ContentfulLexiconFilterInput>;
  legals?: Maybe<S3ContentfulLegalsFilterInput>;
  socialChannels?: Maybe<S3ContentfulSocialChannelFilterListInput>;
  messages?: Maybe<S3ContentfulMessageFilterListInput>;
  contactUs?: Maybe<S3ContentfulContactUsFilterInput>;
  sitemap?: Maybe<S3ContentfulSitemapFilterInput>;
  footerLinks?: Maybe<S3ContentfulContactUsFilterListInput>;
};

export type S3ContentfulWebsiteGroupConnection = {
  __typename?: 'S3ContentfulWebsiteGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<S3ContentfulWebsiteEdge>;
  nodes: Array<S3ContentfulWebsite>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type S3ContentfulWebsiteSortInput = {
  fields?: Maybe<Array<Maybe<S3ContentfulWebsiteFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SignUp = Node & {
  __typename?: 'SignUp';
  absolutePath: Scalars['String'];
  ageConsentLabel?: Maybe<Scalars['String']>;
  brandConsentLabel?: Maybe<Scalars['String']>;
  brandConsentRequired?: Maybe<Scalars['Boolean']>;
  corporateConsentLabel?: Maybe<Scalars['String']>;
  dateOfBirthFieldLabel?: Maybe<Scalars['String']>;
  dayOfBirthFieldLabel?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Html>;
  emailAddressFieldLabel: Scalars['String'];
  enterpriseConsent?: Maybe<Html>;
  failureMessage: Scalars['String'];
  femaleGenderFieldLabel?: Maybe<Scalars['String']>;
  firstNameFieldLabel: Scalars['String'];
  genderFieldLabel?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  hero: Media;
  id: Scalars['ID'];
  lastNameFieldLabel: Scalars['String'];
  maleGenderFieldLabel?: Maybe<Scalars['String']>;
  mobileNumberFieldLabel?: Maybe<Scalars['String']>;
  monthOfBirthFieldLabel?: Maybe<Scalars['String']>;
  notSpecifiedGenderFieldLabel?: Maybe<Scalars['String']>;
  pageType: Scalars['String'];
  path: Scalars['String'];
  postalCodeFieldLabel?: Maybe<Scalars['String']>;
  shouldCaptureAgeConsent?: Maybe<FieldCaptureType>;
  shouldCaptureDayOfBirth?: Maybe<FieldCaptureType>;
  shouldCaptureEnterpriseConsent?: Maybe<FieldCaptureType>;
  shouldCaptureGender?: Maybe<FieldCaptureType>;
  shouldCaptureMobileNumber?: Maybe<FieldCaptureType>;
  shouldCaptureMonthOfBirth?: Maybe<FieldCaptureType>;
  shouldCapturePostalCode?: Maybe<FieldCaptureType>;
  shouldCaptureYearOfBirth?: Maybe<FieldCaptureType>;
  slug: Scalars['String'];
  submitButtonLabel: Scalars['String'];
  successMessage: Scalars['String'];
  successMessageAttachment?: Maybe<Media>;
  termsAndConditionsBlurb?: Maybe<Html>;
  title: Scalars['String'];
  traits: Traits;
  yearOfBirthFieldLabel?: Maybe<Scalars['String']>;
  submissionConsentMessage?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SignUpConnection = {
  __typename?: 'SignUpConnection';
  totalCount: Scalars['Int'];
  edges: Array<SignUpEdge>;
  nodes: Array<SignUp>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SignUpGroupConnection>;
};


export type SignUpConnectionDistinctArgs = {
  field: SignUpFieldsEnum;
};


export type SignUpConnectionMaxArgs = {
  field: SignUpFieldsEnum;
};


export type SignUpConnectionMinArgs = {
  field: SignUpFieldsEnum;
};


export type SignUpConnectionSumArgs = {
  field: SignUpFieldsEnum;
};


export type SignUpConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SignUpFieldsEnum;
};

export type SignUpEdge = {
  __typename?: 'SignUpEdge';
  next?: Maybe<SignUp>;
  node: SignUp;
  previous?: Maybe<SignUp>;
};

export enum SignUpFieldsEnum {
  absolutePath = 'absolutePath',
  ageConsentLabel = 'ageConsentLabel',
  brandConsentLabel = 'brandConsentLabel',
  brandConsentRequired = 'brandConsentRequired',
  corporateConsentLabel = 'corporateConsentLabel',
  dateOfBirthFieldLabel = 'dateOfBirthFieldLabel',
  dayOfBirthFieldLabel = 'dayOfBirthFieldLabel',
  disclaimer___html = 'disclaimer___html',
  disclaimer___json = 'disclaimer___json',
  disclaimer___text = 'disclaimer___text',
  emailAddressFieldLabel = 'emailAddressFieldLabel',
  enterpriseConsent___html = 'enterpriseConsent___html',
  enterpriseConsent___json = 'enterpriseConsent___json',
  enterpriseConsent___text = 'enterpriseConsent___text',
  failureMessage = 'failureMessage',
  femaleGenderFieldLabel = 'femaleGenderFieldLabel',
  firstNameFieldLabel = 'firstNameFieldLabel',
  genderFieldLabel = 'genderFieldLabel',
  heading = 'heading',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  id = 'id',
  lastNameFieldLabel = 'lastNameFieldLabel',
  maleGenderFieldLabel = 'maleGenderFieldLabel',
  mobileNumberFieldLabel = 'mobileNumberFieldLabel',
  monthOfBirthFieldLabel = 'monthOfBirthFieldLabel',
  notSpecifiedGenderFieldLabel = 'notSpecifiedGenderFieldLabel',
  pageType = 'pageType',
  path = 'path',
  postalCodeFieldLabel = 'postalCodeFieldLabel',
  shouldCaptureAgeConsent = 'shouldCaptureAgeConsent',
  shouldCaptureDayOfBirth = 'shouldCaptureDayOfBirth',
  shouldCaptureEnterpriseConsent = 'shouldCaptureEnterpriseConsent',
  shouldCaptureGender = 'shouldCaptureGender',
  shouldCaptureMobileNumber = 'shouldCaptureMobileNumber',
  shouldCaptureMonthOfBirth = 'shouldCaptureMonthOfBirth',
  shouldCapturePostalCode = 'shouldCapturePostalCode',
  shouldCaptureYearOfBirth = 'shouldCaptureYearOfBirth',
  slug = 'slug',
  submitButtonLabel = 'submitButtonLabel',
  successMessage = 'successMessage',
  successMessageAttachment___description = 'successMessageAttachment___description',
  successMessageAttachment___file___fileLocal___sourceInstanceName = 'successMessageAttachment___file___fileLocal___sourceInstanceName',
  successMessageAttachment___file___fileLocal___absolutePath = 'successMessageAttachment___file___fileLocal___absolutePath',
  successMessageAttachment___file___fileLocal___relativePath = 'successMessageAttachment___file___fileLocal___relativePath',
  successMessageAttachment___file___fileLocal___extension = 'successMessageAttachment___file___fileLocal___extension',
  successMessageAttachment___file___fileLocal___size = 'successMessageAttachment___file___fileLocal___size',
  successMessageAttachment___file___fileLocal___prettySize = 'successMessageAttachment___file___fileLocal___prettySize',
  successMessageAttachment___file___fileLocal___modifiedTime = 'successMessageAttachment___file___fileLocal___modifiedTime',
  successMessageAttachment___file___fileLocal___accessTime = 'successMessageAttachment___file___fileLocal___accessTime',
  successMessageAttachment___file___fileLocal___changeTime = 'successMessageAttachment___file___fileLocal___changeTime',
  successMessageAttachment___file___fileLocal___birthTime = 'successMessageAttachment___file___fileLocal___birthTime',
  successMessageAttachment___file___fileLocal___root = 'successMessageAttachment___file___fileLocal___root',
  successMessageAttachment___file___fileLocal___dir = 'successMessageAttachment___file___fileLocal___dir',
  successMessageAttachment___file___fileLocal___base = 'successMessageAttachment___file___fileLocal___base',
  successMessageAttachment___file___fileLocal___ext = 'successMessageAttachment___file___fileLocal___ext',
  successMessageAttachment___file___fileLocal___name = 'successMessageAttachment___file___fileLocal___name',
  successMessageAttachment___file___fileLocal___relativeDirectory = 'successMessageAttachment___file___fileLocal___relativeDirectory',
  successMessageAttachment___file___fileLocal___dev = 'successMessageAttachment___file___fileLocal___dev',
  successMessageAttachment___file___fileLocal___mode = 'successMessageAttachment___file___fileLocal___mode',
  successMessageAttachment___file___fileLocal___nlink = 'successMessageAttachment___file___fileLocal___nlink',
  successMessageAttachment___file___fileLocal___uid = 'successMessageAttachment___file___fileLocal___uid',
  successMessageAttachment___file___fileLocal___gid = 'successMessageAttachment___file___fileLocal___gid',
  successMessageAttachment___file___fileLocal___rdev = 'successMessageAttachment___file___fileLocal___rdev',
  successMessageAttachment___file___fileLocal___ino = 'successMessageAttachment___file___fileLocal___ino',
  successMessageAttachment___file___fileLocal___atimeMs = 'successMessageAttachment___file___fileLocal___atimeMs',
  successMessageAttachment___file___fileLocal___mtimeMs = 'successMessageAttachment___file___fileLocal___mtimeMs',
  successMessageAttachment___file___fileLocal___ctimeMs = 'successMessageAttachment___file___fileLocal___ctimeMs',
  successMessageAttachment___file___fileLocal___atime = 'successMessageAttachment___file___fileLocal___atime',
  successMessageAttachment___file___fileLocal___mtime = 'successMessageAttachment___file___fileLocal___mtime',
  successMessageAttachment___file___fileLocal___ctime = 'successMessageAttachment___file___fileLocal___ctime',
  successMessageAttachment___file___fileLocal___birthtime = 'successMessageAttachment___file___fileLocal___birthtime',
  successMessageAttachment___file___fileLocal___birthtimeMs = 'successMessageAttachment___file___fileLocal___birthtimeMs',
  successMessageAttachment___file___fileLocal___blksize = 'successMessageAttachment___file___fileLocal___blksize',
  successMessageAttachment___file___fileLocal___blocks = 'successMessageAttachment___file___fileLocal___blocks',
  successMessageAttachment___file___fileLocal___url = 'successMessageAttachment___file___fileLocal___url',
  successMessageAttachment___file___fileLocal___publicURL = 'successMessageAttachment___file___fileLocal___publicURL',
  successMessageAttachment___file___fileLocal___childrenImageSharp = 'successMessageAttachment___file___fileLocal___childrenImageSharp',
  successMessageAttachment___file___fileLocal___id = 'successMessageAttachment___file___fileLocal___id',
  successMessageAttachment___file___fileLocal___children = 'successMessageAttachment___file___fileLocal___children',
  successMessageAttachment___file___url = 'successMessageAttachment___file___url',
  successMessageAttachment___title = 'successMessageAttachment___title',
  termsAndConditionsBlurb___html = 'termsAndConditionsBlurb___html',
  termsAndConditionsBlurb___json = 'termsAndConditionsBlurb___json',
  termsAndConditionsBlurb___text = 'termsAndConditionsBlurb___text',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  yearOfBirthFieldLabel = 'yearOfBirthFieldLabel',
  submissionConsentMessage = 'submissionConsentMessage',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SignUpFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  ageConsentLabel?: Maybe<StringQueryOperatorInput>;
  brandConsentLabel?: Maybe<StringQueryOperatorInput>;
  brandConsentRequired?: Maybe<BooleanQueryOperatorInput>;
  corporateConsentLabel?: Maybe<StringQueryOperatorInput>;
  dateOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  dayOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  disclaimer?: Maybe<HtmlFilterInput>;
  emailAddressFieldLabel?: Maybe<StringQueryOperatorInput>;
  enterpriseConsent?: Maybe<HtmlFilterInput>;
  failureMessage?: Maybe<StringQueryOperatorInput>;
  femaleGenderFieldLabel?: Maybe<StringQueryOperatorInput>;
  firstNameFieldLabel?: Maybe<StringQueryOperatorInput>;
  genderFieldLabel?: Maybe<StringQueryOperatorInput>;
  heading?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  lastNameFieldLabel?: Maybe<StringQueryOperatorInput>;
  maleGenderFieldLabel?: Maybe<StringQueryOperatorInput>;
  mobileNumberFieldLabel?: Maybe<StringQueryOperatorInput>;
  monthOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  notSpecifiedGenderFieldLabel?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  postalCodeFieldLabel?: Maybe<StringQueryOperatorInput>;
  shouldCaptureAgeConsent?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureDayOfBirth?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureEnterpriseConsent?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureGender?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureMobileNumber?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureMonthOfBirth?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCapturePostalCode?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  shouldCaptureYearOfBirth?: Maybe<FieldCaptureTypeQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  submitButtonLabel?: Maybe<StringQueryOperatorInput>;
  successMessage?: Maybe<StringQueryOperatorInput>;
  successMessageAttachment?: Maybe<MediaFilterInput>;
  termsAndConditionsBlurb?: Maybe<HtmlFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  yearOfBirthFieldLabel?: Maybe<StringQueryOperatorInput>;
  submissionConsentMessage?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SignUpGroupConnection = {
  __typename?: 'SignUpGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SignUpEdge>;
  nodes: Array<SignUp>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SignUpSortInput = {
  fields?: Maybe<Array<Maybe<SignUpFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Site = Node & {
  __typename?: 'Site';
  buildTime?: Maybe<Scalars['Date']>;
  siteMetadata?: Maybe<SiteSiteMetadata>;
  port?: Maybe<Scalars['Int']>;
  host?: Maybe<Scalars['String']>;
  pathPrefix?: Maybe<Scalars['String']>;
  flags?: Maybe<SiteFlags>;
  polyfill?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type SiteBuildTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SiteBuildMetadata = Node & {
  __typename?: 'SiteBuildMetadata';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  buildTime?: Maybe<Scalars['Date']>;
};


export type SiteBuildMetadataBuildTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SiteBuildMetadataConnection = {
  __typename?: 'SiteBuildMetadataConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteBuildMetadataEdge>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteBuildMetadataGroupConnection>;
};


export type SiteBuildMetadataConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionMaxArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionMinArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionSumArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SiteBuildMetadataFieldsEnum;
};

export type SiteBuildMetadataEdge = {
  __typename?: 'SiteBuildMetadataEdge';
  next?: Maybe<SiteBuildMetadata>;
  node: SiteBuildMetadata;
  previous?: Maybe<SiteBuildMetadata>;
};

export enum SiteBuildMetadataFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  buildTime = 'buildTime'
}

export type SiteBuildMetadataFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  buildTime?: Maybe<DateQueryOperatorInput>;
};

export type SiteBuildMetadataGroupConnection = {
  __typename?: 'SiteBuildMetadataGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteBuildMetadataEdge>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SiteBuildMetadataSortInput = {
  fields?: Maybe<Array<Maybe<SiteBuildMetadataFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SiteConnection = {
  __typename?: 'SiteConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteEdge>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteGroupConnection>;
};


export type SiteConnectionDistinctArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionMaxArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionMinArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionSumArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SiteFieldsEnum;
};

export type SiteEdge = {
  __typename?: 'SiteEdge';
  next?: Maybe<Site>;
  node: Site;
  previous?: Maybe<Site>;
};

export enum SiteFieldsEnum {
  buildTime = 'buildTime',
  siteMetadata___title = 'siteMetadata___title',
  siteMetadata___description = 'siteMetadata___description',
  siteMetadata___siteUrl = 'siteMetadata___siteUrl',
  siteMetadata___assetPrefix = 'siteMetadata___assetPrefix',
  port = 'port',
  host = 'host',
  pathPrefix = 'pathPrefix',
  flags___PRESERVE_WEBPACK_CACHE = 'flags___PRESERVE_WEBPACK_CACHE',
  polyfill = 'polyfill',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SiteFilterInput = {
  buildTime?: Maybe<DateQueryOperatorInput>;
  siteMetadata?: Maybe<SiteSiteMetadataFilterInput>;
  port?: Maybe<IntQueryOperatorInput>;
  host?: Maybe<StringQueryOperatorInput>;
  pathPrefix?: Maybe<StringQueryOperatorInput>;
  flags?: Maybe<SiteFlagsFilterInput>;
  polyfill?: Maybe<BooleanQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SiteFlags = {
  __typename?: 'SiteFlags';
  PRESERVE_WEBPACK_CACHE?: Maybe<Scalars['Boolean']>;
};

export type SiteFlagsFilterInput = {
  PRESERVE_WEBPACK_CACHE?: Maybe<BooleanQueryOperatorInput>;
};

export type SiteFunction = Node & {
  __typename?: 'SiteFunction';
  functionRoute: Scalars['String'];
  pluginName: Scalars['String'];
  originalAbsoluteFilePath: Scalars['String'];
  originalRelativeFilePath: Scalars['String'];
  relativeCompiledFilePath: Scalars['String'];
  absoluteCompiledFilePath: Scalars['String'];
  matchPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SiteFunctionConnection = {
  __typename?: 'SiteFunctionConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteFunctionEdge>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteFunctionGroupConnection>;
};


export type SiteFunctionConnectionDistinctArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionMaxArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionMinArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionSumArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SiteFunctionFieldsEnum;
};

export type SiteFunctionEdge = {
  __typename?: 'SiteFunctionEdge';
  next?: Maybe<SiteFunction>;
  node: SiteFunction;
  previous?: Maybe<SiteFunction>;
};

export enum SiteFunctionFieldsEnum {
  functionRoute = 'functionRoute',
  pluginName = 'pluginName',
  originalAbsoluteFilePath = 'originalAbsoluteFilePath',
  originalRelativeFilePath = 'originalRelativeFilePath',
  relativeCompiledFilePath = 'relativeCompiledFilePath',
  absoluteCompiledFilePath = 'absoluteCompiledFilePath',
  matchPath = 'matchPath',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SiteFunctionFilterInput = {
  functionRoute?: Maybe<StringQueryOperatorInput>;
  pluginName?: Maybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: Maybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: Maybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: Maybe<StringQueryOperatorInput>;
  absoluteCompiledFilePath?: Maybe<StringQueryOperatorInput>;
  matchPath?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SiteFunctionGroupConnection = {
  __typename?: 'SiteFunctionGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteFunctionEdge>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SiteFunctionSortInput = {
  fields?: Maybe<Array<Maybe<SiteFunctionFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SiteGroupConnection = {
  __typename?: 'SiteGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteEdge>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitePage = Node & {
  __typename?: 'SitePage';
  path: Scalars['String'];
  component: Scalars['String'];
  internalComponentName: Scalars['String'];
  componentChunkName: Scalars['String'];
  matchPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  isCreatedByStatefulCreatePages?: Maybe<Scalars['Boolean']>;
  context?: Maybe<SitePageContext>;
  pluginCreator?: Maybe<SitePlugin>;
  pluginCreatorId?: Maybe<Scalars['String']>;
};

export type SitePageConnection = {
  __typename?: 'SitePageConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePageEdge>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitePageGroupConnection>;
};


export type SitePageConnectionDistinctArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionMaxArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionMinArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionSumArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SitePageFieldsEnum;
};

export type SitePageContext = Node & {
  __typename?: 'SitePageContext';
  /** The title to show against this page in the sitemap page */
  sitemapTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  productId?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  topicId?: Maybe<Scalars['String']>;
  productImageCropFocus?: Maybe<Scalars['String']>;
  pluginArticlesPathRegex?: Maybe<Scalars['String']>;
  sitemapExclusions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SitePageContextConnection = {
  __typename?: 'SitePageContextConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePageContextEdge>;
  nodes: Array<SitePageContext>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitePageContextGroupConnection>;
};


export type SitePageContextConnectionDistinctArgs = {
  field: SitePageContextFieldsEnum;
};


export type SitePageContextConnectionMaxArgs = {
  field: SitePageContextFieldsEnum;
};


export type SitePageContextConnectionMinArgs = {
  field: SitePageContextFieldsEnum;
};


export type SitePageContextConnectionSumArgs = {
  field: SitePageContextFieldsEnum;
};


export type SitePageContextConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SitePageContextFieldsEnum;
};

export type SitePageContextEdge = {
  __typename?: 'SitePageContextEdge';
  next?: Maybe<SitePageContext>;
  node: SitePageContext;
  previous?: Maybe<SitePageContext>;
};

export enum SitePageContextFieldsEnum {
  sitemapTitle = 'sitemapTitle',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SitePageContextFilterInput = {
  sitemapTitle?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SitePageContextGroupConnection = {
  __typename?: 'SitePageContextGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePageContextEdge>;
  nodes: Array<SitePageContext>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitePageContextSortInput = {
  fields?: Maybe<Array<Maybe<SitePageContextFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SitePageEdge = {
  __typename?: 'SitePageEdge';
  next?: Maybe<SitePage>;
  node: SitePage;
  previous?: Maybe<SitePage>;
};

export enum SitePageFieldsEnum {
  path = 'path',
  component = 'component',
  internalComponentName = 'internalComponentName',
  componentChunkName = 'componentChunkName',
  matchPath = 'matchPath',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  isCreatedByStatefulCreatePages = 'isCreatedByStatefulCreatePages',
  context___sitemapTitle = 'context___sitemapTitle',
  context___id = 'context___id',
  context___parent___id = 'context___parent___id',
  context___parent___parent___id = 'context___parent___parent___id',
  context___parent___parent___children = 'context___parent___parent___children',
  context___parent___children = 'context___parent___children',
  context___parent___children___id = 'context___parent___children___id',
  context___parent___children___children = 'context___parent___children___children',
  context___parent___internal___content = 'context___parent___internal___content',
  context___parent___internal___contentDigest = 'context___parent___internal___contentDigest',
  context___parent___internal___description = 'context___parent___internal___description',
  context___parent___internal___fieldOwners = 'context___parent___internal___fieldOwners',
  context___parent___internal___ignoreType = 'context___parent___internal___ignoreType',
  context___parent___internal___mediaType = 'context___parent___internal___mediaType',
  context___parent___internal___owner = 'context___parent___internal___owner',
  context___parent___internal___type = 'context___parent___internal___type',
  context___children = 'context___children',
  context___children___id = 'context___children___id',
  context___children___parent___id = 'context___children___parent___id',
  context___children___parent___children = 'context___children___parent___children',
  context___children___children = 'context___children___children',
  context___children___children___id = 'context___children___children___id',
  context___children___children___children = 'context___children___children___children',
  context___children___internal___content = 'context___children___internal___content',
  context___children___internal___contentDigest = 'context___children___internal___contentDigest',
  context___children___internal___description = 'context___children___internal___description',
  context___children___internal___fieldOwners = 'context___children___internal___fieldOwners',
  context___children___internal___ignoreType = 'context___children___internal___ignoreType',
  context___children___internal___mediaType = 'context___children___internal___mediaType',
  context___children___internal___owner = 'context___children___internal___owner',
  context___children___internal___type = 'context___children___internal___type',
  context___internal___content = 'context___internal___content',
  context___internal___contentDigest = 'context___internal___contentDigest',
  context___internal___description = 'context___internal___description',
  context___internal___fieldOwners = 'context___internal___fieldOwners',
  context___internal___ignoreType = 'context___internal___ignoreType',
  context___internal___mediaType = 'context___internal___mediaType',
  context___internal___owner = 'context___internal___owner',
  context___internal___type = 'context___internal___type',
  pluginCreator___id = 'pluginCreator___id',
  pluginCreator___parent___id = 'pluginCreator___parent___id',
  pluginCreator___parent___parent___id = 'pluginCreator___parent___parent___id',
  pluginCreator___parent___parent___children = 'pluginCreator___parent___parent___children',
  pluginCreator___parent___children = 'pluginCreator___parent___children',
  pluginCreator___parent___children___id = 'pluginCreator___parent___children___id',
  pluginCreator___parent___children___children = 'pluginCreator___parent___children___children',
  pluginCreator___parent___internal___content = 'pluginCreator___parent___internal___content',
  pluginCreator___parent___internal___contentDigest = 'pluginCreator___parent___internal___contentDigest',
  pluginCreator___parent___internal___description = 'pluginCreator___parent___internal___description',
  pluginCreator___parent___internal___fieldOwners = 'pluginCreator___parent___internal___fieldOwners',
  pluginCreator___parent___internal___ignoreType = 'pluginCreator___parent___internal___ignoreType',
  pluginCreator___parent___internal___mediaType = 'pluginCreator___parent___internal___mediaType',
  pluginCreator___parent___internal___owner = 'pluginCreator___parent___internal___owner',
  pluginCreator___parent___internal___type = 'pluginCreator___parent___internal___type',
  pluginCreator___children = 'pluginCreator___children',
  pluginCreator___children___id = 'pluginCreator___children___id',
  pluginCreator___children___parent___id = 'pluginCreator___children___parent___id',
  pluginCreator___children___parent___children = 'pluginCreator___children___parent___children',
  pluginCreator___children___children = 'pluginCreator___children___children',
  pluginCreator___children___children___id = 'pluginCreator___children___children___id',
  pluginCreator___children___children___children = 'pluginCreator___children___children___children',
  pluginCreator___children___internal___content = 'pluginCreator___children___internal___content',
  pluginCreator___children___internal___contentDigest = 'pluginCreator___children___internal___contentDigest',
  pluginCreator___children___internal___description = 'pluginCreator___children___internal___description',
  pluginCreator___children___internal___fieldOwners = 'pluginCreator___children___internal___fieldOwners',
  pluginCreator___children___internal___ignoreType = 'pluginCreator___children___internal___ignoreType',
  pluginCreator___children___internal___mediaType = 'pluginCreator___children___internal___mediaType',
  pluginCreator___children___internal___owner = 'pluginCreator___children___internal___owner',
  pluginCreator___children___internal___type = 'pluginCreator___children___internal___type',
  pluginCreator___internal___content = 'pluginCreator___internal___content',
  pluginCreator___internal___contentDigest = 'pluginCreator___internal___contentDigest',
  pluginCreator___internal___description = 'pluginCreator___internal___description',
  pluginCreator___internal___fieldOwners = 'pluginCreator___internal___fieldOwners',
  pluginCreator___internal___ignoreType = 'pluginCreator___internal___ignoreType',
  pluginCreator___internal___mediaType = 'pluginCreator___internal___mediaType',
  pluginCreator___internal___owner = 'pluginCreator___internal___owner',
  pluginCreator___internal___type = 'pluginCreator___internal___type',
  pluginCreator___resolve = 'pluginCreator___resolve',
  pluginCreator___name = 'pluginCreator___name',
  pluginCreator___version = 'pluginCreator___version',
  pluginCreator___pluginOptions___postCssPlugins = 'pluginCreator___pluginOptions___postCssPlugins',
  pluginCreator___pluginOptions___postCssPlugins___postcssPlugin = 'pluginCreator___pluginOptions___postCssPlugins___postcssPlugin',
  pluginCreator___pluginOptions___domain = 'pluginCreator___pluginOptions___domain',
  pluginCreator___pluginOptions___pathPrefix = 'pluginCreator___pluginOptions___pathPrefix',
  pluginCreator___pluginOptions___downloadBinaries = 'pluginCreator___pluginOptions___downloadBinaries',
  pluginCreator___pluginOptions___ffmpegPath = 'pluginCreator___pluginOptions___ffmpegPath',
  pluginCreator___pluginOptions___ffprobePath = 'pluginCreator___pluginOptions___ffprobePath',
  pluginCreator___pluginOptions___name = 'pluginCreator___pluginOptions___name',
  pluginCreator___pluginOptions___path = 'pluginCreator___pluginOptions___path',
  pluginCreator___pluginOptions___base64Width = 'pluginCreator___pluginOptions___base64Width',
  pluginCreator___pluginOptions___stripMetadata = 'pluginCreator___pluginOptions___stripMetadata',
  pluginCreator___pluginOptions___defaultQuality = 'pluginCreator___pluginOptions___defaultQuality',
  pluginCreator___pluginOptions___failOnError = 'pluginCreator___pluginOptions___failOnError',
  pluginCreator___pluginOptions___sitemap = 'pluginCreator___pluginOptions___sitemap',
  pluginCreator___pluginOptions___policy = 'pluginCreator___pluginOptions___policy',
  pluginCreator___pluginOptions___policy___userAgent = 'pluginCreator___pluginOptions___policy___userAgent',
  pluginCreator___pluginOptions___exclude = 'pluginCreator___pluginOptions___exclude',
  pluginCreator___pluginOptions___sitemapPath = 'pluginCreator___pluginOptions___sitemapPath',
  pluginCreator___pluginOptions___gatsbyImageSelector = 'pluginCreator___pluginOptions___gatsbyImageSelector',
  pluginCreator___pluginOptions___createLinkInHead = 'pluginCreator___pluginOptions___createLinkInHead',
  pluginCreator___pluginOptions___query = 'pluginCreator___pluginOptions___query',
  pluginCreator___pluginOptions___output = 'pluginCreator___pluginOptions___output',
  pluginCreator___pluginOptions___enabled = 'pluginCreator___pluginOptions___enabled',
  pluginCreator___pluginOptions___trackingIds = 'pluginCreator___pluginOptions___trackingIds',
  pluginCreator___pluginOptions___s3ContentPath = 'pluginCreator___pluginOptions___s3ContentPath',
  pluginCreator___pluginOptions___pathCheck = 'pluginCreator___pluginOptions___pathCheck',
  pluginCreator___pluginOptions___allExtensions = 'pluginCreator___pluginOptions___allExtensions',
  pluginCreator___pluginOptions___isTSX = 'pluginCreator___pluginOptions___isTSX',
  pluginCreator___pluginOptions___jsxPragma = 'pluginCreator___pluginOptions___jsxPragma',
  pluginCreator___nodeAPIs = 'pluginCreator___nodeAPIs',
  pluginCreator___browserAPIs = 'pluginCreator___browserAPIs',
  pluginCreator___ssrAPIs = 'pluginCreator___ssrAPIs',
  pluginCreator___pluginFilepath = 'pluginCreator___pluginFilepath',
  pluginCreator___packageJson___name = 'pluginCreator___packageJson___name',
  pluginCreator___packageJson___description = 'pluginCreator___packageJson___description',
  pluginCreator___packageJson___version = 'pluginCreator___packageJson___version',
  pluginCreator___packageJson___main = 'pluginCreator___packageJson___main',
  pluginCreator___packageJson___license = 'pluginCreator___packageJson___license',
  pluginCreator___packageJson___dependencies = 'pluginCreator___packageJson___dependencies',
  pluginCreator___packageJson___dependencies___name = 'pluginCreator___packageJson___dependencies___name',
  pluginCreator___packageJson___dependencies___version = 'pluginCreator___packageJson___dependencies___version',
  pluginCreator___packageJson___devDependencies = 'pluginCreator___packageJson___devDependencies',
  pluginCreator___packageJson___devDependencies___name = 'pluginCreator___packageJson___devDependencies___name',
  pluginCreator___packageJson___devDependencies___version = 'pluginCreator___packageJson___devDependencies___version',
  pluginCreator___packageJson___peerDependencies = 'pluginCreator___packageJson___peerDependencies',
  pluginCreator___packageJson___peerDependencies___name = 'pluginCreator___packageJson___peerDependencies___name',
  pluginCreator___packageJson___peerDependencies___version = 'pluginCreator___packageJson___peerDependencies___version',
  pluginCreator___packageJson___keywords = 'pluginCreator___packageJson___keywords',
  pluginCreatorId = 'pluginCreatorId'
}

export type SitePageFilterInput = {
  path?: Maybe<StringQueryOperatorInput>;
  component?: Maybe<StringQueryOperatorInput>;
  internalComponentName?: Maybe<StringQueryOperatorInput>;
  componentChunkName?: Maybe<StringQueryOperatorInput>;
  matchPath?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  isCreatedByStatefulCreatePages?: Maybe<BooleanQueryOperatorInput>;
  context?: Maybe<SitePageContextFilterInput>;
  pluginCreator?: Maybe<SitePluginFilterInput>;
  pluginCreatorId?: Maybe<StringQueryOperatorInput>;
};

export type SitePageGroupConnection = {
  __typename?: 'SitePageGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePageEdge>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitePageSortInput = {
  fields?: Maybe<Array<Maybe<SitePageFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SitePlugin = Node & {
  __typename?: 'SitePlugin';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  resolve?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  pluginOptions?: Maybe<SitePluginPluginOptions>;
  nodeAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  browserAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  ssrAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  pluginFilepath?: Maybe<Scalars['String']>;
  packageJson?: Maybe<SitePluginPackageJson>;
};

export type SitePluginConnection = {
  __typename?: 'SitePluginConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePluginEdge>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitePluginGroupConnection>;
};


export type SitePluginConnectionDistinctArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionMaxArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionMinArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionSumArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SitePluginFieldsEnum;
};

export type SitePluginEdge = {
  __typename?: 'SitePluginEdge';
  next?: Maybe<SitePlugin>;
  node: SitePlugin;
  previous?: Maybe<SitePlugin>;
};

export enum SitePluginFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  resolve = 'resolve',
  name = 'name',
  version = 'version',
  pluginOptions___postCssPlugins = 'pluginOptions___postCssPlugins',
  pluginOptions___postCssPlugins___postcssPlugin = 'pluginOptions___postCssPlugins___postcssPlugin',
  pluginOptions___domain = 'pluginOptions___domain',
  pluginOptions___pathPrefix = 'pluginOptions___pathPrefix',
  pluginOptions___downloadBinaries = 'pluginOptions___downloadBinaries',
  pluginOptions___ffmpegPath = 'pluginOptions___ffmpegPath',
  pluginOptions___ffprobePath = 'pluginOptions___ffprobePath',
  pluginOptions___name = 'pluginOptions___name',
  pluginOptions___path = 'pluginOptions___path',
  pluginOptions___base64Width = 'pluginOptions___base64Width',
  pluginOptions___stripMetadata = 'pluginOptions___stripMetadata',
  pluginOptions___defaultQuality = 'pluginOptions___defaultQuality',
  pluginOptions___failOnError = 'pluginOptions___failOnError',
  pluginOptions___sitemap = 'pluginOptions___sitemap',
  pluginOptions___policy = 'pluginOptions___policy',
  pluginOptions___policy___userAgent = 'pluginOptions___policy___userAgent',
  pluginOptions___exclude = 'pluginOptions___exclude',
  pluginOptions___sitemapPath = 'pluginOptions___sitemapPath',
  pluginOptions___gatsbyImageSelector = 'pluginOptions___gatsbyImageSelector',
  pluginOptions___createLinkInHead = 'pluginOptions___createLinkInHead',
  pluginOptions___query = 'pluginOptions___query',
  pluginOptions___output = 'pluginOptions___output',
  pluginOptions___enabled = 'pluginOptions___enabled',
  pluginOptions___trackingIds = 'pluginOptions___trackingIds',
  pluginOptions___s3ContentPath = 'pluginOptions___s3ContentPath',
  pluginOptions___pathCheck = 'pluginOptions___pathCheck',
  pluginOptions___allExtensions = 'pluginOptions___allExtensions',
  pluginOptions___isTSX = 'pluginOptions___isTSX',
  pluginOptions___jsxPragma = 'pluginOptions___jsxPragma',
  nodeAPIs = 'nodeAPIs',
  browserAPIs = 'browserAPIs',
  ssrAPIs = 'ssrAPIs',
  pluginFilepath = 'pluginFilepath',
  packageJson___name = 'packageJson___name',
  packageJson___description = 'packageJson___description',
  packageJson___version = 'packageJson___version',
  packageJson___main = 'packageJson___main',
  packageJson___license = 'packageJson___license',
  packageJson___dependencies = 'packageJson___dependencies',
  packageJson___dependencies___name = 'packageJson___dependencies___name',
  packageJson___dependencies___version = 'packageJson___dependencies___version',
  packageJson___devDependencies = 'packageJson___devDependencies',
  packageJson___devDependencies___name = 'packageJson___devDependencies___name',
  packageJson___devDependencies___version = 'packageJson___devDependencies___version',
  packageJson___peerDependencies = 'packageJson___peerDependencies',
  packageJson___peerDependencies___name = 'packageJson___peerDependencies___name',
  packageJson___peerDependencies___version = 'packageJson___peerDependencies___version',
  packageJson___keywords = 'packageJson___keywords'
}

export type SitePluginFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  resolve?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
  pluginOptions?: Maybe<SitePluginPluginOptionsFilterInput>;
  nodeAPIs?: Maybe<StringQueryOperatorInput>;
  browserAPIs?: Maybe<StringQueryOperatorInput>;
  ssrAPIs?: Maybe<StringQueryOperatorInput>;
  pluginFilepath?: Maybe<StringQueryOperatorInput>;
  packageJson?: Maybe<SitePluginPackageJsonFilterInput>;
};

export type SitePluginGroupConnection = {
  __typename?: 'SitePluginGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePluginEdge>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJson = {
  __typename?: 'SitePluginPackageJson';
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['String']>;
  license?: Maybe<Scalars['String']>;
  dependencies?: Maybe<Array<Maybe<SitePluginPackageJsonDependencies>>>;
  devDependencies?: Maybe<Array<Maybe<SitePluginPackageJsonDevDependencies>>>;
  peerDependencies?: Maybe<Array<Maybe<SitePluginPackageJsonPeerDependencies>>>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SitePluginPackageJsonDependencies = {
  __typename?: 'SitePluginPackageJsonDependencies';
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJsonDependenciesFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonDependenciesFilterListInput = {
  elemMatch?: Maybe<SitePluginPackageJsonDependenciesFilterInput>;
};

export type SitePluginPackageJsonDevDependencies = {
  __typename?: 'SitePluginPackageJsonDevDependencies';
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJsonDevDependenciesFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonDevDependenciesFilterListInput = {
  elemMatch?: Maybe<SitePluginPackageJsonDevDependenciesFilterInput>;
};

export type SitePluginPackageJsonFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<StringQueryOperatorInput>;
  license?: Maybe<StringQueryOperatorInput>;
  dependencies?: Maybe<SitePluginPackageJsonDependenciesFilterListInput>;
  devDependencies?: Maybe<SitePluginPackageJsonDevDependenciesFilterListInput>;
  peerDependencies?: Maybe<SitePluginPackageJsonPeerDependenciesFilterListInput>;
  keywords?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonPeerDependencies = {
  __typename?: 'SitePluginPackageJsonPeerDependencies';
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJsonPeerDependenciesFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonPeerDependenciesFilterListInput = {
  elemMatch?: Maybe<SitePluginPackageJsonPeerDependenciesFilterInput>;
};

export type SitePluginPluginOptions = {
  __typename?: 'SitePluginPluginOptions';
  postCssPlugins?: Maybe<Array<Maybe<SitePluginPluginOptionsPostCssPlugins>>>;
  domain?: Maybe<Scalars['String']>;
  pathPrefix?: Maybe<Scalars['String']>;
  downloadBinaries?: Maybe<Scalars['Boolean']>;
  ffmpegPath?: Maybe<Scalars['String']>;
  ffprobePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  base64Width?: Maybe<Scalars['Int']>;
  stripMetadata?: Maybe<Scalars['Boolean']>;
  defaultQuality?: Maybe<Scalars['Int']>;
  failOnError?: Maybe<Scalars['Boolean']>;
  sitemap?: Maybe<Array<Maybe<Scalars['String']>>>;
  policy?: Maybe<Array<Maybe<SitePluginPluginOptionsPolicy>>>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
  sitemapPath?: Maybe<Scalars['String']>;
  gatsbyImageSelector?: Maybe<Scalars['String']>;
  createLinkInHead?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
  output?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  trackingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  s3ContentPath?: Maybe<Scalars['String']>;
  pathCheck?: Maybe<Scalars['Boolean']>;
  allExtensions?: Maybe<Scalars['Boolean']>;
  isTSX?: Maybe<Scalars['Boolean']>;
  jsxPragma?: Maybe<Scalars['String']>;
};

export type SitePluginPluginOptionsFilterInput = {
  postCssPlugins?: Maybe<SitePluginPluginOptionsPostCssPluginsFilterListInput>;
  domain?: Maybe<StringQueryOperatorInput>;
  pathPrefix?: Maybe<StringQueryOperatorInput>;
  downloadBinaries?: Maybe<BooleanQueryOperatorInput>;
  ffmpegPath?: Maybe<StringQueryOperatorInput>;
  ffprobePath?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  base64Width?: Maybe<IntQueryOperatorInput>;
  stripMetadata?: Maybe<BooleanQueryOperatorInput>;
  defaultQuality?: Maybe<IntQueryOperatorInput>;
  failOnError?: Maybe<BooleanQueryOperatorInput>;
  sitemap?: Maybe<StringQueryOperatorInput>;
  policy?: Maybe<SitePluginPluginOptionsPolicyFilterListInput>;
  exclude?: Maybe<StringQueryOperatorInput>;
  sitemapPath?: Maybe<StringQueryOperatorInput>;
  gatsbyImageSelector?: Maybe<StringQueryOperatorInput>;
  createLinkInHead?: Maybe<BooleanQueryOperatorInput>;
  query?: Maybe<StringQueryOperatorInput>;
  output?: Maybe<StringQueryOperatorInput>;
  enabled?: Maybe<BooleanQueryOperatorInput>;
  trackingIds?: Maybe<StringQueryOperatorInput>;
  s3ContentPath?: Maybe<StringQueryOperatorInput>;
  pathCheck?: Maybe<BooleanQueryOperatorInput>;
  allExtensions?: Maybe<BooleanQueryOperatorInput>;
  isTSX?: Maybe<BooleanQueryOperatorInput>;
  jsxPragma?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPluginOptionsPolicy = {
  __typename?: 'SitePluginPluginOptionsPolicy';
  userAgent?: Maybe<Scalars['String']>;
};

export type SitePluginPluginOptionsPolicyFilterInput = {
  userAgent?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPluginOptionsPolicyFilterListInput = {
  elemMatch?: Maybe<SitePluginPluginOptionsPolicyFilterInput>;
};

export type SitePluginPluginOptionsPostCssPlugins = {
  __typename?: 'SitePluginPluginOptionsPostCssPlugins';
  postcssPlugin?: Maybe<Scalars['String']>;
};

export type SitePluginPluginOptionsPostCssPluginsFilterInput = {
  postcssPlugin?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPluginOptionsPostCssPluginsFilterListInput = {
  elemMatch?: Maybe<SitePluginPluginOptionsPostCssPluginsFilterInput>;
};

export type SitePluginSortInput = {
  fields?: Maybe<Array<Maybe<SitePluginFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SiteSiteMetadata = {
  __typename?: 'SiteSiteMetadata';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  siteUrl?: Maybe<Scalars['String']>;
  assetPrefix?: Maybe<Scalars['String']>;
};

export type SiteSiteMetadataFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  siteUrl?: Maybe<StringQueryOperatorInput>;
  assetPrefix?: Maybe<StringQueryOperatorInput>;
};

export type SiteSortInput = {
  fields?: Maybe<Array<Maybe<SiteFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Sitemap = Node & {
  __typename?: 'Sitemap';
  absolutePath: Scalars['String'];
  heading: Scalars['String'];
  path: Scalars['String'];
  title: Scalars['String'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SitemapConnection = {
  __typename?: 'SitemapConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitemapEdge>;
  nodes: Array<Sitemap>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitemapGroupConnection>;
};


export type SitemapConnectionDistinctArgs = {
  field: SitemapFieldsEnum;
};


export type SitemapConnectionMaxArgs = {
  field: SitemapFieldsEnum;
};


export type SitemapConnectionMinArgs = {
  field: SitemapFieldsEnum;
};


export type SitemapConnectionSumArgs = {
  field: SitemapFieldsEnum;
};


export type SitemapConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SitemapFieldsEnum;
};

export type SitemapEdge = {
  __typename?: 'SitemapEdge';
  next?: Maybe<Sitemap>;
  node: Sitemap;
  previous?: Maybe<Sitemap>;
};

export enum SitemapFieldsEnum {
  absolutePath = 'absolutePath',
  heading = 'heading',
  path = 'path',
  title = 'title',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SitemapFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  heading?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SitemapGroupConnection = {
  __typename?: 'SitemapGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitemapEdge>;
  nodes: Array<Sitemap>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitemapSortInput = {
  fields?: Maybe<Array<Maybe<SitemapFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SocialChannel = {
  __typename?: 'SocialChannel';
  image: Media;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type SocialChannelFilterInput = {
  image?: Maybe<MediaFilterInput>;
  name?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
};

export type SocialChannelFilterListInput = {
  elemMatch?: Maybe<SocialChannelFilterInput>;
};

export enum SortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StringQueryOperatorInput = {
  eq?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  regex?: Maybe<Scalars['String']>;
  glob?: Maybe<Scalars['String']>;
};

export type SustainabilityCategory = Node & {
  __typename?: 'SustainabilityCategory';
  id: Scalars['ID'];
  absolutePath: Scalars['String'];
  ctaMicrocopy: Scalars['String'];
  hero: Media;
  heroOverlay: Media;
  messageCards: Array<SustainabilityMessageCard>;
  metaDescription: Scalars['String'];
  metaTitle: Scalars['String'];
  path: Scalars['String'];
  shareImage: Media;
  shortDescription: Scalars['String'];
  summary: Html;
  slug: Scalars['String'];
  title: Scalars['String'];
  traits: Traits;
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SustainabilityCategoryConnection = {
  __typename?: 'SustainabilityCategoryConnection';
  totalCount: Scalars['Int'];
  edges: Array<SustainabilityCategoryEdge>;
  nodes: Array<SustainabilityCategory>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SustainabilityCategoryGroupConnection>;
};


export type SustainabilityCategoryConnectionDistinctArgs = {
  field: SustainabilityCategoryFieldsEnum;
};


export type SustainabilityCategoryConnectionMaxArgs = {
  field: SustainabilityCategoryFieldsEnum;
};


export type SustainabilityCategoryConnectionMinArgs = {
  field: SustainabilityCategoryFieldsEnum;
};


export type SustainabilityCategoryConnectionSumArgs = {
  field: SustainabilityCategoryFieldsEnum;
};


export type SustainabilityCategoryConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SustainabilityCategoryFieldsEnum;
};

export type SustainabilityCategoryEdge = {
  __typename?: 'SustainabilityCategoryEdge';
  next?: Maybe<SustainabilityCategory>;
  node: SustainabilityCategory;
  previous?: Maybe<SustainabilityCategory>;
};

export enum SustainabilityCategoryFieldsEnum {
  id = 'id',
  absolutePath = 'absolutePath',
  ctaMicrocopy = 'ctaMicrocopy',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  heroOverlay___description = 'heroOverlay___description',
  heroOverlay___file___fileLocal___sourceInstanceName = 'heroOverlay___file___fileLocal___sourceInstanceName',
  heroOverlay___file___fileLocal___absolutePath = 'heroOverlay___file___fileLocal___absolutePath',
  heroOverlay___file___fileLocal___relativePath = 'heroOverlay___file___fileLocal___relativePath',
  heroOverlay___file___fileLocal___extension = 'heroOverlay___file___fileLocal___extension',
  heroOverlay___file___fileLocal___size = 'heroOverlay___file___fileLocal___size',
  heroOverlay___file___fileLocal___prettySize = 'heroOverlay___file___fileLocal___prettySize',
  heroOverlay___file___fileLocal___modifiedTime = 'heroOverlay___file___fileLocal___modifiedTime',
  heroOverlay___file___fileLocal___accessTime = 'heroOverlay___file___fileLocal___accessTime',
  heroOverlay___file___fileLocal___changeTime = 'heroOverlay___file___fileLocal___changeTime',
  heroOverlay___file___fileLocal___birthTime = 'heroOverlay___file___fileLocal___birthTime',
  heroOverlay___file___fileLocal___root = 'heroOverlay___file___fileLocal___root',
  heroOverlay___file___fileLocal___dir = 'heroOverlay___file___fileLocal___dir',
  heroOverlay___file___fileLocal___base = 'heroOverlay___file___fileLocal___base',
  heroOverlay___file___fileLocal___ext = 'heroOverlay___file___fileLocal___ext',
  heroOverlay___file___fileLocal___name = 'heroOverlay___file___fileLocal___name',
  heroOverlay___file___fileLocal___relativeDirectory = 'heroOverlay___file___fileLocal___relativeDirectory',
  heroOverlay___file___fileLocal___dev = 'heroOverlay___file___fileLocal___dev',
  heroOverlay___file___fileLocal___mode = 'heroOverlay___file___fileLocal___mode',
  heroOverlay___file___fileLocal___nlink = 'heroOverlay___file___fileLocal___nlink',
  heroOverlay___file___fileLocal___uid = 'heroOverlay___file___fileLocal___uid',
  heroOverlay___file___fileLocal___gid = 'heroOverlay___file___fileLocal___gid',
  heroOverlay___file___fileLocal___rdev = 'heroOverlay___file___fileLocal___rdev',
  heroOverlay___file___fileLocal___ino = 'heroOverlay___file___fileLocal___ino',
  heroOverlay___file___fileLocal___atimeMs = 'heroOverlay___file___fileLocal___atimeMs',
  heroOverlay___file___fileLocal___mtimeMs = 'heroOverlay___file___fileLocal___mtimeMs',
  heroOverlay___file___fileLocal___ctimeMs = 'heroOverlay___file___fileLocal___ctimeMs',
  heroOverlay___file___fileLocal___atime = 'heroOverlay___file___fileLocal___atime',
  heroOverlay___file___fileLocal___mtime = 'heroOverlay___file___fileLocal___mtime',
  heroOverlay___file___fileLocal___ctime = 'heroOverlay___file___fileLocal___ctime',
  heroOverlay___file___fileLocal___birthtime = 'heroOverlay___file___fileLocal___birthtime',
  heroOverlay___file___fileLocal___birthtimeMs = 'heroOverlay___file___fileLocal___birthtimeMs',
  heroOverlay___file___fileLocal___blksize = 'heroOverlay___file___fileLocal___blksize',
  heroOverlay___file___fileLocal___blocks = 'heroOverlay___file___fileLocal___blocks',
  heroOverlay___file___fileLocal___url = 'heroOverlay___file___fileLocal___url',
  heroOverlay___file___fileLocal___publicURL = 'heroOverlay___file___fileLocal___publicURL',
  heroOverlay___file___fileLocal___childrenImageSharp = 'heroOverlay___file___fileLocal___childrenImageSharp',
  heroOverlay___file___fileLocal___id = 'heroOverlay___file___fileLocal___id',
  heroOverlay___file___fileLocal___children = 'heroOverlay___file___fileLocal___children',
  heroOverlay___file___url = 'heroOverlay___file___url',
  heroOverlay___title = 'heroOverlay___title',
  messageCards = 'messageCards',
  messageCards___id = 'messageCards___id',
  messageCards___ctaMicrocopy = 'messageCards___ctaMicrocopy',
  messageCards___ctaTagLine = 'messageCards___ctaTagLine',
  messageCards___message___absolutePath = 'messageCards___message___absolutePath',
  messageCards___message___benefitImages = 'messageCards___message___benefitImages',
  messageCards___message___benefitImages___description = 'messageCards___message___benefitImages___description',
  messageCards___message___benefits = 'messageCards___message___benefits',
  messageCards___message___benefitsDisclaimer = 'messageCards___message___benefitsDisclaimer',
  messageCards___message___certificate = 'messageCards___message___certificate',
  messageCards___message___certificate___title = 'messageCards___message___certificate___title',
  messageCards___message___certificate___url = 'messageCards___message___certificate___url',
  messageCards___message___facts = 'messageCards___message___facts',
  messageCards___message___facts___summary = 'messageCards___message___facts___summary',
  messageCards___message___facts___title = 'messageCards___message___facts___title',
  messageCards___message___hero___description = 'messageCards___message___hero___description',
  messageCards___message___hero___title = 'messageCards___message___hero___title',
  messageCards___message___heroVideo___description = 'messageCards___message___heroVideo___description',
  messageCards___message___heroVideo___title = 'messageCards___message___heroVideo___title',
  messageCards___message___main___htmlTruncated = 'messageCards___message___main___htmlTruncated',
  messageCards___message___main___html = 'messageCards___message___main___html',
  messageCards___message___main___rawContent = 'messageCards___message___main___rawContent',
  messageCards___message___main___text = 'messageCards___message___main___text',
  messageCards___message___metaDescription = 'messageCards___message___metaDescription',
  messageCards___message___pageTitle = 'messageCards___message___pageTitle',
  messageCards___message___pageType = 'messageCards___message___pageType',
  messageCards___message___parentTopic___absolutePath = 'messageCards___message___parentTopic___absolutePath',
  messageCards___message___parentTopic___messagesNodes = 'messageCards___message___parentTopic___messagesNodes',
  messageCards___message___parentTopic___metaDescription = 'messageCards___message___parentTopic___metaDescription',
  messageCards___message___parentTopic___navigationTitle = 'messageCards___message___parentTopic___navigationTitle',
  messageCards___message___parentTopic___topicDisclaimer = 'messageCards___message___parentTopic___topicDisclaimer',
  messageCards___message___parentTopic___pageTitle = 'messageCards___message___parentTopic___pageTitle',
  messageCards___message___parentTopic___pageType = 'messageCards___message___parentTopic___pageType',
  messageCards___message___parentTopic___path = 'messageCards___message___parentTopic___path',
  messageCards___message___parentTopic___slug = 'messageCards___message___parentTopic___slug',
  messageCards___message___parentTopic___summary = 'messageCards___message___parentTopic___summary',
  messageCards___message___parentTopic___title = 'messageCards___message___parentTopic___title',
  messageCards___message___parentTopic___id = 'messageCards___message___parentTopic___id',
  messageCards___message___parentTopic___children = 'messageCards___message___parentTopic___children',
  messageCards___message___path = 'messageCards___message___path',
  messageCards___message___product = 'messageCards___message___product',
  messageCards___message___productsNodes = 'messageCards___message___productsNodes',
  messageCards___message___productsNodes___absolutePath = 'messageCards___message___productsNodes___absolutePath',
  messageCards___message___productsNodes___benefits = 'messageCards___message___productsNodes___benefits',
  messageCards___message___productsNodes___benefitsDisclaimer = 'messageCards___message___productsNodes___benefitsDisclaimer',
  messageCards___message___productsNodes___metaDescription = 'messageCards___message___productsNodes___metaDescription',
  messageCards___message___productsNodes___name = 'messageCards___message___productsNodes___name',
  messageCards___message___productsNodes___pageTitle = 'messageCards___message___productsNodes___pageTitle',
  messageCards___message___productsNodes___pageType = 'messageCards___message___productsNodes___pageType',
  messageCards___message___productsNodes___path = 'messageCards___message___productsNodes___path',
  messageCards___message___productsNodes___slug = 'messageCards___message___productsNodes___slug',
  messageCards___message___productsNodes___variants = 'messageCards___message___productsNodes___variants',
  messageCards___message___productsNodes___id = 'messageCards___message___productsNodes___id',
  messageCards___message___productsNodes___children = 'messageCards___message___productsNodes___children',
  messageCards___message___slug = 'messageCards___message___slug',
  messageCards___message___summary = 'messageCards___message___summary',
  messageCards___message___summaryBackground___description = 'messageCards___message___summaryBackground___description',
  messageCards___message___summaryBackground___title = 'messageCards___message___summaryBackground___title',
  messageCards___message___teaserImage___description = 'messageCards___message___teaserImage___description',
  messageCards___message___teaserImage___title = 'messageCards___message___teaserImage___title',
  messageCards___message___territoryWidget___bottomHeading = 'messageCards___message___territoryWidget___bottomHeading',
  messageCards___message___territoryWidget___graphicHeading = 'messageCards___message___territoryWidget___graphicHeading',
  messageCards___message___territoryWidget___topCopy = 'messageCards___message___territoryWidget___topCopy',
  messageCards___message___territoryWidget___topHeading = 'messageCards___message___territoryWidget___topHeading',
  messageCards___message___title = 'messageCards___message___title',
  messageCards___message___traits___traitsStringified = 'messageCards___message___traits___traitsStringified',
  messageCards___message___video___description = 'messageCards___message___video___description',
  messageCards___message___video___title = 'messageCards___message___video___title',
  messageCards___message___id = 'messageCards___message___id',
  messageCards___message___parent___id = 'messageCards___message___parent___id',
  messageCards___message___parent___children = 'messageCards___message___parent___children',
  messageCards___message___children = 'messageCards___message___children',
  messageCards___message___children___id = 'messageCards___message___children___id',
  messageCards___message___children___children = 'messageCards___message___children___children',
  messageCards___message___internal___content = 'messageCards___message___internal___content',
  messageCards___message___internal___contentDigest = 'messageCards___message___internal___contentDigest',
  messageCards___message___internal___description = 'messageCards___message___internal___description',
  messageCards___message___internal___fieldOwners = 'messageCards___message___internal___fieldOwners',
  messageCards___message___internal___ignoreType = 'messageCards___message___internal___ignoreType',
  messageCards___message___internal___mediaType = 'messageCards___message___internal___mediaType',
  messageCards___message___internal___owner = 'messageCards___message___internal___owner',
  messageCards___message___internal___type = 'messageCards___message___internal___type',
  messageCards___teaserImage___description = 'messageCards___teaserImage___description',
  messageCards___teaserImage___file___url = 'messageCards___teaserImage___file___url',
  messageCards___teaserImage___title = 'messageCards___teaserImage___title',
  messageCards___teaserVideo___description = 'messageCards___teaserVideo___description',
  messageCards___teaserVideo___file___url = 'messageCards___teaserVideo___file___url',
  messageCards___teaserVideo___title = 'messageCards___teaserVideo___title',
  metaDescription = 'metaDescription',
  metaTitle = 'metaTitle',
  path = 'path',
  shareImage___description = 'shareImage___description',
  shareImage___file___fileLocal___sourceInstanceName = 'shareImage___file___fileLocal___sourceInstanceName',
  shareImage___file___fileLocal___absolutePath = 'shareImage___file___fileLocal___absolutePath',
  shareImage___file___fileLocal___relativePath = 'shareImage___file___fileLocal___relativePath',
  shareImage___file___fileLocal___extension = 'shareImage___file___fileLocal___extension',
  shareImage___file___fileLocal___size = 'shareImage___file___fileLocal___size',
  shareImage___file___fileLocal___prettySize = 'shareImage___file___fileLocal___prettySize',
  shareImage___file___fileLocal___modifiedTime = 'shareImage___file___fileLocal___modifiedTime',
  shareImage___file___fileLocal___accessTime = 'shareImage___file___fileLocal___accessTime',
  shareImage___file___fileLocal___changeTime = 'shareImage___file___fileLocal___changeTime',
  shareImage___file___fileLocal___birthTime = 'shareImage___file___fileLocal___birthTime',
  shareImage___file___fileLocal___root = 'shareImage___file___fileLocal___root',
  shareImage___file___fileLocal___dir = 'shareImage___file___fileLocal___dir',
  shareImage___file___fileLocal___base = 'shareImage___file___fileLocal___base',
  shareImage___file___fileLocal___ext = 'shareImage___file___fileLocal___ext',
  shareImage___file___fileLocal___name = 'shareImage___file___fileLocal___name',
  shareImage___file___fileLocal___relativeDirectory = 'shareImage___file___fileLocal___relativeDirectory',
  shareImage___file___fileLocal___dev = 'shareImage___file___fileLocal___dev',
  shareImage___file___fileLocal___mode = 'shareImage___file___fileLocal___mode',
  shareImage___file___fileLocal___nlink = 'shareImage___file___fileLocal___nlink',
  shareImage___file___fileLocal___uid = 'shareImage___file___fileLocal___uid',
  shareImage___file___fileLocal___gid = 'shareImage___file___fileLocal___gid',
  shareImage___file___fileLocal___rdev = 'shareImage___file___fileLocal___rdev',
  shareImage___file___fileLocal___ino = 'shareImage___file___fileLocal___ino',
  shareImage___file___fileLocal___atimeMs = 'shareImage___file___fileLocal___atimeMs',
  shareImage___file___fileLocal___mtimeMs = 'shareImage___file___fileLocal___mtimeMs',
  shareImage___file___fileLocal___ctimeMs = 'shareImage___file___fileLocal___ctimeMs',
  shareImage___file___fileLocal___atime = 'shareImage___file___fileLocal___atime',
  shareImage___file___fileLocal___mtime = 'shareImage___file___fileLocal___mtime',
  shareImage___file___fileLocal___ctime = 'shareImage___file___fileLocal___ctime',
  shareImage___file___fileLocal___birthtime = 'shareImage___file___fileLocal___birthtime',
  shareImage___file___fileLocal___birthtimeMs = 'shareImage___file___fileLocal___birthtimeMs',
  shareImage___file___fileLocal___blksize = 'shareImage___file___fileLocal___blksize',
  shareImage___file___fileLocal___blocks = 'shareImage___file___fileLocal___blocks',
  shareImage___file___fileLocal___url = 'shareImage___file___fileLocal___url',
  shareImage___file___fileLocal___publicURL = 'shareImage___file___fileLocal___publicURL',
  shareImage___file___fileLocal___childrenImageSharp = 'shareImage___file___fileLocal___childrenImageSharp',
  shareImage___file___fileLocal___id = 'shareImage___file___fileLocal___id',
  shareImage___file___fileLocal___children = 'shareImage___file___fileLocal___children',
  shareImage___file___url = 'shareImage___file___url',
  shareImage___title = 'shareImage___title',
  shortDescription = 'shortDescription',
  summary___html = 'summary___html',
  summary___json = 'summary___json',
  summary___text = 'summary___text',
  slug = 'slug',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SustainabilityCategoryFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  ctaMicrocopy?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  heroOverlay?: Maybe<MediaFilterInput>;
  messageCards?: Maybe<SustainabilityMessageCardFilterListInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  metaTitle?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  shareImage?: Maybe<MediaFilterInput>;
  shortDescription?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<HtmlFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SustainabilityCategoryGroupConnection = {
  __typename?: 'SustainabilityCategoryGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SustainabilityCategoryEdge>;
  nodes: Array<SustainabilityCategory>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SustainabilityCategorySortInput = {
  fields?: Maybe<Array<Maybe<SustainabilityCategoryFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SustainabilityLandingPage = Node & {
  __typename?: 'SustainabilityLandingPage';
  id: Scalars['ID'];
  absolutePath: Scalars['String'];
  heroVideo?: Maybe<Media>;
  metaDescription: Scalars['String'];
  metaTitle: Scalars['String'];
  path: Scalars['String'];
  shareImage: Media;
  summary: Html;
  slug: Scalars['String'];
  title: Scalars['String'];
  traits: Traits;
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SustainabilityLandingPageConnection = {
  __typename?: 'SustainabilityLandingPageConnection';
  totalCount: Scalars['Int'];
  edges: Array<SustainabilityLandingPageEdge>;
  nodes: Array<SustainabilityLandingPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SustainabilityLandingPageGroupConnection>;
};


export type SustainabilityLandingPageConnectionDistinctArgs = {
  field: SustainabilityLandingPageFieldsEnum;
};


export type SustainabilityLandingPageConnectionMaxArgs = {
  field: SustainabilityLandingPageFieldsEnum;
};


export type SustainabilityLandingPageConnectionMinArgs = {
  field: SustainabilityLandingPageFieldsEnum;
};


export type SustainabilityLandingPageConnectionSumArgs = {
  field: SustainabilityLandingPageFieldsEnum;
};


export type SustainabilityLandingPageConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SustainabilityLandingPageFieldsEnum;
};

export type SustainabilityLandingPageEdge = {
  __typename?: 'SustainabilityLandingPageEdge';
  next?: Maybe<SustainabilityLandingPage>;
  node: SustainabilityLandingPage;
  previous?: Maybe<SustainabilityLandingPage>;
};

export enum SustainabilityLandingPageFieldsEnum {
  id = 'id',
  absolutePath = 'absolutePath',
  heroVideo___description = 'heroVideo___description',
  heroVideo___file___fileLocal___sourceInstanceName = 'heroVideo___file___fileLocal___sourceInstanceName',
  heroVideo___file___fileLocal___absolutePath = 'heroVideo___file___fileLocal___absolutePath',
  heroVideo___file___fileLocal___relativePath = 'heroVideo___file___fileLocal___relativePath',
  heroVideo___file___fileLocal___extension = 'heroVideo___file___fileLocal___extension',
  heroVideo___file___fileLocal___size = 'heroVideo___file___fileLocal___size',
  heroVideo___file___fileLocal___prettySize = 'heroVideo___file___fileLocal___prettySize',
  heroVideo___file___fileLocal___modifiedTime = 'heroVideo___file___fileLocal___modifiedTime',
  heroVideo___file___fileLocal___accessTime = 'heroVideo___file___fileLocal___accessTime',
  heroVideo___file___fileLocal___changeTime = 'heroVideo___file___fileLocal___changeTime',
  heroVideo___file___fileLocal___birthTime = 'heroVideo___file___fileLocal___birthTime',
  heroVideo___file___fileLocal___root = 'heroVideo___file___fileLocal___root',
  heroVideo___file___fileLocal___dir = 'heroVideo___file___fileLocal___dir',
  heroVideo___file___fileLocal___base = 'heroVideo___file___fileLocal___base',
  heroVideo___file___fileLocal___ext = 'heroVideo___file___fileLocal___ext',
  heroVideo___file___fileLocal___name = 'heroVideo___file___fileLocal___name',
  heroVideo___file___fileLocal___relativeDirectory = 'heroVideo___file___fileLocal___relativeDirectory',
  heroVideo___file___fileLocal___dev = 'heroVideo___file___fileLocal___dev',
  heroVideo___file___fileLocal___mode = 'heroVideo___file___fileLocal___mode',
  heroVideo___file___fileLocal___nlink = 'heroVideo___file___fileLocal___nlink',
  heroVideo___file___fileLocal___uid = 'heroVideo___file___fileLocal___uid',
  heroVideo___file___fileLocal___gid = 'heroVideo___file___fileLocal___gid',
  heroVideo___file___fileLocal___rdev = 'heroVideo___file___fileLocal___rdev',
  heroVideo___file___fileLocal___ino = 'heroVideo___file___fileLocal___ino',
  heroVideo___file___fileLocal___atimeMs = 'heroVideo___file___fileLocal___atimeMs',
  heroVideo___file___fileLocal___mtimeMs = 'heroVideo___file___fileLocal___mtimeMs',
  heroVideo___file___fileLocal___ctimeMs = 'heroVideo___file___fileLocal___ctimeMs',
  heroVideo___file___fileLocal___atime = 'heroVideo___file___fileLocal___atime',
  heroVideo___file___fileLocal___mtime = 'heroVideo___file___fileLocal___mtime',
  heroVideo___file___fileLocal___ctime = 'heroVideo___file___fileLocal___ctime',
  heroVideo___file___fileLocal___birthtime = 'heroVideo___file___fileLocal___birthtime',
  heroVideo___file___fileLocal___birthtimeMs = 'heroVideo___file___fileLocal___birthtimeMs',
  heroVideo___file___fileLocal___blksize = 'heroVideo___file___fileLocal___blksize',
  heroVideo___file___fileLocal___blocks = 'heroVideo___file___fileLocal___blocks',
  heroVideo___file___fileLocal___url = 'heroVideo___file___fileLocal___url',
  heroVideo___file___fileLocal___publicURL = 'heroVideo___file___fileLocal___publicURL',
  heroVideo___file___fileLocal___childrenImageSharp = 'heroVideo___file___fileLocal___childrenImageSharp',
  heroVideo___file___fileLocal___id = 'heroVideo___file___fileLocal___id',
  heroVideo___file___fileLocal___children = 'heroVideo___file___fileLocal___children',
  heroVideo___file___url = 'heroVideo___file___url',
  heroVideo___title = 'heroVideo___title',
  metaDescription = 'metaDescription',
  metaTitle = 'metaTitle',
  path = 'path',
  shareImage___description = 'shareImage___description',
  shareImage___file___fileLocal___sourceInstanceName = 'shareImage___file___fileLocal___sourceInstanceName',
  shareImage___file___fileLocal___absolutePath = 'shareImage___file___fileLocal___absolutePath',
  shareImage___file___fileLocal___relativePath = 'shareImage___file___fileLocal___relativePath',
  shareImage___file___fileLocal___extension = 'shareImage___file___fileLocal___extension',
  shareImage___file___fileLocal___size = 'shareImage___file___fileLocal___size',
  shareImage___file___fileLocal___prettySize = 'shareImage___file___fileLocal___prettySize',
  shareImage___file___fileLocal___modifiedTime = 'shareImage___file___fileLocal___modifiedTime',
  shareImage___file___fileLocal___accessTime = 'shareImage___file___fileLocal___accessTime',
  shareImage___file___fileLocal___changeTime = 'shareImage___file___fileLocal___changeTime',
  shareImage___file___fileLocal___birthTime = 'shareImage___file___fileLocal___birthTime',
  shareImage___file___fileLocal___root = 'shareImage___file___fileLocal___root',
  shareImage___file___fileLocal___dir = 'shareImage___file___fileLocal___dir',
  shareImage___file___fileLocal___base = 'shareImage___file___fileLocal___base',
  shareImage___file___fileLocal___ext = 'shareImage___file___fileLocal___ext',
  shareImage___file___fileLocal___name = 'shareImage___file___fileLocal___name',
  shareImage___file___fileLocal___relativeDirectory = 'shareImage___file___fileLocal___relativeDirectory',
  shareImage___file___fileLocal___dev = 'shareImage___file___fileLocal___dev',
  shareImage___file___fileLocal___mode = 'shareImage___file___fileLocal___mode',
  shareImage___file___fileLocal___nlink = 'shareImage___file___fileLocal___nlink',
  shareImage___file___fileLocal___uid = 'shareImage___file___fileLocal___uid',
  shareImage___file___fileLocal___gid = 'shareImage___file___fileLocal___gid',
  shareImage___file___fileLocal___rdev = 'shareImage___file___fileLocal___rdev',
  shareImage___file___fileLocal___ino = 'shareImage___file___fileLocal___ino',
  shareImage___file___fileLocal___atimeMs = 'shareImage___file___fileLocal___atimeMs',
  shareImage___file___fileLocal___mtimeMs = 'shareImage___file___fileLocal___mtimeMs',
  shareImage___file___fileLocal___ctimeMs = 'shareImage___file___fileLocal___ctimeMs',
  shareImage___file___fileLocal___atime = 'shareImage___file___fileLocal___atime',
  shareImage___file___fileLocal___mtime = 'shareImage___file___fileLocal___mtime',
  shareImage___file___fileLocal___ctime = 'shareImage___file___fileLocal___ctime',
  shareImage___file___fileLocal___birthtime = 'shareImage___file___fileLocal___birthtime',
  shareImage___file___fileLocal___birthtimeMs = 'shareImage___file___fileLocal___birthtimeMs',
  shareImage___file___fileLocal___blksize = 'shareImage___file___fileLocal___blksize',
  shareImage___file___fileLocal___blocks = 'shareImage___file___fileLocal___blocks',
  shareImage___file___fileLocal___url = 'shareImage___file___fileLocal___url',
  shareImage___file___fileLocal___publicURL = 'shareImage___file___fileLocal___publicURL',
  shareImage___file___fileLocal___childrenImageSharp = 'shareImage___file___fileLocal___childrenImageSharp',
  shareImage___file___fileLocal___id = 'shareImage___file___fileLocal___id',
  shareImage___file___fileLocal___children = 'shareImage___file___fileLocal___children',
  shareImage___file___url = 'shareImage___file___url',
  shareImage___title = 'shareImage___title',
  summary___html = 'summary___html',
  summary___json = 'summary___json',
  summary___text = 'summary___text',
  slug = 'slug',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SustainabilityLandingPageFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  heroVideo?: Maybe<MediaFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  metaTitle?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  shareImage?: Maybe<MediaFilterInput>;
  summary?: Maybe<HtmlFilterInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SustainabilityLandingPageGroupConnection = {
  __typename?: 'SustainabilityLandingPageGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SustainabilityLandingPageEdge>;
  nodes: Array<SustainabilityLandingPage>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SustainabilityLandingPageSortInput = {
  fields?: Maybe<Array<Maybe<SustainabilityLandingPageFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SustainabilityMessageCard = {
  __typename?: 'SustainabilityMessageCard';
  id: Scalars['ID'];
  ctaMicrocopy: Scalars['String'];
  ctaTagLine: Scalars['String'];
  message: Message;
  teaserImage?: Maybe<Media>;
  teaserVideo?: Maybe<Media>;
};

export type SustainabilityMessageCardFilterInput = {
  id?: Maybe<IdQueryOperatorInput>;
  ctaMicrocopy?: Maybe<StringQueryOperatorInput>;
  ctaTagLine?: Maybe<StringQueryOperatorInput>;
  message?: Maybe<MessageFilterInput>;
  teaserImage?: Maybe<MediaFilterInput>;
  teaserVideo?: Maybe<MediaFilterInput>;
};

export type SustainabilityMessageCardFilterListInput = {
  elemMatch?: Maybe<SustainabilityMessageCardFilterInput>;
};

export type SustainabilityWidget = {
  __typename?: 'SustainabilityWidget';
  strapline: Scalars['String'];
  headingImage: Media;
};

export type SustainabilityWidgetFilterInput = {
  strapline?: Maybe<StringQueryOperatorInput>;
  headingImage?: Maybe<MediaFilterInput>;
};

export type Territory = {
  __typename?: 'Territory';
  bottomGraphic?: Maybe<Media>;
  bottomHeading?: Maybe<Scalars['String']>;
  graphicHeading?: Maybe<Scalars['String']>;
  topCopy: Scalars['String'];
  topHeading: Scalars['String'];
  topHeroImage?: Maybe<Media>;
  topLeftHeadingImage?: Maybe<Media>;
};

export type TerritoryFilterInput = {
  bottomGraphic?: Maybe<MediaFilterInput>;
  bottomHeading?: Maybe<StringQueryOperatorInput>;
  graphicHeading?: Maybe<StringQueryOperatorInput>;
  topCopy?: Maybe<StringQueryOperatorInput>;
  topHeading?: Maybe<StringQueryOperatorInput>;
  topHeroImage?: Maybe<MediaFilterInput>;
  topLeftHeadingImage?: Maybe<MediaFilterInput>;
};

export type Traits = {
  __typename?: 'Traits';
  traitsStringified: Scalars['String'];
};

export type TraitsFilterInput = {
  traitsStringified?: Maybe<StringQueryOperatorInput>;
};

export type TransformOptions = {
  grayscale?: Maybe<Scalars['Boolean']>;
  duotone?: Maybe<DuotoneGradient>;
  rotate?: Maybe<Scalars['Int']>;
  trim?: Maybe<Scalars['Float']>;
  cropFocus?: Maybe<ImageCropFocus>;
  fit?: Maybe<ImageFit>;
};

export type Variant = {
  __typename?: 'Variant';
  buyItNowUrl?: Maybe<Scalars['String']>;
  ingredientsBlurb?: Maybe<Html>;
  name: Scalars['String'];
  packshot: Media;
  product: Scalars['String'];
  sizes: Array<Scalars['String']>;
};

export type VariantFilterInput = {
  buyItNowUrl?: Maybe<StringQueryOperatorInput>;
  ingredientsBlurb?: Maybe<HtmlFilterInput>;
  name?: Maybe<StringQueryOperatorInput>;
  packshot?: Maybe<MediaFilterInput>;
  product?: Maybe<StringQueryOperatorInput>;
  sizes?: Maybe<StringQueryOperatorInput>;
};

export type VariantFilterListInput = {
  elemMatch?: Maybe<VariantFilterInput>;
};

export type WebPOptions = {
  quality?: Maybe<Scalars['Int']>;
};

export type XmlContentMedia = {
  __typename?: 'XMLContentMedia';
  description?: Maybe<Scalars['String']>;
  file?: Maybe<_File>;
  title?: Maybe<Scalars['String']>;
};

export type XmlContentMediaFilterInput = {
  description?: Maybe<StringQueryOperatorInput>;
  file?: Maybe<_FileFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
};

export type _File = {
  __typename?: '_File';
  fileLocal?: Maybe<File>;
  url?: Maybe<Scalars['String']>;
};

export type _FileFilterInput = {
  fileLocal?: Maybe<FileFilterInput>;
  url?: Maybe<StringQueryOperatorInput>;
};

export type Faq = Node & {
  __typename?: 'faq';
  absolutePath: Scalars['String'];
  metaDescription: Scalars['String'];
  path: Scalars['String'];
  questionsAndAnswers: Array<FaqPair>;
  title: Scalars['String'];
  traits?: Maybe<Traits>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type FaqConnection = {
  __typename?: 'faqConnection';
  totalCount: Scalars['Int'];
  edges: Array<FaqEdge>;
  nodes: Array<Faq>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<FaqGroupConnection>;
};


export type FaqConnectionDistinctArgs = {
  field: FaqFieldsEnum;
};


export type FaqConnectionMaxArgs = {
  field: FaqFieldsEnum;
};


export type FaqConnectionMinArgs = {
  field: FaqFieldsEnum;
};


export type FaqConnectionSumArgs = {
  field: FaqFieldsEnum;
};


export type FaqConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: FaqFieldsEnum;
};

export type FaqEdge = {
  __typename?: 'faqEdge';
  next?: Maybe<Faq>;
  node: Faq;
  previous?: Maybe<Faq>;
};

export enum FaqFieldsEnum {
  absolutePath = 'absolutePath',
  metaDescription = 'metaDescription',
  path = 'path',
  questionsAndAnswers = 'questionsAndAnswers',
  questionsAndAnswers___answer___html = 'questionsAndAnswers___answer___html',
  questionsAndAnswers___answer___json = 'questionsAndAnswers___answer___json',
  questionsAndAnswers___answer___text = 'questionsAndAnswers___answer___text',
  questionsAndAnswers___question = 'questionsAndAnswers___question',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type FaqFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  questionsAndAnswers?: Maybe<FaqPairFilterListInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type FaqGroupConnection = {
  __typename?: 'faqGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<FaqEdge>;
  nodes: Array<Faq>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type FaqPair = {
  __typename?: 'faqPair';
  answer: Html;
  question: Scalars['String'];
};

export type FaqPairFilterInput = {
  answer?: Maybe<HtmlFilterInput>;
  question?: Maybe<StringQueryOperatorInput>;
};

export type FaqPairFilterListInput = {
  elemMatch?: Maybe<FaqPairFilterInput>;
};

export type FaqSortInput = {
  fields?: Maybe<Array<Maybe<FaqFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Home = Node & {
  __typename?: 'home';
  absolutePath: Scalars['String'];
  additionalExternalLinks: Array<Hyperlink>;
  brand: Brand;
  certificate?: Maybe<Array<Maybe<Certificate>>>;
  contactUs?: Maybe<ContactUs>;
  contactUsMessage?: Maybe<Message>;
  coreMessage?: Maybe<Message>;
  currentYear: Scalars['String'];
  disclaimerMessage?: Maybe<Message>;
  domain: Domain;
  externalLinks: Array<Hyperlink>;
  faq?: Maybe<Faq>;
  legals?: Maybe<Legals>;
  lexicon: Lexicon;
  messagesNodes?: Maybe<Array<Maybe<Message>>>;
  pageType: Scalars['String'];
  path: Scalars['String'];
  product: Scalars['String'];
  productsNodes?: Maybe<Array<Maybe<Product>>>;
  secondaryMessage?: Maybe<Message>;
  signUp?: Maybe<SignUp>;
  socialChannels?: Maybe<Array<Maybe<SocialChannel>>>;
  termsMessage?: Maybe<Message>;
  navLinks: Array<NavLink>;
  traits?: Maybe<Traits>;
  sustainabilityWidgetWebsite?: Maybe<SustainabilityWidget>;
  homeVideo?: Maybe<HomeVideo>;
  footerLinks: Array<FooterLink>;
  homepageTitle: Scalars['String'];
  homepageVideoHero?: Maybe<Media>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type HomeConnection = {
  __typename?: 'homeConnection';
  totalCount: Scalars['Int'];
  edges: Array<HomeEdge>;
  nodes: Array<Home>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<HomeGroupConnection>;
};


export type HomeConnectionDistinctArgs = {
  field: HomeFieldsEnum;
};


export type HomeConnectionMaxArgs = {
  field: HomeFieldsEnum;
};


export type HomeConnectionMinArgs = {
  field: HomeFieldsEnum;
};


export type HomeConnectionSumArgs = {
  field: HomeFieldsEnum;
};


export type HomeConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: HomeFieldsEnum;
};

export type HomeEdge = {
  __typename?: 'homeEdge';
  next?: Maybe<Home>;
  node: Home;
  previous?: Maybe<Home>;
};

export enum HomeFieldsEnum {
  absolutePath = 'absolutePath',
  additionalExternalLinks = 'additionalExternalLinks',
  additionalExternalLinks___id = 'additionalExternalLinks___id',
  additionalExternalLinks___title = 'additionalExternalLinks___title',
  additionalExternalLinks___url = 'additionalExternalLinks___url',
  brand___description = 'brand___description',
  brand___disclaimer = 'brand___disclaimer',
  brand___favicon___description = 'brand___favicon___description',
  brand___favicon___file___url = 'brand___favicon___file___url',
  brand___favicon___title = 'brand___favicon___title',
  brand___lang = 'brand___lang',
  brand___logo___description = 'brand___logo___description',
  brand___logo___file___url = 'brand___logo___file___url',
  brand___logo___title = 'brand___logo___title',
  brand___market = 'brand___market',
  brand___name = 'brand___name',
  brand___product = 'brand___product',
  certificate = 'certificate',
  certificate___image___description = 'certificate___image___description',
  certificate___image___file___url = 'certificate___image___file___url',
  certificate___image___title = 'certificate___image___title',
  certificate___title = 'certificate___title',
  certificate___url = 'certificate___url',
  contactUs___absolutePath = 'contactUs___absolutePath',
  contactUs___contactFormWidgetClassName = 'contactUs___contactFormWidgetClassName',
  contactUs___contactFormWidgetUrl = 'contactUs___contactFormWidgetUrl',
  contactUs___legalsTextAdditional___html = 'contactUs___legalsTextAdditional___html',
  contactUs___legalsTextAdditional___json = 'contactUs___legalsTextAdditional___json',
  contactUs___legalsTextAdditional___text = 'contactUs___legalsTextAdditional___text',
  contactUs___liveChatText = 'contactUs___liveChatText',
  contactUs___liveChatID = 'contactUs___liveChatID',
  contactUs___liveChatDeploymentID = 'contactUs___liveChatDeploymentID',
  contactUs___main___htmlTruncated = 'contactUs___main___htmlTruncated',
  contactUs___main___html = 'contactUs___main___html',
  contactUs___main___rawContent = 'contactUs___main___rawContent',
  contactUs___main___text = 'contactUs___main___text',
  contactUs___pageTitle = 'contactUs___pageTitle',
  contactUs___pageType = 'contactUs___pageType',
  contactUs___path = 'contactUs___path',
  contactUs___phoneNumber___html = 'contactUs___phoneNumber___html',
  contactUs___phoneNumber___json = 'contactUs___phoneNumber___json',
  contactUs___phoneNumber___text = 'contactUs___phoneNumber___text',
  contactUs___postalAddress___html = 'contactUs___postalAddress___html',
  contactUs___postalAddress___json = 'contactUs___postalAddress___json',
  contactUs___postalAddress___text = 'contactUs___postalAddress___text',
  contactUs___slug = 'contactUs___slug',
  contactUs___summary = 'contactUs___summary',
  contactUs___title = 'contactUs___title',
  contactUs___titlePhoneNumber = 'contactUs___titlePhoneNumber',
  contactUs___titlePostalAddress = 'contactUs___titlePostalAddress',
  contactUs___traits___traitsStringified = 'contactUs___traits___traitsStringified',
  contactUs___id = 'contactUs___id',
  contactUs___parent___id = 'contactUs___parent___id',
  contactUs___parent___parent___id = 'contactUs___parent___parent___id',
  contactUs___parent___parent___children = 'contactUs___parent___parent___children',
  contactUs___parent___children = 'contactUs___parent___children',
  contactUs___parent___children___id = 'contactUs___parent___children___id',
  contactUs___parent___children___children = 'contactUs___parent___children___children',
  contactUs___parent___internal___content = 'contactUs___parent___internal___content',
  contactUs___parent___internal___contentDigest = 'contactUs___parent___internal___contentDigest',
  contactUs___parent___internal___description = 'contactUs___parent___internal___description',
  contactUs___parent___internal___fieldOwners = 'contactUs___parent___internal___fieldOwners',
  contactUs___parent___internal___ignoreType = 'contactUs___parent___internal___ignoreType',
  contactUs___parent___internal___mediaType = 'contactUs___parent___internal___mediaType',
  contactUs___parent___internal___owner = 'contactUs___parent___internal___owner',
  contactUs___parent___internal___type = 'contactUs___parent___internal___type',
  contactUs___children = 'contactUs___children',
  contactUs___children___id = 'contactUs___children___id',
  contactUs___children___parent___id = 'contactUs___children___parent___id',
  contactUs___children___parent___children = 'contactUs___children___parent___children',
  contactUs___children___children = 'contactUs___children___children',
  contactUs___children___children___id = 'contactUs___children___children___id',
  contactUs___children___children___children = 'contactUs___children___children___children',
  contactUs___children___internal___content = 'contactUs___children___internal___content',
  contactUs___children___internal___contentDigest = 'contactUs___children___internal___contentDigest',
  contactUs___children___internal___description = 'contactUs___children___internal___description',
  contactUs___children___internal___fieldOwners = 'contactUs___children___internal___fieldOwners',
  contactUs___children___internal___ignoreType = 'contactUs___children___internal___ignoreType',
  contactUs___children___internal___mediaType = 'contactUs___children___internal___mediaType',
  contactUs___children___internal___owner = 'contactUs___children___internal___owner',
  contactUs___children___internal___type = 'contactUs___children___internal___type',
  contactUs___internal___content = 'contactUs___internal___content',
  contactUs___internal___contentDigest = 'contactUs___internal___contentDigest',
  contactUs___internal___description = 'contactUs___internal___description',
  contactUs___internal___fieldOwners = 'contactUs___internal___fieldOwners',
  contactUs___internal___ignoreType = 'contactUs___internal___ignoreType',
  contactUs___internal___mediaType = 'contactUs___internal___mediaType',
  contactUs___internal___owner = 'contactUs___internal___owner',
  contactUs___internal___type = 'contactUs___internal___type',
  contactUsMessage___absolutePath = 'contactUsMessage___absolutePath',
  contactUsMessage___benefitImages = 'contactUsMessage___benefitImages',
  contactUsMessage___benefitImages___description = 'contactUsMessage___benefitImages___description',
  contactUsMessage___benefitImages___file___url = 'contactUsMessage___benefitImages___file___url',
  contactUsMessage___benefits = 'contactUsMessage___benefits',
  contactUsMessage___benefitsDisclaimer = 'contactUsMessage___benefitsDisclaimer',
  contactUsMessage___certificate = 'contactUsMessage___certificate',
  contactUsMessage___certificate___image___description = 'contactUsMessage___certificate___image___description',
  contactUsMessage___certificate___image___title = 'contactUsMessage___certificate___image___title',
  contactUsMessage___certificate___title = 'contactUsMessage___certificate___title',
  contactUsMessage___certificate___url = 'contactUsMessage___certificate___url',
  contactUsMessage___facts = 'contactUsMessage___facts',
  contactUsMessage___facts___image___description = 'contactUsMessage___facts___image___description',
  contactUsMessage___facts___image___title = 'contactUsMessage___facts___image___title',
  contactUsMessage___facts___summary = 'contactUsMessage___facts___summary',
  contactUsMessage___facts___title = 'contactUsMessage___facts___title',
  contactUsMessage___hero___description = 'contactUsMessage___hero___description',
  contactUsMessage___hero___file___url = 'contactUsMessage___hero___file___url',
  contactUsMessage___hero___title = 'contactUsMessage___hero___title',
  contactUsMessage___heroVideo___description = 'contactUsMessage___heroVideo___description',
  contactUsMessage___heroVideo___file___url = 'contactUsMessage___heroVideo___file___url',
  contactUsMessage___heroVideo___title = 'contactUsMessage___heroVideo___title',
  contactUsMessage___main___htmlTruncated = 'contactUsMessage___main___htmlTruncated',
  contactUsMessage___main___html = 'contactUsMessage___main___html',
  contactUsMessage___main___rawContent = 'contactUsMessage___main___rawContent',
  contactUsMessage___main___text = 'contactUsMessage___main___text',
  contactUsMessage___metaDescription = 'contactUsMessage___metaDescription',
  contactUsMessage___pageTitle = 'contactUsMessage___pageTitle',
  contactUsMessage___pageType = 'contactUsMessage___pageType',
  contactUsMessage___parentTopic___absolutePath = 'contactUsMessage___parentTopic___absolutePath',
  contactUsMessage___parentTopic___hero___description = 'contactUsMessage___parentTopic___hero___description',
  contactUsMessage___parentTopic___hero___title = 'contactUsMessage___parentTopic___hero___title',
  contactUsMessage___parentTopic___messagesNodes = 'contactUsMessage___parentTopic___messagesNodes',
  contactUsMessage___parentTopic___messagesNodes___absolutePath = 'contactUsMessage___parentTopic___messagesNodes___absolutePath',
  contactUsMessage___parentTopic___messagesNodes___benefitImages = 'contactUsMessage___parentTopic___messagesNodes___benefitImages',
  contactUsMessage___parentTopic___messagesNodes___benefits = 'contactUsMessage___parentTopic___messagesNodes___benefits',
  contactUsMessage___parentTopic___messagesNodes___benefitsDisclaimer = 'contactUsMessage___parentTopic___messagesNodes___benefitsDisclaimer',
  contactUsMessage___parentTopic___messagesNodes___certificate = 'contactUsMessage___parentTopic___messagesNodes___certificate',
  contactUsMessage___parentTopic___messagesNodes___facts = 'contactUsMessage___parentTopic___messagesNodes___facts',
  contactUsMessage___parentTopic___messagesNodes___metaDescription = 'contactUsMessage___parentTopic___messagesNodes___metaDescription',
  contactUsMessage___parentTopic___messagesNodes___pageTitle = 'contactUsMessage___parentTopic___messagesNodes___pageTitle',
  contactUsMessage___parentTopic___messagesNodes___pageType = 'contactUsMessage___parentTopic___messagesNodes___pageType',
  contactUsMessage___parentTopic___messagesNodes___path = 'contactUsMessage___parentTopic___messagesNodes___path',
  contactUsMessage___parentTopic___messagesNodes___product = 'contactUsMessage___parentTopic___messagesNodes___product',
  contactUsMessage___parentTopic___messagesNodes___productsNodes = 'contactUsMessage___parentTopic___messagesNodes___productsNodes',
  contactUsMessage___parentTopic___messagesNodes___slug = 'contactUsMessage___parentTopic___messagesNodes___slug',
  contactUsMessage___parentTopic___messagesNodes___summary = 'contactUsMessage___parentTopic___messagesNodes___summary',
  contactUsMessage___parentTopic___messagesNodes___title = 'contactUsMessage___parentTopic___messagesNodes___title',
  contactUsMessage___parentTopic___messagesNodes___id = 'contactUsMessage___parentTopic___messagesNodes___id',
  contactUsMessage___parentTopic___messagesNodes___children = 'contactUsMessage___parentTopic___messagesNodes___children',
  contactUsMessage___parentTopic___metaDescription = 'contactUsMessage___parentTopic___metaDescription',
  contactUsMessage___parentTopic___navigationTitle = 'contactUsMessage___parentTopic___navigationTitle',
  contactUsMessage___parentTopic___topicDisclaimer = 'contactUsMessage___parentTopic___topicDisclaimer',
  contactUsMessage___parentTopic___pageTitle = 'contactUsMessage___parentTopic___pageTitle',
  contactUsMessage___parentTopic___pageType = 'contactUsMessage___parentTopic___pageType',
  contactUsMessage___parentTopic___path = 'contactUsMessage___parentTopic___path',
  contactUsMessage___parentTopic___slug = 'contactUsMessage___parentTopic___slug',
  contactUsMessage___parentTopic___summary = 'contactUsMessage___parentTopic___summary',
  contactUsMessage___parentTopic___title = 'contactUsMessage___parentTopic___title',
  contactUsMessage___parentTopic___traits___traitsStringified = 'contactUsMessage___parentTopic___traits___traitsStringified',
  contactUsMessage___parentTopic___id = 'contactUsMessage___parentTopic___id',
  contactUsMessage___parentTopic___parent___id = 'contactUsMessage___parentTopic___parent___id',
  contactUsMessage___parentTopic___parent___children = 'contactUsMessage___parentTopic___parent___children',
  contactUsMessage___parentTopic___children = 'contactUsMessage___parentTopic___children',
  contactUsMessage___parentTopic___children___id = 'contactUsMessage___parentTopic___children___id',
  contactUsMessage___parentTopic___children___children = 'contactUsMessage___parentTopic___children___children',
  contactUsMessage___parentTopic___internal___content = 'contactUsMessage___parentTopic___internal___content',
  contactUsMessage___parentTopic___internal___contentDigest = 'contactUsMessage___parentTopic___internal___contentDigest',
  contactUsMessage___parentTopic___internal___description = 'contactUsMessage___parentTopic___internal___description',
  contactUsMessage___parentTopic___internal___fieldOwners = 'contactUsMessage___parentTopic___internal___fieldOwners',
  contactUsMessage___parentTopic___internal___ignoreType = 'contactUsMessage___parentTopic___internal___ignoreType',
  contactUsMessage___parentTopic___internal___mediaType = 'contactUsMessage___parentTopic___internal___mediaType',
  contactUsMessage___parentTopic___internal___owner = 'contactUsMessage___parentTopic___internal___owner',
  contactUsMessage___parentTopic___internal___type = 'contactUsMessage___parentTopic___internal___type',
  contactUsMessage___path = 'contactUsMessage___path',
  contactUsMessage___product = 'contactUsMessage___product',
  contactUsMessage___productsNodes = 'contactUsMessage___productsNodes',
  contactUsMessage___productsNodes___absolutePath = 'contactUsMessage___productsNodes___absolutePath',
  contactUsMessage___productsNodes___benefits = 'contactUsMessage___productsNodes___benefits',
  contactUsMessage___productsNodes___benefitsDisclaimer = 'contactUsMessage___productsNodes___benefitsDisclaimer',
  contactUsMessage___productsNodes___description___htmlTruncated = 'contactUsMessage___productsNodes___description___htmlTruncated',
  contactUsMessage___productsNodes___description___html = 'contactUsMessage___productsNodes___description___html',
  contactUsMessage___productsNodes___description___rawContent = 'contactUsMessage___productsNodes___description___rawContent',
  contactUsMessage___productsNodes___description___text = 'contactUsMessage___productsNodes___description___text',
  contactUsMessage___productsNodes___hero___description = 'contactUsMessage___productsNodes___hero___description',
  contactUsMessage___productsNodes___hero___title = 'contactUsMessage___productsNodes___hero___title',
  contactUsMessage___productsNodes___howToUse___html = 'contactUsMessage___productsNodes___howToUse___html',
  contactUsMessage___productsNodes___howToUse___json = 'contactUsMessage___productsNodes___howToUse___json',
  contactUsMessage___productsNodes___howToUse___text = 'contactUsMessage___productsNodes___howToUse___text',
  contactUsMessage___productsNodes___main___htmlTruncated = 'contactUsMessage___productsNodes___main___htmlTruncated',
  contactUsMessage___productsNodes___main___html = 'contactUsMessage___productsNodes___main___html',
  contactUsMessage___productsNodes___main___rawContent = 'contactUsMessage___productsNodes___main___rawContent',
  contactUsMessage___productsNodes___main___text = 'contactUsMessage___productsNodes___main___text',
  contactUsMessage___productsNodes___metaDescription = 'contactUsMessage___productsNodes___metaDescription',
  contactUsMessage___productsNodes___name = 'contactUsMessage___productsNodes___name',
  contactUsMessage___productsNodes___pageTitle = 'contactUsMessage___productsNodes___pageTitle',
  contactUsMessage___productsNodes___pageType = 'contactUsMessage___productsNodes___pageType',
  contactUsMessage___productsNodes___parentMessage___absolutePath = 'contactUsMessage___productsNodes___parentMessage___absolutePath',
  contactUsMessage___productsNodes___parentMessage___benefitImages = 'contactUsMessage___productsNodes___parentMessage___benefitImages',
  contactUsMessage___productsNodes___parentMessage___benefits = 'contactUsMessage___productsNodes___parentMessage___benefits',
  contactUsMessage___productsNodes___parentMessage___benefitsDisclaimer = 'contactUsMessage___productsNodes___parentMessage___benefitsDisclaimer',
  contactUsMessage___productsNodes___parentMessage___certificate = 'contactUsMessage___productsNodes___parentMessage___certificate',
  contactUsMessage___productsNodes___parentMessage___facts = 'contactUsMessage___productsNodes___parentMessage___facts',
  contactUsMessage___productsNodes___parentMessage___metaDescription = 'contactUsMessage___productsNodes___parentMessage___metaDescription',
  contactUsMessage___productsNodes___parentMessage___pageTitle = 'contactUsMessage___productsNodes___parentMessage___pageTitle',
  contactUsMessage___productsNodes___parentMessage___pageType = 'contactUsMessage___productsNodes___parentMessage___pageType',
  contactUsMessage___productsNodes___parentMessage___path = 'contactUsMessage___productsNodes___parentMessage___path',
  contactUsMessage___productsNodes___parentMessage___product = 'contactUsMessage___productsNodes___parentMessage___product',
  contactUsMessage___productsNodes___parentMessage___productsNodes = 'contactUsMessage___productsNodes___parentMessage___productsNodes',
  contactUsMessage___productsNodes___parentMessage___slug = 'contactUsMessage___productsNodes___parentMessage___slug',
  contactUsMessage___productsNodes___parentMessage___summary = 'contactUsMessage___productsNodes___parentMessage___summary',
  contactUsMessage___productsNodes___parentMessage___title = 'contactUsMessage___productsNodes___parentMessage___title',
  contactUsMessage___productsNodes___parentMessage___id = 'contactUsMessage___productsNodes___parentMessage___id',
  contactUsMessage___productsNodes___parentMessage___children = 'contactUsMessage___productsNodes___parentMessage___children',
  contactUsMessage___productsNodes___path = 'contactUsMessage___productsNodes___path',
  contactUsMessage___productsNodes___slug = 'contactUsMessage___productsNodes___slug',
  contactUsMessage___productsNodes___summaryBackground___description = 'contactUsMessage___productsNodes___summaryBackground___description',
  contactUsMessage___productsNodes___summaryBackground___title = 'contactUsMessage___productsNodes___summaryBackground___title',
  contactUsMessage___productsNodes___traits___traitsStringified = 'contactUsMessage___productsNodes___traits___traitsStringified',
  contactUsMessage___productsNodes___variants = 'contactUsMessage___productsNodes___variants',
  contactUsMessage___productsNodes___variants___buyItNowUrl = 'contactUsMessage___productsNodes___variants___buyItNowUrl',
  contactUsMessage___productsNodes___variants___name = 'contactUsMessage___productsNodes___variants___name',
  contactUsMessage___productsNodes___variants___product = 'contactUsMessage___productsNodes___variants___product',
  contactUsMessage___productsNodes___variants___sizes = 'contactUsMessage___productsNodes___variants___sizes',
  contactUsMessage___productsNodes___id = 'contactUsMessage___productsNodes___id',
  contactUsMessage___productsNodes___parent___id = 'contactUsMessage___productsNodes___parent___id',
  contactUsMessage___productsNodes___parent___children = 'contactUsMessage___productsNodes___parent___children',
  contactUsMessage___productsNodes___children = 'contactUsMessage___productsNodes___children',
  contactUsMessage___productsNodes___children___id = 'contactUsMessage___productsNodes___children___id',
  contactUsMessage___productsNodes___children___children = 'contactUsMessage___productsNodes___children___children',
  contactUsMessage___productsNodes___internal___content = 'contactUsMessage___productsNodes___internal___content',
  contactUsMessage___productsNodes___internal___contentDigest = 'contactUsMessage___productsNodes___internal___contentDigest',
  contactUsMessage___productsNodes___internal___description = 'contactUsMessage___productsNodes___internal___description',
  contactUsMessage___productsNodes___internal___fieldOwners = 'contactUsMessage___productsNodes___internal___fieldOwners',
  contactUsMessage___productsNodes___internal___ignoreType = 'contactUsMessage___productsNodes___internal___ignoreType',
  contactUsMessage___productsNodes___internal___mediaType = 'contactUsMessage___productsNodes___internal___mediaType',
  contactUsMessage___productsNodes___internal___owner = 'contactUsMessage___productsNodes___internal___owner',
  contactUsMessage___productsNodes___internal___type = 'contactUsMessage___productsNodes___internal___type',
  contactUsMessage___slug = 'contactUsMessage___slug',
  contactUsMessage___summary = 'contactUsMessage___summary',
  contactUsMessage___summaryBackground___description = 'contactUsMessage___summaryBackground___description',
  contactUsMessage___summaryBackground___file___url = 'contactUsMessage___summaryBackground___file___url',
  contactUsMessage___summaryBackground___title = 'contactUsMessage___summaryBackground___title',
  contactUsMessage___teaserImage___description = 'contactUsMessage___teaserImage___description',
  contactUsMessage___teaserImage___file___url = 'contactUsMessage___teaserImage___file___url',
  contactUsMessage___teaserImage___title = 'contactUsMessage___teaserImage___title',
  contactUsMessage___territoryWidget___bottomGraphic___description = 'contactUsMessage___territoryWidget___bottomGraphic___description',
  contactUsMessage___territoryWidget___bottomGraphic___title = 'contactUsMessage___territoryWidget___bottomGraphic___title',
  contactUsMessage___territoryWidget___bottomHeading = 'contactUsMessage___territoryWidget___bottomHeading',
  contactUsMessage___territoryWidget___graphicHeading = 'contactUsMessage___territoryWidget___graphicHeading',
  contactUsMessage___territoryWidget___topCopy = 'contactUsMessage___territoryWidget___topCopy',
  contactUsMessage___territoryWidget___topHeading = 'contactUsMessage___territoryWidget___topHeading',
  contactUsMessage___territoryWidget___topHeroImage___description = 'contactUsMessage___territoryWidget___topHeroImage___description',
  contactUsMessage___territoryWidget___topHeroImage___title = 'contactUsMessage___territoryWidget___topHeroImage___title',
  contactUsMessage___territoryWidget___topLeftHeadingImage___description = 'contactUsMessage___territoryWidget___topLeftHeadingImage___description',
  contactUsMessage___territoryWidget___topLeftHeadingImage___title = 'contactUsMessage___territoryWidget___topLeftHeadingImage___title',
  contactUsMessage___title = 'contactUsMessage___title',
  contactUsMessage___traits___traitsStringified = 'contactUsMessage___traits___traitsStringified',
  contactUsMessage___video___description = 'contactUsMessage___video___description',
  contactUsMessage___video___file___url = 'contactUsMessage___video___file___url',
  contactUsMessage___video___title = 'contactUsMessage___video___title',
  contactUsMessage___id = 'contactUsMessage___id',
  contactUsMessage___parent___id = 'contactUsMessage___parent___id',
  contactUsMessage___parent___parent___id = 'contactUsMessage___parent___parent___id',
  contactUsMessage___parent___parent___children = 'contactUsMessage___parent___parent___children',
  contactUsMessage___parent___children = 'contactUsMessage___parent___children',
  contactUsMessage___parent___children___id = 'contactUsMessage___parent___children___id',
  contactUsMessage___parent___children___children = 'contactUsMessage___parent___children___children',
  contactUsMessage___parent___internal___content = 'contactUsMessage___parent___internal___content',
  contactUsMessage___parent___internal___contentDigest = 'contactUsMessage___parent___internal___contentDigest',
  contactUsMessage___parent___internal___description = 'contactUsMessage___parent___internal___description',
  contactUsMessage___parent___internal___fieldOwners = 'contactUsMessage___parent___internal___fieldOwners',
  contactUsMessage___parent___internal___ignoreType = 'contactUsMessage___parent___internal___ignoreType',
  contactUsMessage___parent___internal___mediaType = 'contactUsMessage___parent___internal___mediaType',
  contactUsMessage___parent___internal___owner = 'contactUsMessage___parent___internal___owner',
  contactUsMessage___parent___internal___type = 'contactUsMessage___parent___internal___type',
  contactUsMessage___children = 'contactUsMessage___children',
  contactUsMessage___children___id = 'contactUsMessage___children___id',
  contactUsMessage___children___parent___id = 'contactUsMessage___children___parent___id',
  contactUsMessage___children___parent___children = 'contactUsMessage___children___parent___children',
  contactUsMessage___children___children = 'contactUsMessage___children___children',
  contactUsMessage___children___children___id = 'contactUsMessage___children___children___id',
  contactUsMessage___children___children___children = 'contactUsMessage___children___children___children',
  contactUsMessage___children___internal___content = 'contactUsMessage___children___internal___content',
  contactUsMessage___children___internal___contentDigest = 'contactUsMessage___children___internal___contentDigest',
  contactUsMessage___children___internal___description = 'contactUsMessage___children___internal___description',
  contactUsMessage___children___internal___fieldOwners = 'contactUsMessage___children___internal___fieldOwners',
  contactUsMessage___children___internal___ignoreType = 'contactUsMessage___children___internal___ignoreType',
  contactUsMessage___children___internal___mediaType = 'contactUsMessage___children___internal___mediaType',
  contactUsMessage___children___internal___owner = 'contactUsMessage___children___internal___owner',
  contactUsMessage___children___internal___type = 'contactUsMessage___children___internal___type',
  contactUsMessage___internal___content = 'contactUsMessage___internal___content',
  contactUsMessage___internal___contentDigest = 'contactUsMessage___internal___contentDigest',
  contactUsMessage___internal___description = 'contactUsMessage___internal___description',
  contactUsMessage___internal___fieldOwners = 'contactUsMessage___internal___fieldOwners',
  contactUsMessage___internal___ignoreType = 'contactUsMessage___internal___ignoreType',
  contactUsMessage___internal___mediaType = 'contactUsMessage___internal___mediaType',
  contactUsMessage___internal___owner = 'contactUsMessage___internal___owner',
  contactUsMessage___internal___type = 'contactUsMessage___internal___type',
  coreMessage___absolutePath = 'coreMessage___absolutePath',
  coreMessage___benefitImages = 'coreMessage___benefitImages',
  coreMessage___benefitImages___description = 'coreMessage___benefitImages___description',
  coreMessage___benefitImages___file___url = 'coreMessage___benefitImages___file___url',
  coreMessage___benefits = 'coreMessage___benefits',
  coreMessage___benefitsDisclaimer = 'coreMessage___benefitsDisclaimer',
  coreMessage___certificate = 'coreMessage___certificate',
  coreMessage___certificate___image___description = 'coreMessage___certificate___image___description',
  coreMessage___certificate___image___title = 'coreMessage___certificate___image___title',
  coreMessage___certificate___title = 'coreMessage___certificate___title',
  coreMessage___certificate___url = 'coreMessage___certificate___url',
  coreMessage___facts = 'coreMessage___facts',
  coreMessage___facts___image___description = 'coreMessage___facts___image___description',
  coreMessage___facts___image___title = 'coreMessage___facts___image___title',
  coreMessage___facts___summary = 'coreMessage___facts___summary',
  coreMessage___facts___title = 'coreMessage___facts___title',
  coreMessage___hero___description = 'coreMessage___hero___description',
  coreMessage___hero___file___url = 'coreMessage___hero___file___url',
  coreMessage___hero___title = 'coreMessage___hero___title',
  coreMessage___heroVideo___description = 'coreMessage___heroVideo___description',
  coreMessage___heroVideo___file___url = 'coreMessage___heroVideo___file___url',
  coreMessage___heroVideo___title = 'coreMessage___heroVideo___title',
  coreMessage___main___htmlTruncated = 'coreMessage___main___htmlTruncated',
  coreMessage___main___html = 'coreMessage___main___html',
  coreMessage___main___rawContent = 'coreMessage___main___rawContent',
  coreMessage___main___text = 'coreMessage___main___text',
  coreMessage___metaDescription = 'coreMessage___metaDescription',
  coreMessage___pageTitle = 'coreMessage___pageTitle',
  coreMessage___pageType = 'coreMessage___pageType',
  coreMessage___parentTopic___absolutePath = 'coreMessage___parentTopic___absolutePath',
  coreMessage___parentTopic___hero___description = 'coreMessage___parentTopic___hero___description',
  coreMessage___parentTopic___hero___title = 'coreMessage___parentTopic___hero___title',
  coreMessage___parentTopic___messagesNodes = 'coreMessage___parentTopic___messagesNodes',
  coreMessage___parentTopic___messagesNodes___absolutePath = 'coreMessage___parentTopic___messagesNodes___absolutePath',
  coreMessage___parentTopic___messagesNodes___benefitImages = 'coreMessage___parentTopic___messagesNodes___benefitImages',
  coreMessage___parentTopic___messagesNodes___benefits = 'coreMessage___parentTopic___messagesNodes___benefits',
  coreMessage___parentTopic___messagesNodes___benefitsDisclaimer = 'coreMessage___parentTopic___messagesNodes___benefitsDisclaimer',
  coreMessage___parentTopic___messagesNodes___certificate = 'coreMessage___parentTopic___messagesNodes___certificate',
  coreMessage___parentTopic___messagesNodes___facts = 'coreMessage___parentTopic___messagesNodes___facts',
  coreMessage___parentTopic___messagesNodes___metaDescription = 'coreMessage___parentTopic___messagesNodes___metaDescription',
  coreMessage___parentTopic___messagesNodes___pageTitle = 'coreMessage___parentTopic___messagesNodes___pageTitle',
  coreMessage___parentTopic___messagesNodes___pageType = 'coreMessage___parentTopic___messagesNodes___pageType',
  coreMessage___parentTopic___messagesNodes___path = 'coreMessage___parentTopic___messagesNodes___path',
  coreMessage___parentTopic___messagesNodes___product = 'coreMessage___parentTopic___messagesNodes___product',
  coreMessage___parentTopic___messagesNodes___productsNodes = 'coreMessage___parentTopic___messagesNodes___productsNodes',
  coreMessage___parentTopic___messagesNodes___slug = 'coreMessage___parentTopic___messagesNodes___slug',
  coreMessage___parentTopic___messagesNodes___summary = 'coreMessage___parentTopic___messagesNodes___summary',
  coreMessage___parentTopic___messagesNodes___title = 'coreMessage___parentTopic___messagesNodes___title',
  coreMessage___parentTopic___messagesNodes___id = 'coreMessage___parentTopic___messagesNodes___id',
  coreMessage___parentTopic___messagesNodes___children = 'coreMessage___parentTopic___messagesNodes___children',
  coreMessage___parentTopic___metaDescription = 'coreMessage___parentTopic___metaDescription',
  coreMessage___parentTopic___navigationTitle = 'coreMessage___parentTopic___navigationTitle',
  coreMessage___parentTopic___topicDisclaimer = 'coreMessage___parentTopic___topicDisclaimer',
  coreMessage___parentTopic___pageTitle = 'coreMessage___parentTopic___pageTitle',
  coreMessage___parentTopic___pageType = 'coreMessage___parentTopic___pageType',
  coreMessage___parentTopic___path = 'coreMessage___parentTopic___path',
  coreMessage___parentTopic___slug = 'coreMessage___parentTopic___slug',
  coreMessage___parentTopic___summary = 'coreMessage___parentTopic___summary',
  coreMessage___parentTopic___title = 'coreMessage___parentTopic___title',
  coreMessage___parentTopic___traits___traitsStringified = 'coreMessage___parentTopic___traits___traitsStringified',
  coreMessage___parentTopic___id = 'coreMessage___parentTopic___id',
  coreMessage___parentTopic___parent___id = 'coreMessage___parentTopic___parent___id',
  coreMessage___parentTopic___parent___children = 'coreMessage___parentTopic___parent___children',
  coreMessage___parentTopic___children = 'coreMessage___parentTopic___children',
  coreMessage___parentTopic___children___id = 'coreMessage___parentTopic___children___id',
  coreMessage___parentTopic___children___children = 'coreMessage___parentTopic___children___children',
  coreMessage___parentTopic___internal___content = 'coreMessage___parentTopic___internal___content',
  coreMessage___parentTopic___internal___contentDigest = 'coreMessage___parentTopic___internal___contentDigest',
  coreMessage___parentTopic___internal___description = 'coreMessage___parentTopic___internal___description',
  coreMessage___parentTopic___internal___fieldOwners = 'coreMessage___parentTopic___internal___fieldOwners',
  coreMessage___parentTopic___internal___ignoreType = 'coreMessage___parentTopic___internal___ignoreType',
  coreMessage___parentTopic___internal___mediaType = 'coreMessage___parentTopic___internal___mediaType',
  coreMessage___parentTopic___internal___owner = 'coreMessage___parentTopic___internal___owner',
  coreMessage___parentTopic___internal___type = 'coreMessage___parentTopic___internal___type',
  coreMessage___path = 'coreMessage___path',
  coreMessage___product = 'coreMessage___product',
  coreMessage___productsNodes = 'coreMessage___productsNodes',
  coreMessage___productsNodes___absolutePath = 'coreMessage___productsNodes___absolutePath',
  coreMessage___productsNodes___benefits = 'coreMessage___productsNodes___benefits',
  coreMessage___productsNodes___benefitsDisclaimer = 'coreMessage___productsNodes___benefitsDisclaimer',
  coreMessage___productsNodes___description___htmlTruncated = 'coreMessage___productsNodes___description___htmlTruncated',
  coreMessage___productsNodes___description___html = 'coreMessage___productsNodes___description___html',
  coreMessage___productsNodes___description___rawContent = 'coreMessage___productsNodes___description___rawContent',
  coreMessage___productsNodes___description___text = 'coreMessage___productsNodes___description___text',
  coreMessage___productsNodes___hero___description = 'coreMessage___productsNodes___hero___description',
  coreMessage___productsNodes___hero___title = 'coreMessage___productsNodes___hero___title',
  coreMessage___productsNodes___howToUse___html = 'coreMessage___productsNodes___howToUse___html',
  coreMessage___productsNodes___howToUse___json = 'coreMessage___productsNodes___howToUse___json',
  coreMessage___productsNodes___howToUse___text = 'coreMessage___productsNodes___howToUse___text',
  coreMessage___productsNodes___main___htmlTruncated = 'coreMessage___productsNodes___main___htmlTruncated',
  coreMessage___productsNodes___main___html = 'coreMessage___productsNodes___main___html',
  coreMessage___productsNodes___main___rawContent = 'coreMessage___productsNodes___main___rawContent',
  coreMessage___productsNodes___main___text = 'coreMessage___productsNodes___main___text',
  coreMessage___productsNodes___metaDescription = 'coreMessage___productsNodes___metaDescription',
  coreMessage___productsNodes___name = 'coreMessage___productsNodes___name',
  coreMessage___productsNodes___pageTitle = 'coreMessage___productsNodes___pageTitle',
  coreMessage___productsNodes___pageType = 'coreMessage___productsNodes___pageType',
  coreMessage___productsNodes___parentMessage___absolutePath = 'coreMessage___productsNodes___parentMessage___absolutePath',
  coreMessage___productsNodes___parentMessage___benefitImages = 'coreMessage___productsNodes___parentMessage___benefitImages',
  coreMessage___productsNodes___parentMessage___benefits = 'coreMessage___productsNodes___parentMessage___benefits',
  coreMessage___productsNodes___parentMessage___benefitsDisclaimer = 'coreMessage___productsNodes___parentMessage___benefitsDisclaimer',
  coreMessage___productsNodes___parentMessage___certificate = 'coreMessage___productsNodes___parentMessage___certificate',
  coreMessage___productsNodes___parentMessage___facts = 'coreMessage___productsNodes___parentMessage___facts',
  coreMessage___productsNodes___parentMessage___metaDescription = 'coreMessage___productsNodes___parentMessage___metaDescription',
  coreMessage___productsNodes___parentMessage___pageTitle = 'coreMessage___productsNodes___parentMessage___pageTitle',
  coreMessage___productsNodes___parentMessage___pageType = 'coreMessage___productsNodes___parentMessage___pageType',
  coreMessage___productsNodes___parentMessage___path = 'coreMessage___productsNodes___parentMessage___path',
  coreMessage___productsNodes___parentMessage___product = 'coreMessage___productsNodes___parentMessage___product',
  coreMessage___productsNodes___parentMessage___productsNodes = 'coreMessage___productsNodes___parentMessage___productsNodes',
  coreMessage___productsNodes___parentMessage___slug = 'coreMessage___productsNodes___parentMessage___slug',
  coreMessage___productsNodes___parentMessage___summary = 'coreMessage___productsNodes___parentMessage___summary',
  coreMessage___productsNodes___parentMessage___title = 'coreMessage___productsNodes___parentMessage___title',
  coreMessage___productsNodes___parentMessage___id = 'coreMessage___productsNodes___parentMessage___id',
  coreMessage___productsNodes___parentMessage___children = 'coreMessage___productsNodes___parentMessage___children',
  coreMessage___productsNodes___path = 'coreMessage___productsNodes___path',
  coreMessage___productsNodes___slug = 'coreMessage___productsNodes___slug',
  coreMessage___productsNodes___summaryBackground___description = 'coreMessage___productsNodes___summaryBackground___description',
  coreMessage___productsNodes___summaryBackground___title = 'coreMessage___productsNodes___summaryBackground___title',
  coreMessage___productsNodes___traits___traitsStringified = 'coreMessage___productsNodes___traits___traitsStringified',
  coreMessage___productsNodes___variants = 'coreMessage___productsNodes___variants',
  coreMessage___productsNodes___variants___buyItNowUrl = 'coreMessage___productsNodes___variants___buyItNowUrl',
  coreMessage___productsNodes___variants___name = 'coreMessage___productsNodes___variants___name',
  coreMessage___productsNodes___variants___product = 'coreMessage___productsNodes___variants___product',
  coreMessage___productsNodes___variants___sizes = 'coreMessage___productsNodes___variants___sizes',
  coreMessage___productsNodes___id = 'coreMessage___productsNodes___id',
  coreMessage___productsNodes___parent___id = 'coreMessage___productsNodes___parent___id',
  coreMessage___productsNodes___parent___children = 'coreMessage___productsNodes___parent___children',
  coreMessage___productsNodes___children = 'coreMessage___productsNodes___children',
  coreMessage___productsNodes___children___id = 'coreMessage___productsNodes___children___id',
  coreMessage___productsNodes___children___children = 'coreMessage___productsNodes___children___children',
  coreMessage___productsNodes___internal___content = 'coreMessage___productsNodes___internal___content',
  coreMessage___productsNodes___internal___contentDigest = 'coreMessage___productsNodes___internal___contentDigest',
  coreMessage___productsNodes___internal___description = 'coreMessage___productsNodes___internal___description',
  coreMessage___productsNodes___internal___fieldOwners = 'coreMessage___productsNodes___internal___fieldOwners',
  coreMessage___productsNodes___internal___ignoreType = 'coreMessage___productsNodes___internal___ignoreType',
  coreMessage___productsNodes___internal___mediaType = 'coreMessage___productsNodes___internal___mediaType',
  coreMessage___productsNodes___internal___owner = 'coreMessage___productsNodes___internal___owner',
  coreMessage___productsNodes___internal___type = 'coreMessage___productsNodes___internal___type',
  coreMessage___slug = 'coreMessage___slug',
  coreMessage___summary = 'coreMessage___summary',
  coreMessage___summaryBackground___description = 'coreMessage___summaryBackground___description',
  coreMessage___summaryBackground___file___url = 'coreMessage___summaryBackground___file___url',
  coreMessage___summaryBackground___title = 'coreMessage___summaryBackground___title',
  coreMessage___teaserImage___description = 'coreMessage___teaserImage___description',
  coreMessage___teaserImage___file___url = 'coreMessage___teaserImage___file___url',
  coreMessage___teaserImage___title = 'coreMessage___teaserImage___title',
  coreMessage___territoryWidget___bottomGraphic___description = 'coreMessage___territoryWidget___bottomGraphic___description',
  coreMessage___territoryWidget___bottomGraphic___title = 'coreMessage___territoryWidget___bottomGraphic___title',
  coreMessage___territoryWidget___bottomHeading = 'coreMessage___territoryWidget___bottomHeading',
  coreMessage___territoryWidget___graphicHeading = 'coreMessage___territoryWidget___graphicHeading',
  coreMessage___territoryWidget___topCopy = 'coreMessage___territoryWidget___topCopy',
  coreMessage___territoryWidget___topHeading = 'coreMessage___territoryWidget___topHeading',
  coreMessage___territoryWidget___topHeroImage___description = 'coreMessage___territoryWidget___topHeroImage___description',
  coreMessage___territoryWidget___topHeroImage___title = 'coreMessage___territoryWidget___topHeroImage___title',
  coreMessage___territoryWidget___topLeftHeadingImage___description = 'coreMessage___territoryWidget___topLeftHeadingImage___description',
  coreMessage___territoryWidget___topLeftHeadingImage___title = 'coreMessage___territoryWidget___topLeftHeadingImage___title',
  coreMessage___title = 'coreMessage___title',
  coreMessage___traits___traitsStringified = 'coreMessage___traits___traitsStringified',
  coreMessage___video___description = 'coreMessage___video___description',
  coreMessage___video___file___url = 'coreMessage___video___file___url',
  coreMessage___video___title = 'coreMessage___video___title',
  coreMessage___id = 'coreMessage___id',
  coreMessage___parent___id = 'coreMessage___parent___id',
  coreMessage___parent___parent___id = 'coreMessage___parent___parent___id',
  coreMessage___parent___parent___children = 'coreMessage___parent___parent___children',
  coreMessage___parent___children = 'coreMessage___parent___children',
  coreMessage___parent___children___id = 'coreMessage___parent___children___id',
  coreMessage___parent___children___children = 'coreMessage___parent___children___children',
  coreMessage___parent___internal___content = 'coreMessage___parent___internal___content',
  coreMessage___parent___internal___contentDigest = 'coreMessage___parent___internal___contentDigest',
  coreMessage___parent___internal___description = 'coreMessage___parent___internal___description',
  coreMessage___parent___internal___fieldOwners = 'coreMessage___parent___internal___fieldOwners',
  coreMessage___parent___internal___ignoreType = 'coreMessage___parent___internal___ignoreType',
  coreMessage___parent___internal___mediaType = 'coreMessage___parent___internal___mediaType',
  coreMessage___parent___internal___owner = 'coreMessage___parent___internal___owner',
  coreMessage___parent___internal___type = 'coreMessage___parent___internal___type',
  coreMessage___children = 'coreMessage___children',
  coreMessage___children___id = 'coreMessage___children___id',
  coreMessage___children___parent___id = 'coreMessage___children___parent___id',
  coreMessage___children___parent___children = 'coreMessage___children___parent___children',
  coreMessage___children___children = 'coreMessage___children___children',
  coreMessage___children___children___id = 'coreMessage___children___children___id',
  coreMessage___children___children___children = 'coreMessage___children___children___children',
  coreMessage___children___internal___content = 'coreMessage___children___internal___content',
  coreMessage___children___internal___contentDigest = 'coreMessage___children___internal___contentDigest',
  coreMessage___children___internal___description = 'coreMessage___children___internal___description',
  coreMessage___children___internal___fieldOwners = 'coreMessage___children___internal___fieldOwners',
  coreMessage___children___internal___ignoreType = 'coreMessage___children___internal___ignoreType',
  coreMessage___children___internal___mediaType = 'coreMessage___children___internal___mediaType',
  coreMessage___children___internal___owner = 'coreMessage___children___internal___owner',
  coreMessage___children___internal___type = 'coreMessage___children___internal___type',
  coreMessage___internal___content = 'coreMessage___internal___content',
  coreMessage___internal___contentDigest = 'coreMessage___internal___contentDigest',
  coreMessage___internal___description = 'coreMessage___internal___description',
  coreMessage___internal___fieldOwners = 'coreMessage___internal___fieldOwners',
  coreMessage___internal___ignoreType = 'coreMessage___internal___ignoreType',
  coreMessage___internal___mediaType = 'coreMessage___internal___mediaType',
  coreMessage___internal___owner = 'coreMessage___internal___owner',
  coreMessage___internal___type = 'coreMessage___internal___type',
  currentYear = 'currentYear',
  disclaimerMessage___absolutePath = 'disclaimerMessage___absolutePath',
  disclaimerMessage___benefitImages = 'disclaimerMessage___benefitImages',
  disclaimerMessage___benefitImages___description = 'disclaimerMessage___benefitImages___description',
  disclaimerMessage___benefitImages___file___url = 'disclaimerMessage___benefitImages___file___url',
  disclaimerMessage___benefits = 'disclaimerMessage___benefits',
  disclaimerMessage___benefitsDisclaimer = 'disclaimerMessage___benefitsDisclaimer',
  disclaimerMessage___certificate = 'disclaimerMessage___certificate',
  disclaimerMessage___certificate___image___description = 'disclaimerMessage___certificate___image___description',
  disclaimerMessage___certificate___image___title = 'disclaimerMessage___certificate___image___title',
  disclaimerMessage___certificate___title = 'disclaimerMessage___certificate___title',
  disclaimerMessage___certificate___url = 'disclaimerMessage___certificate___url',
  disclaimerMessage___facts = 'disclaimerMessage___facts',
  disclaimerMessage___facts___image___description = 'disclaimerMessage___facts___image___description',
  disclaimerMessage___facts___image___title = 'disclaimerMessage___facts___image___title',
  disclaimerMessage___facts___summary = 'disclaimerMessage___facts___summary',
  disclaimerMessage___facts___title = 'disclaimerMessage___facts___title',
  disclaimerMessage___hero___description = 'disclaimerMessage___hero___description',
  disclaimerMessage___hero___file___url = 'disclaimerMessage___hero___file___url',
  disclaimerMessage___hero___title = 'disclaimerMessage___hero___title',
  disclaimerMessage___heroVideo___description = 'disclaimerMessage___heroVideo___description',
  disclaimerMessage___heroVideo___file___url = 'disclaimerMessage___heroVideo___file___url',
  disclaimerMessage___heroVideo___title = 'disclaimerMessage___heroVideo___title',
  disclaimerMessage___main___htmlTruncated = 'disclaimerMessage___main___htmlTruncated',
  disclaimerMessage___main___html = 'disclaimerMessage___main___html',
  disclaimerMessage___main___rawContent = 'disclaimerMessage___main___rawContent',
  disclaimerMessage___main___text = 'disclaimerMessage___main___text',
  disclaimerMessage___metaDescription = 'disclaimerMessage___metaDescription',
  disclaimerMessage___pageTitle = 'disclaimerMessage___pageTitle',
  disclaimerMessage___pageType = 'disclaimerMessage___pageType',
  disclaimerMessage___parentTopic___absolutePath = 'disclaimerMessage___parentTopic___absolutePath',
  disclaimerMessage___parentTopic___hero___description = 'disclaimerMessage___parentTopic___hero___description',
  disclaimerMessage___parentTopic___hero___title = 'disclaimerMessage___parentTopic___hero___title',
  disclaimerMessage___parentTopic___messagesNodes = 'disclaimerMessage___parentTopic___messagesNodes',
  disclaimerMessage___parentTopic___messagesNodes___absolutePath = 'disclaimerMessage___parentTopic___messagesNodes___absolutePath',
  disclaimerMessage___parentTopic___messagesNodes___benefitImages = 'disclaimerMessage___parentTopic___messagesNodes___benefitImages',
  disclaimerMessage___parentTopic___messagesNodes___benefits = 'disclaimerMessage___parentTopic___messagesNodes___benefits',
  disclaimerMessage___parentTopic___messagesNodes___benefitsDisclaimer = 'disclaimerMessage___parentTopic___messagesNodes___benefitsDisclaimer',
  disclaimerMessage___parentTopic___messagesNodes___certificate = 'disclaimerMessage___parentTopic___messagesNodes___certificate',
  disclaimerMessage___parentTopic___messagesNodes___facts = 'disclaimerMessage___parentTopic___messagesNodes___facts',
  disclaimerMessage___parentTopic___messagesNodes___metaDescription = 'disclaimerMessage___parentTopic___messagesNodes___metaDescription',
  disclaimerMessage___parentTopic___messagesNodes___pageTitle = 'disclaimerMessage___parentTopic___messagesNodes___pageTitle',
  disclaimerMessage___parentTopic___messagesNodes___pageType = 'disclaimerMessage___parentTopic___messagesNodes___pageType',
  disclaimerMessage___parentTopic___messagesNodes___path = 'disclaimerMessage___parentTopic___messagesNodes___path',
  disclaimerMessage___parentTopic___messagesNodes___product = 'disclaimerMessage___parentTopic___messagesNodes___product',
  disclaimerMessage___parentTopic___messagesNodes___productsNodes = 'disclaimerMessage___parentTopic___messagesNodes___productsNodes',
  disclaimerMessage___parentTopic___messagesNodes___slug = 'disclaimerMessage___parentTopic___messagesNodes___slug',
  disclaimerMessage___parentTopic___messagesNodes___summary = 'disclaimerMessage___parentTopic___messagesNodes___summary',
  disclaimerMessage___parentTopic___messagesNodes___title = 'disclaimerMessage___parentTopic___messagesNodes___title',
  disclaimerMessage___parentTopic___messagesNodes___id = 'disclaimerMessage___parentTopic___messagesNodes___id',
  disclaimerMessage___parentTopic___messagesNodes___children = 'disclaimerMessage___parentTopic___messagesNodes___children',
  disclaimerMessage___parentTopic___metaDescription = 'disclaimerMessage___parentTopic___metaDescription',
  disclaimerMessage___parentTopic___navigationTitle = 'disclaimerMessage___parentTopic___navigationTitle',
  disclaimerMessage___parentTopic___topicDisclaimer = 'disclaimerMessage___parentTopic___topicDisclaimer',
  disclaimerMessage___parentTopic___pageTitle = 'disclaimerMessage___parentTopic___pageTitle',
  disclaimerMessage___parentTopic___pageType = 'disclaimerMessage___parentTopic___pageType',
  disclaimerMessage___parentTopic___path = 'disclaimerMessage___parentTopic___path',
  disclaimerMessage___parentTopic___slug = 'disclaimerMessage___parentTopic___slug',
  disclaimerMessage___parentTopic___summary = 'disclaimerMessage___parentTopic___summary',
  disclaimerMessage___parentTopic___title = 'disclaimerMessage___parentTopic___title',
  disclaimerMessage___parentTopic___traits___traitsStringified = 'disclaimerMessage___parentTopic___traits___traitsStringified',
  disclaimerMessage___parentTopic___id = 'disclaimerMessage___parentTopic___id',
  disclaimerMessage___parentTopic___parent___id = 'disclaimerMessage___parentTopic___parent___id',
  disclaimerMessage___parentTopic___parent___children = 'disclaimerMessage___parentTopic___parent___children',
  disclaimerMessage___parentTopic___children = 'disclaimerMessage___parentTopic___children',
  disclaimerMessage___parentTopic___children___id = 'disclaimerMessage___parentTopic___children___id',
  disclaimerMessage___parentTopic___children___children = 'disclaimerMessage___parentTopic___children___children',
  disclaimerMessage___parentTopic___internal___content = 'disclaimerMessage___parentTopic___internal___content',
  disclaimerMessage___parentTopic___internal___contentDigest = 'disclaimerMessage___parentTopic___internal___contentDigest',
  disclaimerMessage___parentTopic___internal___description = 'disclaimerMessage___parentTopic___internal___description',
  disclaimerMessage___parentTopic___internal___fieldOwners = 'disclaimerMessage___parentTopic___internal___fieldOwners',
  disclaimerMessage___parentTopic___internal___ignoreType = 'disclaimerMessage___parentTopic___internal___ignoreType',
  disclaimerMessage___parentTopic___internal___mediaType = 'disclaimerMessage___parentTopic___internal___mediaType',
  disclaimerMessage___parentTopic___internal___owner = 'disclaimerMessage___parentTopic___internal___owner',
  disclaimerMessage___parentTopic___internal___type = 'disclaimerMessage___parentTopic___internal___type',
  disclaimerMessage___path = 'disclaimerMessage___path',
  disclaimerMessage___product = 'disclaimerMessage___product',
  disclaimerMessage___productsNodes = 'disclaimerMessage___productsNodes',
  disclaimerMessage___productsNodes___absolutePath = 'disclaimerMessage___productsNodes___absolutePath',
  disclaimerMessage___productsNodes___benefits = 'disclaimerMessage___productsNodes___benefits',
  disclaimerMessage___productsNodes___benefitsDisclaimer = 'disclaimerMessage___productsNodes___benefitsDisclaimer',
  disclaimerMessage___productsNodes___description___htmlTruncated = 'disclaimerMessage___productsNodes___description___htmlTruncated',
  disclaimerMessage___productsNodes___description___html = 'disclaimerMessage___productsNodes___description___html',
  disclaimerMessage___productsNodes___description___rawContent = 'disclaimerMessage___productsNodes___description___rawContent',
  disclaimerMessage___productsNodes___description___text = 'disclaimerMessage___productsNodes___description___text',
  disclaimerMessage___productsNodes___hero___description = 'disclaimerMessage___productsNodes___hero___description',
  disclaimerMessage___productsNodes___hero___title = 'disclaimerMessage___productsNodes___hero___title',
  disclaimerMessage___productsNodes___howToUse___html = 'disclaimerMessage___productsNodes___howToUse___html',
  disclaimerMessage___productsNodes___howToUse___json = 'disclaimerMessage___productsNodes___howToUse___json',
  disclaimerMessage___productsNodes___howToUse___text = 'disclaimerMessage___productsNodes___howToUse___text',
  disclaimerMessage___productsNodes___main___htmlTruncated = 'disclaimerMessage___productsNodes___main___htmlTruncated',
  disclaimerMessage___productsNodes___main___html = 'disclaimerMessage___productsNodes___main___html',
  disclaimerMessage___productsNodes___main___rawContent = 'disclaimerMessage___productsNodes___main___rawContent',
  disclaimerMessage___productsNodes___main___text = 'disclaimerMessage___productsNodes___main___text',
  disclaimerMessage___productsNodes___metaDescription = 'disclaimerMessage___productsNodes___metaDescription',
  disclaimerMessage___productsNodes___name = 'disclaimerMessage___productsNodes___name',
  disclaimerMessage___productsNodes___pageTitle = 'disclaimerMessage___productsNodes___pageTitle',
  disclaimerMessage___productsNodes___pageType = 'disclaimerMessage___productsNodes___pageType',
  disclaimerMessage___productsNodes___parentMessage___absolutePath = 'disclaimerMessage___productsNodes___parentMessage___absolutePath',
  disclaimerMessage___productsNodes___parentMessage___benefitImages = 'disclaimerMessage___productsNodes___parentMessage___benefitImages',
  disclaimerMessage___productsNodes___parentMessage___benefits = 'disclaimerMessage___productsNodes___parentMessage___benefits',
  disclaimerMessage___productsNodes___parentMessage___benefitsDisclaimer = 'disclaimerMessage___productsNodes___parentMessage___benefitsDisclaimer',
  disclaimerMessage___productsNodes___parentMessage___certificate = 'disclaimerMessage___productsNodes___parentMessage___certificate',
  disclaimerMessage___productsNodes___parentMessage___facts = 'disclaimerMessage___productsNodes___parentMessage___facts',
  disclaimerMessage___productsNodes___parentMessage___metaDescription = 'disclaimerMessage___productsNodes___parentMessage___metaDescription',
  disclaimerMessage___productsNodes___parentMessage___pageTitle = 'disclaimerMessage___productsNodes___parentMessage___pageTitle',
  disclaimerMessage___productsNodes___parentMessage___pageType = 'disclaimerMessage___productsNodes___parentMessage___pageType',
  disclaimerMessage___productsNodes___parentMessage___path = 'disclaimerMessage___productsNodes___parentMessage___path',
  disclaimerMessage___productsNodes___parentMessage___product = 'disclaimerMessage___productsNodes___parentMessage___product',
  disclaimerMessage___productsNodes___parentMessage___productsNodes = 'disclaimerMessage___productsNodes___parentMessage___productsNodes',
  disclaimerMessage___productsNodes___parentMessage___slug = 'disclaimerMessage___productsNodes___parentMessage___slug',
  disclaimerMessage___productsNodes___parentMessage___summary = 'disclaimerMessage___productsNodes___parentMessage___summary',
  disclaimerMessage___productsNodes___parentMessage___title = 'disclaimerMessage___productsNodes___parentMessage___title',
  disclaimerMessage___productsNodes___parentMessage___id = 'disclaimerMessage___productsNodes___parentMessage___id',
  disclaimerMessage___productsNodes___parentMessage___children = 'disclaimerMessage___productsNodes___parentMessage___children',
  disclaimerMessage___productsNodes___path = 'disclaimerMessage___productsNodes___path',
  disclaimerMessage___productsNodes___slug = 'disclaimerMessage___productsNodes___slug',
  disclaimerMessage___productsNodes___summaryBackground___description = 'disclaimerMessage___productsNodes___summaryBackground___description',
  disclaimerMessage___productsNodes___summaryBackground___title = 'disclaimerMessage___productsNodes___summaryBackground___title',
  disclaimerMessage___productsNodes___traits___traitsStringified = 'disclaimerMessage___productsNodes___traits___traitsStringified',
  disclaimerMessage___productsNodes___variants = 'disclaimerMessage___productsNodes___variants',
  disclaimerMessage___productsNodes___variants___buyItNowUrl = 'disclaimerMessage___productsNodes___variants___buyItNowUrl',
  disclaimerMessage___productsNodes___variants___name = 'disclaimerMessage___productsNodes___variants___name',
  disclaimerMessage___productsNodes___variants___product = 'disclaimerMessage___productsNodes___variants___product',
  disclaimerMessage___productsNodes___variants___sizes = 'disclaimerMessage___productsNodes___variants___sizes',
  disclaimerMessage___productsNodes___id = 'disclaimerMessage___productsNodes___id',
  disclaimerMessage___productsNodes___parent___id = 'disclaimerMessage___productsNodes___parent___id',
  disclaimerMessage___productsNodes___parent___children = 'disclaimerMessage___productsNodes___parent___children',
  disclaimerMessage___productsNodes___children = 'disclaimerMessage___productsNodes___children',
  disclaimerMessage___productsNodes___children___id = 'disclaimerMessage___productsNodes___children___id',
  disclaimerMessage___productsNodes___children___children = 'disclaimerMessage___productsNodes___children___children',
  disclaimerMessage___productsNodes___internal___content = 'disclaimerMessage___productsNodes___internal___content',
  disclaimerMessage___productsNodes___internal___contentDigest = 'disclaimerMessage___productsNodes___internal___contentDigest',
  disclaimerMessage___productsNodes___internal___description = 'disclaimerMessage___productsNodes___internal___description',
  disclaimerMessage___productsNodes___internal___fieldOwners = 'disclaimerMessage___productsNodes___internal___fieldOwners',
  disclaimerMessage___productsNodes___internal___ignoreType = 'disclaimerMessage___productsNodes___internal___ignoreType',
  disclaimerMessage___productsNodes___internal___mediaType = 'disclaimerMessage___productsNodes___internal___mediaType',
  disclaimerMessage___productsNodes___internal___owner = 'disclaimerMessage___productsNodes___internal___owner',
  disclaimerMessage___productsNodes___internal___type = 'disclaimerMessage___productsNodes___internal___type',
  disclaimerMessage___slug = 'disclaimerMessage___slug',
  disclaimerMessage___summary = 'disclaimerMessage___summary',
  disclaimerMessage___summaryBackground___description = 'disclaimerMessage___summaryBackground___description',
  disclaimerMessage___summaryBackground___file___url = 'disclaimerMessage___summaryBackground___file___url',
  disclaimerMessage___summaryBackground___title = 'disclaimerMessage___summaryBackground___title',
  disclaimerMessage___teaserImage___description = 'disclaimerMessage___teaserImage___description',
  disclaimerMessage___teaserImage___file___url = 'disclaimerMessage___teaserImage___file___url',
  disclaimerMessage___teaserImage___title = 'disclaimerMessage___teaserImage___title',
  disclaimerMessage___territoryWidget___bottomGraphic___description = 'disclaimerMessage___territoryWidget___bottomGraphic___description',
  disclaimerMessage___territoryWidget___bottomGraphic___title = 'disclaimerMessage___territoryWidget___bottomGraphic___title',
  disclaimerMessage___territoryWidget___bottomHeading = 'disclaimerMessage___territoryWidget___bottomHeading',
  disclaimerMessage___territoryWidget___graphicHeading = 'disclaimerMessage___territoryWidget___graphicHeading',
  disclaimerMessage___territoryWidget___topCopy = 'disclaimerMessage___territoryWidget___topCopy',
  disclaimerMessage___territoryWidget___topHeading = 'disclaimerMessage___territoryWidget___topHeading',
  disclaimerMessage___territoryWidget___topHeroImage___description = 'disclaimerMessage___territoryWidget___topHeroImage___description',
  disclaimerMessage___territoryWidget___topHeroImage___title = 'disclaimerMessage___territoryWidget___topHeroImage___title',
  disclaimerMessage___territoryWidget___topLeftHeadingImage___description = 'disclaimerMessage___territoryWidget___topLeftHeadingImage___description',
  disclaimerMessage___territoryWidget___topLeftHeadingImage___title = 'disclaimerMessage___territoryWidget___topLeftHeadingImage___title',
  disclaimerMessage___title = 'disclaimerMessage___title',
  disclaimerMessage___traits___traitsStringified = 'disclaimerMessage___traits___traitsStringified',
  disclaimerMessage___video___description = 'disclaimerMessage___video___description',
  disclaimerMessage___video___file___url = 'disclaimerMessage___video___file___url',
  disclaimerMessage___video___title = 'disclaimerMessage___video___title',
  disclaimerMessage___id = 'disclaimerMessage___id',
  disclaimerMessage___parent___id = 'disclaimerMessage___parent___id',
  disclaimerMessage___parent___parent___id = 'disclaimerMessage___parent___parent___id',
  disclaimerMessage___parent___parent___children = 'disclaimerMessage___parent___parent___children',
  disclaimerMessage___parent___children = 'disclaimerMessage___parent___children',
  disclaimerMessage___parent___children___id = 'disclaimerMessage___parent___children___id',
  disclaimerMessage___parent___children___children = 'disclaimerMessage___parent___children___children',
  disclaimerMessage___parent___internal___content = 'disclaimerMessage___parent___internal___content',
  disclaimerMessage___parent___internal___contentDigest = 'disclaimerMessage___parent___internal___contentDigest',
  disclaimerMessage___parent___internal___description = 'disclaimerMessage___parent___internal___description',
  disclaimerMessage___parent___internal___fieldOwners = 'disclaimerMessage___parent___internal___fieldOwners',
  disclaimerMessage___parent___internal___ignoreType = 'disclaimerMessage___parent___internal___ignoreType',
  disclaimerMessage___parent___internal___mediaType = 'disclaimerMessage___parent___internal___mediaType',
  disclaimerMessage___parent___internal___owner = 'disclaimerMessage___parent___internal___owner',
  disclaimerMessage___parent___internal___type = 'disclaimerMessage___parent___internal___type',
  disclaimerMessage___children = 'disclaimerMessage___children',
  disclaimerMessage___children___id = 'disclaimerMessage___children___id',
  disclaimerMessage___children___parent___id = 'disclaimerMessage___children___parent___id',
  disclaimerMessage___children___parent___children = 'disclaimerMessage___children___parent___children',
  disclaimerMessage___children___children = 'disclaimerMessage___children___children',
  disclaimerMessage___children___children___id = 'disclaimerMessage___children___children___id',
  disclaimerMessage___children___children___children = 'disclaimerMessage___children___children___children',
  disclaimerMessage___children___internal___content = 'disclaimerMessage___children___internal___content',
  disclaimerMessage___children___internal___contentDigest = 'disclaimerMessage___children___internal___contentDigest',
  disclaimerMessage___children___internal___description = 'disclaimerMessage___children___internal___description',
  disclaimerMessage___children___internal___fieldOwners = 'disclaimerMessage___children___internal___fieldOwners',
  disclaimerMessage___children___internal___ignoreType = 'disclaimerMessage___children___internal___ignoreType',
  disclaimerMessage___children___internal___mediaType = 'disclaimerMessage___children___internal___mediaType',
  disclaimerMessage___children___internal___owner = 'disclaimerMessage___children___internal___owner',
  disclaimerMessage___children___internal___type = 'disclaimerMessage___children___internal___type',
  disclaimerMessage___internal___content = 'disclaimerMessage___internal___content',
  disclaimerMessage___internal___contentDigest = 'disclaimerMessage___internal___contentDigest',
  disclaimerMessage___internal___description = 'disclaimerMessage___internal___description',
  disclaimerMessage___internal___fieldOwners = 'disclaimerMessage___internal___fieldOwners',
  disclaimerMessage___internal___ignoreType = 'disclaimerMessage___internal___ignoreType',
  disclaimerMessage___internal___mediaType = 'disclaimerMessage___internal___mediaType',
  disclaimerMessage___internal___owner = 'disclaimerMessage___internal___owner',
  disclaimerMessage___internal___type = 'disclaimerMessage___internal___type',
  domain___adChoicesConfig = 'domain___adChoicesConfig',
  domain___adobeConfig___account = 'domain___adobeConfig___account',
  domain___adobeConfig___containerId = 'domain___adobeConfig___containerId',
  domain___adobeConfig___language = 'domain___adobeConfig___language',
  domain___adobeConfig___region = 'domain___adobeConfig___region',
  domain___adobeConfig___reportSuiteId = 'domain___adobeConfig___reportSuiteId',
  domain___adobeConfig___trackingServer = 'domain___adobeConfig___trackingServer',
  domain___adobeConfig___trackingServerSecure = 'domain___adobeConfig___trackingServerSecure',
  domain___dv360AnalyticsID = 'domain___dv360AnalyticsID',
  domain___hotJarID = 'domain___hotJarID',
  domain___hasVersatag = 'domain___hasVersatag',
  domain___hasVKAnalytics = 'domain___hasVKAnalytics',
  domain___lang = 'domain___lang',
  domain___languages = 'domain___languages',
  domain___languages___locale = 'domain___languages___locale',
  domain___languages___name = 'domain___languages___name',
  domain___languages___path = 'domain___languages___path',
  domain___market = 'domain___market',
  domain___myTargetAnalyticsID = 'domain___myTargetAnalyticsID',
  domain___name = 'domain___name',
  domain___oneTrustAutoBlock = 'domain___oneTrustAutoBlock',
  domain___oneTrustId = 'domain___oneTrustId',
  domain___path = 'domain___path',
  domain___product = 'domain___product',
  domain___yandexId = 'domain___yandexId',
  externalLinks = 'externalLinks',
  externalLinks___id = 'externalLinks___id',
  externalLinks___title = 'externalLinks___title',
  externalLinks___url = 'externalLinks___url',
  faq___absolutePath = 'faq___absolutePath',
  faq___metaDescription = 'faq___metaDescription',
  faq___path = 'faq___path',
  faq___questionsAndAnswers = 'faq___questionsAndAnswers',
  faq___questionsAndAnswers___answer___html = 'faq___questionsAndAnswers___answer___html',
  faq___questionsAndAnswers___answer___json = 'faq___questionsAndAnswers___answer___json',
  faq___questionsAndAnswers___answer___text = 'faq___questionsAndAnswers___answer___text',
  faq___questionsAndAnswers___question = 'faq___questionsAndAnswers___question',
  faq___title = 'faq___title',
  faq___traits___traitsStringified = 'faq___traits___traitsStringified',
  faq___id = 'faq___id',
  faq___parent___id = 'faq___parent___id',
  faq___parent___parent___id = 'faq___parent___parent___id',
  faq___parent___parent___children = 'faq___parent___parent___children',
  faq___parent___children = 'faq___parent___children',
  faq___parent___children___id = 'faq___parent___children___id',
  faq___parent___children___children = 'faq___parent___children___children',
  faq___parent___internal___content = 'faq___parent___internal___content',
  faq___parent___internal___contentDigest = 'faq___parent___internal___contentDigest',
  faq___parent___internal___description = 'faq___parent___internal___description',
  faq___parent___internal___fieldOwners = 'faq___parent___internal___fieldOwners',
  faq___parent___internal___ignoreType = 'faq___parent___internal___ignoreType',
  faq___parent___internal___mediaType = 'faq___parent___internal___mediaType',
  faq___parent___internal___owner = 'faq___parent___internal___owner',
  faq___parent___internal___type = 'faq___parent___internal___type',
  faq___children = 'faq___children',
  faq___children___id = 'faq___children___id',
  faq___children___parent___id = 'faq___children___parent___id',
  faq___children___parent___children = 'faq___children___parent___children',
  faq___children___children = 'faq___children___children',
  faq___children___children___id = 'faq___children___children___id',
  faq___children___children___children = 'faq___children___children___children',
  faq___children___internal___content = 'faq___children___internal___content',
  faq___children___internal___contentDigest = 'faq___children___internal___contentDigest',
  faq___children___internal___description = 'faq___children___internal___description',
  faq___children___internal___fieldOwners = 'faq___children___internal___fieldOwners',
  faq___children___internal___ignoreType = 'faq___children___internal___ignoreType',
  faq___children___internal___mediaType = 'faq___children___internal___mediaType',
  faq___children___internal___owner = 'faq___children___internal___owner',
  faq___children___internal___type = 'faq___children___internal___type',
  faq___internal___content = 'faq___internal___content',
  faq___internal___contentDigest = 'faq___internal___contentDigest',
  faq___internal___description = 'faq___internal___description',
  faq___internal___fieldOwners = 'faq___internal___fieldOwners',
  faq___internal___ignoreType = 'faq___internal___ignoreType',
  faq___internal___mediaType = 'faq___internal___mediaType',
  faq___internal___owner = 'faq___internal___owner',
  faq___internal___type = 'faq___internal___type',
  legals___additionalMessages = 'legals___additionalMessages',
  legals___additionalMessages___absolutePath = 'legals___additionalMessages___absolutePath',
  legals___additionalMessages___benefitImages = 'legals___additionalMessages___benefitImages',
  legals___additionalMessages___benefitImages___description = 'legals___additionalMessages___benefitImages___description',
  legals___additionalMessages___benefits = 'legals___additionalMessages___benefits',
  legals___additionalMessages___benefitsDisclaimer = 'legals___additionalMessages___benefitsDisclaimer',
  legals___additionalMessages___certificate = 'legals___additionalMessages___certificate',
  legals___additionalMessages___certificate___title = 'legals___additionalMessages___certificate___title',
  legals___additionalMessages___certificate___url = 'legals___additionalMessages___certificate___url',
  legals___additionalMessages___facts = 'legals___additionalMessages___facts',
  legals___additionalMessages___facts___summary = 'legals___additionalMessages___facts___summary',
  legals___additionalMessages___facts___title = 'legals___additionalMessages___facts___title',
  legals___additionalMessages___hero___description = 'legals___additionalMessages___hero___description',
  legals___additionalMessages___hero___title = 'legals___additionalMessages___hero___title',
  legals___additionalMessages___heroVideo___description = 'legals___additionalMessages___heroVideo___description',
  legals___additionalMessages___heroVideo___title = 'legals___additionalMessages___heroVideo___title',
  legals___additionalMessages___main___htmlTruncated = 'legals___additionalMessages___main___htmlTruncated',
  legals___additionalMessages___main___html = 'legals___additionalMessages___main___html',
  legals___additionalMessages___main___rawContent = 'legals___additionalMessages___main___rawContent',
  legals___additionalMessages___main___text = 'legals___additionalMessages___main___text',
  legals___additionalMessages___metaDescription = 'legals___additionalMessages___metaDescription',
  legals___additionalMessages___pageTitle = 'legals___additionalMessages___pageTitle',
  legals___additionalMessages___pageType = 'legals___additionalMessages___pageType',
  legals___additionalMessages___parentTopic___absolutePath = 'legals___additionalMessages___parentTopic___absolutePath',
  legals___additionalMessages___parentTopic___messagesNodes = 'legals___additionalMessages___parentTopic___messagesNodes',
  legals___additionalMessages___parentTopic___metaDescription = 'legals___additionalMessages___parentTopic___metaDescription',
  legals___additionalMessages___parentTopic___navigationTitle = 'legals___additionalMessages___parentTopic___navigationTitle',
  legals___additionalMessages___parentTopic___topicDisclaimer = 'legals___additionalMessages___parentTopic___topicDisclaimer',
  legals___additionalMessages___parentTopic___pageTitle = 'legals___additionalMessages___parentTopic___pageTitle',
  legals___additionalMessages___parentTopic___pageType = 'legals___additionalMessages___parentTopic___pageType',
  legals___additionalMessages___parentTopic___path = 'legals___additionalMessages___parentTopic___path',
  legals___additionalMessages___parentTopic___slug = 'legals___additionalMessages___parentTopic___slug',
  legals___additionalMessages___parentTopic___summary = 'legals___additionalMessages___parentTopic___summary',
  legals___additionalMessages___parentTopic___title = 'legals___additionalMessages___parentTopic___title',
  legals___additionalMessages___parentTopic___id = 'legals___additionalMessages___parentTopic___id',
  legals___additionalMessages___parentTopic___children = 'legals___additionalMessages___parentTopic___children',
  legals___additionalMessages___path = 'legals___additionalMessages___path',
  legals___additionalMessages___product = 'legals___additionalMessages___product',
  legals___additionalMessages___productsNodes = 'legals___additionalMessages___productsNodes',
  legals___additionalMessages___productsNodes___absolutePath = 'legals___additionalMessages___productsNodes___absolutePath',
  legals___additionalMessages___productsNodes___benefits = 'legals___additionalMessages___productsNodes___benefits',
  legals___additionalMessages___productsNodes___benefitsDisclaimer = 'legals___additionalMessages___productsNodes___benefitsDisclaimer',
  legals___additionalMessages___productsNodes___metaDescription = 'legals___additionalMessages___productsNodes___metaDescription',
  legals___additionalMessages___productsNodes___name = 'legals___additionalMessages___productsNodes___name',
  legals___additionalMessages___productsNodes___pageTitle = 'legals___additionalMessages___productsNodes___pageTitle',
  legals___additionalMessages___productsNodes___pageType = 'legals___additionalMessages___productsNodes___pageType',
  legals___additionalMessages___productsNodes___path = 'legals___additionalMessages___productsNodes___path',
  legals___additionalMessages___productsNodes___slug = 'legals___additionalMessages___productsNodes___slug',
  legals___additionalMessages___productsNodes___variants = 'legals___additionalMessages___productsNodes___variants',
  legals___additionalMessages___productsNodes___id = 'legals___additionalMessages___productsNodes___id',
  legals___additionalMessages___productsNodes___children = 'legals___additionalMessages___productsNodes___children',
  legals___additionalMessages___slug = 'legals___additionalMessages___slug',
  legals___additionalMessages___summary = 'legals___additionalMessages___summary',
  legals___additionalMessages___summaryBackground___description = 'legals___additionalMessages___summaryBackground___description',
  legals___additionalMessages___summaryBackground___title = 'legals___additionalMessages___summaryBackground___title',
  legals___additionalMessages___teaserImage___description = 'legals___additionalMessages___teaserImage___description',
  legals___additionalMessages___teaserImage___title = 'legals___additionalMessages___teaserImage___title',
  legals___additionalMessages___territoryWidget___bottomHeading = 'legals___additionalMessages___territoryWidget___bottomHeading',
  legals___additionalMessages___territoryWidget___graphicHeading = 'legals___additionalMessages___territoryWidget___graphicHeading',
  legals___additionalMessages___territoryWidget___topCopy = 'legals___additionalMessages___territoryWidget___topCopy',
  legals___additionalMessages___territoryWidget___topHeading = 'legals___additionalMessages___territoryWidget___topHeading',
  legals___additionalMessages___title = 'legals___additionalMessages___title',
  legals___additionalMessages___traits___traitsStringified = 'legals___additionalMessages___traits___traitsStringified',
  legals___additionalMessages___video___description = 'legals___additionalMessages___video___description',
  legals___additionalMessages___video___title = 'legals___additionalMessages___video___title',
  legals___additionalMessages___id = 'legals___additionalMessages___id',
  legals___additionalMessages___parent___id = 'legals___additionalMessages___parent___id',
  legals___additionalMessages___parent___children = 'legals___additionalMessages___parent___children',
  legals___additionalMessages___children = 'legals___additionalMessages___children',
  legals___additionalMessages___children___id = 'legals___additionalMessages___children___id',
  legals___additionalMessages___children___children = 'legals___additionalMessages___children___children',
  legals___additionalMessages___internal___content = 'legals___additionalMessages___internal___content',
  legals___additionalMessages___internal___contentDigest = 'legals___additionalMessages___internal___contentDigest',
  legals___additionalMessages___internal___description = 'legals___additionalMessages___internal___description',
  legals___additionalMessages___internal___fieldOwners = 'legals___additionalMessages___internal___fieldOwners',
  legals___additionalMessages___internal___ignoreType = 'legals___additionalMessages___internal___ignoreType',
  legals___additionalMessages___internal___mediaType = 'legals___additionalMessages___internal___mediaType',
  legals___additionalMessages___internal___owner = 'legals___additionalMessages___internal___owner',
  legals___additionalMessages___internal___type = 'legals___additionalMessages___internal___type',
  legals___blurb___html = 'legals___blurb___html',
  legals___blurb___json = 'legals___blurb___json',
  legals___blurb___text = 'legals___blurb___text',
  legals___contactUsLabel = 'legals___contactUsLabel',
  legals___contactUsUrl = 'legals___contactUsUrl',
  legals___cookieNoticeLabel = 'legals___cookieNoticeLabel',
  legals___cookieNoticeUrl = 'legals___cookieNoticeUrl',
  legals___legalWarningLabel = 'legals___legalWarningLabel',
  legals___legalWarningUrl = 'legals___legalWarningUrl',
  legals___privacyNoticeLabel = 'legals___privacyNoticeLabel',
  legals___privacyNoticeUrl = 'legals___privacyNoticeUrl',
  legals___protectionOfPersonalDataLabel = 'legals___protectionOfPersonalDataLabel',
  legals___protectionOfPersonalDataUrl = 'legals___protectionOfPersonalDataUrl',
  legals___termsOfUseLabel = 'legals___termsOfUseLabel',
  legals___termsOfUseUrl = 'legals___termsOfUseUrl',
  legals___whatsInOurProductsLabel = 'legals___whatsInOurProductsLabel',
  legals___whatsInOurProductsUrl = 'legals___whatsInOurProductsUrl',
  lexicon___benefits = 'lexicon___benefits',
  lexicon___buyItNow = 'lexicon___buyItNow',
  lexicon___certificates = 'lexicon___certificates',
  lexicon___description = 'lexicon___description',
  lexicon___facts = 'lexicon___facts',
  lexicon___home = 'lexicon___home',
  lexicon___howToUseHeading = 'lexicon___howToUseHeading',
  lexicon___ingredients = 'lexicon___ingredients',
  lexicon___opensInNewTab = 'lexicon___opensInNewTab',
  lexicon___pageNotFoundText = 'lexicon___pageNotFoundText',
  lexicon___products = 'lexicon___products',
  lexicon___ratingFormatString = 'lexicon___ratingFormatString',
  lexicon___readMore = 'lexicon___readMore',
  lexicon___reviewCountFormatString = 'lexicon___reviewCountFormatString',
  lexicon___reviewsHeading = 'lexicon___reviewsHeading',
  lexicon___share = 'lexicon___share',
  lexicon___skipToContent = 'lexicon___skipToContent',
  lexicon___socialTitle = 'lexicon___socialTitle',
  messagesNodes = 'messagesNodes',
  messagesNodes___absolutePath = 'messagesNodes___absolutePath',
  messagesNodes___benefitImages = 'messagesNodes___benefitImages',
  messagesNodes___benefitImages___description = 'messagesNodes___benefitImages___description',
  messagesNodes___benefitImages___file___url = 'messagesNodes___benefitImages___file___url',
  messagesNodes___benefits = 'messagesNodes___benefits',
  messagesNodes___benefitsDisclaimer = 'messagesNodes___benefitsDisclaimer',
  messagesNodes___certificate = 'messagesNodes___certificate',
  messagesNodes___certificate___image___description = 'messagesNodes___certificate___image___description',
  messagesNodes___certificate___image___title = 'messagesNodes___certificate___image___title',
  messagesNodes___certificate___title = 'messagesNodes___certificate___title',
  messagesNodes___certificate___url = 'messagesNodes___certificate___url',
  messagesNodes___facts = 'messagesNodes___facts',
  messagesNodes___facts___image___description = 'messagesNodes___facts___image___description',
  messagesNodes___facts___image___title = 'messagesNodes___facts___image___title',
  messagesNodes___facts___summary = 'messagesNodes___facts___summary',
  messagesNodes___facts___title = 'messagesNodes___facts___title',
  messagesNodes___hero___description = 'messagesNodes___hero___description',
  messagesNodes___hero___file___url = 'messagesNodes___hero___file___url',
  messagesNodes___hero___title = 'messagesNodes___hero___title',
  messagesNodes___heroVideo___description = 'messagesNodes___heroVideo___description',
  messagesNodes___heroVideo___file___url = 'messagesNodes___heroVideo___file___url',
  messagesNodes___heroVideo___title = 'messagesNodes___heroVideo___title',
  messagesNodes___main___htmlTruncated = 'messagesNodes___main___htmlTruncated',
  messagesNodes___main___html = 'messagesNodes___main___html',
  messagesNodes___main___rawContent = 'messagesNodes___main___rawContent',
  messagesNodes___main___text = 'messagesNodes___main___text',
  messagesNodes___metaDescription = 'messagesNodes___metaDescription',
  messagesNodes___pageTitle = 'messagesNodes___pageTitle',
  messagesNodes___pageType = 'messagesNodes___pageType',
  messagesNodes___parentTopic___absolutePath = 'messagesNodes___parentTopic___absolutePath',
  messagesNodes___parentTopic___hero___description = 'messagesNodes___parentTopic___hero___description',
  messagesNodes___parentTopic___hero___title = 'messagesNodes___parentTopic___hero___title',
  messagesNodes___parentTopic___messagesNodes = 'messagesNodes___parentTopic___messagesNodes',
  messagesNodes___parentTopic___messagesNodes___absolutePath = 'messagesNodes___parentTopic___messagesNodes___absolutePath',
  messagesNodes___parentTopic___messagesNodes___benefitImages = 'messagesNodes___parentTopic___messagesNodes___benefitImages',
  messagesNodes___parentTopic___messagesNodes___benefits = 'messagesNodes___parentTopic___messagesNodes___benefits',
  messagesNodes___parentTopic___messagesNodes___benefitsDisclaimer = 'messagesNodes___parentTopic___messagesNodes___benefitsDisclaimer',
  messagesNodes___parentTopic___messagesNodes___certificate = 'messagesNodes___parentTopic___messagesNodes___certificate',
  messagesNodes___parentTopic___messagesNodes___facts = 'messagesNodes___parentTopic___messagesNodes___facts',
  messagesNodes___parentTopic___messagesNodes___metaDescription = 'messagesNodes___parentTopic___messagesNodes___metaDescription',
  messagesNodes___parentTopic___messagesNodes___pageTitle = 'messagesNodes___parentTopic___messagesNodes___pageTitle',
  messagesNodes___parentTopic___messagesNodes___pageType = 'messagesNodes___parentTopic___messagesNodes___pageType',
  messagesNodes___parentTopic___messagesNodes___path = 'messagesNodes___parentTopic___messagesNodes___path',
  messagesNodes___parentTopic___messagesNodes___product = 'messagesNodes___parentTopic___messagesNodes___product',
  messagesNodes___parentTopic___messagesNodes___productsNodes = 'messagesNodes___parentTopic___messagesNodes___productsNodes',
  messagesNodes___parentTopic___messagesNodes___slug = 'messagesNodes___parentTopic___messagesNodes___slug',
  messagesNodes___parentTopic___messagesNodes___summary = 'messagesNodes___parentTopic___messagesNodes___summary',
  messagesNodes___parentTopic___messagesNodes___title = 'messagesNodes___parentTopic___messagesNodes___title',
  messagesNodes___parentTopic___messagesNodes___id = 'messagesNodes___parentTopic___messagesNodes___id',
  messagesNodes___parentTopic___messagesNodes___children = 'messagesNodes___parentTopic___messagesNodes___children',
  messagesNodes___parentTopic___metaDescription = 'messagesNodes___parentTopic___metaDescription',
  messagesNodes___parentTopic___navigationTitle = 'messagesNodes___parentTopic___navigationTitle',
  messagesNodes___parentTopic___topicDisclaimer = 'messagesNodes___parentTopic___topicDisclaimer',
  messagesNodes___parentTopic___pageTitle = 'messagesNodes___parentTopic___pageTitle',
  messagesNodes___parentTopic___pageType = 'messagesNodes___parentTopic___pageType',
  messagesNodes___parentTopic___path = 'messagesNodes___parentTopic___path',
  messagesNodes___parentTopic___slug = 'messagesNodes___parentTopic___slug',
  messagesNodes___parentTopic___summary = 'messagesNodes___parentTopic___summary',
  messagesNodes___parentTopic___title = 'messagesNodes___parentTopic___title',
  messagesNodes___parentTopic___traits___traitsStringified = 'messagesNodes___parentTopic___traits___traitsStringified',
  messagesNodes___parentTopic___id = 'messagesNodes___parentTopic___id',
  messagesNodes___parentTopic___parent___id = 'messagesNodes___parentTopic___parent___id',
  messagesNodes___parentTopic___parent___children = 'messagesNodes___parentTopic___parent___children',
  messagesNodes___parentTopic___children = 'messagesNodes___parentTopic___children',
  messagesNodes___parentTopic___children___id = 'messagesNodes___parentTopic___children___id',
  messagesNodes___parentTopic___children___children = 'messagesNodes___parentTopic___children___children',
  messagesNodes___parentTopic___internal___content = 'messagesNodes___parentTopic___internal___content',
  messagesNodes___parentTopic___internal___contentDigest = 'messagesNodes___parentTopic___internal___contentDigest',
  messagesNodes___parentTopic___internal___description = 'messagesNodes___parentTopic___internal___description',
  messagesNodes___parentTopic___internal___fieldOwners = 'messagesNodes___parentTopic___internal___fieldOwners',
  messagesNodes___parentTopic___internal___ignoreType = 'messagesNodes___parentTopic___internal___ignoreType',
  messagesNodes___parentTopic___internal___mediaType = 'messagesNodes___parentTopic___internal___mediaType',
  messagesNodes___parentTopic___internal___owner = 'messagesNodes___parentTopic___internal___owner',
  messagesNodes___parentTopic___internal___type = 'messagesNodes___parentTopic___internal___type',
  messagesNodes___path = 'messagesNodes___path',
  messagesNodes___product = 'messagesNodes___product',
  messagesNodes___productsNodes = 'messagesNodes___productsNodes',
  messagesNodes___productsNodes___absolutePath = 'messagesNodes___productsNodes___absolutePath',
  messagesNodes___productsNodes___benefits = 'messagesNodes___productsNodes___benefits',
  messagesNodes___productsNodes___benefitsDisclaimer = 'messagesNodes___productsNodes___benefitsDisclaimer',
  messagesNodes___productsNodes___description___htmlTruncated = 'messagesNodes___productsNodes___description___htmlTruncated',
  messagesNodes___productsNodes___description___html = 'messagesNodes___productsNodes___description___html',
  messagesNodes___productsNodes___description___rawContent = 'messagesNodes___productsNodes___description___rawContent',
  messagesNodes___productsNodes___description___text = 'messagesNodes___productsNodes___description___text',
  messagesNodes___productsNodes___hero___description = 'messagesNodes___productsNodes___hero___description',
  messagesNodes___productsNodes___hero___title = 'messagesNodes___productsNodes___hero___title',
  messagesNodes___productsNodes___howToUse___html = 'messagesNodes___productsNodes___howToUse___html',
  messagesNodes___productsNodes___howToUse___json = 'messagesNodes___productsNodes___howToUse___json',
  messagesNodes___productsNodes___howToUse___text = 'messagesNodes___productsNodes___howToUse___text',
  messagesNodes___productsNodes___main___htmlTruncated = 'messagesNodes___productsNodes___main___htmlTruncated',
  messagesNodes___productsNodes___main___html = 'messagesNodes___productsNodes___main___html',
  messagesNodes___productsNodes___main___rawContent = 'messagesNodes___productsNodes___main___rawContent',
  messagesNodes___productsNodes___main___text = 'messagesNodes___productsNodes___main___text',
  messagesNodes___productsNodes___metaDescription = 'messagesNodes___productsNodes___metaDescription',
  messagesNodes___productsNodes___name = 'messagesNodes___productsNodes___name',
  messagesNodes___productsNodes___pageTitle = 'messagesNodes___productsNodes___pageTitle',
  messagesNodes___productsNodes___pageType = 'messagesNodes___productsNodes___pageType',
  messagesNodes___productsNodes___parentMessage___absolutePath = 'messagesNodes___productsNodes___parentMessage___absolutePath',
  messagesNodes___productsNodes___parentMessage___benefitImages = 'messagesNodes___productsNodes___parentMessage___benefitImages',
  messagesNodes___productsNodes___parentMessage___benefits = 'messagesNodes___productsNodes___parentMessage___benefits',
  messagesNodes___productsNodes___parentMessage___benefitsDisclaimer = 'messagesNodes___productsNodes___parentMessage___benefitsDisclaimer',
  messagesNodes___productsNodes___parentMessage___certificate = 'messagesNodes___productsNodes___parentMessage___certificate',
  messagesNodes___productsNodes___parentMessage___facts = 'messagesNodes___productsNodes___parentMessage___facts',
  messagesNodes___productsNodes___parentMessage___metaDescription = 'messagesNodes___productsNodes___parentMessage___metaDescription',
  messagesNodes___productsNodes___parentMessage___pageTitle = 'messagesNodes___productsNodes___parentMessage___pageTitle',
  messagesNodes___productsNodes___parentMessage___pageType = 'messagesNodes___productsNodes___parentMessage___pageType',
  messagesNodes___productsNodes___parentMessage___path = 'messagesNodes___productsNodes___parentMessage___path',
  messagesNodes___productsNodes___parentMessage___product = 'messagesNodes___productsNodes___parentMessage___product',
  messagesNodes___productsNodes___parentMessage___productsNodes = 'messagesNodes___productsNodes___parentMessage___productsNodes',
  messagesNodes___productsNodes___parentMessage___slug = 'messagesNodes___productsNodes___parentMessage___slug',
  messagesNodes___productsNodes___parentMessage___summary = 'messagesNodes___productsNodes___parentMessage___summary',
  messagesNodes___productsNodes___parentMessage___title = 'messagesNodes___productsNodes___parentMessage___title',
  messagesNodes___productsNodes___parentMessage___id = 'messagesNodes___productsNodes___parentMessage___id',
  messagesNodes___productsNodes___parentMessage___children = 'messagesNodes___productsNodes___parentMessage___children',
  messagesNodes___productsNodes___path = 'messagesNodes___productsNodes___path',
  messagesNodes___productsNodes___slug = 'messagesNodes___productsNodes___slug',
  messagesNodes___productsNodes___summaryBackground___description = 'messagesNodes___productsNodes___summaryBackground___description',
  messagesNodes___productsNodes___summaryBackground___title = 'messagesNodes___productsNodes___summaryBackground___title',
  messagesNodes___productsNodes___traits___traitsStringified = 'messagesNodes___productsNodes___traits___traitsStringified',
  messagesNodes___productsNodes___variants = 'messagesNodes___productsNodes___variants',
  messagesNodes___productsNodes___variants___buyItNowUrl = 'messagesNodes___productsNodes___variants___buyItNowUrl',
  messagesNodes___productsNodes___variants___name = 'messagesNodes___productsNodes___variants___name',
  messagesNodes___productsNodes___variants___product = 'messagesNodes___productsNodes___variants___product',
  messagesNodes___productsNodes___variants___sizes = 'messagesNodes___productsNodes___variants___sizes',
  messagesNodes___productsNodes___id = 'messagesNodes___productsNodes___id',
  messagesNodes___productsNodes___parent___id = 'messagesNodes___productsNodes___parent___id',
  messagesNodes___productsNodes___parent___children = 'messagesNodes___productsNodes___parent___children',
  messagesNodes___productsNodes___children = 'messagesNodes___productsNodes___children',
  messagesNodes___productsNodes___children___id = 'messagesNodes___productsNodes___children___id',
  messagesNodes___productsNodes___children___children = 'messagesNodes___productsNodes___children___children',
  messagesNodes___productsNodes___internal___content = 'messagesNodes___productsNodes___internal___content',
  messagesNodes___productsNodes___internal___contentDigest = 'messagesNodes___productsNodes___internal___contentDigest',
  messagesNodes___productsNodes___internal___description = 'messagesNodes___productsNodes___internal___description',
  messagesNodes___productsNodes___internal___fieldOwners = 'messagesNodes___productsNodes___internal___fieldOwners',
  messagesNodes___productsNodes___internal___ignoreType = 'messagesNodes___productsNodes___internal___ignoreType',
  messagesNodes___productsNodes___internal___mediaType = 'messagesNodes___productsNodes___internal___mediaType',
  messagesNodes___productsNodes___internal___owner = 'messagesNodes___productsNodes___internal___owner',
  messagesNodes___productsNodes___internal___type = 'messagesNodes___productsNodes___internal___type',
  messagesNodes___slug = 'messagesNodes___slug',
  messagesNodes___summary = 'messagesNodes___summary',
  messagesNodes___summaryBackground___description = 'messagesNodes___summaryBackground___description',
  messagesNodes___summaryBackground___file___url = 'messagesNodes___summaryBackground___file___url',
  messagesNodes___summaryBackground___title = 'messagesNodes___summaryBackground___title',
  messagesNodes___teaserImage___description = 'messagesNodes___teaserImage___description',
  messagesNodes___teaserImage___file___url = 'messagesNodes___teaserImage___file___url',
  messagesNodes___teaserImage___title = 'messagesNodes___teaserImage___title',
  messagesNodes___territoryWidget___bottomGraphic___description = 'messagesNodes___territoryWidget___bottomGraphic___description',
  messagesNodes___territoryWidget___bottomGraphic___title = 'messagesNodes___territoryWidget___bottomGraphic___title',
  messagesNodes___territoryWidget___bottomHeading = 'messagesNodes___territoryWidget___bottomHeading',
  messagesNodes___territoryWidget___graphicHeading = 'messagesNodes___territoryWidget___graphicHeading',
  messagesNodes___territoryWidget___topCopy = 'messagesNodes___territoryWidget___topCopy',
  messagesNodes___territoryWidget___topHeading = 'messagesNodes___territoryWidget___topHeading',
  messagesNodes___territoryWidget___topHeroImage___description = 'messagesNodes___territoryWidget___topHeroImage___description',
  messagesNodes___territoryWidget___topHeroImage___title = 'messagesNodes___territoryWidget___topHeroImage___title',
  messagesNodes___territoryWidget___topLeftHeadingImage___description = 'messagesNodes___territoryWidget___topLeftHeadingImage___description',
  messagesNodes___territoryWidget___topLeftHeadingImage___title = 'messagesNodes___territoryWidget___topLeftHeadingImage___title',
  messagesNodes___title = 'messagesNodes___title',
  messagesNodes___traits___traitsStringified = 'messagesNodes___traits___traitsStringified',
  messagesNodes___video___description = 'messagesNodes___video___description',
  messagesNodes___video___file___url = 'messagesNodes___video___file___url',
  messagesNodes___video___title = 'messagesNodes___video___title',
  messagesNodes___id = 'messagesNodes___id',
  messagesNodes___parent___id = 'messagesNodes___parent___id',
  messagesNodes___parent___parent___id = 'messagesNodes___parent___parent___id',
  messagesNodes___parent___parent___children = 'messagesNodes___parent___parent___children',
  messagesNodes___parent___children = 'messagesNodes___parent___children',
  messagesNodes___parent___children___id = 'messagesNodes___parent___children___id',
  messagesNodes___parent___children___children = 'messagesNodes___parent___children___children',
  messagesNodes___parent___internal___content = 'messagesNodes___parent___internal___content',
  messagesNodes___parent___internal___contentDigest = 'messagesNodes___parent___internal___contentDigest',
  messagesNodes___parent___internal___description = 'messagesNodes___parent___internal___description',
  messagesNodes___parent___internal___fieldOwners = 'messagesNodes___parent___internal___fieldOwners',
  messagesNodes___parent___internal___ignoreType = 'messagesNodes___parent___internal___ignoreType',
  messagesNodes___parent___internal___mediaType = 'messagesNodes___parent___internal___mediaType',
  messagesNodes___parent___internal___owner = 'messagesNodes___parent___internal___owner',
  messagesNodes___parent___internal___type = 'messagesNodes___parent___internal___type',
  messagesNodes___children = 'messagesNodes___children',
  messagesNodes___children___id = 'messagesNodes___children___id',
  messagesNodes___children___parent___id = 'messagesNodes___children___parent___id',
  messagesNodes___children___parent___children = 'messagesNodes___children___parent___children',
  messagesNodes___children___children = 'messagesNodes___children___children',
  messagesNodes___children___children___id = 'messagesNodes___children___children___id',
  messagesNodes___children___children___children = 'messagesNodes___children___children___children',
  messagesNodes___children___internal___content = 'messagesNodes___children___internal___content',
  messagesNodes___children___internal___contentDigest = 'messagesNodes___children___internal___contentDigest',
  messagesNodes___children___internal___description = 'messagesNodes___children___internal___description',
  messagesNodes___children___internal___fieldOwners = 'messagesNodes___children___internal___fieldOwners',
  messagesNodes___children___internal___ignoreType = 'messagesNodes___children___internal___ignoreType',
  messagesNodes___children___internal___mediaType = 'messagesNodes___children___internal___mediaType',
  messagesNodes___children___internal___owner = 'messagesNodes___children___internal___owner',
  messagesNodes___children___internal___type = 'messagesNodes___children___internal___type',
  messagesNodes___internal___content = 'messagesNodes___internal___content',
  messagesNodes___internal___contentDigest = 'messagesNodes___internal___contentDigest',
  messagesNodes___internal___description = 'messagesNodes___internal___description',
  messagesNodes___internal___fieldOwners = 'messagesNodes___internal___fieldOwners',
  messagesNodes___internal___ignoreType = 'messagesNodes___internal___ignoreType',
  messagesNodes___internal___mediaType = 'messagesNodes___internal___mediaType',
  messagesNodes___internal___owner = 'messagesNodes___internal___owner',
  messagesNodes___internal___type = 'messagesNodes___internal___type',
  pageType = 'pageType',
  path = 'path',
  product = 'product',
  productsNodes = 'productsNodes',
  productsNodes___absolutePath = 'productsNodes___absolutePath',
  productsNodes___benefits = 'productsNodes___benefits',
  productsNodes___benefitsDisclaimer = 'productsNodes___benefitsDisclaimer',
  productsNodes___description___htmlTruncated = 'productsNodes___description___htmlTruncated',
  productsNodes___description___html = 'productsNodes___description___html',
  productsNodes___description___rawContent = 'productsNodes___description___rawContent',
  productsNodes___description___text = 'productsNodes___description___text',
  productsNodes___hero___description = 'productsNodes___hero___description',
  productsNodes___hero___file___url = 'productsNodes___hero___file___url',
  productsNodes___hero___title = 'productsNodes___hero___title',
  productsNodes___howToUse___html = 'productsNodes___howToUse___html',
  productsNodes___howToUse___json = 'productsNodes___howToUse___json',
  productsNodes___howToUse___text = 'productsNodes___howToUse___text',
  productsNodes___main___htmlTruncated = 'productsNodes___main___htmlTruncated',
  productsNodes___main___html = 'productsNodes___main___html',
  productsNodes___main___rawContent = 'productsNodes___main___rawContent',
  productsNodes___main___text = 'productsNodes___main___text',
  productsNodes___metaDescription = 'productsNodes___metaDescription',
  productsNodes___name = 'productsNodes___name',
  productsNodes___pageTitle = 'productsNodes___pageTitle',
  productsNodes___pageType = 'productsNodes___pageType',
  productsNodes___parentMessage___absolutePath = 'productsNodes___parentMessage___absolutePath',
  productsNodes___parentMessage___benefitImages = 'productsNodes___parentMessage___benefitImages',
  productsNodes___parentMessage___benefitImages___description = 'productsNodes___parentMessage___benefitImages___description',
  productsNodes___parentMessage___benefits = 'productsNodes___parentMessage___benefits',
  productsNodes___parentMessage___benefitsDisclaimer = 'productsNodes___parentMessage___benefitsDisclaimer',
  productsNodes___parentMessage___certificate = 'productsNodes___parentMessage___certificate',
  productsNodes___parentMessage___certificate___title = 'productsNodes___parentMessage___certificate___title',
  productsNodes___parentMessage___certificate___url = 'productsNodes___parentMessage___certificate___url',
  productsNodes___parentMessage___facts = 'productsNodes___parentMessage___facts',
  productsNodes___parentMessage___facts___summary = 'productsNodes___parentMessage___facts___summary',
  productsNodes___parentMessage___facts___title = 'productsNodes___parentMessage___facts___title',
  productsNodes___parentMessage___hero___description = 'productsNodes___parentMessage___hero___description',
  productsNodes___parentMessage___hero___title = 'productsNodes___parentMessage___hero___title',
  productsNodes___parentMessage___heroVideo___description = 'productsNodes___parentMessage___heroVideo___description',
  productsNodes___parentMessage___heroVideo___title = 'productsNodes___parentMessage___heroVideo___title',
  productsNodes___parentMessage___main___htmlTruncated = 'productsNodes___parentMessage___main___htmlTruncated',
  productsNodes___parentMessage___main___html = 'productsNodes___parentMessage___main___html',
  productsNodes___parentMessage___main___rawContent = 'productsNodes___parentMessage___main___rawContent',
  productsNodes___parentMessage___main___text = 'productsNodes___parentMessage___main___text',
  productsNodes___parentMessage___metaDescription = 'productsNodes___parentMessage___metaDescription',
  productsNodes___parentMessage___pageTitle = 'productsNodes___parentMessage___pageTitle',
  productsNodes___parentMessage___pageType = 'productsNodes___parentMessage___pageType',
  productsNodes___parentMessage___parentTopic___absolutePath = 'productsNodes___parentMessage___parentTopic___absolutePath',
  productsNodes___parentMessage___parentTopic___messagesNodes = 'productsNodes___parentMessage___parentTopic___messagesNodes',
  productsNodes___parentMessage___parentTopic___metaDescription = 'productsNodes___parentMessage___parentTopic___metaDescription',
  productsNodes___parentMessage___parentTopic___navigationTitle = 'productsNodes___parentMessage___parentTopic___navigationTitle',
  productsNodes___parentMessage___parentTopic___topicDisclaimer = 'productsNodes___parentMessage___parentTopic___topicDisclaimer',
  productsNodes___parentMessage___parentTopic___pageTitle = 'productsNodes___parentMessage___parentTopic___pageTitle',
  productsNodes___parentMessage___parentTopic___pageType = 'productsNodes___parentMessage___parentTopic___pageType',
  productsNodes___parentMessage___parentTopic___path = 'productsNodes___parentMessage___parentTopic___path',
  productsNodes___parentMessage___parentTopic___slug = 'productsNodes___parentMessage___parentTopic___slug',
  productsNodes___parentMessage___parentTopic___summary = 'productsNodes___parentMessage___parentTopic___summary',
  productsNodes___parentMessage___parentTopic___title = 'productsNodes___parentMessage___parentTopic___title',
  productsNodes___parentMessage___parentTopic___id = 'productsNodes___parentMessage___parentTopic___id',
  productsNodes___parentMessage___parentTopic___children = 'productsNodes___parentMessage___parentTopic___children',
  productsNodes___parentMessage___path = 'productsNodes___parentMessage___path',
  productsNodes___parentMessage___product = 'productsNodes___parentMessage___product',
  productsNodes___parentMessage___productsNodes = 'productsNodes___parentMessage___productsNodes',
  productsNodes___parentMessage___productsNodes___absolutePath = 'productsNodes___parentMessage___productsNodes___absolutePath',
  productsNodes___parentMessage___productsNodes___benefits = 'productsNodes___parentMessage___productsNodes___benefits',
  productsNodes___parentMessage___productsNodes___benefitsDisclaimer = 'productsNodes___parentMessage___productsNodes___benefitsDisclaimer',
  productsNodes___parentMessage___productsNodes___metaDescription = 'productsNodes___parentMessage___productsNodes___metaDescription',
  productsNodes___parentMessage___productsNodes___name = 'productsNodes___parentMessage___productsNodes___name',
  productsNodes___parentMessage___productsNodes___pageTitle = 'productsNodes___parentMessage___productsNodes___pageTitle',
  productsNodes___parentMessage___productsNodes___pageType = 'productsNodes___parentMessage___productsNodes___pageType',
  productsNodes___parentMessage___productsNodes___path = 'productsNodes___parentMessage___productsNodes___path',
  productsNodes___parentMessage___productsNodes___slug = 'productsNodes___parentMessage___productsNodes___slug',
  productsNodes___parentMessage___productsNodes___variants = 'productsNodes___parentMessage___productsNodes___variants',
  productsNodes___parentMessage___productsNodes___id = 'productsNodes___parentMessage___productsNodes___id',
  productsNodes___parentMessage___productsNodes___children = 'productsNodes___parentMessage___productsNodes___children',
  productsNodes___parentMessage___slug = 'productsNodes___parentMessage___slug',
  productsNodes___parentMessage___summary = 'productsNodes___parentMessage___summary',
  productsNodes___parentMessage___summaryBackground___description = 'productsNodes___parentMessage___summaryBackground___description',
  productsNodes___parentMessage___summaryBackground___title = 'productsNodes___parentMessage___summaryBackground___title',
  productsNodes___parentMessage___teaserImage___description = 'productsNodes___parentMessage___teaserImage___description',
  productsNodes___parentMessage___teaserImage___title = 'productsNodes___parentMessage___teaserImage___title',
  productsNodes___parentMessage___territoryWidget___bottomHeading = 'productsNodes___parentMessage___territoryWidget___bottomHeading',
  productsNodes___parentMessage___territoryWidget___graphicHeading = 'productsNodes___parentMessage___territoryWidget___graphicHeading',
  productsNodes___parentMessage___territoryWidget___topCopy = 'productsNodes___parentMessage___territoryWidget___topCopy',
  productsNodes___parentMessage___territoryWidget___topHeading = 'productsNodes___parentMessage___territoryWidget___topHeading',
  productsNodes___parentMessage___title = 'productsNodes___parentMessage___title',
  productsNodes___parentMessage___traits___traitsStringified = 'productsNodes___parentMessage___traits___traitsStringified',
  productsNodes___parentMessage___video___description = 'productsNodes___parentMessage___video___description',
  productsNodes___parentMessage___video___title = 'productsNodes___parentMessage___video___title',
  productsNodes___parentMessage___id = 'productsNodes___parentMessage___id',
  productsNodes___parentMessage___parent___id = 'productsNodes___parentMessage___parent___id',
  productsNodes___parentMessage___parent___children = 'productsNodes___parentMessage___parent___children',
  productsNodes___parentMessage___children = 'productsNodes___parentMessage___children',
  productsNodes___parentMessage___children___id = 'productsNodes___parentMessage___children___id',
  productsNodes___parentMessage___children___children = 'productsNodes___parentMessage___children___children',
  productsNodes___parentMessage___internal___content = 'productsNodes___parentMessage___internal___content',
  productsNodes___parentMessage___internal___contentDigest = 'productsNodes___parentMessage___internal___contentDigest',
  productsNodes___parentMessage___internal___description = 'productsNodes___parentMessage___internal___description',
  productsNodes___parentMessage___internal___fieldOwners = 'productsNodes___parentMessage___internal___fieldOwners',
  productsNodes___parentMessage___internal___ignoreType = 'productsNodes___parentMessage___internal___ignoreType',
  productsNodes___parentMessage___internal___mediaType = 'productsNodes___parentMessage___internal___mediaType',
  productsNodes___parentMessage___internal___owner = 'productsNodes___parentMessage___internal___owner',
  productsNodes___parentMessage___internal___type = 'productsNodes___parentMessage___internal___type',
  productsNodes___path = 'productsNodes___path',
  productsNodes___slug = 'productsNodes___slug',
  productsNodes___summaryBackground___description = 'productsNodes___summaryBackground___description',
  productsNodes___summaryBackground___file___url = 'productsNodes___summaryBackground___file___url',
  productsNodes___summaryBackground___title = 'productsNodes___summaryBackground___title',
  productsNodes___traits___traitsStringified = 'productsNodes___traits___traitsStringified',
  productsNodes___variants = 'productsNodes___variants',
  productsNodes___variants___buyItNowUrl = 'productsNodes___variants___buyItNowUrl',
  productsNodes___variants___ingredientsBlurb___html = 'productsNodes___variants___ingredientsBlurb___html',
  productsNodes___variants___ingredientsBlurb___json = 'productsNodes___variants___ingredientsBlurb___json',
  productsNodes___variants___ingredientsBlurb___text = 'productsNodes___variants___ingredientsBlurb___text',
  productsNodes___variants___name = 'productsNodes___variants___name',
  productsNodes___variants___packshot___description = 'productsNodes___variants___packshot___description',
  productsNodes___variants___packshot___title = 'productsNodes___variants___packshot___title',
  productsNodes___variants___product = 'productsNodes___variants___product',
  productsNodes___variants___sizes = 'productsNodes___variants___sizes',
  productsNodes___fields___kritiqueRating___averageRating = 'productsNodes___fields___kritiqueRating___averageRating',
  productsNodes___fields___kritiqueRating___reviewCount = 'productsNodes___fields___kritiqueRating___reviewCount',
  productsNodes___fields___kritiqueRating___reviews = 'productsNodes___fields___kritiqueRating___reviews',
  productsNodes___id = 'productsNodes___id',
  productsNodes___parent___id = 'productsNodes___parent___id',
  productsNodes___parent___parent___id = 'productsNodes___parent___parent___id',
  productsNodes___parent___parent___children = 'productsNodes___parent___parent___children',
  productsNodes___parent___children = 'productsNodes___parent___children',
  productsNodes___parent___children___id = 'productsNodes___parent___children___id',
  productsNodes___parent___children___children = 'productsNodes___parent___children___children',
  productsNodes___parent___internal___content = 'productsNodes___parent___internal___content',
  productsNodes___parent___internal___contentDigest = 'productsNodes___parent___internal___contentDigest',
  productsNodes___parent___internal___description = 'productsNodes___parent___internal___description',
  productsNodes___parent___internal___fieldOwners = 'productsNodes___parent___internal___fieldOwners',
  productsNodes___parent___internal___ignoreType = 'productsNodes___parent___internal___ignoreType',
  productsNodes___parent___internal___mediaType = 'productsNodes___parent___internal___mediaType',
  productsNodes___parent___internal___owner = 'productsNodes___parent___internal___owner',
  productsNodes___parent___internal___type = 'productsNodes___parent___internal___type',
  productsNodes___children = 'productsNodes___children',
  productsNodes___children___id = 'productsNodes___children___id',
  productsNodes___children___parent___id = 'productsNodes___children___parent___id',
  productsNodes___children___parent___children = 'productsNodes___children___parent___children',
  productsNodes___children___children = 'productsNodes___children___children',
  productsNodes___children___children___id = 'productsNodes___children___children___id',
  productsNodes___children___children___children = 'productsNodes___children___children___children',
  productsNodes___children___internal___content = 'productsNodes___children___internal___content',
  productsNodes___children___internal___contentDigest = 'productsNodes___children___internal___contentDigest',
  productsNodes___children___internal___description = 'productsNodes___children___internal___description',
  productsNodes___children___internal___fieldOwners = 'productsNodes___children___internal___fieldOwners',
  productsNodes___children___internal___ignoreType = 'productsNodes___children___internal___ignoreType',
  productsNodes___children___internal___mediaType = 'productsNodes___children___internal___mediaType',
  productsNodes___children___internal___owner = 'productsNodes___children___internal___owner',
  productsNodes___children___internal___type = 'productsNodes___children___internal___type',
  productsNodes___internal___content = 'productsNodes___internal___content',
  productsNodes___internal___contentDigest = 'productsNodes___internal___contentDigest',
  productsNodes___internal___description = 'productsNodes___internal___description',
  productsNodes___internal___fieldOwners = 'productsNodes___internal___fieldOwners',
  productsNodes___internal___ignoreType = 'productsNodes___internal___ignoreType',
  productsNodes___internal___mediaType = 'productsNodes___internal___mediaType',
  productsNodes___internal___owner = 'productsNodes___internal___owner',
  productsNodes___internal___type = 'productsNodes___internal___type',
  secondaryMessage___absolutePath = 'secondaryMessage___absolutePath',
  secondaryMessage___benefitImages = 'secondaryMessage___benefitImages',
  secondaryMessage___benefitImages___description = 'secondaryMessage___benefitImages___description',
  secondaryMessage___benefitImages___file___url = 'secondaryMessage___benefitImages___file___url',
  secondaryMessage___benefits = 'secondaryMessage___benefits',
  secondaryMessage___benefitsDisclaimer = 'secondaryMessage___benefitsDisclaimer',
  secondaryMessage___certificate = 'secondaryMessage___certificate',
  secondaryMessage___certificate___image___description = 'secondaryMessage___certificate___image___description',
  secondaryMessage___certificate___image___title = 'secondaryMessage___certificate___image___title',
  secondaryMessage___certificate___title = 'secondaryMessage___certificate___title',
  secondaryMessage___certificate___url = 'secondaryMessage___certificate___url',
  secondaryMessage___facts = 'secondaryMessage___facts',
  secondaryMessage___facts___image___description = 'secondaryMessage___facts___image___description',
  secondaryMessage___facts___image___title = 'secondaryMessage___facts___image___title',
  secondaryMessage___facts___summary = 'secondaryMessage___facts___summary',
  secondaryMessage___facts___title = 'secondaryMessage___facts___title',
  secondaryMessage___hero___description = 'secondaryMessage___hero___description',
  secondaryMessage___hero___file___url = 'secondaryMessage___hero___file___url',
  secondaryMessage___hero___title = 'secondaryMessage___hero___title',
  secondaryMessage___heroVideo___description = 'secondaryMessage___heroVideo___description',
  secondaryMessage___heroVideo___file___url = 'secondaryMessage___heroVideo___file___url',
  secondaryMessage___heroVideo___title = 'secondaryMessage___heroVideo___title',
  secondaryMessage___main___htmlTruncated = 'secondaryMessage___main___htmlTruncated',
  secondaryMessage___main___html = 'secondaryMessage___main___html',
  secondaryMessage___main___rawContent = 'secondaryMessage___main___rawContent',
  secondaryMessage___main___text = 'secondaryMessage___main___text',
  secondaryMessage___metaDescription = 'secondaryMessage___metaDescription',
  secondaryMessage___pageTitle = 'secondaryMessage___pageTitle',
  secondaryMessage___pageType = 'secondaryMessage___pageType',
  secondaryMessage___parentTopic___absolutePath = 'secondaryMessage___parentTopic___absolutePath',
  secondaryMessage___parentTopic___hero___description = 'secondaryMessage___parentTopic___hero___description',
  secondaryMessage___parentTopic___hero___title = 'secondaryMessage___parentTopic___hero___title',
  secondaryMessage___parentTopic___messagesNodes = 'secondaryMessage___parentTopic___messagesNodes',
  secondaryMessage___parentTopic___messagesNodes___absolutePath = 'secondaryMessage___parentTopic___messagesNodes___absolutePath',
  secondaryMessage___parentTopic___messagesNodes___benefitImages = 'secondaryMessage___parentTopic___messagesNodes___benefitImages',
  secondaryMessage___parentTopic___messagesNodes___benefits = 'secondaryMessage___parentTopic___messagesNodes___benefits',
  secondaryMessage___parentTopic___messagesNodes___benefitsDisclaimer = 'secondaryMessage___parentTopic___messagesNodes___benefitsDisclaimer',
  secondaryMessage___parentTopic___messagesNodes___certificate = 'secondaryMessage___parentTopic___messagesNodes___certificate',
  secondaryMessage___parentTopic___messagesNodes___facts = 'secondaryMessage___parentTopic___messagesNodes___facts',
  secondaryMessage___parentTopic___messagesNodes___metaDescription = 'secondaryMessage___parentTopic___messagesNodes___metaDescription',
  secondaryMessage___parentTopic___messagesNodes___pageTitle = 'secondaryMessage___parentTopic___messagesNodes___pageTitle',
  secondaryMessage___parentTopic___messagesNodes___pageType = 'secondaryMessage___parentTopic___messagesNodes___pageType',
  secondaryMessage___parentTopic___messagesNodes___path = 'secondaryMessage___parentTopic___messagesNodes___path',
  secondaryMessage___parentTopic___messagesNodes___product = 'secondaryMessage___parentTopic___messagesNodes___product',
  secondaryMessage___parentTopic___messagesNodes___productsNodes = 'secondaryMessage___parentTopic___messagesNodes___productsNodes',
  secondaryMessage___parentTopic___messagesNodes___slug = 'secondaryMessage___parentTopic___messagesNodes___slug',
  secondaryMessage___parentTopic___messagesNodes___summary = 'secondaryMessage___parentTopic___messagesNodes___summary',
  secondaryMessage___parentTopic___messagesNodes___title = 'secondaryMessage___parentTopic___messagesNodes___title',
  secondaryMessage___parentTopic___messagesNodes___id = 'secondaryMessage___parentTopic___messagesNodes___id',
  secondaryMessage___parentTopic___messagesNodes___children = 'secondaryMessage___parentTopic___messagesNodes___children',
  secondaryMessage___parentTopic___metaDescription = 'secondaryMessage___parentTopic___metaDescription',
  secondaryMessage___parentTopic___navigationTitle = 'secondaryMessage___parentTopic___navigationTitle',
  secondaryMessage___parentTopic___topicDisclaimer = 'secondaryMessage___parentTopic___topicDisclaimer',
  secondaryMessage___parentTopic___pageTitle = 'secondaryMessage___parentTopic___pageTitle',
  secondaryMessage___parentTopic___pageType = 'secondaryMessage___parentTopic___pageType',
  secondaryMessage___parentTopic___path = 'secondaryMessage___parentTopic___path',
  secondaryMessage___parentTopic___slug = 'secondaryMessage___parentTopic___slug',
  secondaryMessage___parentTopic___summary = 'secondaryMessage___parentTopic___summary',
  secondaryMessage___parentTopic___title = 'secondaryMessage___parentTopic___title',
  secondaryMessage___parentTopic___traits___traitsStringified = 'secondaryMessage___parentTopic___traits___traitsStringified',
  secondaryMessage___parentTopic___id = 'secondaryMessage___parentTopic___id',
  secondaryMessage___parentTopic___parent___id = 'secondaryMessage___parentTopic___parent___id',
  secondaryMessage___parentTopic___parent___children = 'secondaryMessage___parentTopic___parent___children',
  secondaryMessage___parentTopic___children = 'secondaryMessage___parentTopic___children',
  secondaryMessage___parentTopic___children___id = 'secondaryMessage___parentTopic___children___id',
  secondaryMessage___parentTopic___children___children = 'secondaryMessage___parentTopic___children___children',
  secondaryMessage___parentTopic___internal___content = 'secondaryMessage___parentTopic___internal___content',
  secondaryMessage___parentTopic___internal___contentDigest = 'secondaryMessage___parentTopic___internal___contentDigest',
  secondaryMessage___parentTopic___internal___description = 'secondaryMessage___parentTopic___internal___description',
  secondaryMessage___parentTopic___internal___fieldOwners = 'secondaryMessage___parentTopic___internal___fieldOwners',
  secondaryMessage___parentTopic___internal___ignoreType = 'secondaryMessage___parentTopic___internal___ignoreType',
  secondaryMessage___parentTopic___internal___mediaType = 'secondaryMessage___parentTopic___internal___mediaType',
  secondaryMessage___parentTopic___internal___owner = 'secondaryMessage___parentTopic___internal___owner',
  secondaryMessage___parentTopic___internal___type = 'secondaryMessage___parentTopic___internal___type',
  secondaryMessage___path = 'secondaryMessage___path',
  secondaryMessage___product = 'secondaryMessage___product',
  secondaryMessage___productsNodes = 'secondaryMessage___productsNodes',
  secondaryMessage___productsNodes___absolutePath = 'secondaryMessage___productsNodes___absolutePath',
  secondaryMessage___productsNodes___benefits = 'secondaryMessage___productsNodes___benefits',
  secondaryMessage___productsNodes___benefitsDisclaimer = 'secondaryMessage___productsNodes___benefitsDisclaimer',
  secondaryMessage___productsNodes___description___htmlTruncated = 'secondaryMessage___productsNodes___description___htmlTruncated',
  secondaryMessage___productsNodes___description___html = 'secondaryMessage___productsNodes___description___html',
  secondaryMessage___productsNodes___description___rawContent = 'secondaryMessage___productsNodes___description___rawContent',
  secondaryMessage___productsNodes___description___text = 'secondaryMessage___productsNodes___description___text',
  secondaryMessage___productsNodes___hero___description = 'secondaryMessage___productsNodes___hero___description',
  secondaryMessage___productsNodes___hero___title = 'secondaryMessage___productsNodes___hero___title',
  secondaryMessage___productsNodes___howToUse___html = 'secondaryMessage___productsNodes___howToUse___html',
  secondaryMessage___productsNodes___howToUse___json = 'secondaryMessage___productsNodes___howToUse___json',
  secondaryMessage___productsNodes___howToUse___text = 'secondaryMessage___productsNodes___howToUse___text',
  secondaryMessage___productsNodes___main___htmlTruncated = 'secondaryMessage___productsNodes___main___htmlTruncated',
  secondaryMessage___productsNodes___main___html = 'secondaryMessage___productsNodes___main___html',
  secondaryMessage___productsNodes___main___rawContent = 'secondaryMessage___productsNodes___main___rawContent',
  secondaryMessage___productsNodes___main___text = 'secondaryMessage___productsNodes___main___text',
  secondaryMessage___productsNodes___metaDescription = 'secondaryMessage___productsNodes___metaDescription',
  secondaryMessage___productsNodes___name = 'secondaryMessage___productsNodes___name',
  secondaryMessage___productsNodes___pageTitle = 'secondaryMessage___productsNodes___pageTitle',
  secondaryMessage___productsNodes___pageType = 'secondaryMessage___productsNodes___pageType',
  secondaryMessage___productsNodes___parentMessage___absolutePath = 'secondaryMessage___productsNodes___parentMessage___absolutePath',
  secondaryMessage___productsNodes___parentMessage___benefitImages = 'secondaryMessage___productsNodes___parentMessage___benefitImages',
  secondaryMessage___productsNodes___parentMessage___benefits = 'secondaryMessage___productsNodes___parentMessage___benefits',
  secondaryMessage___productsNodes___parentMessage___benefitsDisclaimer = 'secondaryMessage___productsNodes___parentMessage___benefitsDisclaimer',
  secondaryMessage___productsNodes___parentMessage___certificate = 'secondaryMessage___productsNodes___parentMessage___certificate',
  secondaryMessage___productsNodes___parentMessage___facts = 'secondaryMessage___productsNodes___parentMessage___facts',
  secondaryMessage___productsNodes___parentMessage___metaDescription = 'secondaryMessage___productsNodes___parentMessage___metaDescription',
  secondaryMessage___productsNodes___parentMessage___pageTitle = 'secondaryMessage___productsNodes___parentMessage___pageTitle',
  secondaryMessage___productsNodes___parentMessage___pageType = 'secondaryMessage___productsNodes___parentMessage___pageType',
  secondaryMessage___productsNodes___parentMessage___path = 'secondaryMessage___productsNodes___parentMessage___path',
  secondaryMessage___productsNodes___parentMessage___product = 'secondaryMessage___productsNodes___parentMessage___product',
  secondaryMessage___productsNodes___parentMessage___productsNodes = 'secondaryMessage___productsNodes___parentMessage___productsNodes',
  secondaryMessage___productsNodes___parentMessage___slug = 'secondaryMessage___productsNodes___parentMessage___slug',
  secondaryMessage___productsNodes___parentMessage___summary = 'secondaryMessage___productsNodes___parentMessage___summary',
  secondaryMessage___productsNodes___parentMessage___title = 'secondaryMessage___productsNodes___parentMessage___title',
  secondaryMessage___productsNodes___parentMessage___id = 'secondaryMessage___productsNodes___parentMessage___id',
  secondaryMessage___productsNodes___parentMessage___children = 'secondaryMessage___productsNodes___parentMessage___children',
  secondaryMessage___productsNodes___path = 'secondaryMessage___productsNodes___path',
  secondaryMessage___productsNodes___slug = 'secondaryMessage___productsNodes___slug',
  secondaryMessage___productsNodes___summaryBackground___description = 'secondaryMessage___productsNodes___summaryBackground___description',
  secondaryMessage___productsNodes___summaryBackground___title = 'secondaryMessage___productsNodes___summaryBackground___title',
  secondaryMessage___productsNodes___traits___traitsStringified = 'secondaryMessage___productsNodes___traits___traitsStringified',
  secondaryMessage___productsNodes___variants = 'secondaryMessage___productsNodes___variants',
  secondaryMessage___productsNodes___variants___buyItNowUrl = 'secondaryMessage___productsNodes___variants___buyItNowUrl',
  secondaryMessage___productsNodes___variants___name = 'secondaryMessage___productsNodes___variants___name',
  secondaryMessage___productsNodes___variants___product = 'secondaryMessage___productsNodes___variants___product',
  secondaryMessage___productsNodes___variants___sizes = 'secondaryMessage___productsNodes___variants___sizes',
  secondaryMessage___productsNodes___id = 'secondaryMessage___productsNodes___id',
  secondaryMessage___productsNodes___parent___id = 'secondaryMessage___productsNodes___parent___id',
  secondaryMessage___productsNodes___parent___children = 'secondaryMessage___productsNodes___parent___children',
  secondaryMessage___productsNodes___children = 'secondaryMessage___productsNodes___children',
  secondaryMessage___productsNodes___children___id = 'secondaryMessage___productsNodes___children___id',
  secondaryMessage___productsNodes___children___children = 'secondaryMessage___productsNodes___children___children',
  secondaryMessage___productsNodes___internal___content = 'secondaryMessage___productsNodes___internal___content',
  secondaryMessage___productsNodes___internal___contentDigest = 'secondaryMessage___productsNodes___internal___contentDigest',
  secondaryMessage___productsNodes___internal___description = 'secondaryMessage___productsNodes___internal___description',
  secondaryMessage___productsNodes___internal___fieldOwners = 'secondaryMessage___productsNodes___internal___fieldOwners',
  secondaryMessage___productsNodes___internal___ignoreType = 'secondaryMessage___productsNodes___internal___ignoreType',
  secondaryMessage___productsNodes___internal___mediaType = 'secondaryMessage___productsNodes___internal___mediaType',
  secondaryMessage___productsNodes___internal___owner = 'secondaryMessage___productsNodes___internal___owner',
  secondaryMessage___productsNodes___internal___type = 'secondaryMessage___productsNodes___internal___type',
  secondaryMessage___slug = 'secondaryMessage___slug',
  secondaryMessage___summary = 'secondaryMessage___summary',
  secondaryMessage___summaryBackground___description = 'secondaryMessage___summaryBackground___description',
  secondaryMessage___summaryBackground___file___url = 'secondaryMessage___summaryBackground___file___url',
  secondaryMessage___summaryBackground___title = 'secondaryMessage___summaryBackground___title',
  secondaryMessage___teaserImage___description = 'secondaryMessage___teaserImage___description',
  secondaryMessage___teaserImage___file___url = 'secondaryMessage___teaserImage___file___url',
  secondaryMessage___teaserImage___title = 'secondaryMessage___teaserImage___title',
  secondaryMessage___territoryWidget___bottomGraphic___description = 'secondaryMessage___territoryWidget___bottomGraphic___description',
  secondaryMessage___territoryWidget___bottomGraphic___title = 'secondaryMessage___territoryWidget___bottomGraphic___title',
  secondaryMessage___territoryWidget___bottomHeading = 'secondaryMessage___territoryWidget___bottomHeading',
  secondaryMessage___territoryWidget___graphicHeading = 'secondaryMessage___territoryWidget___graphicHeading',
  secondaryMessage___territoryWidget___topCopy = 'secondaryMessage___territoryWidget___topCopy',
  secondaryMessage___territoryWidget___topHeading = 'secondaryMessage___territoryWidget___topHeading',
  secondaryMessage___territoryWidget___topHeroImage___description = 'secondaryMessage___territoryWidget___topHeroImage___description',
  secondaryMessage___territoryWidget___topHeroImage___title = 'secondaryMessage___territoryWidget___topHeroImage___title',
  secondaryMessage___territoryWidget___topLeftHeadingImage___description = 'secondaryMessage___territoryWidget___topLeftHeadingImage___description',
  secondaryMessage___territoryWidget___topLeftHeadingImage___title = 'secondaryMessage___territoryWidget___topLeftHeadingImage___title',
  secondaryMessage___title = 'secondaryMessage___title',
  secondaryMessage___traits___traitsStringified = 'secondaryMessage___traits___traitsStringified',
  secondaryMessage___video___description = 'secondaryMessage___video___description',
  secondaryMessage___video___file___url = 'secondaryMessage___video___file___url',
  secondaryMessage___video___title = 'secondaryMessage___video___title',
  secondaryMessage___id = 'secondaryMessage___id',
  secondaryMessage___parent___id = 'secondaryMessage___parent___id',
  secondaryMessage___parent___parent___id = 'secondaryMessage___parent___parent___id',
  secondaryMessage___parent___parent___children = 'secondaryMessage___parent___parent___children',
  secondaryMessage___parent___children = 'secondaryMessage___parent___children',
  secondaryMessage___parent___children___id = 'secondaryMessage___parent___children___id',
  secondaryMessage___parent___children___children = 'secondaryMessage___parent___children___children',
  secondaryMessage___parent___internal___content = 'secondaryMessage___parent___internal___content',
  secondaryMessage___parent___internal___contentDigest = 'secondaryMessage___parent___internal___contentDigest',
  secondaryMessage___parent___internal___description = 'secondaryMessage___parent___internal___description',
  secondaryMessage___parent___internal___fieldOwners = 'secondaryMessage___parent___internal___fieldOwners',
  secondaryMessage___parent___internal___ignoreType = 'secondaryMessage___parent___internal___ignoreType',
  secondaryMessage___parent___internal___mediaType = 'secondaryMessage___parent___internal___mediaType',
  secondaryMessage___parent___internal___owner = 'secondaryMessage___parent___internal___owner',
  secondaryMessage___parent___internal___type = 'secondaryMessage___parent___internal___type',
  secondaryMessage___children = 'secondaryMessage___children',
  secondaryMessage___children___id = 'secondaryMessage___children___id',
  secondaryMessage___children___parent___id = 'secondaryMessage___children___parent___id',
  secondaryMessage___children___parent___children = 'secondaryMessage___children___parent___children',
  secondaryMessage___children___children = 'secondaryMessage___children___children',
  secondaryMessage___children___children___id = 'secondaryMessage___children___children___id',
  secondaryMessage___children___children___children = 'secondaryMessage___children___children___children',
  secondaryMessage___children___internal___content = 'secondaryMessage___children___internal___content',
  secondaryMessage___children___internal___contentDigest = 'secondaryMessage___children___internal___contentDigest',
  secondaryMessage___children___internal___description = 'secondaryMessage___children___internal___description',
  secondaryMessage___children___internal___fieldOwners = 'secondaryMessage___children___internal___fieldOwners',
  secondaryMessage___children___internal___ignoreType = 'secondaryMessage___children___internal___ignoreType',
  secondaryMessage___children___internal___mediaType = 'secondaryMessage___children___internal___mediaType',
  secondaryMessage___children___internal___owner = 'secondaryMessage___children___internal___owner',
  secondaryMessage___children___internal___type = 'secondaryMessage___children___internal___type',
  secondaryMessage___internal___content = 'secondaryMessage___internal___content',
  secondaryMessage___internal___contentDigest = 'secondaryMessage___internal___contentDigest',
  secondaryMessage___internal___description = 'secondaryMessage___internal___description',
  secondaryMessage___internal___fieldOwners = 'secondaryMessage___internal___fieldOwners',
  secondaryMessage___internal___ignoreType = 'secondaryMessage___internal___ignoreType',
  secondaryMessage___internal___mediaType = 'secondaryMessage___internal___mediaType',
  secondaryMessage___internal___owner = 'secondaryMessage___internal___owner',
  secondaryMessage___internal___type = 'secondaryMessage___internal___type',
  signUp___absolutePath = 'signUp___absolutePath',
  signUp___ageConsentLabel = 'signUp___ageConsentLabel',
  signUp___brandConsentLabel = 'signUp___brandConsentLabel',
  signUp___brandConsentRequired = 'signUp___brandConsentRequired',
  signUp___corporateConsentLabel = 'signUp___corporateConsentLabel',
  signUp___dateOfBirthFieldLabel = 'signUp___dateOfBirthFieldLabel',
  signUp___dayOfBirthFieldLabel = 'signUp___dayOfBirthFieldLabel',
  signUp___disclaimer___html = 'signUp___disclaimer___html',
  signUp___disclaimer___json = 'signUp___disclaimer___json',
  signUp___disclaimer___text = 'signUp___disclaimer___text',
  signUp___emailAddressFieldLabel = 'signUp___emailAddressFieldLabel',
  signUp___enterpriseConsent___html = 'signUp___enterpriseConsent___html',
  signUp___enterpriseConsent___json = 'signUp___enterpriseConsent___json',
  signUp___enterpriseConsent___text = 'signUp___enterpriseConsent___text',
  signUp___failureMessage = 'signUp___failureMessage',
  signUp___femaleGenderFieldLabel = 'signUp___femaleGenderFieldLabel',
  signUp___firstNameFieldLabel = 'signUp___firstNameFieldLabel',
  signUp___genderFieldLabel = 'signUp___genderFieldLabel',
  signUp___heading = 'signUp___heading',
  signUp___hero___description = 'signUp___hero___description',
  signUp___hero___file___url = 'signUp___hero___file___url',
  signUp___hero___title = 'signUp___hero___title',
  signUp___id = 'signUp___id',
  signUp___lastNameFieldLabel = 'signUp___lastNameFieldLabel',
  signUp___maleGenderFieldLabel = 'signUp___maleGenderFieldLabel',
  signUp___mobileNumberFieldLabel = 'signUp___mobileNumberFieldLabel',
  signUp___monthOfBirthFieldLabel = 'signUp___monthOfBirthFieldLabel',
  signUp___notSpecifiedGenderFieldLabel = 'signUp___notSpecifiedGenderFieldLabel',
  signUp___pageType = 'signUp___pageType',
  signUp___path = 'signUp___path',
  signUp___postalCodeFieldLabel = 'signUp___postalCodeFieldLabel',
  signUp___shouldCaptureAgeConsent = 'signUp___shouldCaptureAgeConsent',
  signUp___shouldCaptureDayOfBirth = 'signUp___shouldCaptureDayOfBirth',
  signUp___shouldCaptureEnterpriseConsent = 'signUp___shouldCaptureEnterpriseConsent',
  signUp___shouldCaptureGender = 'signUp___shouldCaptureGender',
  signUp___shouldCaptureMobileNumber = 'signUp___shouldCaptureMobileNumber',
  signUp___shouldCaptureMonthOfBirth = 'signUp___shouldCaptureMonthOfBirth',
  signUp___shouldCapturePostalCode = 'signUp___shouldCapturePostalCode',
  signUp___shouldCaptureYearOfBirth = 'signUp___shouldCaptureYearOfBirth',
  signUp___slug = 'signUp___slug',
  signUp___submitButtonLabel = 'signUp___submitButtonLabel',
  signUp___successMessage = 'signUp___successMessage',
  signUp___successMessageAttachment___description = 'signUp___successMessageAttachment___description',
  signUp___successMessageAttachment___file___url = 'signUp___successMessageAttachment___file___url',
  signUp___successMessageAttachment___title = 'signUp___successMessageAttachment___title',
  signUp___termsAndConditionsBlurb___html = 'signUp___termsAndConditionsBlurb___html',
  signUp___termsAndConditionsBlurb___json = 'signUp___termsAndConditionsBlurb___json',
  signUp___termsAndConditionsBlurb___text = 'signUp___termsAndConditionsBlurb___text',
  signUp___title = 'signUp___title',
  signUp___traits___traitsStringified = 'signUp___traits___traitsStringified',
  signUp___yearOfBirthFieldLabel = 'signUp___yearOfBirthFieldLabel',
  signUp___submissionConsentMessage = 'signUp___submissionConsentMessage',
  signUp___parent___id = 'signUp___parent___id',
  signUp___parent___parent___id = 'signUp___parent___parent___id',
  signUp___parent___parent___children = 'signUp___parent___parent___children',
  signUp___parent___children = 'signUp___parent___children',
  signUp___parent___children___id = 'signUp___parent___children___id',
  signUp___parent___children___children = 'signUp___parent___children___children',
  signUp___parent___internal___content = 'signUp___parent___internal___content',
  signUp___parent___internal___contentDigest = 'signUp___parent___internal___contentDigest',
  signUp___parent___internal___description = 'signUp___parent___internal___description',
  signUp___parent___internal___fieldOwners = 'signUp___parent___internal___fieldOwners',
  signUp___parent___internal___ignoreType = 'signUp___parent___internal___ignoreType',
  signUp___parent___internal___mediaType = 'signUp___parent___internal___mediaType',
  signUp___parent___internal___owner = 'signUp___parent___internal___owner',
  signUp___parent___internal___type = 'signUp___parent___internal___type',
  signUp___children = 'signUp___children',
  signUp___children___id = 'signUp___children___id',
  signUp___children___parent___id = 'signUp___children___parent___id',
  signUp___children___parent___children = 'signUp___children___parent___children',
  signUp___children___children = 'signUp___children___children',
  signUp___children___children___id = 'signUp___children___children___id',
  signUp___children___children___children = 'signUp___children___children___children',
  signUp___children___internal___content = 'signUp___children___internal___content',
  signUp___children___internal___contentDigest = 'signUp___children___internal___contentDigest',
  signUp___children___internal___description = 'signUp___children___internal___description',
  signUp___children___internal___fieldOwners = 'signUp___children___internal___fieldOwners',
  signUp___children___internal___ignoreType = 'signUp___children___internal___ignoreType',
  signUp___children___internal___mediaType = 'signUp___children___internal___mediaType',
  signUp___children___internal___owner = 'signUp___children___internal___owner',
  signUp___children___internal___type = 'signUp___children___internal___type',
  signUp___internal___content = 'signUp___internal___content',
  signUp___internal___contentDigest = 'signUp___internal___contentDigest',
  signUp___internal___description = 'signUp___internal___description',
  signUp___internal___fieldOwners = 'signUp___internal___fieldOwners',
  signUp___internal___ignoreType = 'signUp___internal___ignoreType',
  signUp___internal___mediaType = 'signUp___internal___mediaType',
  signUp___internal___owner = 'signUp___internal___owner',
  signUp___internal___type = 'signUp___internal___type',
  socialChannels = 'socialChannels',
  socialChannels___image___description = 'socialChannels___image___description',
  socialChannels___image___file___url = 'socialChannels___image___file___url',
  socialChannels___image___title = 'socialChannels___image___title',
  socialChannels___name = 'socialChannels___name',
  socialChannels___url = 'socialChannels___url',
  termsMessage___absolutePath = 'termsMessage___absolutePath',
  termsMessage___benefitImages = 'termsMessage___benefitImages',
  termsMessage___benefitImages___description = 'termsMessage___benefitImages___description',
  termsMessage___benefitImages___file___url = 'termsMessage___benefitImages___file___url',
  termsMessage___benefits = 'termsMessage___benefits',
  termsMessage___benefitsDisclaimer = 'termsMessage___benefitsDisclaimer',
  termsMessage___certificate = 'termsMessage___certificate',
  termsMessage___certificate___image___description = 'termsMessage___certificate___image___description',
  termsMessage___certificate___image___title = 'termsMessage___certificate___image___title',
  termsMessage___certificate___title = 'termsMessage___certificate___title',
  termsMessage___certificate___url = 'termsMessage___certificate___url',
  termsMessage___facts = 'termsMessage___facts',
  termsMessage___facts___image___description = 'termsMessage___facts___image___description',
  termsMessage___facts___image___title = 'termsMessage___facts___image___title',
  termsMessage___facts___summary = 'termsMessage___facts___summary',
  termsMessage___facts___title = 'termsMessage___facts___title',
  termsMessage___hero___description = 'termsMessage___hero___description',
  termsMessage___hero___file___url = 'termsMessage___hero___file___url',
  termsMessage___hero___title = 'termsMessage___hero___title',
  termsMessage___heroVideo___description = 'termsMessage___heroVideo___description',
  termsMessage___heroVideo___file___url = 'termsMessage___heroVideo___file___url',
  termsMessage___heroVideo___title = 'termsMessage___heroVideo___title',
  termsMessage___main___htmlTruncated = 'termsMessage___main___htmlTruncated',
  termsMessage___main___html = 'termsMessage___main___html',
  termsMessage___main___rawContent = 'termsMessage___main___rawContent',
  termsMessage___main___text = 'termsMessage___main___text',
  termsMessage___metaDescription = 'termsMessage___metaDescription',
  termsMessage___pageTitle = 'termsMessage___pageTitle',
  termsMessage___pageType = 'termsMessage___pageType',
  termsMessage___parentTopic___absolutePath = 'termsMessage___parentTopic___absolutePath',
  termsMessage___parentTopic___hero___description = 'termsMessage___parentTopic___hero___description',
  termsMessage___parentTopic___hero___title = 'termsMessage___parentTopic___hero___title',
  termsMessage___parentTopic___messagesNodes = 'termsMessage___parentTopic___messagesNodes',
  termsMessage___parentTopic___messagesNodes___absolutePath = 'termsMessage___parentTopic___messagesNodes___absolutePath',
  termsMessage___parentTopic___messagesNodes___benefitImages = 'termsMessage___parentTopic___messagesNodes___benefitImages',
  termsMessage___parentTopic___messagesNodes___benefits = 'termsMessage___parentTopic___messagesNodes___benefits',
  termsMessage___parentTopic___messagesNodes___benefitsDisclaimer = 'termsMessage___parentTopic___messagesNodes___benefitsDisclaimer',
  termsMessage___parentTopic___messagesNodes___certificate = 'termsMessage___parentTopic___messagesNodes___certificate',
  termsMessage___parentTopic___messagesNodes___facts = 'termsMessage___parentTopic___messagesNodes___facts',
  termsMessage___parentTopic___messagesNodes___metaDescription = 'termsMessage___parentTopic___messagesNodes___metaDescription',
  termsMessage___parentTopic___messagesNodes___pageTitle = 'termsMessage___parentTopic___messagesNodes___pageTitle',
  termsMessage___parentTopic___messagesNodes___pageType = 'termsMessage___parentTopic___messagesNodes___pageType',
  termsMessage___parentTopic___messagesNodes___path = 'termsMessage___parentTopic___messagesNodes___path',
  termsMessage___parentTopic___messagesNodes___product = 'termsMessage___parentTopic___messagesNodes___product',
  termsMessage___parentTopic___messagesNodes___productsNodes = 'termsMessage___parentTopic___messagesNodes___productsNodes',
  termsMessage___parentTopic___messagesNodes___slug = 'termsMessage___parentTopic___messagesNodes___slug',
  termsMessage___parentTopic___messagesNodes___summary = 'termsMessage___parentTopic___messagesNodes___summary',
  termsMessage___parentTopic___messagesNodes___title = 'termsMessage___parentTopic___messagesNodes___title',
  termsMessage___parentTopic___messagesNodes___id = 'termsMessage___parentTopic___messagesNodes___id',
  termsMessage___parentTopic___messagesNodes___children = 'termsMessage___parentTopic___messagesNodes___children',
  termsMessage___parentTopic___metaDescription = 'termsMessage___parentTopic___metaDescription',
  termsMessage___parentTopic___navigationTitle = 'termsMessage___parentTopic___navigationTitle',
  termsMessage___parentTopic___topicDisclaimer = 'termsMessage___parentTopic___topicDisclaimer',
  termsMessage___parentTopic___pageTitle = 'termsMessage___parentTopic___pageTitle',
  termsMessage___parentTopic___pageType = 'termsMessage___parentTopic___pageType',
  termsMessage___parentTopic___path = 'termsMessage___parentTopic___path',
  termsMessage___parentTopic___slug = 'termsMessage___parentTopic___slug',
  termsMessage___parentTopic___summary = 'termsMessage___parentTopic___summary',
  termsMessage___parentTopic___title = 'termsMessage___parentTopic___title',
  termsMessage___parentTopic___traits___traitsStringified = 'termsMessage___parentTopic___traits___traitsStringified',
  termsMessage___parentTopic___id = 'termsMessage___parentTopic___id',
  termsMessage___parentTopic___parent___id = 'termsMessage___parentTopic___parent___id',
  termsMessage___parentTopic___parent___children = 'termsMessage___parentTopic___parent___children',
  termsMessage___parentTopic___children = 'termsMessage___parentTopic___children',
  termsMessage___parentTopic___children___id = 'termsMessage___parentTopic___children___id',
  termsMessage___parentTopic___children___children = 'termsMessage___parentTopic___children___children',
  termsMessage___parentTopic___internal___content = 'termsMessage___parentTopic___internal___content',
  termsMessage___parentTopic___internal___contentDigest = 'termsMessage___parentTopic___internal___contentDigest',
  termsMessage___parentTopic___internal___description = 'termsMessage___parentTopic___internal___description',
  termsMessage___parentTopic___internal___fieldOwners = 'termsMessage___parentTopic___internal___fieldOwners',
  termsMessage___parentTopic___internal___ignoreType = 'termsMessage___parentTopic___internal___ignoreType',
  termsMessage___parentTopic___internal___mediaType = 'termsMessage___parentTopic___internal___mediaType',
  termsMessage___parentTopic___internal___owner = 'termsMessage___parentTopic___internal___owner',
  termsMessage___parentTopic___internal___type = 'termsMessage___parentTopic___internal___type',
  termsMessage___path = 'termsMessage___path',
  termsMessage___product = 'termsMessage___product',
  termsMessage___productsNodes = 'termsMessage___productsNodes',
  termsMessage___productsNodes___absolutePath = 'termsMessage___productsNodes___absolutePath',
  termsMessage___productsNodes___benefits = 'termsMessage___productsNodes___benefits',
  termsMessage___productsNodes___benefitsDisclaimer = 'termsMessage___productsNodes___benefitsDisclaimer',
  termsMessage___productsNodes___description___htmlTruncated = 'termsMessage___productsNodes___description___htmlTruncated',
  termsMessage___productsNodes___description___html = 'termsMessage___productsNodes___description___html',
  termsMessage___productsNodes___description___rawContent = 'termsMessage___productsNodes___description___rawContent',
  termsMessage___productsNodes___description___text = 'termsMessage___productsNodes___description___text',
  termsMessage___productsNodes___hero___description = 'termsMessage___productsNodes___hero___description',
  termsMessage___productsNodes___hero___title = 'termsMessage___productsNodes___hero___title',
  termsMessage___productsNodes___howToUse___html = 'termsMessage___productsNodes___howToUse___html',
  termsMessage___productsNodes___howToUse___json = 'termsMessage___productsNodes___howToUse___json',
  termsMessage___productsNodes___howToUse___text = 'termsMessage___productsNodes___howToUse___text',
  termsMessage___productsNodes___main___htmlTruncated = 'termsMessage___productsNodes___main___htmlTruncated',
  termsMessage___productsNodes___main___html = 'termsMessage___productsNodes___main___html',
  termsMessage___productsNodes___main___rawContent = 'termsMessage___productsNodes___main___rawContent',
  termsMessage___productsNodes___main___text = 'termsMessage___productsNodes___main___text',
  termsMessage___productsNodes___metaDescription = 'termsMessage___productsNodes___metaDescription',
  termsMessage___productsNodes___name = 'termsMessage___productsNodes___name',
  termsMessage___productsNodes___pageTitle = 'termsMessage___productsNodes___pageTitle',
  termsMessage___productsNodes___pageType = 'termsMessage___productsNodes___pageType',
  termsMessage___productsNodes___parentMessage___absolutePath = 'termsMessage___productsNodes___parentMessage___absolutePath',
  termsMessage___productsNodes___parentMessage___benefitImages = 'termsMessage___productsNodes___parentMessage___benefitImages',
  termsMessage___productsNodes___parentMessage___benefits = 'termsMessage___productsNodes___parentMessage___benefits',
  termsMessage___productsNodes___parentMessage___benefitsDisclaimer = 'termsMessage___productsNodes___parentMessage___benefitsDisclaimer',
  termsMessage___productsNodes___parentMessage___certificate = 'termsMessage___productsNodes___parentMessage___certificate',
  termsMessage___productsNodes___parentMessage___facts = 'termsMessage___productsNodes___parentMessage___facts',
  termsMessage___productsNodes___parentMessage___metaDescription = 'termsMessage___productsNodes___parentMessage___metaDescription',
  termsMessage___productsNodes___parentMessage___pageTitle = 'termsMessage___productsNodes___parentMessage___pageTitle',
  termsMessage___productsNodes___parentMessage___pageType = 'termsMessage___productsNodes___parentMessage___pageType',
  termsMessage___productsNodes___parentMessage___path = 'termsMessage___productsNodes___parentMessage___path',
  termsMessage___productsNodes___parentMessage___product = 'termsMessage___productsNodes___parentMessage___product',
  termsMessage___productsNodes___parentMessage___productsNodes = 'termsMessage___productsNodes___parentMessage___productsNodes',
  termsMessage___productsNodes___parentMessage___slug = 'termsMessage___productsNodes___parentMessage___slug',
  termsMessage___productsNodes___parentMessage___summary = 'termsMessage___productsNodes___parentMessage___summary',
  termsMessage___productsNodes___parentMessage___title = 'termsMessage___productsNodes___parentMessage___title',
  termsMessage___productsNodes___parentMessage___id = 'termsMessage___productsNodes___parentMessage___id',
  termsMessage___productsNodes___parentMessage___children = 'termsMessage___productsNodes___parentMessage___children',
  termsMessage___productsNodes___path = 'termsMessage___productsNodes___path',
  termsMessage___productsNodes___slug = 'termsMessage___productsNodes___slug',
  termsMessage___productsNodes___summaryBackground___description = 'termsMessage___productsNodes___summaryBackground___description',
  termsMessage___productsNodes___summaryBackground___title = 'termsMessage___productsNodes___summaryBackground___title',
  termsMessage___productsNodes___traits___traitsStringified = 'termsMessage___productsNodes___traits___traitsStringified',
  termsMessage___productsNodes___variants = 'termsMessage___productsNodes___variants',
  termsMessage___productsNodes___variants___buyItNowUrl = 'termsMessage___productsNodes___variants___buyItNowUrl',
  termsMessage___productsNodes___variants___name = 'termsMessage___productsNodes___variants___name',
  termsMessage___productsNodes___variants___product = 'termsMessage___productsNodes___variants___product',
  termsMessage___productsNodes___variants___sizes = 'termsMessage___productsNodes___variants___sizes',
  termsMessage___productsNodes___id = 'termsMessage___productsNodes___id',
  termsMessage___productsNodes___parent___id = 'termsMessage___productsNodes___parent___id',
  termsMessage___productsNodes___parent___children = 'termsMessage___productsNodes___parent___children',
  termsMessage___productsNodes___children = 'termsMessage___productsNodes___children',
  termsMessage___productsNodes___children___id = 'termsMessage___productsNodes___children___id',
  termsMessage___productsNodes___children___children = 'termsMessage___productsNodes___children___children',
  termsMessage___productsNodes___internal___content = 'termsMessage___productsNodes___internal___content',
  termsMessage___productsNodes___internal___contentDigest = 'termsMessage___productsNodes___internal___contentDigest',
  termsMessage___productsNodes___internal___description = 'termsMessage___productsNodes___internal___description',
  termsMessage___productsNodes___internal___fieldOwners = 'termsMessage___productsNodes___internal___fieldOwners',
  termsMessage___productsNodes___internal___ignoreType = 'termsMessage___productsNodes___internal___ignoreType',
  termsMessage___productsNodes___internal___mediaType = 'termsMessage___productsNodes___internal___mediaType',
  termsMessage___productsNodes___internal___owner = 'termsMessage___productsNodes___internal___owner',
  termsMessage___productsNodes___internal___type = 'termsMessage___productsNodes___internal___type',
  termsMessage___slug = 'termsMessage___slug',
  termsMessage___summary = 'termsMessage___summary',
  termsMessage___summaryBackground___description = 'termsMessage___summaryBackground___description',
  termsMessage___summaryBackground___file___url = 'termsMessage___summaryBackground___file___url',
  termsMessage___summaryBackground___title = 'termsMessage___summaryBackground___title',
  termsMessage___teaserImage___description = 'termsMessage___teaserImage___description',
  termsMessage___teaserImage___file___url = 'termsMessage___teaserImage___file___url',
  termsMessage___teaserImage___title = 'termsMessage___teaserImage___title',
  termsMessage___territoryWidget___bottomGraphic___description = 'termsMessage___territoryWidget___bottomGraphic___description',
  termsMessage___territoryWidget___bottomGraphic___title = 'termsMessage___territoryWidget___bottomGraphic___title',
  termsMessage___territoryWidget___bottomHeading = 'termsMessage___territoryWidget___bottomHeading',
  termsMessage___territoryWidget___graphicHeading = 'termsMessage___territoryWidget___graphicHeading',
  termsMessage___territoryWidget___topCopy = 'termsMessage___territoryWidget___topCopy',
  termsMessage___territoryWidget___topHeading = 'termsMessage___territoryWidget___topHeading',
  termsMessage___territoryWidget___topHeroImage___description = 'termsMessage___territoryWidget___topHeroImage___description',
  termsMessage___territoryWidget___topHeroImage___title = 'termsMessage___territoryWidget___topHeroImage___title',
  termsMessage___territoryWidget___topLeftHeadingImage___description = 'termsMessage___territoryWidget___topLeftHeadingImage___description',
  termsMessage___territoryWidget___topLeftHeadingImage___title = 'termsMessage___territoryWidget___topLeftHeadingImage___title',
  termsMessage___title = 'termsMessage___title',
  termsMessage___traits___traitsStringified = 'termsMessage___traits___traitsStringified',
  termsMessage___video___description = 'termsMessage___video___description',
  termsMessage___video___file___url = 'termsMessage___video___file___url',
  termsMessage___video___title = 'termsMessage___video___title',
  termsMessage___id = 'termsMessage___id',
  termsMessage___parent___id = 'termsMessage___parent___id',
  termsMessage___parent___parent___id = 'termsMessage___parent___parent___id',
  termsMessage___parent___parent___children = 'termsMessage___parent___parent___children',
  termsMessage___parent___children = 'termsMessage___parent___children',
  termsMessage___parent___children___id = 'termsMessage___parent___children___id',
  termsMessage___parent___children___children = 'termsMessage___parent___children___children',
  termsMessage___parent___internal___content = 'termsMessage___parent___internal___content',
  termsMessage___parent___internal___contentDigest = 'termsMessage___parent___internal___contentDigest',
  termsMessage___parent___internal___description = 'termsMessage___parent___internal___description',
  termsMessage___parent___internal___fieldOwners = 'termsMessage___parent___internal___fieldOwners',
  termsMessage___parent___internal___ignoreType = 'termsMessage___parent___internal___ignoreType',
  termsMessage___parent___internal___mediaType = 'termsMessage___parent___internal___mediaType',
  termsMessage___parent___internal___owner = 'termsMessage___parent___internal___owner',
  termsMessage___parent___internal___type = 'termsMessage___parent___internal___type',
  termsMessage___children = 'termsMessage___children',
  termsMessage___children___id = 'termsMessage___children___id',
  termsMessage___children___parent___id = 'termsMessage___children___parent___id',
  termsMessage___children___parent___children = 'termsMessage___children___parent___children',
  termsMessage___children___children = 'termsMessage___children___children',
  termsMessage___children___children___id = 'termsMessage___children___children___id',
  termsMessage___children___children___children = 'termsMessage___children___children___children',
  termsMessage___children___internal___content = 'termsMessage___children___internal___content',
  termsMessage___children___internal___contentDigest = 'termsMessage___children___internal___contentDigest',
  termsMessage___children___internal___description = 'termsMessage___children___internal___description',
  termsMessage___children___internal___fieldOwners = 'termsMessage___children___internal___fieldOwners',
  termsMessage___children___internal___ignoreType = 'termsMessage___children___internal___ignoreType',
  termsMessage___children___internal___mediaType = 'termsMessage___children___internal___mediaType',
  termsMessage___children___internal___owner = 'termsMessage___children___internal___owner',
  termsMessage___children___internal___type = 'termsMessage___children___internal___type',
  termsMessage___internal___content = 'termsMessage___internal___content',
  termsMessage___internal___contentDigest = 'termsMessage___internal___contentDigest',
  termsMessage___internal___description = 'termsMessage___internal___description',
  termsMessage___internal___fieldOwners = 'termsMessage___internal___fieldOwners',
  termsMessage___internal___ignoreType = 'termsMessage___internal___ignoreType',
  termsMessage___internal___mediaType = 'termsMessage___internal___mediaType',
  termsMessage___internal___owner = 'termsMessage___internal___owner',
  termsMessage___internal___type = 'termsMessage___internal___type',
  navLinks = 'navLinks',
  navLinks___path = 'navLinks___path',
  navLinks___title = 'navLinks___title',
  traits___traitsStringified = 'traits___traitsStringified',
  sustainabilityWidgetWebsite___strapline = 'sustainabilityWidgetWebsite___strapline',
  sustainabilityWidgetWebsite___headingImage___description = 'sustainabilityWidgetWebsite___headingImage___description',
  sustainabilityWidgetWebsite___headingImage___file___url = 'sustainabilityWidgetWebsite___headingImage___file___url',
  sustainabilityWidgetWebsite___headingImage___title = 'sustainabilityWidgetWebsite___headingImage___title',
  homeVideo___description = 'homeVideo___description',
  homeVideo___title = 'homeVideo___title',
  homeVideo___video___sourceInstanceName = 'homeVideo___video___sourceInstanceName',
  homeVideo___video___absolutePath = 'homeVideo___video___absolutePath',
  homeVideo___video___relativePath = 'homeVideo___video___relativePath',
  homeVideo___video___extension = 'homeVideo___video___extension',
  homeVideo___video___size = 'homeVideo___video___size',
  homeVideo___video___prettySize = 'homeVideo___video___prettySize',
  homeVideo___video___modifiedTime = 'homeVideo___video___modifiedTime',
  homeVideo___video___accessTime = 'homeVideo___video___accessTime',
  homeVideo___video___changeTime = 'homeVideo___video___changeTime',
  homeVideo___video___birthTime = 'homeVideo___video___birthTime',
  homeVideo___video___root = 'homeVideo___video___root',
  homeVideo___video___dir = 'homeVideo___video___dir',
  homeVideo___video___base = 'homeVideo___video___base',
  homeVideo___video___ext = 'homeVideo___video___ext',
  homeVideo___video___name = 'homeVideo___video___name',
  homeVideo___video___relativeDirectory = 'homeVideo___video___relativeDirectory',
  homeVideo___video___dev = 'homeVideo___video___dev',
  homeVideo___video___mode = 'homeVideo___video___mode',
  homeVideo___video___nlink = 'homeVideo___video___nlink',
  homeVideo___video___uid = 'homeVideo___video___uid',
  homeVideo___video___gid = 'homeVideo___video___gid',
  homeVideo___video___rdev = 'homeVideo___video___rdev',
  homeVideo___video___ino = 'homeVideo___video___ino',
  homeVideo___video___atimeMs = 'homeVideo___video___atimeMs',
  homeVideo___video___mtimeMs = 'homeVideo___video___mtimeMs',
  homeVideo___video___ctimeMs = 'homeVideo___video___ctimeMs',
  homeVideo___video___atime = 'homeVideo___video___atime',
  homeVideo___video___mtime = 'homeVideo___video___mtime',
  homeVideo___video___ctime = 'homeVideo___video___ctime',
  homeVideo___video___birthtime = 'homeVideo___video___birthtime',
  homeVideo___video___birthtimeMs = 'homeVideo___video___birthtimeMs',
  homeVideo___video___blksize = 'homeVideo___video___blksize',
  homeVideo___video___blocks = 'homeVideo___video___blocks',
  homeVideo___video___url = 'homeVideo___video___url',
  homeVideo___video___publicURL = 'homeVideo___video___publicURL',
  homeVideo___video___childrenImageSharp = 'homeVideo___video___childrenImageSharp',
  homeVideo___video___childrenImageSharp___gatsbyImageData = 'homeVideo___video___childrenImageSharp___gatsbyImageData',
  homeVideo___video___childrenImageSharp___id = 'homeVideo___video___childrenImageSharp___id',
  homeVideo___video___childrenImageSharp___children = 'homeVideo___video___childrenImageSharp___children',
  homeVideo___video___childImageSharp___gatsbyImageData = 'homeVideo___video___childImageSharp___gatsbyImageData',
  homeVideo___video___childImageSharp___id = 'homeVideo___video___childImageSharp___id',
  homeVideo___video___childImageSharp___children = 'homeVideo___video___childImageSharp___children',
  homeVideo___video___id = 'homeVideo___video___id',
  homeVideo___video___parent___id = 'homeVideo___video___parent___id',
  homeVideo___video___parent___children = 'homeVideo___video___parent___children',
  homeVideo___video___children = 'homeVideo___video___children',
  homeVideo___video___children___id = 'homeVideo___video___children___id',
  homeVideo___video___children___children = 'homeVideo___video___children___children',
  homeVideo___video___internal___content = 'homeVideo___video___internal___content',
  homeVideo___video___internal___contentDigest = 'homeVideo___video___internal___contentDigest',
  homeVideo___video___internal___description = 'homeVideo___video___internal___description',
  homeVideo___video___internal___fieldOwners = 'homeVideo___video___internal___fieldOwners',
  homeVideo___video___internal___ignoreType = 'homeVideo___video___internal___ignoreType',
  homeVideo___video___internal___mediaType = 'homeVideo___video___internal___mediaType',
  homeVideo___video___internal___owner = 'homeVideo___video___internal___owner',
  homeVideo___video___internal___type = 'homeVideo___video___internal___type',
  homeVideo___videoPoster___sourceInstanceName = 'homeVideo___videoPoster___sourceInstanceName',
  homeVideo___videoPoster___absolutePath = 'homeVideo___videoPoster___absolutePath',
  homeVideo___videoPoster___relativePath = 'homeVideo___videoPoster___relativePath',
  homeVideo___videoPoster___extension = 'homeVideo___videoPoster___extension',
  homeVideo___videoPoster___size = 'homeVideo___videoPoster___size',
  homeVideo___videoPoster___prettySize = 'homeVideo___videoPoster___prettySize',
  homeVideo___videoPoster___modifiedTime = 'homeVideo___videoPoster___modifiedTime',
  homeVideo___videoPoster___accessTime = 'homeVideo___videoPoster___accessTime',
  homeVideo___videoPoster___changeTime = 'homeVideo___videoPoster___changeTime',
  homeVideo___videoPoster___birthTime = 'homeVideo___videoPoster___birthTime',
  homeVideo___videoPoster___root = 'homeVideo___videoPoster___root',
  homeVideo___videoPoster___dir = 'homeVideo___videoPoster___dir',
  homeVideo___videoPoster___base = 'homeVideo___videoPoster___base',
  homeVideo___videoPoster___ext = 'homeVideo___videoPoster___ext',
  homeVideo___videoPoster___name = 'homeVideo___videoPoster___name',
  homeVideo___videoPoster___relativeDirectory = 'homeVideo___videoPoster___relativeDirectory',
  homeVideo___videoPoster___dev = 'homeVideo___videoPoster___dev',
  homeVideo___videoPoster___mode = 'homeVideo___videoPoster___mode',
  homeVideo___videoPoster___nlink = 'homeVideo___videoPoster___nlink',
  homeVideo___videoPoster___uid = 'homeVideo___videoPoster___uid',
  homeVideo___videoPoster___gid = 'homeVideo___videoPoster___gid',
  homeVideo___videoPoster___rdev = 'homeVideo___videoPoster___rdev',
  homeVideo___videoPoster___ino = 'homeVideo___videoPoster___ino',
  homeVideo___videoPoster___atimeMs = 'homeVideo___videoPoster___atimeMs',
  homeVideo___videoPoster___mtimeMs = 'homeVideo___videoPoster___mtimeMs',
  homeVideo___videoPoster___ctimeMs = 'homeVideo___videoPoster___ctimeMs',
  homeVideo___videoPoster___atime = 'homeVideo___videoPoster___atime',
  homeVideo___videoPoster___mtime = 'homeVideo___videoPoster___mtime',
  homeVideo___videoPoster___ctime = 'homeVideo___videoPoster___ctime',
  homeVideo___videoPoster___birthtime = 'homeVideo___videoPoster___birthtime',
  homeVideo___videoPoster___birthtimeMs = 'homeVideo___videoPoster___birthtimeMs',
  homeVideo___videoPoster___blksize = 'homeVideo___videoPoster___blksize',
  homeVideo___videoPoster___blocks = 'homeVideo___videoPoster___blocks',
  homeVideo___videoPoster___url = 'homeVideo___videoPoster___url',
  homeVideo___videoPoster___publicURL = 'homeVideo___videoPoster___publicURL',
  homeVideo___videoPoster___childrenImageSharp = 'homeVideo___videoPoster___childrenImageSharp',
  homeVideo___videoPoster___childrenImageSharp___gatsbyImageData = 'homeVideo___videoPoster___childrenImageSharp___gatsbyImageData',
  homeVideo___videoPoster___childrenImageSharp___id = 'homeVideo___videoPoster___childrenImageSharp___id',
  homeVideo___videoPoster___childrenImageSharp___children = 'homeVideo___videoPoster___childrenImageSharp___children',
  homeVideo___videoPoster___childImageSharp___gatsbyImageData = 'homeVideo___videoPoster___childImageSharp___gatsbyImageData',
  homeVideo___videoPoster___childImageSharp___id = 'homeVideo___videoPoster___childImageSharp___id',
  homeVideo___videoPoster___childImageSharp___children = 'homeVideo___videoPoster___childImageSharp___children',
  homeVideo___videoPoster___id = 'homeVideo___videoPoster___id',
  homeVideo___videoPoster___parent___id = 'homeVideo___videoPoster___parent___id',
  homeVideo___videoPoster___parent___children = 'homeVideo___videoPoster___parent___children',
  homeVideo___videoPoster___children = 'homeVideo___videoPoster___children',
  homeVideo___videoPoster___children___id = 'homeVideo___videoPoster___children___id',
  homeVideo___videoPoster___children___children = 'homeVideo___videoPoster___children___children',
  homeVideo___videoPoster___internal___content = 'homeVideo___videoPoster___internal___content',
  homeVideo___videoPoster___internal___contentDigest = 'homeVideo___videoPoster___internal___contentDigest',
  homeVideo___videoPoster___internal___description = 'homeVideo___videoPoster___internal___description',
  homeVideo___videoPoster___internal___fieldOwners = 'homeVideo___videoPoster___internal___fieldOwners',
  homeVideo___videoPoster___internal___ignoreType = 'homeVideo___videoPoster___internal___ignoreType',
  homeVideo___videoPoster___internal___mediaType = 'homeVideo___videoPoster___internal___mediaType',
  homeVideo___videoPoster___internal___owner = 'homeVideo___videoPoster___internal___owner',
  homeVideo___videoPoster___internal___type = 'homeVideo___videoPoster___internal___type',
  homepageTitle = 'homepageTitle',
  homepageVideoHero___description = 'homepageVideoHero___description',
  homepageVideoHero___file___fileLocal___sourceInstanceName = 'homepageVideoHero___file___fileLocal___sourceInstanceName',
  homepageVideoHero___file___fileLocal___absolutePath = 'homepageVideoHero___file___fileLocal___absolutePath',
  homepageVideoHero___file___fileLocal___relativePath = 'homepageVideoHero___file___fileLocal___relativePath',
  homepageVideoHero___file___fileLocal___extension = 'homepageVideoHero___file___fileLocal___extension',
  homepageVideoHero___file___fileLocal___size = 'homepageVideoHero___file___fileLocal___size',
  homepageVideoHero___file___fileLocal___prettySize = 'homepageVideoHero___file___fileLocal___prettySize',
  homepageVideoHero___file___fileLocal___modifiedTime = 'homepageVideoHero___file___fileLocal___modifiedTime',
  homepageVideoHero___file___fileLocal___accessTime = 'homepageVideoHero___file___fileLocal___accessTime',
  homepageVideoHero___file___fileLocal___changeTime = 'homepageVideoHero___file___fileLocal___changeTime',
  homepageVideoHero___file___fileLocal___birthTime = 'homepageVideoHero___file___fileLocal___birthTime',
  homepageVideoHero___file___fileLocal___root = 'homepageVideoHero___file___fileLocal___root',
  homepageVideoHero___file___fileLocal___dir = 'homepageVideoHero___file___fileLocal___dir',
  homepageVideoHero___file___fileLocal___base = 'homepageVideoHero___file___fileLocal___base',
  homepageVideoHero___file___fileLocal___ext = 'homepageVideoHero___file___fileLocal___ext',
  homepageVideoHero___file___fileLocal___name = 'homepageVideoHero___file___fileLocal___name',
  homepageVideoHero___file___fileLocal___relativeDirectory = 'homepageVideoHero___file___fileLocal___relativeDirectory',
  homepageVideoHero___file___fileLocal___dev = 'homepageVideoHero___file___fileLocal___dev',
  homepageVideoHero___file___fileLocal___mode = 'homepageVideoHero___file___fileLocal___mode',
  homepageVideoHero___file___fileLocal___nlink = 'homepageVideoHero___file___fileLocal___nlink',
  homepageVideoHero___file___fileLocal___uid = 'homepageVideoHero___file___fileLocal___uid',
  homepageVideoHero___file___fileLocal___gid = 'homepageVideoHero___file___fileLocal___gid',
  homepageVideoHero___file___fileLocal___rdev = 'homepageVideoHero___file___fileLocal___rdev',
  homepageVideoHero___file___fileLocal___ino = 'homepageVideoHero___file___fileLocal___ino',
  homepageVideoHero___file___fileLocal___atimeMs = 'homepageVideoHero___file___fileLocal___atimeMs',
  homepageVideoHero___file___fileLocal___mtimeMs = 'homepageVideoHero___file___fileLocal___mtimeMs',
  homepageVideoHero___file___fileLocal___ctimeMs = 'homepageVideoHero___file___fileLocal___ctimeMs',
  homepageVideoHero___file___fileLocal___atime = 'homepageVideoHero___file___fileLocal___atime',
  homepageVideoHero___file___fileLocal___mtime = 'homepageVideoHero___file___fileLocal___mtime',
  homepageVideoHero___file___fileLocal___ctime = 'homepageVideoHero___file___fileLocal___ctime',
  homepageVideoHero___file___fileLocal___birthtime = 'homepageVideoHero___file___fileLocal___birthtime',
  homepageVideoHero___file___fileLocal___birthtimeMs = 'homepageVideoHero___file___fileLocal___birthtimeMs',
  homepageVideoHero___file___fileLocal___blksize = 'homepageVideoHero___file___fileLocal___blksize',
  homepageVideoHero___file___fileLocal___blocks = 'homepageVideoHero___file___fileLocal___blocks',
  homepageVideoHero___file___fileLocal___url = 'homepageVideoHero___file___fileLocal___url',
  homepageVideoHero___file___fileLocal___publicURL = 'homepageVideoHero___file___fileLocal___publicURL',
  homepageVideoHero___file___fileLocal___childrenImageSharp = 'homepageVideoHero___file___fileLocal___childrenImageSharp',
  homepageVideoHero___file___fileLocal___id = 'homepageVideoHero___file___fileLocal___id',
  homepageVideoHero___file___fileLocal___children = 'homepageVideoHero___file___fileLocal___children',
  homepageVideoHero___file___url = 'homepageVideoHero___file___url',
  homepageVideoHero___title = 'homepageVideoHero___title',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type HomeFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  additionalExternalLinks?: Maybe<HyperlinkFilterListInput>;
  brand?: Maybe<BrandFilterInput>;
  certificate?: Maybe<CertificateFilterListInput>;
  contactUs?: Maybe<ContactUsFilterInput>;
  contactUsMessage?: Maybe<MessageFilterInput>;
  coreMessage?: Maybe<MessageFilterInput>;
  currentYear?: Maybe<StringQueryOperatorInput>;
  disclaimerMessage?: Maybe<MessageFilterInput>;
  domain?: Maybe<DomainFilterInput>;
  externalLinks?: Maybe<HyperlinkFilterListInput>;
  faq?: Maybe<FaqFilterInput>;
  legals?: Maybe<LegalsFilterInput>;
  lexicon?: Maybe<LexiconFilterInput>;
  messagesNodes?: Maybe<MessageFilterListInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  product?: Maybe<StringQueryOperatorInput>;
  productsNodes?: Maybe<ProductFilterListInput>;
  secondaryMessage?: Maybe<MessageFilterInput>;
  signUp?: Maybe<SignUpFilterInput>;
  socialChannels?: Maybe<SocialChannelFilterListInput>;
  termsMessage?: Maybe<MessageFilterInput>;
  navLinks?: Maybe<NavLinkFilterListInput>;
  traits?: Maybe<TraitsFilterInput>;
  sustainabilityWidgetWebsite?: Maybe<SustainabilityWidgetFilterInput>;
  homeVideo?: Maybe<HomeVideoFilterInput>;
  homepageTitle?: Maybe<StringQueryOperatorInput>;
  homepageVideoHero?: Maybe<MediaFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type HomeGroupConnection = {
  __typename?: 'homeGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<HomeEdge>;
  nodes: Array<Home>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type HomeSortInput = {
  fields?: Maybe<Array<Maybe<HomeFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Message = Node & {
  __typename?: 'message';
  absolutePath: Scalars['String'];
  benefitImages?: Maybe<Array<Maybe<BenefitImages>>>;
  benefits?: Maybe<Array<Maybe<Scalars['String']>>>;
  benefitsDisclaimer?: Maybe<Scalars['String']>;
  certificate?: Maybe<Array<Maybe<Certificate>>>;
  facts?: Maybe<Array<Maybe<Fact>>>;
  hero: Media;
  heroVideo?: Maybe<Media>;
  main?: Maybe<Main>;
  metaDescription?: Maybe<Scalars['String']>;
  pageTitle: Scalars['String'];
  pageType?: Maybe<Scalars['String']>;
  parentTopic?: Maybe<Topic>;
  path: Scalars['String'];
  product: Scalars['String'];
  productsNodes?: Maybe<Array<Maybe<Product>>>;
  slug: Scalars['String'];
  summary: Scalars['String'];
  summaryBackground?: Maybe<Media>;
  teaserImage?: Maybe<Media>;
  territoryWidget?: Maybe<Territory>;
  title: Scalars['String'];
  traits?: Maybe<Traits>;
  video?: Maybe<Media>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type MessageConnection = {
  __typename?: 'messageConnection';
  totalCount: Scalars['Int'];
  edges: Array<MessageEdge>;
  nodes: Array<Message>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<MessageGroupConnection>;
};


export type MessageConnectionDistinctArgs = {
  field: MessageFieldsEnum;
};


export type MessageConnectionMaxArgs = {
  field: MessageFieldsEnum;
};


export type MessageConnectionMinArgs = {
  field: MessageFieldsEnum;
};


export type MessageConnectionSumArgs = {
  field: MessageFieldsEnum;
};


export type MessageConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: MessageFieldsEnum;
};

export type MessageEdge = {
  __typename?: 'messageEdge';
  next?: Maybe<Message>;
  node: Message;
  previous?: Maybe<Message>;
};

export enum MessageFieldsEnum {
  absolutePath = 'absolutePath',
  benefitImages = 'benefitImages',
  benefitImages___description = 'benefitImages___description',
  benefitImages___file___fileLocal___sourceInstanceName = 'benefitImages___file___fileLocal___sourceInstanceName',
  benefitImages___file___fileLocal___absolutePath = 'benefitImages___file___fileLocal___absolutePath',
  benefitImages___file___fileLocal___relativePath = 'benefitImages___file___fileLocal___relativePath',
  benefitImages___file___fileLocal___extension = 'benefitImages___file___fileLocal___extension',
  benefitImages___file___fileLocal___size = 'benefitImages___file___fileLocal___size',
  benefitImages___file___fileLocal___prettySize = 'benefitImages___file___fileLocal___prettySize',
  benefitImages___file___fileLocal___modifiedTime = 'benefitImages___file___fileLocal___modifiedTime',
  benefitImages___file___fileLocal___accessTime = 'benefitImages___file___fileLocal___accessTime',
  benefitImages___file___fileLocal___changeTime = 'benefitImages___file___fileLocal___changeTime',
  benefitImages___file___fileLocal___birthTime = 'benefitImages___file___fileLocal___birthTime',
  benefitImages___file___fileLocal___root = 'benefitImages___file___fileLocal___root',
  benefitImages___file___fileLocal___dir = 'benefitImages___file___fileLocal___dir',
  benefitImages___file___fileLocal___base = 'benefitImages___file___fileLocal___base',
  benefitImages___file___fileLocal___ext = 'benefitImages___file___fileLocal___ext',
  benefitImages___file___fileLocal___name = 'benefitImages___file___fileLocal___name',
  benefitImages___file___fileLocal___relativeDirectory = 'benefitImages___file___fileLocal___relativeDirectory',
  benefitImages___file___fileLocal___dev = 'benefitImages___file___fileLocal___dev',
  benefitImages___file___fileLocal___mode = 'benefitImages___file___fileLocal___mode',
  benefitImages___file___fileLocal___nlink = 'benefitImages___file___fileLocal___nlink',
  benefitImages___file___fileLocal___uid = 'benefitImages___file___fileLocal___uid',
  benefitImages___file___fileLocal___gid = 'benefitImages___file___fileLocal___gid',
  benefitImages___file___fileLocal___rdev = 'benefitImages___file___fileLocal___rdev',
  benefitImages___file___fileLocal___ino = 'benefitImages___file___fileLocal___ino',
  benefitImages___file___fileLocal___atimeMs = 'benefitImages___file___fileLocal___atimeMs',
  benefitImages___file___fileLocal___mtimeMs = 'benefitImages___file___fileLocal___mtimeMs',
  benefitImages___file___fileLocal___ctimeMs = 'benefitImages___file___fileLocal___ctimeMs',
  benefitImages___file___fileLocal___atime = 'benefitImages___file___fileLocal___atime',
  benefitImages___file___fileLocal___mtime = 'benefitImages___file___fileLocal___mtime',
  benefitImages___file___fileLocal___ctime = 'benefitImages___file___fileLocal___ctime',
  benefitImages___file___fileLocal___birthtime = 'benefitImages___file___fileLocal___birthtime',
  benefitImages___file___fileLocal___birthtimeMs = 'benefitImages___file___fileLocal___birthtimeMs',
  benefitImages___file___fileLocal___blksize = 'benefitImages___file___fileLocal___blksize',
  benefitImages___file___fileLocal___blocks = 'benefitImages___file___fileLocal___blocks',
  benefitImages___file___fileLocal___url = 'benefitImages___file___fileLocal___url',
  benefitImages___file___fileLocal___publicURL = 'benefitImages___file___fileLocal___publicURL',
  benefitImages___file___fileLocal___childrenImageSharp = 'benefitImages___file___fileLocal___childrenImageSharp',
  benefitImages___file___fileLocal___id = 'benefitImages___file___fileLocal___id',
  benefitImages___file___fileLocal___children = 'benefitImages___file___fileLocal___children',
  benefitImages___file___url = 'benefitImages___file___url',
  benefits = 'benefits',
  benefitsDisclaimer = 'benefitsDisclaimer',
  certificate = 'certificate',
  certificate___image___description = 'certificate___image___description',
  certificate___image___file___url = 'certificate___image___file___url',
  certificate___image___title = 'certificate___image___title',
  certificate___title = 'certificate___title',
  certificate___url = 'certificate___url',
  facts = 'facts',
  facts___image___description = 'facts___image___description',
  facts___image___file___url = 'facts___image___file___url',
  facts___image___title = 'facts___image___title',
  facts___summary = 'facts___summary',
  facts___title = 'facts___title',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  heroVideo___description = 'heroVideo___description',
  heroVideo___file___fileLocal___sourceInstanceName = 'heroVideo___file___fileLocal___sourceInstanceName',
  heroVideo___file___fileLocal___absolutePath = 'heroVideo___file___fileLocal___absolutePath',
  heroVideo___file___fileLocal___relativePath = 'heroVideo___file___fileLocal___relativePath',
  heroVideo___file___fileLocal___extension = 'heroVideo___file___fileLocal___extension',
  heroVideo___file___fileLocal___size = 'heroVideo___file___fileLocal___size',
  heroVideo___file___fileLocal___prettySize = 'heroVideo___file___fileLocal___prettySize',
  heroVideo___file___fileLocal___modifiedTime = 'heroVideo___file___fileLocal___modifiedTime',
  heroVideo___file___fileLocal___accessTime = 'heroVideo___file___fileLocal___accessTime',
  heroVideo___file___fileLocal___changeTime = 'heroVideo___file___fileLocal___changeTime',
  heroVideo___file___fileLocal___birthTime = 'heroVideo___file___fileLocal___birthTime',
  heroVideo___file___fileLocal___root = 'heroVideo___file___fileLocal___root',
  heroVideo___file___fileLocal___dir = 'heroVideo___file___fileLocal___dir',
  heroVideo___file___fileLocal___base = 'heroVideo___file___fileLocal___base',
  heroVideo___file___fileLocal___ext = 'heroVideo___file___fileLocal___ext',
  heroVideo___file___fileLocal___name = 'heroVideo___file___fileLocal___name',
  heroVideo___file___fileLocal___relativeDirectory = 'heroVideo___file___fileLocal___relativeDirectory',
  heroVideo___file___fileLocal___dev = 'heroVideo___file___fileLocal___dev',
  heroVideo___file___fileLocal___mode = 'heroVideo___file___fileLocal___mode',
  heroVideo___file___fileLocal___nlink = 'heroVideo___file___fileLocal___nlink',
  heroVideo___file___fileLocal___uid = 'heroVideo___file___fileLocal___uid',
  heroVideo___file___fileLocal___gid = 'heroVideo___file___fileLocal___gid',
  heroVideo___file___fileLocal___rdev = 'heroVideo___file___fileLocal___rdev',
  heroVideo___file___fileLocal___ino = 'heroVideo___file___fileLocal___ino',
  heroVideo___file___fileLocal___atimeMs = 'heroVideo___file___fileLocal___atimeMs',
  heroVideo___file___fileLocal___mtimeMs = 'heroVideo___file___fileLocal___mtimeMs',
  heroVideo___file___fileLocal___ctimeMs = 'heroVideo___file___fileLocal___ctimeMs',
  heroVideo___file___fileLocal___atime = 'heroVideo___file___fileLocal___atime',
  heroVideo___file___fileLocal___mtime = 'heroVideo___file___fileLocal___mtime',
  heroVideo___file___fileLocal___ctime = 'heroVideo___file___fileLocal___ctime',
  heroVideo___file___fileLocal___birthtime = 'heroVideo___file___fileLocal___birthtime',
  heroVideo___file___fileLocal___birthtimeMs = 'heroVideo___file___fileLocal___birthtimeMs',
  heroVideo___file___fileLocal___blksize = 'heroVideo___file___fileLocal___blksize',
  heroVideo___file___fileLocal___blocks = 'heroVideo___file___fileLocal___blocks',
  heroVideo___file___fileLocal___url = 'heroVideo___file___fileLocal___url',
  heroVideo___file___fileLocal___publicURL = 'heroVideo___file___fileLocal___publicURL',
  heroVideo___file___fileLocal___childrenImageSharp = 'heroVideo___file___fileLocal___childrenImageSharp',
  heroVideo___file___fileLocal___id = 'heroVideo___file___fileLocal___id',
  heroVideo___file___fileLocal___children = 'heroVideo___file___fileLocal___children',
  heroVideo___file___url = 'heroVideo___file___url',
  heroVideo___title = 'heroVideo___title',
  main___htmlTruncated = 'main___htmlTruncated',
  main___html = 'main___html',
  main___rawContent = 'main___rawContent',
  main___text = 'main___text',
  metaDescription = 'metaDescription',
  pageTitle = 'pageTitle',
  pageType = 'pageType',
  parentTopic___absolutePath = 'parentTopic___absolutePath',
  parentTopic___hero___description = 'parentTopic___hero___description',
  parentTopic___hero___file___url = 'parentTopic___hero___file___url',
  parentTopic___hero___title = 'parentTopic___hero___title',
  parentTopic___messagesNodes = 'parentTopic___messagesNodes',
  parentTopic___messagesNodes___absolutePath = 'parentTopic___messagesNodes___absolutePath',
  parentTopic___messagesNodes___benefitImages = 'parentTopic___messagesNodes___benefitImages',
  parentTopic___messagesNodes___benefitImages___description = 'parentTopic___messagesNodes___benefitImages___description',
  parentTopic___messagesNodes___benefits = 'parentTopic___messagesNodes___benefits',
  parentTopic___messagesNodes___benefitsDisclaimer = 'parentTopic___messagesNodes___benefitsDisclaimer',
  parentTopic___messagesNodes___certificate = 'parentTopic___messagesNodes___certificate',
  parentTopic___messagesNodes___certificate___title = 'parentTopic___messagesNodes___certificate___title',
  parentTopic___messagesNodes___certificate___url = 'parentTopic___messagesNodes___certificate___url',
  parentTopic___messagesNodes___facts = 'parentTopic___messagesNodes___facts',
  parentTopic___messagesNodes___facts___summary = 'parentTopic___messagesNodes___facts___summary',
  parentTopic___messagesNodes___facts___title = 'parentTopic___messagesNodes___facts___title',
  parentTopic___messagesNodes___hero___description = 'parentTopic___messagesNodes___hero___description',
  parentTopic___messagesNodes___hero___title = 'parentTopic___messagesNodes___hero___title',
  parentTopic___messagesNodes___heroVideo___description = 'parentTopic___messagesNodes___heroVideo___description',
  parentTopic___messagesNodes___heroVideo___title = 'parentTopic___messagesNodes___heroVideo___title',
  parentTopic___messagesNodes___main___htmlTruncated = 'parentTopic___messagesNodes___main___htmlTruncated',
  parentTopic___messagesNodes___main___html = 'parentTopic___messagesNodes___main___html',
  parentTopic___messagesNodes___main___rawContent = 'parentTopic___messagesNodes___main___rawContent',
  parentTopic___messagesNodes___main___text = 'parentTopic___messagesNodes___main___text',
  parentTopic___messagesNodes___metaDescription = 'parentTopic___messagesNodes___metaDescription',
  parentTopic___messagesNodes___pageTitle = 'parentTopic___messagesNodes___pageTitle',
  parentTopic___messagesNodes___pageType = 'parentTopic___messagesNodes___pageType',
  parentTopic___messagesNodes___parentTopic___absolutePath = 'parentTopic___messagesNodes___parentTopic___absolutePath',
  parentTopic___messagesNodes___parentTopic___messagesNodes = 'parentTopic___messagesNodes___parentTopic___messagesNodes',
  parentTopic___messagesNodes___parentTopic___metaDescription = 'parentTopic___messagesNodes___parentTopic___metaDescription',
  parentTopic___messagesNodes___parentTopic___navigationTitle = 'parentTopic___messagesNodes___parentTopic___navigationTitle',
  parentTopic___messagesNodes___parentTopic___topicDisclaimer = 'parentTopic___messagesNodes___parentTopic___topicDisclaimer',
  parentTopic___messagesNodes___parentTopic___pageTitle = 'parentTopic___messagesNodes___parentTopic___pageTitle',
  parentTopic___messagesNodes___parentTopic___pageType = 'parentTopic___messagesNodes___parentTopic___pageType',
  parentTopic___messagesNodes___parentTopic___path = 'parentTopic___messagesNodes___parentTopic___path',
  parentTopic___messagesNodes___parentTopic___slug = 'parentTopic___messagesNodes___parentTopic___slug',
  parentTopic___messagesNodes___parentTopic___summary = 'parentTopic___messagesNodes___parentTopic___summary',
  parentTopic___messagesNodes___parentTopic___title = 'parentTopic___messagesNodes___parentTopic___title',
  parentTopic___messagesNodes___parentTopic___id = 'parentTopic___messagesNodes___parentTopic___id',
  parentTopic___messagesNodes___parentTopic___children = 'parentTopic___messagesNodes___parentTopic___children',
  parentTopic___messagesNodes___path = 'parentTopic___messagesNodes___path',
  parentTopic___messagesNodes___product = 'parentTopic___messagesNodes___product',
  parentTopic___messagesNodes___productsNodes = 'parentTopic___messagesNodes___productsNodes',
  parentTopic___messagesNodes___productsNodes___absolutePath = 'parentTopic___messagesNodes___productsNodes___absolutePath',
  parentTopic___messagesNodes___productsNodes___benefits = 'parentTopic___messagesNodes___productsNodes___benefits',
  parentTopic___messagesNodes___productsNodes___benefitsDisclaimer = 'parentTopic___messagesNodes___productsNodes___benefitsDisclaimer',
  parentTopic___messagesNodes___productsNodes___metaDescription = 'parentTopic___messagesNodes___productsNodes___metaDescription',
  parentTopic___messagesNodes___productsNodes___name = 'parentTopic___messagesNodes___productsNodes___name',
  parentTopic___messagesNodes___productsNodes___pageTitle = 'parentTopic___messagesNodes___productsNodes___pageTitle',
  parentTopic___messagesNodes___productsNodes___pageType = 'parentTopic___messagesNodes___productsNodes___pageType',
  parentTopic___messagesNodes___productsNodes___path = 'parentTopic___messagesNodes___productsNodes___path',
  parentTopic___messagesNodes___productsNodes___slug = 'parentTopic___messagesNodes___productsNodes___slug',
  parentTopic___messagesNodes___productsNodes___variants = 'parentTopic___messagesNodes___productsNodes___variants',
  parentTopic___messagesNodes___productsNodes___id = 'parentTopic___messagesNodes___productsNodes___id',
  parentTopic___messagesNodes___productsNodes___children = 'parentTopic___messagesNodes___productsNodes___children',
  parentTopic___messagesNodes___slug = 'parentTopic___messagesNodes___slug',
  parentTopic___messagesNodes___summary = 'parentTopic___messagesNodes___summary',
  parentTopic___messagesNodes___summaryBackground___description = 'parentTopic___messagesNodes___summaryBackground___description',
  parentTopic___messagesNodes___summaryBackground___title = 'parentTopic___messagesNodes___summaryBackground___title',
  parentTopic___messagesNodes___teaserImage___description = 'parentTopic___messagesNodes___teaserImage___description',
  parentTopic___messagesNodes___teaserImage___title = 'parentTopic___messagesNodes___teaserImage___title',
  parentTopic___messagesNodes___territoryWidget___bottomHeading = 'parentTopic___messagesNodes___territoryWidget___bottomHeading',
  parentTopic___messagesNodes___territoryWidget___graphicHeading = 'parentTopic___messagesNodes___territoryWidget___graphicHeading',
  parentTopic___messagesNodes___territoryWidget___topCopy = 'parentTopic___messagesNodes___territoryWidget___topCopy',
  parentTopic___messagesNodes___territoryWidget___topHeading = 'parentTopic___messagesNodes___territoryWidget___topHeading',
  parentTopic___messagesNodes___title = 'parentTopic___messagesNodes___title',
  parentTopic___messagesNodes___traits___traitsStringified = 'parentTopic___messagesNodes___traits___traitsStringified',
  parentTopic___messagesNodes___video___description = 'parentTopic___messagesNodes___video___description',
  parentTopic___messagesNodes___video___title = 'parentTopic___messagesNodes___video___title',
  parentTopic___messagesNodes___id = 'parentTopic___messagesNodes___id',
  parentTopic___messagesNodes___parent___id = 'parentTopic___messagesNodes___parent___id',
  parentTopic___messagesNodes___parent___children = 'parentTopic___messagesNodes___parent___children',
  parentTopic___messagesNodes___children = 'parentTopic___messagesNodes___children',
  parentTopic___messagesNodes___children___id = 'parentTopic___messagesNodes___children___id',
  parentTopic___messagesNodes___children___children = 'parentTopic___messagesNodes___children___children',
  parentTopic___messagesNodes___internal___content = 'parentTopic___messagesNodes___internal___content',
  parentTopic___messagesNodes___internal___contentDigest = 'parentTopic___messagesNodes___internal___contentDigest',
  parentTopic___messagesNodes___internal___description = 'parentTopic___messagesNodes___internal___description',
  parentTopic___messagesNodes___internal___fieldOwners = 'parentTopic___messagesNodes___internal___fieldOwners',
  parentTopic___messagesNodes___internal___ignoreType = 'parentTopic___messagesNodes___internal___ignoreType',
  parentTopic___messagesNodes___internal___mediaType = 'parentTopic___messagesNodes___internal___mediaType',
  parentTopic___messagesNodes___internal___owner = 'parentTopic___messagesNodes___internal___owner',
  parentTopic___messagesNodes___internal___type = 'parentTopic___messagesNodes___internal___type',
  parentTopic___metaDescription = 'parentTopic___metaDescription',
  parentTopic___navigationTitle = 'parentTopic___navigationTitle',
  parentTopic___topicDisclaimer = 'parentTopic___topicDisclaimer',
  parentTopic___pageTitle = 'parentTopic___pageTitle',
  parentTopic___pageType = 'parentTopic___pageType',
  parentTopic___path = 'parentTopic___path',
  parentTopic___slug = 'parentTopic___slug',
  parentTopic___summary = 'parentTopic___summary',
  parentTopic___title = 'parentTopic___title',
  parentTopic___traits___traitsStringified = 'parentTopic___traits___traitsStringified',
  parentTopic___id = 'parentTopic___id',
  parentTopic___parent___id = 'parentTopic___parent___id',
  parentTopic___parent___parent___id = 'parentTopic___parent___parent___id',
  parentTopic___parent___parent___children = 'parentTopic___parent___parent___children',
  parentTopic___parent___children = 'parentTopic___parent___children',
  parentTopic___parent___children___id = 'parentTopic___parent___children___id',
  parentTopic___parent___children___children = 'parentTopic___parent___children___children',
  parentTopic___parent___internal___content = 'parentTopic___parent___internal___content',
  parentTopic___parent___internal___contentDigest = 'parentTopic___parent___internal___contentDigest',
  parentTopic___parent___internal___description = 'parentTopic___parent___internal___description',
  parentTopic___parent___internal___fieldOwners = 'parentTopic___parent___internal___fieldOwners',
  parentTopic___parent___internal___ignoreType = 'parentTopic___parent___internal___ignoreType',
  parentTopic___parent___internal___mediaType = 'parentTopic___parent___internal___mediaType',
  parentTopic___parent___internal___owner = 'parentTopic___parent___internal___owner',
  parentTopic___parent___internal___type = 'parentTopic___parent___internal___type',
  parentTopic___children = 'parentTopic___children',
  parentTopic___children___id = 'parentTopic___children___id',
  parentTopic___children___parent___id = 'parentTopic___children___parent___id',
  parentTopic___children___parent___children = 'parentTopic___children___parent___children',
  parentTopic___children___children = 'parentTopic___children___children',
  parentTopic___children___children___id = 'parentTopic___children___children___id',
  parentTopic___children___children___children = 'parentTopic___children___children___children',
  parentTopic___children___internal___content = 'parentTopic___children___internal___content',
  parentTopic___children___internal___contentDigest = 'parentTopic___children___internal___contentDigest',
  parentTopic___children___internal___description = 'parentTopic___children___internal___description',
  parentTopic___children___internal___fieldOwners = 'parentTopic___children___internal___fieldOwners',
  parentTopic___children___internal___ignoreType = 'parentTopic___children___internal___ignoreType',
  parentTopic___children___internal___mediaType = 'parentTopic___children___internal___mediaType',
  parentTopic___children___internal___owner = 'parentTopic___children___internal___owner',
  parentTopic___children___internal___type = 'parentTopic___children___internal___type',
  parentTopic___internal___content = 'parentTopic___internal___content',
  parentTopic___internal___contentDigest = 'parentTopic___internal___contentDigest',
  parentTopic___internal___description = 'parentTopic___internal___description',
  parentTopic___internal___fieldOwners = 'parentTopic___internal___fieldOwners',
  parentTopic___internal___ignoreType = 'parentTopic___internal___ignoreType',
  parentTopic___internal___mediaType = 'parentTopic___internal___mediaType',
  parentTopic___internal___owner = 'parentTopic___internal___owner',
  parentTopic___internal___type = 'parentTopic___internal___type',
  path = 'path',
  product = 'product',
  productsNodes = 'productsNodes',
  productsNodes___absolutePath = 'productsNodes___absolutePath',
  productsNodes___benefits = 'productsNodes___benefits',
  productsNodes___benefitsDisclaimer = 'productsNodes___benefitsDisclaimer',
  productsNodes___description___htmlTruncated = 'productsNodes___description___htmlTruncated',
  productsNodes___description___html = 'productsNodes___description___html',
  productsNodes___description___rawContent = 'productsNodes___description___rawContent',
  productsNodes___description___text = 'productsNodes___description___text',
  productsNodes___hero___description = 'productsNodes___hero___description',
  productsNodes___hero___file___url = 'productsNodes___hero___file___url',
  productsNodes___hero___title = 'productsNodes___hero___title',
  productsNodes___howToUse___html = 'productsNodes___howToUse___html',
  productsNodes___howToUse___json = 'productsNodes___howToUse___json',
  productsNodes___howToUse___text = 'productsNodes___howToUse___text',
  productsNodes___main___htmlTruncated = 'productsNodes___main___htmlTruncated',
  productsNodes___main___html = 'productsNodes___main___html',
  productsNodes___main___rawContent = 'productsNodes___main___rawContent',
  productsNodes___main___text = 'productsNodes___main___text',
  productsNodes___metaDescription = 'productsNodes___metaDescription',
  productsNodes___name = 'productsNodes___name',
  productsNodes___pageTitle = 'productsNodes___pageTitle',
  productsNodes___pageType = 'productsNodes___pageType',
  productsNodes___parentMessage___absolutePath = 'productsNodes___parentMessage___absolutePath',
  productsNodes___parentMessage___benefitImages = 'productsNodes___parentMessage___benefitImages',
  productsNodes___parentMessage___benefitImages___description = 'productsNodes___parentMessage___benefitImages___description',
  productsNodes___parentMessage___benefits = 'productsNodes___parentMessage___benefits',
  productsNodes___parentMessage___benefitsDisclaimer = 'productsNodes___parentMessage___benefitsDisclaimer',
  productsNodes___parentMessage___certificate = 'productsNodes___parentMessage___certificate',
  productsNodes___parentMessage___certificate___title = 'productsNodes___parentMessage___certificate___title',
  productsNodes___parentMessage___certificate___url = 'productsNodes___parentMessage___certificate___url',
  productsNodes___parentMessage___facts = 'productsNodes___parentMessage___facts',
  productsNodes___parentMessage___facts___summary = 'productsNodes___parentMessage___facts___summary',
  productsNodes___parentMessage___facts___title = 'productsNodes___parentMessage___facts___title',
  productsNodes___parentMessage___hero___description = 'productsNodes___parentMessage___hero___description',
  productsNodes___parentMessage___hero___title = 'productsNodes___parentMessage___hero___title',
  productsNodes___parentMessage___heroVideo___description = 'productsNodes___parentMessage___heroVideo___description',
  productsNodes___parentMessage___heroVideo___title = 'productsNodes___parentMessage___heroVideo___title',
  productsNodes___parentMessage___main___htmlTruncated = 'productsNodes___parentMessage___main___htmlTruncated',
  productsNodes___parentMessage___main___html = 'productsNodes___parentMessage___main___html',
  productsNodes___parentMessage___main___rawContent = 'productsNodes___parentMessage___main___rawContent',
  productsNodes___parentMessage___main___text = 'productsNodes___parentMessage___main___text',
  productsNodes___parentMessage___metaDescription = 'productsNodes___parentMessage___metaDescription',
  productsNodes___parentMessage___pageTitle = 'productsNodes___parentMessage___pageTitle',
  productsNodes___parentMessage___pageType = 'productsNodes___parentMessage___pageType',
  productsNodes___parentMessage___parentTopic___absolutePath = 'productsNodes___parentMessage___parentTopic___absolutePath',
  productsNodes___parentMessage___parentTopic___messagesNodes = 'productsNodes___parentMessage___parentTopic___messagesNodes',
  productsNodes___parentMessage___parentTopic___metaDescription = 'productsNodes___parentMessage___parentTopic___metaDescription',
  productsNodes___parentMessage___parentTopic___navigationTitle = 'productsNodes___parentMessage___parentTopic___navigationTitle',
  productsNodes___parentMessage___parentTopic___topicDisclaimer = 'productsNodes___parentMessage___parentTopic___topicDisclaimer',
  productsNodes___parentMessage___parentTopic___pageTitle = 'productsNodes___parentMessage___parentTopic___pageTitle',
  productsNodes___parentMessage___parentTopic___pageType = 'productsNodes___parentMessage___parentTopic___pageType',
  productsNodes___parentMessage___parentTopic___path = 'productsNodes___parentMessage___parentTopic___path',
  productsNodes___parentMessage___parentTopic___slug = 'productsNodes___parentMessage___parentTopic___slug',
  productsNodes___parentMessage___parentTopic___summary = 'productsNodes___parentMessage___parentTopic___summary',
  productsNodes___parentMessage___parentTopic___title = 'productsNodes___parentMessage___parentTopic___title',
  productsNodes___parentMessage___parentTopic___id = 'productsNodes___parentMessage___parentTopic___id',
  productsNodes___parentMessage___parentTopic___children = 'productsNodes___parentMessage___parentTopic___children',
  productsNodes___parentMessage___path = 'productsNodes___parentMessage___path',
  productsNodes___parentMessage___product = 'productsNodes___parentMessage___product',
  productsNodes___parentMessage___productsNodes = 'productsNodes___parentMessage___productsNodes',
  productsNodes___parentMessage___productsNodes___absolutePath = 'productsNodes___parentMessage___productsNodes___absolutePath',
  productsNodes___parentMessage___productsNodes___benefits = 'productsNodes___parentMessage___productsNodes___benefits',
  productsNodes___parentMessage___productsNodes___benefitsDisclaimer = 'productsNodes___parentMessage___productsNodes___benefitsDisclaimer',
  productsNodes___parentMessage___productsNodes___metaDescription = 'productsNodes___parentMessage___productsNodes___metaDescription',
  productsNodes___parentMessage___productsNodes___name = 'productsNodes___parentMessage___productsNodes___name',
  productsNodes___parentMessage___productsNodes___pageTitle = 'productsNodes___parentMessage___productsNodes___pageTitle',
  productsNodes___parentMessage___productsNodes___pageType = 'productsNodes___parentMessage___productsNodes___pageType',
  productsNodes___parentMessage___productsNodes___path = 'productsNodes___parentMessage___productsNodes___path',
  productsNodes___parentMessage___productsNodes___slug = 'productsNodes___parentMessage___productsNodes___slug',
  productsNodes___parentMessage___productsNodes___variants = 'productsNodes___parentMessage___productsNodes___variants',
  productsNodes___parentMessage___productsNodes___id = 'productsNodes___parentMessage___productsNodes___id',
  productsNodes___parentMessage___productsNodes___children = 'productsNodes___parentMessage___productsNodes___children',
  productsNodes___parentMessage___slug = 'productsNodes___parentMessage___slug',
  productsNodes___parentMessage___summary = 'productsNodes___parentMessage___summary',
  productsNodes___parentMessage___summaryBackground___description = 'productsNodes___parentMessage___summaryBackground___description',
  productsNodes___parentMessage___summaryBackground___title = 'productsNodes___parentMessage___summaryBackground___title',
  productsNodes___parentMessage___teaserImage___description = 'productsNodes___parentMessage___teaserImage___description',
  productsNodes___parentMessage___teaserImage___title = 'productsNodes___parentMessage___teaserImage___title',
  productsNodes___parentMessage___territoryWidget___bottomHeading = 'productsNodes___parentMessage___territoryWidget___bottomHeading',
  productsNodes___parentMessage___territoryWidget___graphicHeading = 'productsNodes___parentMessage___territoryWidget___graphicHeading',
  productsNodes___parentMessage___territoryWidget___topCopy = 'productsNodes___parentMessage___territoryWidget___topCopy',
  productsNodes___parentMessage___territoryWidget___topHeading = 'productsNodes___parentMessage___territoryWidget___topHeading',
  productsNodes___parentMessage___title = 'productsNodes___parentMessage___title',
  productsNodes___parentMessage___traits___traitsStringified = 'productsNodes___parentMessage___traits___traitsStringified',
  productsNodes___parentMessage___video___description = 'productsNodes___parentMessage___video___description',
  productsNodes___parentMessage___video___title = 'productsNodes___parentMessage___video___title',
  productsNodes___parentMessage___id = 'productsNodes___parentMessage___id',
  productsNodes___parentMessage___parent___id = 'productsNodes___parentMessage___parent___id',
  productsNodes___parentMessage___parent___children = 'productsNodes___parentMessage___parent___children',
  productsNodes___parentMessage___children = 'productsNodes___parentMessage___children',
  productsNodes___parentMessage___children___id = 'productsNodes___parentMessage___children___id',
  productsNodes___parentMessage___children___children = 'productsNodes___parentMessage___children___children',
  productsNodes___parentMessage___internal___content = 'productsNodes___parentMessage___internal___content',
  productsNodes___parentMessage___internal___contentDigest = 'productsNodes___parentMessage___internal___contentDigest',
  productsNodes___parentMessage___internal___description = 'productsNodes___parentMessage___internal___description',
  productsNodes___parentMessage___internal___fieldOwners = 'productsNodes___parentMessage___internal___fieldOwners',
  productsNodes___parentMessage___internal___ignoreType = 'productsNodes___parentMessage___internal___ignoreType',
  productsNodes___parentMessage___internal___mediaType = 'productsNodes___parentMessage___internal___mediaType',
  productsNodes___parentMessage___internal___owner = 'productsNodes___parentMessage___internal___owner',
  productsNodes___parentMessage___internal___type = 'productsNodes___parentMessage___internal___type',
  productsNodes___path = 'productsNodes___path',
  productsNodes___slug = 'productsNodes___slug',
  productsNodes___summaryBackground___description = 'productsNodes___summaryBackground___description',
  productsNodes___summaryBackground___file___url = 'productsNodes___summaryBackground___file___url',
  productsNodes___summaryBackground___title = 'productsNodes___summaryBackground___title',
  productsNodes___traits___traitsStringified = 'productsNodes___traits___traitsStringified',
  productsNodes___variants = 'productsNodes___variants',
  productsNodes___variants___buyItNowUrl = 'productsNodes___variants___buyItNowUrl',
  productsNodes___variants___ingredientsBlurb___html = 'productsNodes___variants___ingredientsBlurb___html',
  productsNodes___variants___ingredientsBlurb___json = 'productsNodes___variants___ingredientsBlurb___json',
  productsNodes___variants___ingredientsBlurb___text = 'productsNodes___variants___ingredientsBlurb___text',
  productsNodes___variants___name = 'productsNodes___variants___name',
  productsNodes___variants___packshot___description = 'productsNodes___variants___packshot___description',
  productsNodes___variants___packshot___title = 'productsNodes___variants___packshot___title',
  productsNodes___variants___product = 'productsNodes___variants___product',
  productsNodes___variants___sizes = 'productsNodes___variants___sizes',
  productsNodes___fields___kritiqueRating___averageRating = 'productsNodes___fields___kritiqueRating___averageRating',
  productsNodes___fields___kritiqueRating___reviewCount = 'productsNodes___fields___kritiqueRating___reviewCount',
  productsNodes___fields___kritiqueRating___reviews = 'productsNodes___fields___kritiqueRating___reviews',
  productsNodes___id = 'productsNodes___id',
  productsNodes___parent___id = 'productsNodes___parent___id',
  productsNodes___parent___parent___id = 'productsNodes___parent___parent___id',
  productsNodes___parent___parent___children = 'productsNodes___parent___parent___children',
  productsNodes___parent___children = 'productsNodes___parent___children',
  productsNodes___parent___children___id = 'productsNodes___parent___children___id',
  productsNodes___parent___children___children = 'productsNodes___parent___children___children',
  productsNodes___parent___internal___content = 'productsNodes___parent___internal___content',
  productsNodes___parent___internal___contentDigest = 'productsNodes___parent___internal___contentDigest',
  productsNodes___parent___internal___description = 'productsNodes___parent___internal___description',
  productsNodes___parent___internal___fieldOwners = 'productsNodes___parent___internal___fieldOwners',
  productsNodes___parent___internal___ignoreType = 'productsNodes___parent___internal___ignoreType',
  productsNodes___parent___internal___mediaType = 'productsNodes___parent___internal___mediaType',
  productsNodes___parent___internal___owner = 'productsNodes___parent___internal___owner',
  productsNodes___parent___internal___type = 'productsNodes___parent___internal___type',
  productsNodes___children = 'productsNodes___children',
  productsNodes___children___id = 'productsNodes___children___id',
  productsNodes___children___parent___id = 'productsNodes___children___parent___id',
  productsNodes___children___parent___children = 'productsNodes___children___parent___children',
  productsNodes___children___children = 'productsNodes___children___children',
  productsNodes___children___children___id = 'productsNodes___children___children___id',
  productsNodes___children___children___children = 'productsNodes___children___children___children',
  productsNodes___children___internal___content = 'productsNodes___children___internal___content',
  productsNodes___children___internal___contentDigest = 'productsNodes___children___internal___contentDigest',
  productsNodes___children___internal___description = 'productsNodes___children___internal___description',
  productsNodes___children___internal___fieldOwners = 'productsNodes___children___internal___fieldOwners',
  productsNodes___children___internal___ignoreType = 'productsNodes___children___internal___ignoreType',
  productsNodes___children___internal___mediaType = 'productsNodes___children___internal___mediaType',
  productsNodes___children___internal___owner = 'productsNodes___children___internal___owner',
  productsNodes___children___internal___type = 'productsNodes___children___internal___type',
  productsNodes___internal___content = 'productsNodes___internal___content',
  productsNodes___internal___contentDigest = 'productsNodes___internal___contentDigest',
  productsNodes___internal___description = 'productsNodes___internal___description',
  productsNodes___internal___fieldOwners = 'productsNodes___internal___fieldOwners',
  productsNodes___internal___ignoreType = 'productsNodes___internal___ignoreType',
  productsNodes___internal___mediaType = 'productsNodes___internal___mediaType',
  productsNodes___internal___owner = 'productsNodes___internal___owner',
  productsNodes___internal___type = 'productsNodes___internal___type',
  slug = 'slug',
  summary = 'summary',
  summaryBackground___description = 'summaryBackground___description',
  summaryBackground___file___fileLocal___sourceInstanceName = 'summaryBackground___file___fileLocal___sourceInstanceName',
  summaryBackground___file___fileLocal___absolutePath = 'summaryBackground___file___fileLocal___absolutePath',
  summaryBackground___file___fileLocal___relativePath = 'summaryBackground___file___fileLocal___relativePath',
  summaryBackground___file___fileLocal___extension = 'summaryBackground___file___fileLocal___extension',
  summaryBackground___file___fileLocal___size = 'summaryBackground___file___fileLocal___size',
  summaryBackground___file___fileLocal___prettySize = 'summaryBackground___file___fileLocal___prettySize',
  summaryBackground___file___fileLocal___modifiedTime = 'summaryBackground___file___fileLocal___modifiedTime',
  summaryBackground___file___fileLocal___accessTime = 'summaryBackground___file___fileLocal___accessTime',
  summaryBackground___file___fileLocal___changeTime = 'summaryBackground___file___fileLocal___changeTime',
  summaryBackground___file___fileLocal___birthTime = 'summaryBackground___file___fileLocal___birthTime',
  summaryBackground___file___fileLocal___root = 'summaryBackground___file___fileLocal___root',
  summaryBackground___file___fileLocal___dir = 'summaryBackground___file___fileLocal___dir',
  summaryBackground___file___fileLocal___base = 'summaryBackground___file___fileLocal___base',
  summaryBackground___file___fileLocal___ext = 'summaryBackground___file___fileLocal___ext',
  summaryBackground___file___fileLocal___name = 'summaryBackground___file___fileLocal___name',
  summaryBackground___file___fileLocal___relativeDirectory = 'summaryBackground___file___fileLocal___relativeDirectory',
  summaryBackground___file___fileLocal___dev = 'summaryBackground___file___fileLocal___dev',
  summaryBackground___file___fileLocal___mode = 'summaryBackground___file___fileLocal___mode',
  summaryBackground___file___fileLocal___nlink = 'summaryBackground___file___fileLocal___nlink',
  summaryBackground___file___fileLocal___uid = 'summaryBackground___file___fileLocal___uid',
  summaryBackground___file___fileLocal___gid = 'summaryBackground___file___fileLocal___gid',
  summaryBackground___file___fileLocal___rdev = 'summaryBackground___file___fileLocal___rdev',
  summaryBackground___file___fileLocal___ino = 'summaryBackground___file___fileLocal___ino',
  summaryBackground___file___fileLocal___atimeMs = 'summaryBackground___file___fileLocal___atimeMs',
  summaryBackground___file___fileLocal___mtimeMs = 'summaryBackground___file___fileLocal___mtimeMs',
  summaryBackground___file___fileLocal___ctimeMs = 'summaryBackground___file___fileLocal___ctimeMs',
  summaryBackground___file___fileLocal___atime = 'summaryBackground___file___fileLocal___atime',
  summaryBackground___file___fileLocal___mtime = 'summaryBackground___file___fileLocal___mtime',
  summaryBackground___file___fileLocal___ctime = 'summaryBackground___file___fileLocal___ctime',
  summaryBackground___file___fileLocal___birthtime = 'summaryBackground___file___fileLocal___birthtime',
  summaryBackground___file___fileLocal___birthtimeMs = 'summaryBackground___file___fileLocal___birthtimeMs',
  summaryBackground___file___fileLocal___blksize = 'summaryBackground___file___fileLocal___blksize',
  summaryBackground___file___fileLocal___blocks = 'summaryBackground___file___fileLocal___blocks',
  summaryBackground___file___fileLocal___url = 'summaryBackground___file___fileLocal___url',
  summaryBackground___file___fileLocal___publicURL = 'summaryBackground___file___fileLocal___publicURL',
  summaryBackground___file___fileLocal___childrenImageSharp = 'summaryBackground___file___fileLocal___childrenImageSharp',
  summaryBackground___file___fileLocal___id = 'summaryBackground___file___fileLocal___id',
  summaryBackground___file___fileLocal___children = 'summaryBackground___file___fileLocal___children',
  summaryBackground___file___url = 'summaryBackground___file___url',
  summaryBackground___title = 'summaryBackground___title',
  teaserImage___description = 'teaserImage___description',
  teaserImage___file___fileLocal___sourceInstanceName = 'teaserImage___file___fileLocal___sourceInstanceName',
  teaserImage___file___fileLocal___absolutePath = 'teaserImage___file___fileLocal___absolutePath',
  teaserImage___file___fileLocal___relativePath = 'teaserImage___file___fileLocal___relativePath',
  teaserImage___file___fileLocal___extension = 'teaserImage___file___fileLocal___extension',
  teaserImage___file___fileLocal___size = 'teaserImage___file___fileLocal___size',
  teaserImage___file___fileLocal___prettySize = 'teaserImage___file___fileLocal___prettySize',
  teaserImage___file___fileLocal___modifiedTime = 'teaserImage___file___fileLocal___modifiedTime',
  teaserImage___file___fileLocal___accessTime = 'teaserImage___file___fileLocal___accessTime',
  teaserImage___file___fileLocal___changeTime = 'teaserImage___file___fileLocal___changeTime',
  teaserImage___file___fileLocal___birthTime = 'teaserImage___file___fileLocal___birthTime',
  teaserImage___file___fileLocal___root = 'teaserImage___file___fileLocal___root',
  teaserImage___file___fileLocal___dir = 'teaserImage___file___fileLocal___dir',
  teaserImage___file___fileLocal___base = 'teaserImage___file___fileLocal___base',
  teaserImage___file___fileLocal___ext = 'teaserImage___file___fileLocal___ext',
  teaserImage___file___fileLocal___name = 'teaserImage___file___fileLocal___name',
  teaserImage___file___fileLocal___relativeDirectory = 'teaserImage___file___fileLocal___relativeDirectory',
  teaserImage___file___fileLocal___dev = 'teaserImage___file___fileLocal___dev',
  teaserImage___file___fileLocal___mode = 'teaserImage___file___fileLocal___mode',
  teaserImage___file___fileLocal___nlink = 'teaserImage___file___fileLocal___nlink',
  teaserImage___file___fileLocal___uid = 'teaserImage___file___fileLocal___uid',
  teaserImage___file___fileLocal___gid = 'teaserImage___file___fileLocal___gid',
  teaserImage___file___fileLocal___rdev = 'teaserImage___file___fileLocal___rdev',
  teaserImage___file___fileLocal___ino = 'teaserImage___file___fileLocal___ino',
  teaserImage___file___fileLocal___atimeMs = 'teaserImage___file___fileLocal___atimeMs',
  teaserImage___file___fileLocal___mtimeMs = 'teaserImage___file___fileLocal___mtimeMs',
  teaserImage___file___fileLocal___ctimeMs = 'teaserImage___file___fileLocal___ctimeMs',
  teaserImage___file___fileLocal___atime = 'teaserImage___file___fileLocal___atime',
  teaserImage___file___fileLocal___mtime = 'teaserImage___file___fileLocal___mtime',
  teaserImage___file___fileLocal___ctime = 'teaserImage___file___fileLocal___ctime',
  teaserImage___file___fileLocal___birthtime = 'teaserImage___file___fileLocal___birthtime',
  teaserImage___file___fileLocal___birthtimeMs = 'teaserImage___file___fileLocal___birthtimeMs',
  teaserImage___file___fileLocal___blksize = 'teaserImage___file___fileLocal___blksize',
  teaserImage___file___fileLocal___blocks = 'teaserImage___file___fileLocal___blocks',
  teaserImage___file___fileLocal___url = 'teaserImage___file___fileLocal___url',
  teaserImage___file___fileLocal___publicURL = 'teaserImage___file___fileLocal___publicURL',
  teaserImage___file___fileLocal___childrenImageSharp = 'teaserImage___file___fileLocal___childrenImageSharp',
  teaserImage___file___fileLocal___id = 'teaserImage___file___fileLocal___id',
  teaserImage___file___fileLocal___children = 'teaserImage___file___fileLocal___children',
  teaserImage___file___url = 'teaserImage___file___url',
  teaserImage___title = 'teaserImage___title',
  territoryWidget___bottomGraphic___description = 'territoryWidget___bottomGraphic___description',
  territoryWidget___bottomGraphic___file___url = 'territoryWidget___bottomGraphic___file___url',
  territoryWidget___bottomGraphic___title = 'territoryWidget___bottomGraphic___title',
  territoryWidget___bottomHeading = 'territoryWidget___bottomHeading',
  territoryWidget___graphicHeading = 'territoryWidget___graphicHeading',
  territoryWidget___topCopy = 'territoryWidget___topCopy',
  territoryWidget___topHeading = 'territoryWidget___topHeading',
  territoryWidget___topHeroImage___description = 'territoryWidget___topHeroImage___description',
  territoryWidget___topHeroImage___file___url = 'territoryWidget___topHeroImage___file___url',
  territoryWidget___topHeroImage___title = 'territoryWidget___topHeroImage___title',
  territoryWidget___topLeftHeadingImage___description = 'territoryWidget___topLeftHeadingImage___description',
  territoryWidget___topLeftHeadingImage___file___url = 'territoryWidget___topLeftHeadingImage___file___url',
  territoryWidget___topLeftHeadingImage___title = 'territoryWidget___topLeftHeadingImage___title',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  video___description = 'video___description',
  video___file___fileLocal___sourceInstanceName = 'video___file___fileLocal___sourceInstanceName',
  video___file___fileLocal___absolutePath = 'video___file___fileLocal___absolutePath',
  video___file___fileLocal___relativePath = 'video___file___fileLocal___relativePath',
  video___file___fileLocal___extension = 'video___file___fileLocal___extension',
  video___file___fileLocal___size = 'video___file___fileLocal___size',
  video___file___fileLocal___prettySize = 'video___file___fileLocal___prettySize',
  video___file___fileLocal___modifiedTime = 'video___file___fileLocal___modifiedTime',
  video___file___fileLocal___accessTime = 'video___file___fileLocal___accessTime',
  video___file___fileLocal___changeTime = 'video___file___fileLocal___changeTime',
  video___file___fileLocal___birthTime = 'video___file___fileLocal___birthTime',
  video___file___fileLocal___root = 'video___file___fileLocal___root',
  video___file___fileLocal___dir = 'video___file___fileLocal___dir',
  video___file___fileLocal___base = 'video___file___fileLocal___base',
  video___file___fileLocal___ext = 'video___file___fileLocal___ext',
  video___file___fileLocal___name = 'video___file___fileLocal___name',
  video___file___fileLocal___relativeDirectory = 'video___file___fileLocal___relativeDirectory',
  video___file___fileLocal___dev = 'video___file___fileLocal___dev',
  video___file___fileLocal___mode = 'video___file___fileLocal___mode',
  video___file___fileLocal___nlink = 'video___file___fileLocal___nlink',
  video___file___fileLocal___uid = 'video___file___fileLocal___uid',
  video___file___fileLocal___gid = 'video___file___fileLocal___gid',
  video___file___fileLocal___rdev = 'video___file___fileLocal___rdev',
  video___file___fileLocal___ino = 'video___file___fileLocal___ino',
  video___file___fileLocal___atimeMs = 'video___file___fileLocal___atimeMs',
  video___file___fileLocal___mtimeMs = 'video___file___fileLocal___mtimeMs',
  video___file___fileLocal___ctimeMs = 'video___file___fileLocal___ctimeMs',
  video___file___fileLocal___atime = 'video___file___fileLocal___atime',
  video___file___fileLocal___mtime = 'video___file___fileLocal___mtime',
  video___file___fileLocal___ctime = 'video___file___fileLocal___ctime',
  video___file___fileLocal___birthtime = 'video___file___fileLocal___birthtime',
  video___file___fileLocal___birthtimeMs = 'video___file___fileLocal___birthtimeMs',
  video___file___fileLocal___blksize = 'video___file___fileLocal___blksize',
  video___file___fileLocal___blocks = 'video___file___fileLocal___blocks',
  video___file___fileLocal___url = 'video___file___fileLocal___url',
  video___file___fileLocal___publicURL = 'video___file___fileLocal___publicURL',
  video___file___fileLocal___childrenImageSharp = 'video___file___fileLocal___childrenImageSharp',
  video___file___fileLocal___id = 'video___file___fileLocal___id',
  video___file___fileLocal___children = 'video___file___fileLocal___children',
  video___file___url = 'video___file___url',
  video___title = 'video___title',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type MessageFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  benefitImages?: Maybe<BenefitImagesFilterListInput>;
  benefits?: Maybe<StringQueryOperatorInput>;
  benefitsDisclaimer?: Maybe<StringQueryOperatorInput>;
  certificate?: Maybe<CertificateFilterListInput>;
  facts?: Maybe<FactFilterListInput>;
  hero?: Maybe<MediaFilterInput>;
  heroVideo?: Maybe<MediaFilterInput>;
  main?: Maybe<MainFilterInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  parentTopic?: Maybe<TopicFilterInput>;
  path?: Maybe<StringQueryOperatorInput>;
  product?: Maybe<StringQueryOperatorInput>;
  productsNodes?: Maybe<ProductFilterListInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  summaryBackground?: Maybe<MediaFilterInput>;
  teaserImage?: Maybe<MediaFilterInput>;
  territoryWidget?: Maybe<TerritoryFilterInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  video?: Maybe<MediaFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type MessageFilterListInput = {
  elemMatch?: Maybe<MessageFilterInput>;
};

export type MessageGroupConnection = {
  __typename?: 'messageGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<MessageEdge>;
  nodes: Array<Message>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type MessageSortInput = {
  fields?: Maybe<Array<Maybe<MessageFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type Topic = Node & {
  __typename?: 'topic';
  absolutePath: Scalars['String'];
  hero: Media;
  messagesNodes?: Maybe<Array<Maybe<Message>>>;
  metaDescription?: Maybe<Scalars['String']>;
  navigationTitle: Scalars['String'];
  topicDisclaimer?: Maybe<Scalars['String']>;
  pageTitle: Scalars['String'];
  pageType: Scalars['String'];
  path: Scalars['String'];
  slug: Scalars['String'];
  summary: Scalars['String'];
  title: Scalars['String'];
  traits?: Maybe<Traits>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type TopicConnection = {
  __typename?: 'topicConnection';
  totalCount: Scalars['Int'];
  edges: Array<TopicEdge>;
  nodes: Array<Topic>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<TopicGroupConnection>;
};


export type TopicConnectionDistinctArgs = {
  field: TopicFieldsEnum;
};


export type TopicConnectionMaxArgs = {
  field: TopicFieldsEnum;
};


export type TopicConnectionMinArgs = {
  field: TopicFieldsEnum;
};


export type TopicConnectionSumArgs = {
  field: TopicFieldsEnum;
};


export type TopicConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: TopicFieldsEnum;
};

export type TopicEdge = {
  __typename?: 'topicEdge';
  next?: Maybe<Topic>;
  node: Topic;
  previous?: Maybe<Topic>;
};

export enum TopicFieldsEnum {
  absolutePath = 'absolutePath',
  hero___description = 'hero___description',
  hero___file___fileLocal___sourceInstanceName = 'hero___file___fileLocal___sourceInstanceName',
  hero___file___fileLocal___absolutePath = 'hero___file___fileLocal___absolutePath',
  hero___file___fileLocal___relativePath = 'hero___file___fileLocal___relativePath',
  hero___file___fileLocal___extension = 'hero___file___fileLocal___extension',
  hero___file___fileLocal___size = 'hero___file___fileLocal___size',
  hero___file___fileLocal___prettySize = 'hero___file___fileLocal___prettySize',
  hero___file___fileLocal___modifiedTime = 'hero___file___fileLocal___modifiedTime',
  hero___file___fileLocal___accessTime = 'hero___file___fileLocal___accessTime',
  hero___file___fileLocal___changeTime = 'hero___file___fileLocal___changeTime',
  hero___file___fileLocal___birthTime = 'hero___file___fileLocal___birthTime',
  hero___file___fileLocal___root = 'hero___file___fileLocal___root',
  hero___file___fileLocal___dir = 'hero___file___fileLocal___dir',
  hero___file___fileLocal___base = 'hero___file___fileLocal___base',
  hero___file___fileLocal___ext = 'hero___file___fileLocal___ext',
  hero___file___fileLocal___name = 'hero___file___fileLocal___name',
  hero___file___fileLocal___relativeDirectory = 'hero___file___fileLocal___relativeDirectory',
  hero___file___fileLocal___dev = 'hero___file___fileLocal___dev',
  hero___file___fileLocal___mode = 'hero___file___fileLocal___mode',
  hero___file___fileLocal___nlink = 'hero___file___fileLocal___nlink',
  hero___file___fileLocal___uid = 'hero___file___fileLocal___uid',
  hero___file___fileLocal___gid = 'hero___file___fileLocal___gid',
  hero___file___fileLocal___rdev = 'hero___file___fileLocal___rdev',
  hero___file___fileLocal___ino = 'hero___file___fileLocal___ino',
  hero___file___fileLocal___atimeMs = 'hero___file___fileLocal___atimeMs',
  hero___file___fileLocal___mtimeMs = 'hero___file___fileLocal___mtimeMs',
  hero___file___fileLocal___ctimeMs = 'hero___file___fileLocal___ctimeMs',
  hero___file___fileLocal___atime = 'hero___file___fileLocal___atime',
  hero___file___fileLocal___mtime = 'hero___file___fileLocal___mtime',
  hero___file___fileLocal___ctime = 'hero___file___fileLocal___ctime',
  hero___file___fileLocal___birthtime = 'hero___file___fileLocal___birthtime',
  hero___file___fileLocal___birthtimeMs = 'hero___file___fileLocal___birthtimeMs',
  hero___file___fileLocal___blksize = 'hero___file___fileLocal___blksize',
  hero___file___fileLocal___blocks = 'hero___file___fileLocal___blocks',
  hero___file___fileLocal___url = 'hero___file___fileLocal___url',
  hero___file___fileLocal___publicURL = 'hero___file___fileLocal___publicURL',
  hero___file___fileLocal___childrenImageSharp = 'hero___file___fileLocal___childrenImageSharp',
  hero___file___fileLocal___id = 'hero___file___fileLocal___id',
  hero___file___fileLocal___children = 'hero___file___fileLocal___children',
  hero___file___url = 'hero___file___url',
  hero___title = 'hero___title',
  messagesNodes = 'messagesNodes',
  messagesNodes___absolutePath = 'messagesNodes___absolutePath',
  messagesNodes___benefitImages = 'messagesNodes___benefitImages',
  messagesNodes___benefitImages___description = 'messagesNodes___benefitImages___description',
  messagesNodes___benefitImages___file___url = 'messagesNodes___benefitImages___file___url',
  messagesNodes___benefits = 'messagesNodes___benefits',
  messagesNodes___benefitsDisclaimer = 'messagesNodes___benefitsDisclaimer',
  messagesNodes___certificate = 'messagesNodes___certificate',
  messagesNodes___certificate___image___description = 'messagesNodes___certificate___image___description',
  messagesNodes___certificate___image___title = 'messagesNodes___certificate___image___title',
  messagesNodes___certificate___title = 'messagesNodes___certificate___title',
  messagesNodes___certificate___url = 'messagesNodes___certificate___url',
  messagesNodes___facts = 'messagesNodes___facts',
  messagesNodes___facts___image___description = 'messagesNodes___facts___image___description',
  messagesNodes___facts___image___title = 'messagesNodes___facts___image___title',
  messagesNodes___facts___summary = 'messagesNodes___facts___summary',
  messagesNodes___facts___title = 'messagesNodes___facts___title',
  messagesNodes___hero___description = 'messagesNodes___hero___description',
  messagesNodes___hero___file___url = 'messagesNodes___hero___file___url',
  messagesNodes___hero___title = 'messagesNodes___hero___title',
  messagesNodes___heroVideo___description = 'messagesNodes___heroVideo___description',
  messagesNodes___heroVideo___file___url = 'messagesNodes___heroVideo___file___url',
  messagesNodes___heroVideo___title = 'messagesNodes___heroVideo___title',
  messagesNodes___main___htmlTruncated = 'messagesNodes___main___htmlTruncated',
  messagesNodes___main___html = 'messagesNodes___main___html',
  messagesNodes___main___rawContent = 'messagesNodes___main___rawContent',
  messagesNodes___main___text = 'messagesNodes___main___text',
  messagesNodes___metaDescription = 'messagesNodes___metaDescription',
  messagesNodes___pageTitle = 'messagesNodes___pageTitle',
  messagesNodes___pageType = 'messagesNodes___pageType',
  messagesNodes___parentTopic___absolutePath = 'messagesNodes___parentTopic___absolutePath',
  messagesNodes___parentTopic___hero___description = 'messagesNodes___parentTopic___hero___description',
  messagesNodes___parentTopic___hero___title = 'messagesNodes___parentTopic___hero___title',
  messagesNodes___parentTopic___messagesNodes = 'messagesNodes___parentTopic___messagesNodes',
  messagesNodes___parentTopic___messagesNodes___absolutePath = 'messagesNodes___parentTopic___messagesNodes___absolutePath',
  messagesNodes___parentTopic___messagesNodes___benefitImages = 'messagesNodes___parentTopic___messagesNodes___benefitImages',
  messagesNodes___parentTopic___messagesNodes___benefits = 'messagesNodes___parentTopic___messagesNodes___benefits',
  messagesNodes___parentTopic___messagesNodes___benefitsDisclaimer = 'messagesNodes___parentTopic___messagesNodes___benefitsDisclaimer',
  messagesNodes___parentTopic___messagesNodes___certificate = 'messagesNodes___parentTopic___messagesNodes___certificate',
  messagesNodes___parentTopic___messagesNodes___facts = 'messagesNodes___parentTopic___messagesNodes___facts',
  messagesNodes___parentTopic___messagesNodes___metaDescription = 'messagesNodes___parentTopic___messagesNodes___metaDescription',
  messagesNodes___parentTopic___messagesNodes___pageTitle = 'messagesNodes___parentTopic___messagesNodes___pageTitle',
  messagesNodes___parentTopic___messagesNodes___pageType = 'messagesNodes___parentTopic___messagesNodes___pageType',
  messagesNodes___parentTopic___messagesNodes___path = 'messagesNodes___parentTopic___messagesNodes___path',
  messagesNodes___parentTopic___messagesNodes___product = 'messagesNodes___parentTopic___messagesNodes___product',
  messagesNodes___parentTopic___messagesNodes___productsNodes = 'messagesNodes___parentTopic___messagesNodes___productsNodes',
  messagesNodes___parentTopic___messagesNodes___slug = 'messagesNodes___parentTopic___messagesNodes___slug',
  messagesNodes___parentTopic___messagesNodes___summary = 'messagesNodes___parentTopic___messagesNodes___summary',
  messagesNodes___parentTopic___messagesNodes___title = 'messagesNodes___parentTopic___messagesNodes___title',
  messagesNodes___parentTopic___messagesNodes___id = 'messagesNodes___parentTopic___messagesNodes___id',
  messagesNodes___parentTopic___messagesNodes___children = 'messagesNodes___parentTopic___messagesNodes___children',
  messagesNodes___parentTopic___metaDescription = 'messagesNodes___parentTopic___metaDescription',
  messagesNodes___parentTopic___navigationTitle = 'messagesNodes___parentTopic___navigationTitle',
  messagesNodes___parentTopic___topicDisclaimer = 'messagesNodes___parentTopic___topicDisclaimer',
  messagesNodes___parentTopic___pageTitle = 'messagesNodes___parentTopic___pageTitle',
  messagesNodes___parentTopic___pageType = 'messagesNodes___parentTopic___pageType',
  messagesNodes___parentTopic___path = 'messagesNodes___parentTopic___path',
  messagesNodes___parentTopic___slug = 'messagesNodes___parentTopic___slug',
  messagesNodes___parentTopic___summary = 'messagesNodes___parentTopic___summary',
  messagesNodes___parentTopic___title = 'messagesNodes___parentTopic___title',
  messagesNodes___parentTopic___traits___traitsStringified = 'messagesNodes___parentTopic___traits___traitsStringified',
  messagesNodes___parentTopic___id = 'messagesNodes___parentTopic___id',
  messagesNodes___parentTopic___parent___id = 'messagesNodes___parentTopic___parent___id',
  messagesNodes___parentTopic___parent___children = 'messagesNodes___parentTopic___parent___children',
  messagesNodes___parentTopic___children = 'messagesNodes___parentTopic___children',
  messagesNodes___parentTopic___children___id = 'messagesNodes___parentTopic___children___id',
  messagesNodes___parentTopic___children___children = 'messagesNodes___parentTopic___children___children',
  messagesNodes___parentTopic___internal___content = 'messagesNodes___parentTopic___internal___content',
  messagesNodes___parentTopic___internal___contentDigest = 'messagesNodes___parentTopic___internal___contentDigest',
  messagesNodes___parentTopic___internal___description = 'messagesNodes___parentTopic___internal___description',
  messagesNodes___parentTopic___internal___fieldOwners = 'messagesNodes___parentTopic___internal___fieldOwners',
  messagesNodes___parentTopic___internal___ignoreType = 'messagesNodes___parentTopic___internal___ignoreType',
  messagesNodes___parentTopic___internal___mediaType = 'messagesNodes___parentTopic___internal___mediaType',
  messagesNodes___parentTopic___internal___owner = 'messagesNodes___parentTopic___internal___owner',
  messagesNodes___parentTopic___internal___type = 'messagesNodes___parentTopic___internal___type',
  messagesNodes___path = 'messagesNodes___path',
  messagesNodes___product = 'messagesNodes___product',
  messagesNodes___productsNodes = 'messagesNodes___productsNodes',
  messagesNodes___productsNodes___absolutePath = 'messagesNodes___productsNodes___absolutePath',
  messagesNodes___productsNodes___benefits = 'messagesNodes___productsNodes___benefits',
  messagesNodes___productsNodes___benefitsDisclaimer = 'messagesNodes___productsNodes___benefitsDisclaimer',
  messagesNodes___productsNodes___description___htmlTruncated = 'messagesNodes___productsNodes___description___htmlTruncated',
  messagesNodes___productsNodes___description___html = 'messagesNodes___productsNodes___description___html',
  messagesNodes___productsNodes___description___rawContent = 'messagesNodes___productsNodes___description___rawContent',
  messagesNodes___productsNodes___description___text = 'messagesNodes___productsNodes___description___text',
  messagesNodes___productsNodes___hero___description = 'messagesNodes___productsNodes___hero___description',
  messagesNodes___productsNodes___hero___title = 'messagesNodes___productsNodes___hero___title',
  messagesNodes___productsNodes___howToUse___html = 'messagesNodes___productsNodes___howToUse___html',
  messagesNodes___productsNodes___howToUse___json = 'messagesNodes___productsNodes___howToUse___json',
  messagesNodes___productsNodes___howToUse___text = 'messagesNodes___productsNodes___howToUse___text',
  messagesNodes___productsNodes___main___htmlTruncated = 'messagesNodes___productsNodes___main___htmlTruncated',
  messagesNodes___productsNodes___main___html = 'messagesNodes___productsNodes___main___html',
  messagesNodes___productsNodes___main___rawContent = 'messagesNodes___productsNodes___main___rawContent',
  messagesNodes___productsNodes___main___text = 'messagesNodes___productsNodes___main___text',
  messagesNodes___productsNodes___metaDescription = 'messagesNodes___productsNodes___metaDescription',
  messagesNodes___productsNodes___name = 'messagesNodes___productsNodes___name',
  messagesNodes___productsNodes___pageTitle = 'messagesNodes___productsNodes___pageTitle',
  messagesNodes___productsNodes___pageType = 'messagesNodes___productsNodes___pageType',
  messagesNodes___productsNodes___parentMessage___absolutePath = 'messagesNodes___productsNodes___parentMessage___absolutePath',
  messagesNodes___productsNodes___parentMessage___benefitImages = 'messagesNodes___productsNodes___parentMessage___benefitImages',
  messagesNodes___productsNodes___parentMessage___benefits = 'messagesNodes___productsNodes___parentMessage___benefits',
  messagesNodes___productsNodes___parentMessage___benefitsDisclaimer = 'messagesNodes___productsNodes___parentMessage___benefitsDisclaimer',
  messagesNodes___productsNodes___parentMessage___certificate = 'messagesNodes___productsNodes___parentMessage___certificate',
  messagesNodes___productsNodes___parentMessage___facts = 'messagesNodes___productsNodes___parentMessage___facts',
  messagesNodes___productsNodes___parentMessage___metaDescription = 'messagesNodes___productsNodes___parentMessage___metaDescription',
  messagesNodes___productsNodes___parentMessage___pageTitle = 'messagesNodes___productsNodes___parentMessage___pageTitle',
  messagesNodes___productsNodes___parentMessage___pageType = 'messagesNodes___productsNodes___parentMessage___pageType',
  messagesNodes___productsNodes___parentMessage___path = 'messagesNodes___productsNodes___parentMessage___path',
  messagesNodes___productsNodes___parentMessage___product = 'messagesNodes___productsNodes___parentMessage___product',
  messagesNodes___productsNodes___parentMessage___productsNodes = 'messagesNodes___productsNodes___parentMessage___productsNodes',
  messagesNodes___productsNodes___parentMessage___slug = 'messagesNodes___productsNodes___parentMessage___slug',
  messagesNodes___productsNodes___parentMessage___summary = 'messagesNodes___productsNodes___parentMessage___summary',
  messagesNodes___productsNodes___parentMessage___title = 'messagesNodes___productsNodes___parentMessage___title',
  messagesNodes___productsNodes___parentMessage___id = 'messagesNodes___productsNodes___parentMessage___id',
  messagesNodes___productsNodes___parentMessage___children = 'messagesNodes___productsNodes___parentMessage___children',
  messagesNodes___productsNodes___path = 'messagesNodes___productsNodes___path',
  messagesNodes___productsNodes___slug = 'messagesNodes___productsNodes___slug',
  messagesNodes___productsNodes___summaryBackground___description = 'messagesNodes___productsNodes___summaryBackground___description',
  messagesNodes___productsNodes___summaryBackground___title = 'messagesNodes___productsNodes___summaryBackground___title',
  messagesNodes___productsNodes___traits___traitsStringified = 'messagesNodes___productsNodes___traits___traitsStringified',
  messagesNodes___productsNodes___variants = 'messagesNodes___productsNodes___variants',
  messagesNodes___productsNodes___variants___buyItNowUrl = 'messagesNodes___productsNodes___variants___buyItNowUrl',
  messagesNodes___productsNodes___variants___name = 'messagesNodes___productsNodes___variants___name',
  messagesNodes___productsNodes___variants___product = 'messagesNodes___productsNodes___variants___product',
  messagesNodes___productsNodes___variants___sizes = 'messagesNodes___productsNodes___variants___sizes',
  messagesNodes___productsNodes___id = 'messagesNodes___productsNodes___id',
  messagesNodes___productsNodes___parent___id = 'messagesNodes___productsNodes___parent___id',
  messagesNodes___productsNodes___parent___children = 'messagesNodes___productsNodes___parent___children',
  messagesNodes___productsNodes___children = 'messagesNodes___productsNodes___children',
  messagesNodes___productsNodes___children___id = 'messagesNodes___productsNodes___children___id',
  messagesNodes___productsNodes___children___children = 'messagesNodes___productsNodes___children___children',
  messagesNodes___productsNodes___internal___content = 'messagesNodes___productsNodes___internal___content',
  messagesNodes___productsNodes___internal___contentDigest = 'messagesNodes___productsNodes___internal___contentDigest',
  messagesNodes___productsNodes___internal___description = 'messagesNodes___productsNodes___internal___description',
  messagesNodes___productsNodes___internal___fieldOwners = 'messagesNodes___productsNodes___internal___fieldOwners',
  messagesNodes___productsNodes___internal___ignoreType = 'messagesNodes___productsNodes___internal___ignoreType',
  messagesNodes___productsNodes___internal___mediaType = 'messagesNodes___productsNodes___internal___mediaType',
  messagesNodes___productsNodes___internal___owner = 'messagesNodes___productsNodes___internal___owner',
  messagesNodes___productsNodes___internal___type = 'messagesNodes___productsNodes___internal___type',
  messagesNodes___slug = 'messagesNodes___slug',
  messagesNodes___summary = 'messagesNodes___summary',
  messagesNodes___summaryBackground___description = 'messagesNodes___summaryBackground___description',
  messagesNodes___summaryBackground___file___url = 'messagesNodes___summaryBackground___file___url',
  messagesNodes___summaryBackground___title = 'messagesNodes___summaryBackground___title',
  messagesNodes___teaserImage___description = 'messagesNodes___teaserImage___description',
  messagesNodes___teaserImage___file___url = 'messagesNodes___teaserImage___file___url',
  messagesNodes___teaserImage___title = 'messagesNodes___teaserImage___title',
  messagesNodes___territoryWidget___bottomGraphic___description = 'messagesNodes___territoryWidget___bottomGraphic___description',
  messagesNodes___territoryWidget___bottomGraphic___title = 'messagesNodes___territoryWidget___bottomGraphic___title',
  messagesNodes___territoryWidget___bottomHeading = 'messagesNodes___territoryWidget___bottomHeading',
  messagesNodes___territoryWidget___graphicHeading = 'messagesNodes___territoryWidget___graphicHeading',
  messagesNodes___territoryWidget___topCopy = 'messagesNodes___territoryWidget___topCopy',
  messagesNodes___territoryWidget___topHeading = 'messagesNodes___territoryWidget___topHeading',
  messagesNodes___territoryWidget___topHeroImage___description = 'messagesNodes___territoryWidget___topHeroImage___description',
  messagesNodes___territoryWidget___topHeroImage___title = 'messagesNodes___territoryWidget___topHeroImage___title',
  messagesNodes___territoryWidget___topLeftHeadingImage___description = 'messagesNodes___territoryWidget___topLeftHeadingImage___description',
  messagesNodes___territoryWidget___topLeftHeadingImage___title = 'messagesNodes___territoryWidget___topLeftHeadingImage___title',
  messagesNodes___title = 'messagesNodes___title',
  messagesNodes___traits___traitsStringified = 'messagesNodes___traits___traitsStringified',
  messagesNodes___video___description = 'messagesNodes___video___description',
  messagesNodes___video___file___url = 'messagesNodes___video___file___url',
  messagesNodes___video___title = 'messagesNodes___video___title',
  messagesNodes___id = 'messagesNodes___id',
  messagesNodes___parent___id = 'messagesNodes___parent___id',
  messagesNodes___parent___parent___id = 'messagesNodes___parent___parent___id',
  messagesNodes___parent___parent___children = 'messagesNodes___parent___parent___children',
  messagesNodes___parent___children = 'messagesNodes___parent___children',
  messagesNodes___parent___children___id = 'messagesNodes___parent___children___id',
  messagesNodes___parent___children___children = 'messagesNodes___parent___children___children',
  messagesNodes___parent___internal___content = 'messagesNodes___parent___internal___content',
  messagesNodes___parent___internal___contentDigest = 'messagesNodes___parent___internal___contentDigest',
  messagesNodes___parent___internal___description = 'messagesNodes___parent___internal___description',
  messagesNodes___parent___internal___fieldOwners = 'messagesNodes___parent___internal___fieldOwners',
  messagesNodes___parent___internal___ignoreType = 'messagesNodes___parent___internal___ignoreType',
  messagesNodes___parent___internal___mediaType = 'messagesNodes___parent___internal___mediaType',
  messagesNodes___parent___internal___owner = 'messagesNodes___parent___internal___owner',
  messagesNodes___parent___internal___type = 'messagesNodes___parent___internal___type',
  messagesNodes___children = 'messagesNodes___children',
  messagesNodes___children___id = 'messagesNodes___children___id',
  messagesNodes___children___parent___id = 'messagesNodes___children___parent___id',
  messagesNodes___children___parent___children = 'messagesNodes___children___parent___children',
  messagesNodes___children___children = 'messagesNodes___children___children',
  messagesNodes___children___children___id = 'messagesNodes___children___children___id',
  messagesNodes___children___children___children = 'messagesNodes___children___children___children',
  messagesNodes___children___internal___content = 'messagesNodes___children___internal___content',
  messagesNodes___children___internal___contentDigest = 'messagesNodes___children___internal___contentDigest',
  messagesNodes___children___internal___description = 'messagesNodes___children___internal___description',
  messagesNodes___children___internal___fieldOwners = 'messagesNodes___children___internal___fieldOwners',
  messagesNodes___children___internal___ignoreType = 'messagesNodes___children___internal___ignoreType',
  messagesNodes___children___internal___mediaType = 'messagesNodes___children___internal___mediaType',
  messagesNodes___children___internal___owner = 'messagesNodes___children___internal___owner',
  messagesNodes___children___internal___type = 'messagesNodes___children___internal___type',
  messagesNodes___internal___content = 'messagesNodes___internal___content',
  messagesNodes___internal___contentDigest = 'messagesNodes___internal___contentDigest',
  messagesNodes___internal___description = 'messagesNodes___internal___description',
  messagesNodes___internal___fieldOwners = 'messagesNodes___internal___fieldOwners',
  messagesNodes___internal___ignoreType = 'messagesNodes___internal___ignoreType',
  messagesNodes___internal___mediaType = 'messagesNodes___internal___mediaType',
  messagesNodes___internal___owner = 'messagesNodes___internal___owner',
  messagesNodes___internal___type = 'messagesNodes___internal___type',
  metaDescription = 'metaDescription',
  navigationTitle = 'navigationTitle',
  topicDisclaimer = 'topicDisclaimer',
  pageTitle = 'pageTitle',
  pageType = 'pageType',
  path = 'path',
  slug = 'slug',
  summary = 'summary',
  title = 'title',
  traits___traitsStringified = 'traits___traitsStringified',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type TopicFilterInput = {
  absolutePath?: Maybe<StringQueryOperatorInput>;
  hero?: Maybe<MediaFilterInput>;
  messagesNodes?: Maybe<MessageFilterListInput>;
  metaDescription?: Maybe<StringQueryOperatorInput>;
  navigationTitle?: Maybe<StringQueryOperatorInput>;
  topicDisclaimer?: Maybe<StringQueryOperatorInput>;
  pageTitle?: Maybe<StringQueryOperatorInput>;
  pageType?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  summary?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  traits?: Maybe<TraitsFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type TopicGroupConnection = {
  __typename?: 'topicGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<TopicEdge>;
  nodes: Array<Topic>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type TopicSortInput = {
  fields?: Maybe<Array<Maybe<TopicFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type GatsbyImageSharpFixedFragment = (
  { __typename?: 'ImageSharpFixed' }
  & Pick<ImageSharpFixed, 'base64' | 'width' | 'height' | 'src' | 'srcSet'>
);

export type GatsbyImageSharpFixed_TracedSvgFragment = (
  { __typename?: 'ImageSharpFixed' }
  & Pick<ImageSharpFixed, 'tracedSVG' | 'width' | 'height' | 'src' | 'srcSet'>
);

export type GatsbyImageSharpFixed_WithWebpFragment = (
  { __typename?: 'ImageSharpFixed' }
  & Pick<ImageSharpFixed, 'base64' | 'width' | 'height' | 'src' | 'srcSet' | 'srcWebp' | 'srcSetWebp'>
);

export type GatsbyImageSharpFixed_WithWebp_TracedSvgFragment = (
  { __typename?: 'ImageSharpFixed' }
  & Pick<ImageSharpFixed, 'tracedSVG' | 'width' | 'height' | 'src' | 'srcSet' | 'srcWebp' | 'srcSetWebp'>
);

export type GatsbyImageSharpFixed_NoBase64Fragment = (
  { __typename?: 'ImageSharpFixed' }
  & Pick<ImageSharpFixed, 'width' | 'height' | 'src' | 'srcSet'>
);

export type GatsbyImageSharpFixed_WithWebp_NoBase64Fragment = (
  { __typename?: 'ImageSharpFixed' }
  & Pick<ImageSharpFixed, 'width' | 'height' | 'src' | 'srcSet' | 'srcWebp' | 'srcSetWebp'>
);

export type GatsbyImageSharpFluidFragment = (
  { __typename?: 'ImageSharpFluid' }
  & Pick<ImageSharpFluid, 'base64' | 'aspectRatio' | 'src' | 'srcSet' | 'sizes'>
);

export type GatsbyImageSharpFluidLimitPresentationSizeFragment = (
  { __typename?: 'ImageSharpFluid' }
  & { maxHeight: ImageSharpFluid['presentationHeight'], maxWidth: ImageSharpFluid['presentationWidth'] }
);

export type GatsbyImageSharpFluid_TracedSvgFragment = (
  { __typename?: 'ImageSharpFluid' }
  & Pick<ImageSharpFluid, 'tracedSVG' | 'aspectRatio' | 'src' | 'srcSet' | 'sizes'>
);

export type GatsbyImageSharpFluid_WithWebpFragment = (
  { __typename?: 'ImageSharpFluid' }
  & Pick<ImageSharpFluid, 'base64' | 'aspectRatio' | 'src' | 'srcSet' | 'srcWebp' | 'srcSetWebp' | 'sizes'>
);

export type GatsbyImageSharpFluid_WithWebp_TracedSvgFragment = (
  { __typename?: 'ImageSharpFluid' }
  & Pick<ImageSharpFluid, 'tracedSVG' | 'aspectRatio' | 'src' | 'srcSet' | 'srcWebp' | 'srcSetWebp' | 'sizes'>
);

export type GatsbyImageSharpFluid_NoBase64Fragment = (
  { __typename?: 'ImageSharpFluid' }
  & Pick<ImageSharpFluid, 'aspectRatio' | 'src' | 'srcSet' | 'sizes'>
);

export type GatsbyImageSharpFluid_WithWebp_NoBase64Fragment = (
  { __typename?: 'ImageSharpFluid' }
  & Pick<ImageSharpFluid, 'aspectRatio' | 'src' | 'srcSet' | 'srcWebp' | 'srcSetWebp' | 'sizes'>
);

export type PagesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PagesQueryQuery = (
  { __typename?: 'Query' }
  & { allSiteFunction: (
    { __typename?: 'SiteFunctionConnection' }
    & { nodes: Array<(
      { __typename?: 'SiteFunction' }
      & Pick<SiteFunction, 'functionRoute'>
    )> }
  ), allSitePage: (
    { __typename?: 'SitePageConnection' }
    & { nodes: Array<(
      { __typename?: 'SitePage' }
      & Pick<SitePage, 'path'>
    )> }
  ) }
);

export type AdobeAnalyticsAdobeConfigFragment = (
  { __typename?: 'AdobeConfig' }
  & { analytics__adobe__account: AdobeConfig['account'], analytics__adobe__trackingServer: AdobeConfig['trackingServer'], analytics__adobe__trackingServerSecure: AdobeConfig['trackingServerSecure'], analytics__adobe__reportSuiteId: AdobeConfig['reportSuiteId'], analytics__adobe__containerId: AdobeConfig['containerId'], analytics__adobe__region: AdobeConfig['region'], analytics__adobe__language: AdobeConfig['language'] }
);

export type BreadcrumbQueryVariables = Exact<{ [key: string]: never; }>;


export type BreadcrumbQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & Pick<Home, 'absolutePath'>
    & { lexicon: (
      { __typename?: 'Lexicon' }
      & Pick<Lexicon, 'home'>
    ) }
  )> }
);

export type ExternalLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalLinkQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { lexicon: (
      { __typename?: 'Lexicon' }
      & Pick<Lexicon, 'opensInNewTab'>
    ) }
  )> }
);

export type FaviconQueryVariables = Exact<{ [key: string]: never; }>;


export type FaviconQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { brand: (
      { __typename?: 'Brand' }
      & { touchIcon: (
        { __typename?: 'Media' }
        & { file?: Maybe<(
          { __typename?: '_File' }
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        )> }
      ), favicon?: Maybe<(
        { __typename?: 'Media' }
        & { file?: Maybe<(
          { __typename?: '_File' }
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & Pick<File, 'publicURL'>
          )> }
        )> }
      )>, logo: (
        { __typename?: 'Media' }
        & { file?: Maybe<(
          { __typename?: '_File' }
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        )> }
      ) }
    ) }
  )> }
);

export type FooterQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { lexicon: (
      { __typename?: 'Lexicon' }
      & Pick<Lexicon, 'opensInNewTab'>
    ) }
  )>, unileverLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, sitemap?: Maybe<(
    { __typename?: 'Sitemap' }
    & Pick<Sitemap, 'path' | 'title'>
  )> }
);

export type FooterHomeFragment = (
  { __typename?: 'home' }
  & { brand: (
    { __typename?: 'Brand' }
    & Pick<Brand, 'disclaimer'>
  ), disclaimerMessage?: Maybe<(
    { __typename?: 'message' }
    & Pick<Message, 'absolutePath'>
  )>, domain: (
    { __typename?: 'Domain' }
    & { languages?: Maybe<Array<(
      { __typename?: 'Language' }
      & LanguageSelectorLanguageFragment
    )>> }
  ), lexicon: (
    { __typename?: 'Lexicon' }
    & Pick<Lexicon, 'socialTitle' | 'opensInNewTab'>
  ), socialChannels?: Maybe<Array<Maybe<(
    { __typename?: 'SocialChannel' }
    & Pick<SocialChannel, 'name' | 'url'>
    & { image: (
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & Pick<File, 'publicURL'>
        )> }
      )> }
    ) }
  )>>>, legals?: Maybe<(
    { __typename?: 'Legals' }
    & Pick<Legals, 'cookieNoticeLabel' | 'cookieNoticeUrl' | 'privacyNoticeLabel' | 'privacyNoticeUrl' | 'termsOfUseLabel' | 'termsOfUseUrl' | 'whatsInOurProductsLabel' | 'whatsInOurProductsUrl' | 'protectionOfPersonalDataLabel' | 'protectionOfPersonalDataUrl' | 'legalWarningLabel' | 'legalWarningUrl'>
    & { blurb?: Maybe<(
      { __typename?: 'Html' }
      & Pick<Html, 'json'>
    )>, additionalMessages?: Maybe<Array<Maybe<(
      { __typename?: 'message' }
      & Pick<Message, 'id' | 'slug' | 'title'>
    )>>> }
  )>, faq?: Maybe<(
    { __typename?: 'faq' }
    & Pick<Faq, 'path' | 'title'>
  )>, footerLinks: Array<(
    { __typename?: 'Hyperlink' }
    & Pick<Hyperlink, 'id' | 'title'>
    & { path: Hyperlink['url'] }
  ) | (
    { __typename?: 'ContentfulArticle' }
    & Pick<ContentfulArticle, 'id' | 'path'>
    & { title: ContentfulArticle['pageTitle'] }
  ) | (
    { __typename?: 'ContentfulCategory' }
    & Pick<ContentfulCategory, 'id' | 'path'>
    & { title: ContentfulCategory['pageTitle'] }
  ) | (
    { __typename?: 'ContactUs' }
    & Pick<ContactUs, 'id' | 'title' | 'path'>
  ) | (
    { __typename?: 'message' }
    & Pick<Message, 'id' | 'title' | 'path'>
  ) | (
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'path'>
    & { title: Product['name'] }
  ) | (
    { __typename?: 'Sitemap' }
    & Pick<Sitemap, 'id' | 'title' | 'path'>
  ) | (
    { __typename?: 'SustainabilityCategory' }
    & Pick<SustainabilityCategory, 'id' | 'title' | 'path'>
  ) | (
    { __typename?: 'SustainabilityLandingPage' }
    & Pick<SustainabilityLandingPage, 'id' | 'title' | 'path'>
  ) | (
    { __typename?: 'topic' }
    & Pick<Topic, 'id' | 'title' | 'path'>
  )>, additionalExternalLinks: Array<(
    { __typename?: 'Hyperlink' }
    & Pick<Hyperlink, 'id' | 'title' | 'url'>
  )> }
);

export type LanguageSelectorLanguageFragment = (
  { __typename?: 'Language' }
  & Pick<Language, 'locale' | 'name' | 'path'>
);

export type NavLinkItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type NavLinkItemsQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & Pick<Home, 'path'>
    & { lexicon: (
      { __typename?: 'Lexicon' }
      & Pick<Lexicon, 'home'>
    ), navLinks: Array<(
      { __typename?: 'NavLink' }
      & Pick<NavLink, 'title' | 'path'>
    )>, signUp?: Maybe<(
      { __typename?: 'SignUp' }
      & Pick<SignUp, 'path' | 'title'>
    )> }
  )>, allSustainabilityLandingPage: (
    { __typename?: 'SustainabilityLandingPageConnection' }
    & { nodes: Array<(
      { __typename?: 'SustainabilityLandingPage' }
      & Pick<SustainabilityLandingPage, 'title' | 'path'>
    )> }
  ) }
);

export type SchoolsLayoutDataFragment = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, silhouette?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, silhouetteMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, shareImage?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )> }
);

export type ProductFieldsFragment = (
  { __typename?: 'Product' }
  & Pick<Product, 'absolutePath' | 'path' | 'pageType' | 'benefits' | 'benefitsDisclaimer' | 'pageTitle' | 'name' | 'metaDescription'>
  & { description: (
    { __typename?: 'Main' }
    & Pick<Main, 'html' | 'text'>
  ), hero: (
    { __typename?: 'Media' }
    & Pick<Media, 'description'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { childImageSharp?: Maybe<(
          { __typename?: 'ImageSharp' }
          & Pick<ImageSharp, 'gatsbyImageData'>
        )> }
      )> }
    )> }
  ), variants: Array<(
    { __typename?: 'Variant' }
    & Pick<Variant, 'sizes' | 'name' | 'buyItNowUrl'>
    & { ingredientsBlurb?: Maybe<(
      { __typename?: 'Html' }
      & Pick<Html, 'html'>
    )>, packshot: (
      { __typename?: 'Media' }
      & Pick<Media, 'description' | 'title'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ) }
  )> }
);

export type MessageFieldsFragment = (
  { __typename?: 'message' }
  & Pick<Message, 'path' | 'benefits' | 'benefitsDisclaimer' | 'title' | 'summary' | 'product'>
  & { benefitImages?: Maybe<Array<Maybe<(
    { __typename?: 'BenefitImages' }
    & Pick<BenefitImages, 'description'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & Pick<File, 'publicURL'>
      )> }
    )> }
  )>>>, main?: Maybe<(
    { __typename?: 'Main' }
    & Pick<Main, 'html' | 'htmlTruncated'>
  )>, facts?: Maybe<Array<Maybe<(
    { __typename?: 'Fact' }
    & Pick<Fact, 'title' | 'summary'>
    & { image: (
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ) }
  )>>>, summaryBackground?: Maybe<(
    { __typename?: 'Media' }
    & Pick<Media, 'description' | 'title'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { childImageSharp?: Maybe<(
          { __typename?: 'ImageSharp' }
          & Pick<ImageSharp, 'gatsbyImageData'>
        )> }
      )> }
    )> }
  )>, hero: (
    { __typename?: 'Media' }
    & Pick<Media, 'description' | 'title'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { childImageSharp?: Maybe<(
          { __typename?: 'ImageSharp' }
          & Pick<ImageSharp, 'gatsbyImageData'>
        )> }
      )> }
    )> }
  ) }
);

export type HomeFieldsFragment = (
  { __typename?: 'home' }
  & Pick<Home, 'absolutePath' | 'pageType' | 'homepageTitle'>
  & { coreMessage?: Maybe<(
    { __typename?: 'message' }
    & MessageFieldsFragment
  )>, secondaryMessage?: Maybe<(
    { __typename?: 'message' }
    & MessageFieldsFragment
  )>, contactUsMessage?: Maybe<(
    { __typename?: 'message' }
    & Pick<Message, 'path' | 'title'>
  )>, contactUs?: Maybe<(
    { __typename?: 'ContactUs' }
    & Pick<ContactUs, 'path' | 'title'>
  )>, disclaimerMessage?: Maybe<(
    { __typename?: 'message' }
    & Pick<Message, 'absolutePath'>
  )>, brand: (
    { __typename?: 'Brand' }
    & Pick<Brand, 'name' | 'product' | 'description' | 'disclaimer'>
    & { logo: (
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ) }
  ), certificate?: Maybe<Array<Maybe<(
    { __typename?: 'Certificate' }
    & Pick<Certificate, 'title' | 'url'>
    & { image: (
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ) }
  )>>>, socialChannels?: Maybe<Array<Maybe<(
    { __typename?: 'SocialChannel' }
    & Pick<SocialChannel, 'name' | 'url'>
    & { image: (
      { __typename?: 'Media' }
      & Pick<Media, 'description' | 'title'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & Pick<File, 'extension' | 'publicURL'>
        )> }
      )> }
    ) }
  )>>>, domain: (
    { __typename?: 'Domain' }
    & Pick<Domain, 'yandexId' | 'name' | 'adChoicesConfig' | 'myTargetAnalyticsID' | 'dv360AnalyticsID' | 'hasVKAnalytics' | 'hasVersatag' | 'hotJarID' | 'oneTrustId' | 'oneTrustAutoBlock' | 'path' | 'lang' | 'market' | 'product'>
    & { adobeConfig?: Maybe<(
      { __typename?: 'AdobeConfig' }
      & { analytics__adobe__account: AdobeConfig['account'], analytics__adobe__trackingServer: AdobeConfig['trackingServer'], analytics__adobe__trackingServerSecure: AdobeConfig['trackingServerSecure'], analytics__adobe__reportSuiteId: AdobeConfig['reportSuiteId'], analytics__adobe__containerId: AdobeConfig['containerId'], analytics__adobe__region: AdobeConfig['region'], analytics__adobe__language: AdobeConfig['language'] }
    )> }
  ), legals?: Maybe<(
    { __typename?: 'Legals' }
    & Pick<Legals, 'contactUsLabel' | 'contactUsUrl' | 'cookieNoticeLabel' | 'cookieNoticeUrl' | 'privacyNoticeLabel' | 'privacyNoticeUrl' | 'termsOfUseLabel' | 'termsOfUseUrl' | 'whatsInOurProductsLabel' | 'whatsInOurProductsUrl' | 'protectionOfPersonalDataLabel' | 'protectionOfPersonalDataUrl' | 'legalWarningLabel' | 'legalWarningUrl'>
    & { blurb?: Maybe<(
      { __typename?: 'Html' }
      & Pick<Html, 'json'>
    )> }
  )>, lexicon: (
    { __typename?: 'Lexicon' }
    & Pick<Lexicon, 'description' | 'benefits' | 'buyItNow' | 'home' | 'ingredients' | 'readMore' | 'products' | 'certificates' | 'facts' | 'pageNotFoundText' | 'share' | 'socialTitle' | 'skipToContent'>
  ), termsMessage?: Maybe<(
    { __typename?: 'message' }
    & Pick<Message, 'path' | 'title'>
  )>, productsNodes?: Maybe<Array<Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'path' | 'id' | 'benefits' | 'name'>
    & { description: (
      { __typename?: 'Main' }
      & Pick<Main, 'text'>
    ), variants: Array<(
      { __typename?: 'Variant' }
      & Pick<Variant, 'sizes' | 'name' | 'product'>
      & { packshot: (
        { __typename?: 'Media' }
        & Pick<Media, 'description' | 'title'>
        & { file?: Maybe<(
          { __typename?: '_File' }
          & Pick<_File, 'url'>
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        )> }
      ) }
    )> }
  )>>> }
  & FooterHomeFragment
);

export type MessageCardMediaFragment = (
  { __typename?: 'Media' }
  & Pick<Media, 'description'>
  & { file?: Maybe<(
    { __typename?: '_File' }
    & { fileLocal?: Maybe<(
      { __typename?: 'File' }
      & { childImageSharp?: Maybe<(
        { __typename?: 'ImageSharp' }
        & Pick<ImageSharp, 'gatsbyImageData'>
      )> }
    )> }
  )> }
);

export type FuturoLimpoCommonDataFragment = (
  { __typename?: 'Query' }
  & { sevenGenLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, brilhanteLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, cifLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, comfortLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, omoLogo2?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, surfLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, alaLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, fofoLogo?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, cleanFuturesMan?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type FuturoLimpoCarouselFragment = (
  { __typename?: 'Query' }
  & { bigTree?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, littleTree?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hills?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, butterfly?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, comfort?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, omo?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hands?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, shrubs?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, sun?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, world?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, shadow?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, moon?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, delivery?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, van?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, leafPurple?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, leafPink?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, leafOrange?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type PppCommonImagesDataFragment = (
  { __typename?: 'Query' }
  & { product?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, planet?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, people?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type CurrentYearQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentYearQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & Pick<Home, 'currentYear'>
  )> }
);

export type DomainPathQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainPathQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { domain: (
      { __typename?: 'Domain' }
      & Pick<Domain, 'path'>
    ) }
  )> }
);

export type UnileverLogoQueryVariables = Exact<{ [key: string]: never; }>;


export type UnileverLogoQuery = (
  { __typename?: 'Query' }
  & { file?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type DejaConnectedPackQueryVariables = Exact<{ [key: string]: never; }>;


export type DejaConnectedPackQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { brand: (
      { __typename?: 'Brand' }
      & { logo: (
        { __typename?: 'Media' }
        & Pick<Media, 'description'>
        & { file?: Maybe<(
          { __typename?: '_File' }
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        )> }
      ) }
    ) }
    & FooterHomeFragment
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, bgImage?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, group?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, pasoFourScoop?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type PersilHarlequinsCompetitionTestQueryVariables = Exact<{ [key: string]: never; }>;


export type PersilHarlequinsCompetitionTestQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, shareImage?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type PersilHarlequinsCompetitionQueryVariables = Exact<{ [key: string]: never; }>;


export type PersilHarlequinsCompetitionQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, shareImage?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type SeventhGenDeConnectedPackQrQueryVariables = Exact<{ [key: string]: never; }>;


export type SeventhGenDeConnectedPackQrQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, video?: Maybe<(
    { __typename?: 'File' }
    & { videoH264?: Maybe<(
      { __typename?: 'GatsbyVideo' }
      & Pick<GatsbyVideo, 'path'>
      & { screenshots?: Maybe<Array<Maybe<(
        { __typename?: 'GatsbyVideoScreenshot' }
        & Pick<GatsbyVideoScreenshot, 'path'>
      )>>> }
    )> }
  )>, pasoFourScoop?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type SeventhGenDeConnectedPackQueryVariables = Exact<{ [key: string]: never; }>;


export type SeventhGenDeConnectedPackQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, video?: Maybe<(
    { __typename?: 'File' }
    & { videoH264?: Maybe<(
      { __typename?: 'GatsbyVideo' }
      & Pick<GatsbyVideo, 'path'>
      & { screenshots?: Maybe<Array<Maybe<(
        { __typename?: 'GatsbyVideoScreenshot' }
        & Pick<GatsbyVideoScreenshot, 'path'>
      )>>> }
    )> }
  )>, pasoFourScoop?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type ChatBotTestPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatBotTestPageQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type BreezeAdvancedQueryVariables = Exact<{ [key: string]: never; }>;


export type BreezeAdvancedQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { brand: (
      { __typename?: 'Brand' }
      & { logo: (
        { __typename?: 'Media' }
        & Pick<Media, 'description'>
        & { file?: Maybe<(
          { __typename?: '_File' }
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        )> }
      ) }
    ), legals?: Maybe<(
      { __typename?: 'Legals' }
      & Pick<Legals, 'cookieNoticeLabel' | 'cookieNoticeUrl' | 'privacyNoticeLabel' | 'privacyNoticeUrl'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, benefitBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, bannerTwo?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, lazadaBanner?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, shopeeBanner?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, ucoinBanner?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, video?: Maybe<(
    { __typename?: 'File' }
    & { videoH264?: Maybe<(
      { __typename?: 'GatsbyVideo' }
      & Pick<GatsbyVideo, 'path'>
      & { screenshots?: Maybe<Array<Maybe<(
        { __typename?: 'GatsbyVideoScreenshot' }
        & Pick<GatsbyVideoScreenshot, 'path'>
      )>>> }
    )> }
  )> }
);

export type BenefitImageFragment = (
  { __typename?: 'File' }
  & { childImageSharp?: Maybe<(
    { __typename?: 'ImageSharp' }
    & Pick<ImageSharp, 'gatsbyImageData'>
  )> }
);

export type ComfortAdvancedQueryVariables = Exact<{ [key: string]: never; }>;


export type ComfortAdvancedQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { brand: (
      { __typename?: 'Brand' }
      & { logo: (
        { __typename?: 'Media' }
        & Pick<Media, 'description'>
        & { file?: Maybe<(
          { __typename?: '_File' }
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        )> }
      ) }
    ), domain: (
      { __typename?: 'Domain' }
      & Pick<Domain, 'lang' | 'oneTrustAutoBlock' | 'oneTrustId'>
      & { adobeConfig?: Maybe<(
        { __typename?: 'AdobeConfig' }
        & { analytics__adobe__account: AdobeConfig['account'], analytics__adobe__trackingServer: AdobeConfig['trackingServer'], analytics__adobe__trackingServerSecure: AdobeConfig['trackingServerSecure'], analytics__adobe__reportSuiteId: AdobeConfig['reportSuiteId'], analytics__adobe__containerId: AdobeConfig['containerId'], analytics__adobe__region: AdobeConfig['region'], analytics__adobe__language: AdobeConfig['language'] }
      )> }
    ), legals?: Maybe<(
      { __typename?: 'Legals' }
      & Pick<Legals, 'cookieNoticeLabel' | 'cookieNoticeUrl' | 'privacyNoticeLabel' | 'privacyNoticeUrl'>
    )> }
  )>, shareImage?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, packshot?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, supplementaryOne?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, supplementaryTwo?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, benefitOne?: Maybe<(
    { __typename?: 'File' }
    & BenefitImageFragment
  )>, benefitTwo?: Maybe<(
    { __typename?: 'File' }
    & BenefitImageFragment
  )>, benefitThree?: Maybe<(
    { __typename?: 'File' }
    & BenefitImageFragment
  )>, benefitFour?: Maybe<(
    { __typename?: 'File' }
    & BenefitImageFragment
  )>, video?: Maybe<(
    { __typename?: 'File' }
    & { videoH264?: Maybe<(
      { __typename?: 'GatsbyVideo' }
      & Pick<GatsbyVideo, 'path'>
      & { screenshots?: Maybe<Array<Maybe<(
        { __typename?: 'GatsbyVideoScreenshot' }
        & Pick<GatsbyVideoScreenshot, 'path'>
      )>>> }
    )> }
  )> }
);

export type ComfortCheetahCampaignQueryVariables = Exact<{ [key: string]: never; }>;


export type ComfortCheetahCampaignQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type ComfortCheetahQueryVariables = Exact<{ [key: string]: never; }>;


export type ComfortCheetahQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type BreezeDigQueryVariables = Exact<{ [key: string]: never; }>;


export type BreezeDigQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, logo?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, fbbg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, fbIcon?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, lineBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, lineIcon?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, headingBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, footer?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type ContentfulArticleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContentfulArticleQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, contentfulArticle?: Maybe<(
    { __typename?: 'ContentfulArticle' }
    & Pick<ContentfulArticle, 'absolutePath' | 'pageTitle' | 'title' | 'metaDescription' | 'summary'>
    & { traits: (
      { __typename?: 'Traits' }
      & Pick<Traits, 'traitsStringified'>
    ), summaryBackground?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    )>, hero?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    )>, main?: Maybe<(
      { __typename?: 'Main' }
      & Pick<Main, 'rawContent'>
      & { assets: Array<(
        { __typename?: 'EmbeddedImage' }
        & Pick<EmbeddedImage, 'title' | 'description'>
        & { file: (
          { __typename?: '_File' }
          & Pick<_File, 'url'>
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        ) }
      ) | (
        { __typename?: 'EmbeddedVideo' }
        & Pick<EmbeddedVideo, 'title' | 'description'>
        & { file: (
          { __typename?: '_File' }
          & Pick<_File, 'url'>
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { videoH264?: Maybe<(
              { __typename?: 'GatsbyVideo' }
              & Pick<GatsbyVideo, 'path'>
              & { screenshots?: Maybe<Array<Maybe<(
                { __typename?: 'GatsbyVideoScreenshot' }
                & Pick<GatsbyVideoScreenshot, 'path'>
              )>>> }
            )> }
          )> }
        ) }
      )> }
    )>, parentCategory: (
      { __typename?: 'ContentfulCategory' }
      & Pick<ContentfulCategory, 'absolutePath' | 'pageTitle'>
      & { parentCategory?: Maybe<(
        { __typename?: 'ContentfulCategory' }
        & Pick<ContentfulCategory, 'absolutePath' | 'pageTitle'>
        & { parentCategory?: Maybe<(
          { __typename?: 'ContentfulCategory' }
          & Pick<ContentfulCategory, 'absolutePath' | 'pageTitle'>
        )> }
      )> }
    ) }
  )> }
);

export type CardHeroFragment = (
  { __typename?: 'Media' }
  & Pick<Media, 'description'>
  & { file?: Maybe<(
    { __typename?: '_File' }
    & { fileLocal?: Maybe<(
      { __typename?: 'File' }
      & { childImageSharp?: Maybe<(
        { __typename?: 'ImageSharp' }
        & Pick<ImageSharp, 'gatsbyImageData'>
      )> }
    )> }
  )> }
);

export type ContentfulCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContentfulCategoryQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, contentfulCategory?: Maybe<(
    { __typename?: 'ContentfulCategory' }
    & Pick<ContentfulCategory, 'absolutePath' | 'pageTitle' | 'metaDescription' | 'summary'>
    & { traits: (
      { __typename?: 'Traits' }
      & Pick<Traits, 'traitsStringified'>
    ), hero?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    )>, main?: Maybe<(
      { __typename?: 'Main' }
      & Pick<Main, 'rawContent'>
      & { assets: Array<(
        { __typename?: 'EmbeddedImage' }
        & Pick<EmbeddedImage, 'title' | 'description'>
        & { file: (
          { __typename?: '_File' }
          & Pick<_File, 'url'>
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { childImageSharp?: Maybe<(
              { __typename?: 'ImageSharp' }
              & Pick<ImageSharp, 'gatsbyImageData'>
            )> }
          )> }
        ) }
      ) | (
        { __typename?: 'EmbeddedVideo' }
        & Pick<EmbeddedVideo, 'title' | 'description'>
        & { file: (
          { __typename?: '_File' }
          & Pick<_File, 'url'>
          & { fileLocal?: Maybe<(
            { __typename?: 'File' }
            & { videoH264?: Maybe<(
              { __typename?: 'GatsbyVideo' }
              & Pick<GatsbyVideo, 'path'>
              & { screenshots?: Maybe<Array<Maybe<(
                { __typename?: 'GatsbyVideoScreenshot' }
                & Pick<GatsbyVideoScreenshot, 'path'>
              )>>> }
            )> }
          )> }
        ) }
      )> }
    )>, childNodes: Array<(
      { __typename?: 'ContentfulCategory' }
      & Pick<ContentfulCategory, 'path' | 'pageTitle'>
      & { hero?: Maybe<(
        { __typename?: 'Media' }
        & CardHeroFragment
      )> }
    ) | (
      { __typename?: 'ContentfulArticle' }
      & Pick<ContentfulArticle, 'path' | 'pageTitle'>
      & { hero?: Maybe<(
        { __typename?: 'Media' }
        & CardHeroFragment
      )> }
    )>, parentCategory?: Maybe<(
      { __typename?: 'ContentfulCategory' }
      & Pick<ContentfulCategory, 'absolutePath' | 'pageTitle'>
    )> }
  )> }
);

export type ParentsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ParentsPageQuery = (
  { __typename?: 'Query' }
  & { hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, changemakerBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, inspireBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, signUpBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, cardOneBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, cardTwoBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, cardThreeBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, cardFourBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
  & SchoolsLayoutDataFragment
);

export type HomeVideoDataFragment = (
  { __typename?: 'HomeVideo' }
  & Pick<HomeVideo, 'description' | 'title'>
  & { video: (
    { __typename?: 'File' }
    & { videoH264?: Maybe<(
      { __typename?: 'GatsbyVideo' }
      & Pick<GatsbyVideo, 'path'>
    )> }
  ), videoPoster: (
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  ) }
);

export type SurfExcelHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type SurfExcelHomeQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & { domain: (
      { __typename?: 'Domain' }
      & LayoutDomainFragment
    ) }
  )>, shareImage?: Maybe<(
    { __typename?: 'File' }
    & Pick<File, 'publicURL'>
  )>, frontLiquid?: Maybe<(
    { __typename?: 'File' }
    & ProductImageFragment
  )>, frontLiquid2?: Maybe<(
    { __typename?: 'File' }
    & ProductImageFragment
  )>, topLiquid?: Maybe<(
    { __typename?: 'File' }
    & ProductImageFragment
  )>, topLiquid2?: Maybe<(
    { __typename?: 'File' }
    & ProductImageFragment
  )>, amazon?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, bigbasket?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, grofers?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type ProductImageFragment = (
  { __typename?: 'File' }
  & { childImageSharp?: Maybe<(
    { __typename?: 'ImageSharp' }
    & Pick<ImageSharp, 'gatsbyImageData'>
  )> }
);

export type LayoutDomainFragment = (
  { __typename?: 'Domain' }
  & Pick<Domain, 'name' | 'lang' | 'oneTrustAutoBlock' | 'oneTrustId'>
);

export type Infographic1QueryVariables = Exact<{ [key: string]: never; }>;


export type Infographic1Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon20Recycled?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon50?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon70Less?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon100Recyclable?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconConcentrated?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconLessPollution?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNewDetergent?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNonPlastic?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, blueBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type Infographic2QueryVariables = Exact<{ [key: string]: never; }>;


export type Infographic2Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRenewableIngredients?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconFossilFuels?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconPlants?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon2030?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type Infographic3QueryVariables = Exact<{ [key: string]: never; }>;


export type Infographic3Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconSmellingFresh?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconStopColourFade?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRemovesStains?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconKindToPlanet?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconAnalyse?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconQualityProducts?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconTime?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type S12yCategoryPageQueryVariables = Exact<{
  categoryId: Scalars['String'];
}>;


export type S12yCategoryPageQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, sustainabilityCategory?: Maybe<(
    { __typename?: 'SustainabilityCategory' }
    & Pick<SustainabilityCategory, 'absolutePath' | 'title' | 'metaDescription' | 'metaTitle'>
    & { summary: (
      { __typename?: 'Html' }
      & Pick<Html, 'json'>
    ), hero: (
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ), heroOverlay: (
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ), shareImage: (
      { __typename?: 'Media' }
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ), messageCards: Array<(
      { __typename?: 'SustainabilityMessageCard' }
      & Pick<SustainabilityMessageCard, 'id'>
      & MessageCardMessageFragment
    )>, traits: (
      { __typename?: 'Traits' }
      & Pick<Traits, 'traitsStringified'>
    ) }
  )> }
);

export type S12yLandingPageQueryVariables = Exact<{
  landingPageId: Scalars['String'];
}>;


export type S12yLandingPageQuery = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, sustainabilityLandingPage?: Maybe<(
    { __typename?: 'SustainabilityLandingPage' }
    & Pick<SustainabilityLandingPage, 'absolutePath' | 'title' | 'metaDescription' | 'metaTitle'>
    & { heroVideo?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'description'>
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { videoH264?: Maybe<(
            { __typename?: 'GatsbyVideo' }
            & Pick<GatsbyVideo, 'path'>
            & { screenshots?: Maybe<Array<Maybe<(
              { __typename?: 'GatsbyVideoScreenshot' }
              & Pick<GatsbyVideoScreenshot, 'path'>
            )>>> }
          )> }
        )> }
      )> }
    )>, shareImage: (
      { __typename?: 'Media' }
      & { file?: Maybe<(
        { __typename?: '_File' }
        & { fileLocal?: Maybe<(
          { __typename?: 'File' }
          & { childImageSharp?: Maybe<(
            { __typename?: 'ImageSharp' }
            & Pick<ImageSharp, 'gatsbyImageData'>
          )> }
        )> }
      )> }
    ), summary: (
      { __typename?: 'Html' }
      & Pick<Html, 'json'>
    ), traits: (
      { __typename?: 'Traits' }
      & Pick<Traits, 'traitsStringified'>
    ) }
  )>, allSustainabilityCategory: (
    { __typename?: 'SustainabilityCategoryConnection' }
    & { nodes: Array<(
      { __typename?: 'SustainabilityCategory' }
      & Pick<SustainabilityCategory, 'id'>
      & CategoryCardCategoryFragment
    )> }
  ) }
);

export type BiotexInfographic1QueryVariables = Exact<{ [key: string]: never; }>;


export type BiotexInfographic1Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon20Recycled?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon50?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon70Less?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon100Recyclable?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconConcentrated?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconLessPollution?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNewDetergent?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNonPlastic?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, blueBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type BiotexInfographic2QueryVariables = Exact<{ [key: string]: never; }>;


export type BiotexInfographic2Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRenewableIngredients?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconFossilFuels?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconPlants?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon2030?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type BiotexInfographic3QueryVariables = Exact<{ [key: string]: never; }>;


export type BiotexInfographic3Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconSmellingFresh?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconStopColourFade?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRemovesStains?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconKindToPlanet?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconAnalyse?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconQualityProducts?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconTime?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type BreezeInfographic1QueryVariables = Exact<{ [key: string]: never; }>;


export type BreezeInfographic1Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon20Recycled?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon50?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon70Less?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon100Recyclable?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconConcentrated?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconLessPollution?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNewDetergent?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNonPlastic?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, blueBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type BreezeInfographic2QueryVariables = Exact<{ [key: string]: never; }>;


export type BreezeInfographic2Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRenewableIngredients?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconFossilFuels?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconPlants?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon2030?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type BreezeInfographic3QueryVariables = Exact<{ [key: string]: never; }>;


export type BreezeInfographic3Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconSmellingFresh?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconStopColourFade?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRemovesStains?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconKindToPlanet?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconAnalyse?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconQualityProducts?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconTime?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type CategoryCardCategoryFragment = (
  { __typename?: 'SustainabilityCategory' }
  & Pick<SustainabilityCategory, 'path' | 'title' | 'ctaMicrocopy' | 'shortDescription'>
  & { hero: (
    { __typename?: 'Media' }
    & Pick<Media, 'description'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { childImageSharp?: Maybe<(
          { __typename?: 'ImageSharp' }
          & Pick<ImageSharp, 'gatsbyImageData'>
        )> }
      )> }
    )> }
  ), heroOverlay: (
    { __typename?: 'Media' }
    & Pick<Media, 'description'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { childImageSharp?: Maybe<(
          { __typename?: 'ImageSharp' }
          & Pick<ImageSharp, 'gatsbyImageData'>
        )> }
      )> }
    )> }
  ) }
);

export type HomeWidgetCategoryFragment = (
  { __typename?: 'SustainabilityCategory' }
  & Pick<SustainabilityCategory, 'id'>
  & CategoryCardCategoryFragment
);

export type HomeWidgetFragment = (
  { __typename?: 'SustainabilityWidget' }
  & Pick<SustainabilityWidget, 'strapline'>
  & { headingImage: (
    { __typename?: 'Media' }
    & Pick<Media, 'description'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { childImageSharp?: Maybe<(
          { __typename?: 'ImageSharp' }
          & Pick<ImageSharp, 'gatsbyImageData'>
        )> }
      )> }
    )> }
  ) }
);

export type MessageCardMessageFragment = (
  { __typename?: 'SustainabilityMessageCard' }
  & Pick<SustainabilityMessageCard, 'ctaMicrocopy' | 'ctaTagLine'>
  & { message: (
    { __typename?: 'message' }
    & Pick<Message, 'path'>
  ), teaserImage?: Maybe<(
    { __typename?: 'Media' }
    & Pick<Media, 'description'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { childImageSharp?: Maybe<(
          { __typename?: 'ImageSharp' }
          & Pick<ImageSharp, 'gatsbyImageData'>
        )> }
      )> }
    )> }
  )>, teaserVideo?: Maybe<(
    { __typename?: 'Media' }
    & Pick<Media, 'description'>
    & { file?: Maybe<(
      { __typename?: '_File' }
      & { fileLocal?: Maybe<(
        { __typename?: 'File' }
        & { videoH264?: Maybe<(
          { __typename?: 'GatsbyVideo' }
          & Pick<GatsbyVideo, 'path'>
          & { screenshots?: Maybe<Array<Maybe<(
            { __typename?: 'GatsbyVideoScreenshot' }
            & Pick<GatsbyVideoScreenshot, 'path'>
          )>>> }
        )> }
      )> }
    )> }
  )> }
);

export type OmoInfographic1QueryVariables = Exact<{ [key: string]: never; }>;


export type OmoInfographic1Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon20Recycled?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon50?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon70Less?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon100Recyclable?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconConcentrated?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconLessPollution?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNewDetergent?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNonPlastic?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, blueBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type OmoInfographic2QueryVariables = Exact<{ [key: string]: never; }>;


export type OmoInfographic2Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRenewableIngredients?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconFossilFuels?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconPlants?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon2030?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type OmoInfographic3QueryVariables = Exact<{ [key: string]: never; }>;


export type OmoInfographic3Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconSmellingFresh?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconStopColourFade?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRemovesStains?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconKindToPlanet?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconAnalyse?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconQualityProducts?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconTime?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type ViaInfographic1QueryVariables = Exact<{ [key: string]: never; }>;


export type ViaInfographic1Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon20Recycled?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon50?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon70Less?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon100Recyclable?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconConcentrated?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconLessPollution?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNewDetergent?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconNonPlastic?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, blueBg?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type ViaInfographic2QueryVariables = Exact<{ [key: string]: never; }>;


export type ViaInfographic2Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRenewableIngredients?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconFossilFuels?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconPlants?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, icon2030?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);

export type ViaInfographic3QueryVariables = Exact<{ [key: string]: never; }>;


export type ViaInfographic3Query = (
  { __typename?: 'Query' }
  & { home?: Maybe<(
    { __typename?: 'home' }
    & HomeFieldsFragment
  )>, share?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, hero?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, heroMobile?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, summary?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconSmellingFresh?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconStopColourFade?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconRemovesStains?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconKindToPlanet?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconAnalyse?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconQualityProducts?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )>, iconTime?: Maybe<(
    { __typename?: 'File' }
    & { childImageSharp?: Maybe<(
      { __typename?: 'ImageSharp' }
      & Pick<ImageSharp, 'gatsbyImageData'>
    )> }
  )> }
);
